(function() {
  'use strict';

  angular
    .module('lebuFend', [
        'ngAnimate',
        'ngCookies',
        'ngSanitize',
        'ngMessages',
        'ngAria',
        'restangular',
        'ui.router',
        'ngMaterial',
        'boxuk.translation',
        'toastr',
        'duScroll',
        'wu.masonry',
        'jkAngularRatingStars',
        'anim-in-out',
        'slickCarousel',
        'angular-flippy',
        'satellizer',
        'sf.treeRepeat',
        'checklist-model',
        'com.2fdevs.videogular',
        'ngDraggable',
        'angular-loading-bar',
        'angularMoment',
        'com.2fdevs.videogular.plugins.controls',
        'com.2fdevs.videogular.plugins.overlayplay',
        'com.2fdevs.videogular.plugins.poster',
        'ct.ui.router.extras.core',
        'ct.ui.router.extras.sticky',
        'ct.ui.router.extras.dsr',
        'ct.ui.router.extras.previous',
        'ct.ui.router.extras.transition',
        'th.co.softever.videogular.plugins.quality',
        'luegg.directives',
        'vxWamp',
        'ui.router.grant',
        'ngImgCrop',
        'ngFileUpload',
        'chart.js',
        'ngScrollbars',
        'infinite-scroll',
        'md.data.table',
        'bm.uiTour',
        'angulartics',
        'angulartics.google.analytics'
  ]);

})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbTruefalseQuizResult', lbTruefalseQuizResult);

    /** @ngInject */
    function lbTruefalseQuizResult() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/quizPlayer/truefalseQuiz/truefalseQuizResult/truefalseQuizResult.html',
            controller: TruefalseQuizResultController,
            controllerAs: 'truefalseQuizResult',
            scope: true,
            bindToController: {
                question: '@',
                answer: '<',
                userExecution: '<',
                solved: '<'
            }
        };
        return directive;

        /** @ngInject */
        function TruefalseQuizResultController($scope) {
            var vm = this;
            vm.showSolution = false;

            $scope.$on('quiz:solution', function() {
                vm.showSolution = true;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbShortanswerQuizResult', lbShortanswerQuizResult);

    /** @ngInject */
    function lbShortanswerQuizResult() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/quizPlayer/shortanswerQuiz/shortanswerQuizResult/shortanswerQuizResult.html',
            controller: ShortanswerQuizResultController,
            controllerAs: 'shortanswerQuizResult',
            scope: true,
            bindToController: {
                question: '@',
                answer: '<',
                userExecution: '<',
                solved: '<'
            }
        };
        return directive;

        /** @ngInject */
        function ShortanswerQuizResultController($scope) {
            var vm = this;
            vm.showSolution = false;

            $scope.$on('quiz:solution', function() {
                vm.showSolution = true;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbMultichoiceQuizResult', lbMultichoiceQuizResult);

    /** @ngInject */
    function lbMultichoiceQuizResult() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/quizPlayer/multichoiceQuiz/multichoiceQuizResult/multichoiceQuizResult.html',
            controller: MultichoiceQuizResultController,
            controllerAs: 'multichoiceQuizResult',
            scope: true,
            bindToController: {
                question: '@',
                options: '<',
                answer: '<',
                userExecution: '<',
                solved: '<'
            }
        };
        return directive;

        /** @ngInject */
        function MultichoiceQuizResultController($scope) {
            var vm = this;
            vm.getAnswer = getAnswer;
            vm.showSolution = false;

            $scope.$on('quiz:solution', function() {
                vm.showSolution = true;
            });
            
            function getAnswer() {
                var rv = [];
                angular.forEach(vm.answer, function(answer, index) {
                    if (answer) {
                        rv.push('"' + vm.options[index].value + '"');
                    }
                });
                return rv.join(', ');
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbMatchingQuizResult', lbMatchingQuizResult);

    /** @ngInject */
    function lbMatchingQuizResult() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/quizPlayer/matchingQuiz/matchingQuizResult/matchingQuizResult.html',
            controller: MatchingQuizResultController,
            controllerAs: 'matchingQuizResult',
            scope: true,
            bindToController: {
                question: '@',
                options: '<',
                answers: '<',
                answer: '<',
                userExecution: '<',
                solved: '<'
            }
        };
        return directive;

        /** @ngInject */
        function MatchingQuizResultController($scope, _) {
            var vm = this;
            vm.getAnswer = getAnswer;
            vm.showSolution = false;

            $scope.$on('quiz:solution', function() {
                vm.showSolution = true;
            });
            
            function getAnswer(solution) {
                var questionLabel = _.find(vm.options, {index: solution.question}).value;
                var answerLabel = _.find(vm.answers, {index: solution.answer}).value;
                return questionLabel + ' > ' + answerLabel;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbTruefalseQuiz', lbTruefalseQuiz);

    /** @ngInject */
    function lbTruefalseQuiz() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/quizPlayer/truefalseQuiz/truefalseQuiz.html',
            controller: TruefalseQuizController,
            controllerAs: 'truefalseQuiz',
            scope: true,
            bindToController: {
                question: '@'
            }
        };
        return directive;

        /** @ngInject */
        function TruefalseQuizController($scope) {
            var vm = this;
            vm.selectedOption = null;
            vm.optionSelected = optionSelected;
            vm.reset = reset;
            
            $scope.$on('quiz:reset', vm.reset);
            $scope.$watch(angular.bind(this, function() {
                return this.selectedOption;
            }), optionSelected);
            
            function optionSelected() {
                if (vm.selectedOption != null) {
                    $scope.$emit('quiz:solution:ready', {solution: [{index: 0, value: vm.selectedOption == 'true'}]});
                }
            }
            function reset() {
                vm.selectedOption = null;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbShortanswerQuiz', lbShortanswerQuiz);

    /** @ngInject */
    function lbShortanswerQuiz() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/quizPlayer/shortanswerQuiz/shortanswerQuiz.html',
            controller: ShortanswerQuizController,
            controllerAs: 'shortanswerQuiz',
            scope: true,
            bindToController: {
                question: '@'
            }
        };
        return directive;

        /** @ngInject */
        function ShortanswerQuizController($scope) {
            var vm = this;
            vm.minAnswerLength = 1;
            vm.answer = '';
            vm.answered = answered;
            vm.reset = reset;
            
            $scope.$watch(angular.bind(this, function() {
                return this.answered;
            }), answered);
            $scope.$on('quiz:reset', vm.reset);
            
            function answered() {
                if (vm.minAnswerLength <= vm.answer.length) {
                    $scope.$emit('quiz:solution:ready', {solution: [{index: 0, value: vm.answer}]});
                }
            }
            function reset() {
                vm.answer = '';
            }
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('QuizConfirmController', QuizConfirmController);


  /** @ngInject */
  function QuizConfirmController($scope) {
      var vm = this;
      vm.confirm = confirm;
      vm.cancel = cancel;
      
      function confirm() {
          $scope.$emit('quiz:confirm');
      }
      function cancel() {
          $scope.$emit('quiz:cancel');
      }
   }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbMultichoiceQuiz', lbMultichoiceQuiz);

    /** @ngInject */
    function lbMultichoiceQuiz() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/quizPlayer/multichoiceQuiz/multichoiceQuiz.html',
            controller: MultichoiceQuizController,
            controllerAs: 'multichoiceQuiz',
            scope: true,
            bindToController: {
                question: '@',
                options: '<'
            }
        };
        return directive;

        /** @ngInject */
        function MultichoiceQuizController($scope) {
            var vm = this;
            vm.selectedOptions = [];
            vm.optionsSelected = optionsSelected;
            vm.reset = reset;

            $scope.$on('quiz:reset', vm.reset);
            
            function optionsSelected() {
                var solution = [];
                angular.forEach(vm.options, function(option) {
                    solution.push({
                        index: option.index,
                        value: angular.isDefined(_.find(vm.selectedOptions, {index: option.index}))
                    });
                });
                if (vm.selectedOptions.length > 0) {
                    $scope.$emit('quiz:solution:ready', {solution: solution});
                }
            }
            function reset() {
                vm.selectedOptions = [];
            }
       }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbMatchingQuiz', lbMatchingQuiz);

    /** @ngInject */
    function lbMatchingQuiz() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/quizPlayer/matchingQuiz/matchingQuiz.html',
            controller: MatchingQuizController,
            controllerAs: 'matchingQuiz',
            scope: true,
            bindToController: {
                question: '@',
                options: '<',
                answers: '<'
            }
        };
        return directive;

        /** @ngInject */
        function MatchingQuizController($scope) {
            var vm = this;
//          vm.matchColors = ['#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800', '#FF5722', '#795548'];
            vm.matchColors = ['#F44336', '#673AB7', '#03A9F4', '#4CAF50', '#E91E63', '#3F51B5', '#8BC34A', '#00BCD4', '#FFC107', '#FF5722', '#9C27B0', '#2196F3', '#009688', '#CDDC39', '#FF9800', '#795548', '#FFEB3B'];
            vm.matches = [];
            vm.match = match;
            vm.matchesSelected = matchesSelected;
            vm.isSelected = isSelected;
            vm.isAnswerSelected = isAnswerSelected;
            vm.reset = reset;
            vm.match = match;
            vm.getOptionColor = getOptionColor;
            vm.getAnswerColor = getAnswerColor;
            
            $scope.$watchCollection(angular.bind(this, function() {
                return this.matches;
            }), matchesSelected);
            $scope.$on('quiz:reset', vm.reset);
            
            function matchesSelected() {
                if (vm.matches.length == vm.answers.length) {
                    $scope.$emit('quiz:solution:ready', {solution: vm.matches});
                }
            }
            function isSelected(option) {
                for (var i = 0; i < vm.matches.length; i++) {
                    if (vm.matches[i].index == option.index) {
                        return true;
                    }
                }
                return false;
            }
            function isAnswerSelected(answer) {
                for (var i = 0; i < vm.matches.length; i++) {
                    if (vm.matches[i].value == answer.index) {
                        return true;
                    }
                }
                return false;
            }
            function reset() {
                vm.matches = [];
            }
            function match(option, targetOption) {
                var colorIndex = option.index % vm.matchColors.length;
                vm.matches.push({
                    index: option.index,
                    value: targetOption.index,
                    color: vm.matchColors[colorIndex]
                });
            }
            function getOptionColor(option) {
                for (var i = 0; i < vm.matches.length; i++) {
                    if (vm.matches[i].index == option.index) {
                        return vm.matches[i].color;
                    }
                }
                return 'normal';
            }
            function getAnswerColor(answer) {
                for (var i = 0; i < vm.matches.length; i++) {
                    if (vm.matches[i].value == answer.index) {
                        return vm.matches[i].color;
                    }
                }
                return 'normal';
            }
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .service('Logger', Logger);

  /** @ngInject */
  function Logger(moment, $injector) {
    var service = {
      post: post
    };
    function post() {
      var $state = $injector.get('$state');
      var $location = $injector.get('$location');
      var $http = $injector.get('$http');
      var arg = arguments[0];
      var info = {
        time: moment(new Date()).format('LLL'),
        message: arg.message || arg,
        stack: arg.stack,
        browser: getBrowserInfo(),
        os: getOsInfo(),
        state: $state.current.name,
        url: $location.url()
      };
      $http.post('/log', info);
    }
    function getBrowserInfo() {
      var nAgt = navigator.userAgent;
      var browserName = navigator.appName;
      var fullVersion = '' + parseFloat(navigator.appVersion);
      var nameOffset, verOffset, ix;

      // In Opera, the true version is after "Opera" or after "Version"
      if ((verOffset = nAgt.indexOf("Opera")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf("Version")) != -1)
          fullVersion = nAgt.substring(verOffset + 8);
      }
      // In MSIE, the true version is after "MSIE" in userAgent
      else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browserName = "Microsoft Internet Explorer";
        fullVersion = nAgt.substring(verOffset + 5);
      }
      // In Chrome, the true version is after "Chrome"
      else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset + 7);
      }
      // In Safari, the true version is after "Safari" or after "Version"
      else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf("Version")) != -1)
          fullVersion = nAgt.substring(verOffset + 8);
      }
      // In Firefox, the true version is after "Firefox"
      else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset + 8);
      }
      // In most other browsers, "name/version" is at the end of userAgent
      else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
        (verOffset = nAgt.lastIndexOf('/'))) {
        browserName = nAgt.substring(nameOffset, verOffset);
        fullVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() == browserName.toUpperCase()) {
          browserName = navigator.appName;
        }
      }
      // trim the fullVersion string at semicolon/space if present
      if ((ix = fullVersion.indexOf(";")) != -1)
        fullVersion = fullVersion.substring(0, ix);
      if ((ix = fullVersion.indexOf(" ")) != -1)
        fullVersion = fullVersion.substring(0, ix);

      return {
        name: browserName,
        version: fullVersion
      };
    }
    function getOsInfo() {
      if (navigator.appVersion.indexOf("Win")!=-1) {
        return "Windows";
      }
      if (navigator.appVersion.indexOf("Mac")!=-1) {
        return "MacOS";
      }
      if (navigator.appVersion.indexOf("X11")!=-1) {
        return "UNIX";
      }
      if (navigator.appVersion.indexOf("Linux")!=-1) {
        return "Linux";
      }
      return "Unknown OS";
    }
    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('UserStatsController', UserStatsController)

  /** @ngInject */
  function UserStatsController(user, _, timeStats, categoryStats, userStats, coursesStats, TranslationService) {
      var vm = this;
      vm.updateTimeStats = updateTimeStats;
      vm.timeStats = timeStats;
      vm.categoryStats = categoryStats;
      vm.userStats = userStats;
      vm.coursesStats = coursesStats;
      vm.userTimeSeries = ['Time Spended on platform'];

      vm.userData = getUserData();
      vm.userLabels = getUserLabels();
      vm.userTimeFrom = getUserTimeFrom();
      vm.userTimeTo = getUserTimeTo();
      vm.userTimeData = getUserTimeData();
      vm.userTimeLabels = getUserTimeLabels();
      vm.userTimeTotal = getUserTimeTotal();
      vm.userCategoryData = getUserCategoryData();
      vm.userCategoryLabels = getUserCategoryLabels();
      vm.userCategoryColours = getUserCategoryColours();

      function updateTimeStats() {
          user.one('timestats').get({
              from: moment(vm.userTimeFrom).unix(),
              to: moment(vm.userTimeTo).unix()
          }).then(function(timeStats) {
              vm.timeStats = timeStats;
              vm.userTimeFrom = getUserTimeFrom();
              vm.userTimeTo = getUserTimeTo();
              vm.userTimeData = getUserTimeData();
              vm.userTimeLabels = getUserTimeLabels();
          });
      }
      function getUserTimeFrom() {
          return moment.unix(vm.timeStats.from).toDate();
      }
      function getUserTimeTo() {
          return moment.unix(vm.timeStats.to).toDate();
      }
      function getUserData() {
          return _.map(vm.userStats, 'value');
      }
      function getUserLabels() {
          return _.map(vm.userStats, function(o) {
              return TranslationService.trans(o.label);
          });
      }
      function getUserTimeData() {
          return [_.map(vm.timeStats.data, 'total')];
      }
      function getUserTimeLabels() {
          return _.map(vm.timeStats.data, function(data) {
              return moment.unix(data.date).format('D MMM');
          });
      }
      function getUserTimeTotal() {
          return moment.duration(vm.timeStats.total, 'minutes').humanize();
      }
      function getUserCategoryData() {
          return _.map(vm.categoryStats, 'value');
      }
      function getUserCategoryLabels() {
          return _.map(vm.categoryStats, function(o) {
              return TranslationService.trans(o.label);
          });
      }
      function getUserCategoryColours() {
          return _.map(vm.categoryStats, 'color');
      }
   }
})();

(function() {
    'use strict';

    angular
      .module('lebuFend')
      .controller('UserPostsController', UserPostsController);

    /** @ngInject */
    function UserPostsController($scope, $rootScope, Optimization, _, user, $timeout) {
        var vm = this;
        vm.user = user;
        vm.loadedPosts = [];
        vm.loadPosts = loadPosts;
        vm.typeFilter = null;
        vm.busy = false;
        vm.after = null;
        vm.reloadPosts = reloadPosts;
        vm.postsLoading = false;
        vm.emptyPosts = false;

        var onSocialPostUpdatedHandler = $rootScope.$on('social:post:updated', vm.reloadPosts);
        $scope.$on('$destroy', onSocialPostUpdatedHandler);

        function reloadPosts() {
            vm.loadedPosts = [];
            vm.after = null;
            vm.emptyPosts = false;
            vm.loadPosts();
        }
        function loadPosts() {
            if (vm.busy || vm.emptyPosts) return;
            vm.busy = true;
            vm.postsLoading = true;
            var params = {
                limit: Optimization.POSTS_PAGE_SIZE
            };
            if (vm.after != null) {
                angular.extend(params, {after: vm.after});
            }
            if (vm.typeFilter != null) {
                angular.extend(params, {type: vm.typeFilter});
            }
            user.getList('posts', params).then(function(posts) {
                _.each(posts, function(post) {
                    vm.loadedPosts.push(post);
                });
                if (posts.length > 0) {
                    vm.after = vm.loadedPosts[vm.loadedPosts.length - 1].id;
                } else {
                    vm.emptyPosts = true;
                }
                vm.busy = false;
                vm.postsLoading = false;
                $timeout(function() {
                    angular.element('#stories').masonry('layout');
                }, 1000);
            }, function() {
                vm.busy = false;
                vm.postsLoading = false;
            });
        }
     }
  })();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('UserGodosController', UserGodosController)

  /** @ngInject */
  function UserGodosController(user, $rootScope, $state, lebuApi, TranslationService) {
      var vm = this;
      vm.loadGodos = loadGodos;
      vm.godos = [];
      vm.godosLoading = true;

      vm.status = ['godo-status-0','godo-status-1','godo-status-2'];

      vm.loadGodos();

      function loadGodos() {
          lebuApi.getGodos().getList().then(function(godos) {
              vm.godos = godos;

              for (var i = 0; i < vm.godos.length; i++) {
                vm.godos[i].duedate = new Date(vm.godos[i].duedate);
                vm.godos[i].status = vm.status[vm.godos[i].status];
              }



              vm.godosLoading = false;
          });
      }

  }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('UserCoursesController', UserCoursesController)

  /** @ngInject */
  function UserCoursesController(user, categories, userCourses) {
      var vm = this;
      vm.user = user;
      vm.categories = categories.children;
      vm.courses = userCourses;
   }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('UserContactsController', UserContactsController)

  /** @ngInject */
  function UserContactsController(user, _) {
      var vm = this;
      vm.selectedRelation = 'all';
      vm.loadUsers = loadUsers;
      vm.usersLoading = false;
      vm.loadedUsers = [];
      vm.moreUsers = moreUsers;
      vm.users = [];
      vm.pageSize = 24;
      vm.user = user;
      vm.updateUsersFilter = updateUsersFilter;
      vm.relationFilter = relationFilter;

      vm.loadUsers();

      function loadUsers() {
          vm.usersLoading = true;
          vm.loadedUsers = [];
          var usersList = vm.user.getList('contacts');
          vm.users = usersList.$object;
          usersList.then(function(users) {
              vm.loadedUsers = _.slice(users, 0, vm.pageSize);
              vm.usersLoading = false;
          });
      }
      function moreUsers() {
          vm.loadedUsers = _.concat(vm.loadedUsers, _.slice(vm.users, vm.loadedUsers.length, vm.loadedUsers.length + vm.pageSize));
      }
      function updateUsersFilter() {
          vm.loadUsers();
      }
      function relationFilter(user) {
          if (vm.selectedRelation == 'following') {
              return user.following;
          } else if (vm.selectedRelation == 'followers') {
              return user.follower;
          }
          return true;
      }
  }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('MessagesTalkController', MessagesTalkController);

    /** @ngInject */
    function MessagesTalkController($scope, viewState, talk, _, $rootScope, lebuApi, $stateParams, $wamp) {
        var vm = this;
        vm.talkId = $stateParams.talkId;
        vm.talk = talk;
        vm.reload = reload;
        vm.getDayMessages = getDayMessages;
        vm.messages = getMessages();
        vm.currentUser = $rootScope.currentUser;
        vm.message = '';
        vm.post = post;
        vm.viewState = viewState;
        vm.onTalkUpdate = onTalkUpdate;

        $wamp.subscribeOnScope($scope, 'it.lebu.chat.room.' + vm.talkId, vm.onTalkUpdate);

        function onTalkUpdate(args) {
            var jsnMessage = args[0];
            var message = angular.fromJson(jsnMessage);
            angular.extend(message, {added: true});
            vm.talk.push(message);
            vm.messages = vm.getDayMessages(vm.talk);
            lebuApi.getTalk(vm.talkId).getList();
            $scope.$apply();
        }
        function post() {
            lebuApi.getTalk(vm.talkId).customPUT({body: vm.message}).then(function() {
                vm.message = '';
                if (!viewState.hasRealtime) {
                    vm.reload();
                }
            });
        }
        function getMessages() {
            return vm.getDayMessages(vm.talk);
        }
        function reload() {
            lebuApi.getTalk(vm.talkId).getList().then(function(talk) {
                vm.messages = vm.getDayMessages(talk);
            });
        }
        function getDayMessages(talk) {
            var rv = _.groupBy(talk, function(message) {
                return moment(message.date.date, 'YYYY-MM-DD').fromNow();
            });
            return rv;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .factory('viewState', viewState);

    /** @ngInject */
    function viewState(LocalStorage, $q, $sce, ajv, $wamp, $window, $mdMedia, $state, $mdSidenav, $mdBottomSheet, $rootScope, $timeout, $mdDialog, amMoment, TranslationService, $http, $log, uiTourService, $templateCache, _, Environment, Symfony, Restangular, themeProvider, $mdTheming) {
        var onContentLoadHandler = $rootScope.$on('$viewContentLoaded', onContentLoad);
        var onStateChangeHandler = $rootScope.$on('$stateChangeStart', onStateChange);
        $rootScope.$on('$destroy', onStateChangeHandler);
        $rootScope.$on('$destroy', onContentLoadHandler);

        var service = {
            theme: Environment.DEFAULT_THEME,
            updateTheme: updateTheme,
            locale: angular.isDefined(Symfony.LOCALE) ? Symfony.LOCALE : Environment.DEFAULT_LOCALE,
            linkedinEnabled: Environment.DEFAULT_LINKEDIN_ENABLED,
            brand: null,
            slideshow: null,
            themeHome: null,
            homeDescription: null,
            modules: [],
			hiddenButtons: [],
            lockLeft: !$mdMedia('gt-md'),
            toggleMain: toggleMain,
            toggleRight: toggleRight,
            socialSelectedTab: 0,
            follows: follows,
            followedBy: followedBy,
            afterLogin: afterLogin,
            updateLocale: updateLocale,
            hasModule: hasModule,
			hasHiddenButton: hasHiddenButton,
            hasTour: false,
            hasIntro: false,
            intro: null,
            tourRunning: false,
            startHomeTutorial: startHomeTutorial,
            initHomeTutorialTheme: initHomeTutorialTheme,
            onlineUsers: [],
            isOnline: isOnline,
            notifications: [],
            unreadedMessages: 0,
            unreadedNotices: 0,
            hasRealtime: false,
            hasRealtimeUsers: false,
            wsConnection: null,
            connectWs: connectWs,
            disconnectWs: disconnectWs,
            connectWamp: connectWamp,
            validateLocalStorage: validateLocalStorage,
            resetLocalStorage: resetLocalStorage,
            theatreMode: $state.is('course.lesson')
        };
        return service;

        function updateTheme(){
            //reload the theme
            $mdTheming.generateTheme(service.theme);
        }

        function initHomeTutorialTheme() {
            $templateCache.put("tour-step-template.html",
                "<div class=\"popover-content tour-step-content\" ng-bind-html=\"tourStep.trustedContent\"></div>\n" +
                "<div md-theme=\"" + service.theme + "\" class=\"popover-navigation tour-step-navigation layout-row\">\n" +
                "    <md-button class=\"md-accent\" data-role=\"end\" ng-click=\"tour.end()\">Fine tutorial</md-button>\n" +
                "    <span class=\"flex\"></span>\n" +
                "    <md-button class=\"md-raised md-accent\" ng-if=\"tourStep.isPrev\" ng-click=\"tour.prev()\">\n" +
                "        <md-icon md-font-set=\"material-icons\" class=\"material-icons\">chevron_left</md-icon>\n" +
                    TranslationService.trans('back') + "\n" +
                "    </md-button>\n" +
                "    <md-button style=\"margin-left:0\" class=\"md-raised md-accent\" ng-if=\"tourStep.isNext\" ng-click=\"tour.next()\">\n" +
                    TranslationService.trans('forward') +"\n" +
                "        <md-icon md-font-set=\"material-icons\" class=\"material-icons\">chevron_right</md-icon>\n" +
                "    </md-button>\n" +
                "</div>\n" +
                "");
            $templateCache.put("tour-step-popup.html",
                "<div md-theme=\"" + service.theme + "\" class=\"popover tour-step\"\n" +
                "     tooltip-animation-class=\"fade\"\n" +
                "     uib-tooltip-classes\n" +
                "     ng-class=\"{in: isOpen()}\">\n" +
                "    <div class=\"arrow\"></div>\n" +
                "    <div class=\"popover-inner tour-step-inner\">\n" +
                "        <h3 class=\"popover-title tour-step-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
                "        <div\n" +
                "             uib-tooltip-template-transclude=\"originScope().tourStep.config('templateUrl') || 'tour-step-template.html'\"\n" +
                "             tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
                "    </div>\n" +
                "</div>\n" +
                "");
        }
        function onStateChange(ev, toState, toParams, fromState) {
            service.theatreMode = toState.name == 'course.lesson' || (fromState.name == 'course.lesson' && angular.isDefined(toState.data) && angular.isDefined(toState.data.dialog));
            if (!toState.$$state().includes['courseDetail', 'socialPost', 'messages']) {
                $mdDialog.hide();
            }
            $mdBottomSheet.hide();
        }
        function onContentLoad() {
            if ($state.is('community')) {
                service.socialSelectedTab = 2;
            } else {
                service.socialSelectedTab = 0;
            }
            if (angular.isUndefined($state.$current.data) || angular.isUndefined($state.$current.data.selectedTab)) {
                $window.scrollTo(0, 0);
            }
        }
        function toggleMain() {
            if ($mdMedia('max-width: 1359px')) {
                $mdSidenav('mainNav').toggle();
            } else {
                service.lockLeft = !service.lockLeft;
            }
            angular.element('slick').each(function(index, el) {
                $timeout(function() {
                    angular.element(el).slick('checkResponsive');
                }, 150);
            });
        }
        function toggleRight() {
            if (service.theatreMode) {
                $mdSidenav('lessonNav').toggle();
            } else {
                $mdSidenav('socialNav').toggle();
            }
        }
        function follows(userId) {
            if ($rootScope.currentUser) {
                for (var i = 0; i < $rootScope.currentUser.following.length; i++) {
                    if ($rootScope.currentUser.following[i] == userId) {
                        return true;
                    }
                }
            }
            return false;
        }
        function followedBy(userId) {
            if ($rootScope.currentUser) {
                for (var i = 0; i < $rootScope.currentUser.followers.length; i++) {
                    if ($rootScope.currentUser.followers[i] == userId) {
                        return true;
                    }
                }
            }
            return false;
        }
        function isOnline(userId) {
            for (var i = 0; i < service.onlineUsers.length; i++) {
                if (Number(service.onlineUsers[i]) == userId) {
                    return true;
                }
            }
            return false;
        }
        function validateLocalStorage() {
            try {
                var lsData = {
                    user: angular.fromJson(localStorage.getItem('user')),
                    tenant: angular.fromJson(localStorage.getItem('tenant')),
                    config: angular.fromJson(localStorage.getItem('config')),
                    realtime: angular.fromJson(localStorage.getItem('realtime')),
                    theme: localStorage.getItem('theme'),
                    locale: localStorage.getItem('locale'),
                    linkedinEnabled: (localStorage.getItem('linkedinEnabled') === 'true')
                };
                if (localStorage.getItem('event') != null) {
                    angular.extend(lsData, {event: angular.fromJson(localStorage.getItem('event'))});
                }
                var validate = ajv.compile(LocalStorage.SCHEMA);
                var valid = validate(lsData);
                if (!valid) {
                    service.resetLocalStorage();
                    $log.log('Local storage validation error: ' + validate.errors[0].message);
                }
                return valid;
            } catch(e) {
                service.resetLocalStorage();
                $log.log('Local storage parsing error: ' + e.message);
            }
            return false;
        }
        function afterLogin() {
            var user = angular.fromJson(localStorage.getItem('user'));
            var tenant = angular.fromJson(localStorage.getItem('tenant'));
            var config = angular.fromJson(localStorage.getItem('config'));
            var realtime = angular.fromJson(localStorage.getItem('realtime'));
            var theme = localStorage.getItem('theme');
            var locale = localStorage.getItem('locale');
            var linkedinEnabled = (localStorage.getItem('linkedinEnabled') === 'true');
            var event = angular.fromJson(localStorage.getItem('event'));

            Restangular.restangularizeElement(null, user, 'currentuser/');
            $rootScope.currentUser = user;
            $rootScope.currentTenant = tenant;
            $rootScope.pageTitle = tenant.description;


            // social sso
            service.linkedinEnabled = linkedinEnabled;

            // i18n
            service.locale = locale;

            // theme
            service.theme = theme;
            service.updateTheme();
            service.brand = {
                main: config.theme.brandUrl,
                header: config.theme.brandHeaderUrl,
                footer: config.theme.brandFooterUrl,
                navbar: config.theme.brandNavbarUrl
            };
            if (angular.isDefined(config.theme.homeRoute)){
              service.themeHome = config.theme.homeRoute;
            }

            if (angular.isDefined(config.theme.hiddenButtons)){
              service.hiddenButtons = config.theme.hiddenButtons;
            }
            if (angular.isDefined(config.theme.slideshow) && typeof(config.theme.slideshow) === "boolean") {
                service.slideshow = config.theme.slideshow;
            }
            if (angular.isDefined(config.theme.intro) && angular.isArray(config.theme.intro.resources) && config.theme.intro.resources.length > 0) {
                var resources = [];
                angular.forEach(config.theme.intro.resources, function(resource) {
                    resources.push({
                        src: $sce.trustAsResourceUrl(resource.url),
                        type: resource.type
                    });
                });
                service.intro = {
                    resources: resources,
                    hasPoster: angular.isDefined(config.theme.intro.posterUrl) && angular.isString(config.theme.intro.posterUrl) && config.theme.intro.posterUrl.length > 3,
                    posterUrl: $sce.trustAsResourceUrl(config.theme.intro.posterUrl)
                };
                service.hasIntro = true;
            }
            if (angular.isDefined(config.theme.tour) && typeof(config.theme.tour) === "boolean") {
                service.hasTour = config.theme.tour;
            }
            if (angular.isDefined(config.homeDescription)) {
                service.homeDescription = config.homeDescription;
            }


            service.modules = config.modules;
            service.initHomeTutorialTheme();

            // events
            if (event != null) {
                var notification = {
                    id: event.id,
                    title: TranslationService.trans(event.title),
                    body: $sce.trustAsHtml(event.htmlContent),
                    options: event.options,
                    type: event.type,
                    state: 'event'
                };
                service.notifications = [notification];
            } else {
                service.notifications = [];
            }

            // realtime
            service.connectWs(user.id);
            service.connectWamp();
            if (angular.isDefined(realtime) && realtime != null) {
//              service.unreadedNotifications = realtime.unreadedNotifications;
                service.unreadedMessages = realtime.unreadedMessages;
            }

            $rootScope.authenticated = true;
            return true;
        }
        function updateLocale() {
            var deferred = $q.defer();
            if (TranslationService.locale != service.locale) {
                amMoment.changeLocale(service.locale);
                var locale = Environment.SUPPORTED_LOCALES.indexOf(service.locale) != -1
                    ? service.locale
                    : Environment.DEFAULT_LOCALE;
                $http.get('/translations/messages.json?locales=' + locale).then(function(messages) {
                    TranslationService.reset();
                    TranslationService.fromJSON(messages.data);
                    TranslationService.locale = service.locale;
                    deferred.resolve();
                }, function(response) {
                    $log.log("There was an error: " + response);
                    deferred.reject(response.statusText);
                });
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        }
        function connectWs(userId) {
            try {
                service.wsConnection = new WebSocket(Symfony.WEBSOCKET_URL);
                service.wsConnection.onopen = function() {
                    service.hasRealtimeUsers = true;
                    service.wsConnection.send(userId);
                };
                service.wsConnection.onclose = function() {
                    service.hasRealtimeUsers = false;
                    if ($rootScope.authenticated){
                        $timeout(function() {
                            service.connectWs(userId);
                        }, 10000);
                    }
                };
                service.wsConnection.onmessage = function(e) {
                    service.onlineUsers = angular.fromJson(e.data);
                    $rootScope.$broadcast('social:onlineusers:update');
                    if (!$rootScope.$$phase) {
                        $rootScope.$apply();
                    }
                };
                service.wsConnection.onerror = function(e) {
                    service.hasRealtimeUsers = false;
                    $log.log('WebSocket error: ' + e.message);
                };
            } catch(e) {
                service.hasRealtimeUsers = false;
                $log.log('WebSocket error: ' + e.message);
            }
        }
        function disconnectWs() {
            try {
                service.wsConnection.close();
                $log.log('WebSocket closed ' + e.message);
            } catch(e) {
                service.hasRealtimeUsers = false;
                $log.log('WebSocket error: ' + e.message);
            }
        }
        function resetLocalStorage() {
            var homeTutorialDone = localStorage.getItem('homeTutorialDone');
            var introDone = localStorage.getItem('introDone');
            var videogularVolume = localStorage.getItem('videogularVolume');
            localStorage.clear();
            if (homeTutorialDone != null) {
                localStorage.setItem('homeTutorialDone', homeTutorialDone);
            }
            if (introDone != null) {
                localStorage.setItem('introDone', introDone);
            }
            if (videogularVolume != null) {
                localStorage.setItem('videogularVolume', videogularVolume);
            }
        }
        function connectWamp() {
            if ($wamp.connection.isConnected) return;
            var onWampOpenHandler = $rootScope.$on("$wamp.open", function (event, session) {
                service.hasRealtime = true;
                $log.log('WAMP connection opened: ' + session);
            });
            $rootScope.$on('$destroy', onWampOpenHandler);
            var onWampCloseHandler = $rootScope.$on("$wamp.close", function (event, data) {
                service.hasRealtime = false;
                $log.log('WAMP connection clesed: ' + data.reason + ' - ' + data.details);
            });
            $rootScope.$on('$destroy', onWampCloseHandler);
            try {
                $wamp.open();
            } catch(e) {
                service.hasRealtime = false;
                $log.log('Wamp error: ' + e);
            }
        }
        function hasModule(id) {
            return service.modules.indexOf(id) != -1;
        }

        function hasHiddenButton(id) {
            return service.hiddenButtons.indexOf(id) != -1;
        }
        function startHomeTutorial() {
            if (service.hasTour && $mdMedia('min-width: 1360px')) {
                var tour = uiTourService.getTour();
                tour.on('ended', function() {
                    service.tourRunning = false;
                    localStorage.setItem('homeTutorialDone', true);
                    if (service.hasIntro && !localStorage.getItem('introDone')) {
                        $state.go('intro');
                    }
                });
                tour.on('started', function() {
                    service.tourRunning = true;
                });
                tour.start();
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbVideoResource', lbVideoResource);

    /** @ngInject */
    function lbVideoResource() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/videoResource/videoResource.html',
            controller: VideoResourceController,
            controllerAs: 'videoResource',
            scope: true,
            bindToController: {
                course: '<',
                lesson: '<'
            }
        };
        return directive;

        /** @ngInject */
        function VideoResourceController($rootScope, $state, $scope, $mdBottomSheet) {
            var vm = this;
            vm.theme = '/assets/css/videogular.min.css';
            vm.onComplete = onComplete;
            vm.videoApi = null;
            vm.playerReady = playerReady;
            vm.nextLesson = nextLesson;
            vm.completed = false;
            vm.videoResources = vm.lesson.getVideoResources();
            vm.currentQualitySource = vm.videoResources[0];

            var videoReplayHandler = $rootScope.$on('video:replay', replayVideo);
            $scope.$on('$destroy', videoReplayHandler);

            function playerReady(videoApi) {
                vm.videoApi = videoApi;
            }
            function replayVideo() {
                $mdBottomSheet.hide();
                vm.videoApi.play();
            }
            function nextLesson(ev) {
                if (!vm.completed || vm.course.nextLesson(vm.lesson.id) == null) {
                    ev.preventDefault();
                } else {
                    $state.go('course.lesson', {
                        courseId: vm.course.id,
                        lessonId: vm.course.nextLesson(vm.lesson.id).id
                    })
                }
            }
            function onComplete() {
                vm.completed = true;
                if (vm.videoApi.isFullScreen) {
                    vm.videoApi.toggleFullScreen();
                }
                $scope.$emit('video:complete', {lesson: vm.lesson});
            }
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('VideoConfirmController', VideoConfirmController);


  /** @ngInject */
  function VideoConfirmController($scope, $stateParams, nextLesson) {
      var vm = this;
      vm.courseId = $stateParams.courseId;
      vm.nextLesson = nextLesson;
      vm.replayLesson = replayLesson;
      
      function replayLesson() {
          $scope.$emit('video:replay');
      }
   }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbUserTimeChart', lbUserTimeChart);

    /** @ngInject */
    function lbUserTimeChart() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/userTimeChart/userTimeChart.html',
            controller: UserTimeChartController,
            controllerAs: 'userTimeChart',
            scope: true,
            bindToController: {
                data: '<',
                labels: '<',
                series: '<',
                total: '<'
            }
        };
        return directive;

        /** @ngInject */
        function UserTimeChartController() {
            var vm = this;
            vm.options = getOptions();
            
            function getOptions() {
                return {
                    maintainAspectRatio: false,
                    scaleIntegersOnly: true,
                    pointDotRadius: 5,
                    scaleBeginAtZero: true,
                    tooltipTemplate: '<%if (label){%><%=label%>: <%}%><%= moment.duration(value, "minutes").asMinutes() %> minuti'
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbUserList', lbUserList);

    /** @ngInject */
    function lbUserList() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/userList/userList.html',
            controller: UserListController,
            controllerAs: 'userList',
            scope: true,
            bindToController: {
                users: '<'
            }
        };
        return directive;

        /** @ngInject */
        function UserListController() {
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbUserCoursesTable', lbUserCoursesTable);

    /** @ngInject */
    function lbUserCoursesTable() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/userCoursesTable/userCoursesTable.html',
            controller: UserCoursesTableController,
            controllerAs: 'userCoursesTable',
            scope: true,
            bindToController: {
                data: '<'
            }
        };
        return directive;

        /** @ngInject */
        function UserCoursesTableController(_, TranslationService) {
            var vm = this;
            vm.formatTime = formatTime;
            vm.getTimePercent = getTimePercent;
            
            function formatTime(time) {
                return moment.duration(time, 'minutes').asMinutes() + ' ' + TranslationService.trans('minutes') ;
            }
            function getTimePercent(time) {
                var totalTime = _.sumBy(vm.data, function(item) { return Number(item.time); });
                return Math.round(100 * time / totalTime);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbUserChart', lbUserChart);

    /** @ngInject */
    function lbUserChart() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/userChart/userChart.html',
            controller: UserChartController,
            controllerAs: 'userChart',
            scope: true,
            bindToController: {
                data: '<',
                labels: '<'
            }
        };
        return directive;

        /** @ngInject */
        function UserChartController() {
            var vm = this;
            vm.options = getOptions();
            
            function getOptions() {
                return {
                    responsive: false,
                    maintainAspectRatio: true,
                    segmentStrokeWidth: 1
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbUserCategoryChart', lbUserCategoryChart);

    /** @ngInject */
    function lbUserCategoryChart() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/userCategoryChart/userCategoryChart.html',
            controller: UserCategoryChartController,
            controllerAs: 'userCategoryChart',
            scope: true,
            bindToController: {
                data: '<',
                colours: '<',
                labels: '<'
            }
        };
        return directive;

        /** @ngInject */
        function UserCategoryChartController() {
            var vm = this;
            vm.options = getOptions();
            
            function getOptions() {
                return {
                    responsive: false,
                    maintainAspectRatio: true,
                    segmentStrokeWidth: 1,
                    tooltipTemplate: '<%if (label){%><%=label%>: <%}%><%= moment.duration(value, "minutes").asMinutes() %> minuti'
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbUserButton', lbUserButton);

    /** @ngInject */
    function lbUserButton() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/userButton/userButton.html',
            controller: UserButtonController,
            controllerAs: 'userButton',
            scope: true,
            bindToController: {
                user: '<',
                size: '@'
            }
        };
        return directive;

        /** @ngInject */
        function UserButtonController(viewState, lebuApi, $rootScope, toastr,TranslationService) {
            var vm = this;
            vm.follow = follow;
            vm.unfollow = unfollow;
            vm.viewState = viewState;
            vm.currentUser = $rootScope.currentUser;
            vm.isOpen = false;
            vm.open = open;
            vm.close = close;

            function follow() {
                lebuApi.getUser(vm.user.id).post('follow').then(function() {
                    lebuApi.getCurrentUser().get().then(function(currentUser) {
                        vm.currentUser = currentUser.user;
                        toastr.success(TranslationService.trans('among-your-following', {name: vm.user.name}));
                    });
                });
            }
            function unfollow() {
                lebuApi.getUser(vm.user.id).customDELETE('follow').then(function() {
                    lebuApi.getCurrentUser().get().then(function(currentUser) {
                        vm.currentUser = currentUser.user;
                        toastr.success(TranslationService.trans('no-among-your-following', {name: vm.user.name}));
                    });
                });
            }
            function open(ev) {
                var smoothableEl = $(ev.currentTarget).parent('.user-button').parent().next('.smoothable');
                smoothableEl.addClass('smoothed');
                vm.isOpen = true;
            }
            function close(ev) {
                var smoothableEl = $(ev.currentTarget).parent('.user-button').parent().next('.smoothable');
                smoothableEl.removeClass('smoothed');
                vm.isOpen = false;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbTextResource', lbTextResource);

    /** @ngInject */
    function lbTextResource() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/textResource/textResource.html',
            controller: TextResourceController,
            controllerAs: 'textResource',
            scope: true,
            bindToController: {
                text: '<',
                lesson: '<'
            }
        };
        return directive;

        /** @ngInject */
        function TextResourceController($scope, $sce) {
            var vm = this;
            vm.text=$sce.trustAsHtml(vm.text);
            $scope.$emit('lesson:complete', {lesson: vm.lesson});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbSocialBar', lbSocialBar);

    /** @ngInject */
    function lbSocialBar() {
        var directive = {
            restrict: 'EA',
            templateUrl: './app/components/socialBar/socialBar.html',
            controller: SocialBarController,
            controllerAs: 'socialBar'
        };
        return directive;

        /** @ngInject */
        function SocialBarController(Restangular, viewState, $rootScope, lebuApi, _, $scope, Optimization, $wamp) {
            var vm = this;
            vm.viewState = viewState;
            vm.currentUser = $rootScope.currentUser;
            vm.selectedSource = 0;
            vm.pageSize = 10;
            vm.userRelationFilter = userRelationFilter;
            vm.selectedUserRelation = 'all';
            vm.users = [];
            vm.loadedUsers = [];
            vm.loadUsers = loadUsers;
            vm.moreUsers = moreUsers;
            vm.ranking = [];
            vm.rankingRelationFilter = rankingRelationFilter;
            vm.selectedRankingRelation = 'all';
            vm.loadedRanking = [];
            vm.loadRanking = loadRanking;
            vm.moreRanking = moreRanking;
            vm.loadPosts = loadPosts;
            vm.posts = [];
            vm.updateUsersFilter = updateUsersFilter;
            vm.updateRankingFilter = updateRankingFilter;
            vm.onPostsUpdate = onPostsUpdate;
            vm.orderUsers = orderUsers;
            vm.onOnlineUsersUpdate = onOnlineUsersUpdate;
            vm.postsLoading = false;
            vm.usersLoading = false;
            vm.rankingLoading = false;
            vm.tourRunning = false;

            var onSocialPostUpdatedHandler = $rootScope.$on('social:post:updated', vm.loadPosts);
            $scope.$on('$destroy', onSocialPostUpdatedHandler);
            var onOnlineUsersUpdateHandler = $rootScope.$on('social:onlineusers:update', vm.onOnlineUsersUpdate);
            $scope.$on('$destroy', onOnlineUsersUpdateHandler);

            $wamp.subscribeOnScope($scope, 'it.lebu.user.' + vm.currentUser.id + '.post', vm.onPostsUpdate);

            function onOnlineUsersUpdate() {
                vm.users = _.sortBy(vm.users, vm.orderUsers);
                vm.loadedUsers = _.slice(vm.users, 0, vm.pageSize);
            }
            function orderUsers(user) {
                return vm.viewState.isOnline(user.id) ? -1 : user.id;
            }
            function onPostsUpdate(args) {
                var post = angular.fromJson(args[0]);
                post = Restangular.restangularizeElement(null, post, 'posts/');
                angular.extend(post, {added: true});
                vm.posts.unshift(post);
                $rootScope.$broadcast('social:post:add', {post: post});
            }
            function loadUsers() {
                vm.usersLoading = true;
                vm.loadedUsers = [];
                var usersList = lebuApi.getUsers().getList();
                vm.users = usersList.$object;
                usersList.then(function(users) {
                    users = _.sortBy(users, vm.orderUsers);
                    vm.loadedUsers = _.slice(users, 0, vm.pageSize);
                    vm.usersLoading = false;
                });
            }
            function moreUsers() {
                vm.loadedUsers = _.concat(vm.loadedUsers, _.slice(vm.users, vm.loadedUsers.length, vm.loadedUsers.length + vm.pageSize));
            }
            function loadRanking() {
                vm.rankingLoading = true;
                vm.loadedRanking = [];
                var rankingList = lebuApi.getRanking().getList();
                vm.ranking = rankingList.$object;
                rankingList.then(function(ranking) {
                    vm.loadedRanking = _.slice(ranking, 0, vm.pageSize);
                    vm.rankingLoading = false;
                });
            }
            function moreRanking() {
                vm.loadedRanking = _.concat(vm.loadedRanking, _.slice(vm.ranking, vm.loadedRanking.length, vm.loadedRanking.length + vm.pageSize));
            }
            function userRelationFilter(user) {
                if (angular.isDefined(user)) {
                    if (vm.selectedUserRelation == 'following') {
                        return vm.viewState.follows(user.id);
                    } else if (vm.selectedUserRelation == 'followers') {
                        return vm.viewState.followedBy(user.id);
                    }
                }
                return true;
            }
            function rankingRelationFilter(user) {
                if (angular.isDefined(user)) {
                    if (vm.selectedRankingRelation == 'following') {
                        return vm.viewState.follows(user.id);
                    } else if (vm.selectedRankingRelation == 'followers') {
                        return vm.viewState.followedBy(user.id);
                    }
                }
                return true;
            }
            function loadPosts() {
                if (viewState.socialSelectedTab == 0) {
                    vm.postsLoading = true;
                    var params = vm.selectedSource == 0
                        ? {limit: Optimization.POSTS_PREVIEW_PAGE_SIZE}
                        : {limit: Optimization.POSTS_PREVIEW_PAGE_SIZE, filter: 'following'};
                    vm.posts = [];
                    lebuApi.getPosts().getList(params).then(function(posts) {
                        vm.posts = posts;
                        vm.postsLoading = false;
                    });
                }
            }
            function updateUsersFilter() {
                vm.loadUsers();
            }
            function updateRankingFilter() {
                vm.loadRanking();
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbSlidingNavBar', lbSlidingNavBar);

    /** @ngInject */
    function lbSlidingNavBar() {
        var directive = {
            restrict: 'EA',
            templateUrl: './app/components/slidingNavBar/slidingNavBar.html',
            controller: SlidingNavBarController,
            controllerAs: 'slidingNavBar',
            bindToController: {
                lastViewedCourse: '<'
            }
        };
        return directive;

        /** @ngInject */
        function SlidingNavBarController(viewState) {
            var vm = this;
            vm.viewState = viewState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbReviewsList', lbReviewsList);

    /** @ngInject */
    function lbReviewsList() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/reviewsList/reviewsList.html',
            controller: ReviewsListController,
            controllerAs: 'reviewsList',
            scope: true,
            bindToController: {
                reviews: '<'
            }
        };
        return directive;

        /** @ngInject */
        function ReviewsListController() {
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbQuizPlayer', lbQuizPlayer);

    /** @ngInject */
    function lbQuizPlayer() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/quizPlayer/quizPlayer.html',
            controller: QuizPlayerController,
            controllerAs: 'quizPlayer',
            scope: true,
            bindToController: {
                course: '<',
                lesson: '='
            }
        };
        return directive;

        /** @ngInject */
        function QuizPlayerController($scope, $rootScope, viewState, $mdBottomSheet) {
            var vm = this;
            vm.viewState = viewState;
            vm.quiz = vm.lesson.quiz;
            vm.solution = null;
            vm.openConfirm = openConfirm;
            vm.getProgress = getProgress;
            vm.showSolutions = showSolutions;
            vm.replay = replay;
            vm.result = null;

            var solutionReadyHandler = $rootScope.$on('quiz:solution:ready', getSolution);
            var quizConfirmHandler = $rootScope.$on('quiz:confirm', sendSolution);
            var quizCancelHandler = $rootScope.$on('quiz:cancel', cancelSolution);
            $scope.$on('$destroy', solutionReadyHandler);
            $scope.$on('$destroy', quizConfirmHandler);
            $scope.$on('$destroy', quizCancelHandler);

            function openConfirm() {
                $mdBottomSheet.show({
                    templateUrl: './app/components/quizPlayer/quizConfirm/quizConfirm.html',
                    disableParentScroll: false,
                    controller: 'QuizConfirmController',
                    controllerAs: 'quizConfirm',
                    clickOutsideToClose: true,
                    parent: angular.element('.quiz-player')
                });
            }
            function cancelSolution() {
                vm.solution = null;
                $mdBottomSheet.hide();
            }
            function getSolution(ev, params) {
                vm.solution = params.solution;
                openConfirm();
            }
            function getProgress() {
                return Math.round((vm.quiz.index * 100) / vm.lesson.quizCounter);
            }
            function sendSolution() {
                vm.lesson.one('quiz/').post(vm.quiz.id, {answers: vm.solution}).then(function(response) {
                    if (response.quiz != null) {
                        vm.quiz = response.quiz;
                        vm.result = null;
                        $scope.$broadcast('quiz:reset');
                    } else {
                        vm.quiz = undefined;
                        var currentLesson = vm.course.getLesson(vm.lesson.id);
                        if (!currentLesson.completed) {
                            currentLesson.completed = response.quizResult.solved;
                        }
                        if (response.quizResult != null) {
                            vm.result = response.quizResult;
                        }
                    }
                });
                $mdBottomSheet.hide();
            }
            function replay() {
                vm.lesson = vm.lesson.get().$object;
            }
            function showSolutions() {
                $scope.$broadcast('quiz:solution');
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbPostPreview', lbPostPreview);

    /** @ngInject */
    function lbPostPreview() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/postPreview/postPreview.html',
            controller: PostPreviewController,
            controllerAs: 'postPreview',
            scope: true,
            bindToController: {
                post: '<'
            }
        };
        return directive;

        /** @ngInject */
        function PostPreviewController($sce, viewState) {
            var vm = this;
            vm.getYTPreview = getYTPreview;
            vm.viewState = viewState;
            
            function getYTPreview(embedUrl) {
                if (embedUrl) {
                    var url = $sce.getTrustedUrl(embedUrl);
                    var found = url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i);
                    if (angular.isDefined(found) && found != null) {
                        return 'http://img.youtube.com/vi/' + found[1] + '/0.jpg';
                    }
                }
                return embedUrl;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbPostCard', lbPostCard);

    /** @ngInject */
    function lbPostCard() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/postCard/postCard.html',
            controller: PostCardController,
            controllerAs: 'postCard',
            scope: true,
            bindToController: {
                post: '<'
            }
        };
        return directive;

        /** @ngInject */
        function PostCardController($mdDialog, $scope, $rootScope, $timeout, toastr, lebuApi, viewState,TranslationService) {
            var vm = this;
            vm.message = '';
            vm.like = like;
            vm.unlike = unlike;
            vm.comment = comment;
            vm.reloadMasonry = reloadMasonry;
            vm.currentUser = $rootScope.currentUser;
            vm.videoPlayerTheme = '/assets/css/videogular.min.css';
            vm.videoPlayerApi = null;
            vm.onVideoPlayerReady = onVideoPlayerReady;
            vm.deletePost = deletePost;
            vm.viewState = viewState;

            $scope.$watch(angular.bind(vm, function() {
                return vm.post.formOpened;
            }), function() {
                if (!vm.post.formOpened) {
                    vm.message = '';
                }
                vm.reloadMasonry();
            });
            $scope.$watch(angular.bind(vm, function() {
                return vm.post.commentsOpened;
            }), vm.reloadMasonry);

            function onVideoPlayerReady(videoApi) {
                vm.videoPlayerApi = videoApi;
            }
            function reloadMasonry() {
                $timeout(function() {
                    angular.element('#stories').masonry('layout');
                }, 100);
            }
            function like() {
                lebuApi.getPost(vm.post.id).post('like').then(function(post) {
                    toastr.success(TranslationService.trans('like-was-registered'));
                    vm.post.liked = post.liked;
                    vm.post.likes = post.likes;
                });
            }
            function unlike() {
                lebuApi.getPost(vm.post.id).customDELETE('like').then(function(post) {
                    toastr.success(TranslationService.trans('like-was-removed'));
                    vm.post.liked = post.liked;
                    vm.post.likes = post.likes;
                });
            }
            function comment() {
                lebuApi.getPost(vm.post.id).post('comment', {comment: vm.message}).then(function(post) {
                    toastr.success(TranslationService.trans('comment-inserted-successfully'));
                    vm.message = '';
                    vm.post.comments = post.comments;
                    vm.post.formOpened = vm.post.commentsOpened = false;
                });
            }
            function deletePost(ev) {
                var confirm = $mdDialog.confirm()
                    .title(TranslationService.trans('delete-post-confirm'))
                    .ariaLabel(TranslationService.trans('delete-post-confirm'))
                    .targetEvent(ev)
                    .ok(TranslationService.trans('ok'))
                    .cancel(TranslationService.trans('cancel'));
                $mdDialog.show(confirm).then(function() {
                    vm.post.remove().then(function() {
                        toastr.success(TranslationService.trans('delete-post-success'));
                        $rootScope.$broadcast('social:post:updated');
                        $mdDialog.hide();
                    });
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbPostAttachment', lbPostAttachment);

    /** @ngInject */
    function lbPostAttachment() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/postAttachment/postAttachment.html',
            controller: PostAttachmentController,
            controllerAs: 'postAttachment',
            scope: true,
            bindToController: {
                exclude: '<',
                defaultType: '<',
                model: '='
            }
        };
        return directive;

        /** @ngInject */
        function PostAttachmentController($log, $scope, Environment, lebuApi, $location) {
            var vm = this;
            vm.form = {
                attachedCourse: null,
                attachedLink: '',
                attachedVideo: null,
                attachedYTVideo: '',
                attachedImage: null,
                attachedDocument: null
            };
            vm.previewUrl = null;
            vm.previewTitle = null;
            vm.previewDescription = null;
            vm.previewImage = null;
            vm.selectedForm = null;
            vm.type = 1;
            vm.videoType = 'youtube';
            vm.attachmentChange = attachmentChange;
            vm.updatePreview = updatePreview;
            vm.getYoutubeEmbedUrl = getYoutubeEmbedUrl;
            vm.selectForm = selectForm;
            vm.searchText = '';
            vm.searchCourse = searchCourse;

            $scope.$watch(angular.bind(vm, function() {
                return vm.previewUrl;
            }), updatePreview);
            $scope.$watchCollection(angular.bind(vm, function() {
                return vm.form;
            }), updateModel);

            function searchCourse() {
                return lebuApi.getSearch().all('content').getList({q: vm.searchText}).$object;
            }
            function selectForm(form, type) {
                vm.form = {
                    attachedCourse: null,
                    attachedLink: '',
                    attachedVideo: null,
                    attachedYTVideo: '',
                    attachedImage: null,
                    attachedDocument: null
                };
                vm.previewUrl = null;
                vm.selectedForm = form;
                vm.videoType = 'youtube';
                vm.type = type;
            }
            function updatePreview() {
                if (vm.previewUrl != null) {
                    lebuApi.getOg().get({url: vm.previewUrl}).then(function(preview) {
                        if (preview) {
                            vm.previewTitle = preview['og:title'];
                            vm.previewDescription = preview['og:description'];
                            vm.previewImage = preview['og:image'];
                        }
                    });
                } else {
                    vm.previewTitle = vm.previewDescription = vm.previewImage = null;
                }
            }
            function attachmentChange() {
                if (vm.type == 1) {
                    vm.previewUrl = $location.protocol() + '://' + $location.host() + Environment.PREVIEW_URL + vm.form.attachedCourse.id;
                } else if (vm.type == 2 && vm.form.attachedLink != '' && vm.selectedForm.attachedLink.$valid) {
                    vm.previewUrl = vm.form.attachedLink;
                } else if (vm.type == 3) {
                    if (vm.videoType == 'youtube') {
                        if (vm.form.attachedYTVideo != '' && vm.selectedForm.attachedYTVideo.$valid) {
                            vm.previewUrl = vm.form.attachedYTVideo;
                        }
                    } else {
                        vm.previewUrl = null;
                    }
                } else {
                    vm.previewUrl = null;
                }
            }
            function getYoutubeEmbedUrl(watchUrl) {
                var found = watchUrl.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i);
                if (angular.isDefined(found) && found != null) {
                    return 'https://www.youtube.com/embed/' + found[1];
                }
                return watchUrl;
            }
            function updateModel() {
                var model = {type: 0, resourceLink: ''};
                if (vm.type == 1 && vm.form.attachedCourse != null) {
                    model.type = 1;
                    model.resourceLink = Environment.PREVIEW_URL + vm.form.attachedCourse.id;
                } else if (vm.type == 2 && vm.form.attachedLink != '' && vm.selectedForm.attachedLink.$valid) {
                    model.type = 2;
                    model.resourceLink = vm.form.attachedLink;
                } else if (vm.type == 3) {
                    if (vm.videoType == 'youtube') {
                        if (vm.form.attachedYTVideo != '' && vm.selectedForm.attachedYTVideo.$valid) {
                            model.type = 3;
                            model.resourceLink = vm.getYoutubeEmbedUrl(vm.form.attachedYTVideo);
                        }
                    } else {
                        if (vm.form.attachedVideo != '' && vm.selectedForm.attachedVideo.$valid) {
                            model.type = 7;
                            model.file = vm.form.attachedVideo;
                        }
                    }
                } else if (vm.type == 4 && vm.form.attachedImage != '' && vm.selectedForm.attachedImage.$valid) {
                    model.type = 4;
                    model.file = vm.form.attachedImage;
                } else if (vm.type == 5 && vm.form.attachedDocument != '' && vm.selectedForm.attachedDocument.$valid) {
                    model.type = 5;
                    model.file = vm.form.attachedDocument;
                }
                vm.model = model;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbPlaylistCard', lbPlaylistCard);

    /** @ngInject */
    function lbPlaylistCard() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/playlistCard/playlistCard.html',
            controller: PlaylistCardController,
            controllerAs: 'playlistCard',
            scope: true,
            bindToController: {
                playlist: '<'
            }
        };
        return directive;

        /** @ngInject */
        function PlaylistCardController() {
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('NotificationsController', NotificationsController);

    /** @ngInject */
    function NotificationsController(mdPanelRef, $state, viewState) {
        var vm = this;
        vm.panel = mdPanelRef;
        vm.viewState = viewState;
        vm.go = go;

        function go(notification) {
            if(notification.state == "event"){
                $state.go(notification.state).then(function() {
                    vm.panel && vm.panel.close();
                });
            }
            if(notification.state == "postDetail"){
                $state.go(notification.state, {postId: notification.id});
            }
            if(notification.state == "user"){
                $state.go(notification.state, {userId: notification.id});
            }
            if(notification.state == "course.lesson"){
                $state.go(notification.state, {courseId: notification.id.course, lessonId: notification.id.lesson});
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbNewsCard', lbNewsCard);

    /** @ngInject */
    function lbNewsCard() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/newsCard/newsCard.html',
            controller: NewsCardController,
            controllerAs: 'newsCard',
            scope: true,
            bindToController: {
                post: '<'
            }
        };
        return directive;

        /** @ngInject */
        function NewsCardController($scope, $rootScope, $timeout, toastr, lebuApi, viewState,TranslationService) {
            var vm = this;
            vm.message = '';
            vm.like = like;
            vm.unlike = unlike;
            vm.reloadMasonry = reloadMasonry;
            vm.currentUser = $rootScope.currentUser;
            vm.videoPlayerTheme = '/assets/css/videogular.min.css';
            vm.videoPlayerApi = null;
            vm.onVideoPlayerReady = onVideoPlayerReady;
            vm.viewState = viewState;

            $scope.$watch(angular.bind(vm, function() {
                return vm.post.commentsOpened;
            }), vm.reloadMasonry);

            function onVideoPlayerReady(videoApi) {
                vm.videoPlayerApi = videoApi;
            }
            function reloadMasonry() {
                $timeout(function() {
                    angular.element('#stories').masonry('layout');
                }, 100);
            }
            function like() {
                lebuApi.getPost(vm.post.id).post('like').then(function(post) {
                    toastr.success(TranslationService.trans('like-was-registered'));
                    vm.post.liked = post.liked;
                    vm.post.likes = post.likes;
                });
            }
            function unlike() {
                lebuApi.getPost(vm.post.id).customDELETE('like').then(function(post) {
                    toastr.success(TranslationService.trans('like-was-removed'));
                    vm.post.liked = post.liked;
                    vm.post.likes = post.likes;
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbNavBar', lbNavBar);

    /** @ngInject */
    function lbNavBar() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/navBar/navBar.html',
            controller: NavBarController,
            controllerAs: 'navBar'
        };
        return directive;

        /** @ngInject */
        function NavBarController(viewState, $rootScope) {
            var vm = this;
            vm.viewState = viewState;
            vm.currentUser = $rootScope.currentUser;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .factory('_', lodash);

    /** @ngInject */
    function lodash($window) {
        return $window._;
    }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('LessonsThumbsController', LessonsThumbsController);


  /** @ngInject */
  function LessonsThumbsController(lessons, $stateParams, selectedIndex) {
      var vm = this;
      vm.lessons = lessons;
      vm.courseId = $stateParams.courseId;
      vm.slickConfig = getSlickConfig();
      
      function getSlickConfig() {
          return {
              method: {},
              dots: false,
              speed: 300,
              infinite: false,
              slidesToShow: 5,
              slidesToScroll: 5,
              swipe: false,
              nextArrow: '<button class="md-fab md-button md-raised md-mini next-button"><md-icon class="material-icons">chevron_right</md-icon></button>',
              prevArrow: '<button class="md-fab md-button md-raised md-mini prev-button"><md-icon class="material-icons">chevron_left</md-icon></button>',
              event: {
                  init: function (event, slick) {
                      slick.slickGoTo(selectedIndex);
                  }
              },
              respondTo: 'slider',
              responsive: [
                  {
                      breakpoint: 850,
                      settings: {
                          slidesToShow: 4,
                          slidesToScroll: 4
                      }
                  },
                  {
                      breakpoint: 600,
                      settings: {
                          swipe: true,
                          slidesToShow: 3,
                          slidesToScroll: 3
                      }
                  },
                  {
                      breakpoint: 480,
                      settings: {
                          swipe: true,
                          slidesToShow: 2,
                          slidesToScroll: 2
                      }
                  },
                  {
                      breakpoint: 340,
                      settings: {
                          swipe: true,
                          slidesToShow: 1,
                          slidesToScroll: 1
                      }
                  }
              ]
          };
      }
   }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbLessonsNav', lbLessonsNav);

    /** @ngInject */
    function lbLessonsNav() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/lessonsNav/lessonsNav.html',
            controller: LessonsNavController,
            controllerAs: 'lessonsNav',
            scope: true,
            bindToController: {
                course: '<',
                lesson: '<'
            }
        };
        return directive;

        /** @ngInject */
        function LessonsNavController($mdBottomSheet, $state, viewState) {
            var vm = this;
            vm.lessonsThumbsShown = false;
            vm.showLessonsThumbs = showLessonsThumbs;
            vm.prevLesson = prevLesson;
            vm.nextLesson = nextLesson;
            vm.isFirstLesson = isFirstLesson;
            vm.isLastLesson = isLastLesson;
            vm.viewState = viewState;

            function showLessonsThumbs($event) {
                if (!vm.lessonsThumbsShown) {
                    $mdBottomSheet.show({
                        templateUrl: './app/components/lessonsThumbs/lessonsThumbs.html',
                        controller: 'LessonsThumbsController',
                        controllerAs: 'lessonsThumbs',
                        locals: {
                            lessons: vm.course.lessons,
                            selectedIndex: vm.course.getLessonIndex(vm.lesson.id)
                        },
                        disableParentScroll: false,
                        targetEvent: $event,
                        parent: angular.element('.resource-container')
                    }).finally(function() {
                        vm.lessonsThumbsShown = false;
                    });
                    vm.lessonsThumbsShown = true;
                } else {
                    $mdBottomSheet.hide();
                }
            }
            function prevLesson() {
                $state.go('course.lesson', {
                    courseId: vm.course.id,
                    lessonId: vm.course.prevLesson(vm.lesson.id).id
                });
            }
            function nextLesson() {
                $state.go('course.lesson', {
                    courseId: vm.course.id,
                    lessonId: vm.course.nextLesson(vm.lesson.id).id
                });
            }
            function isFirstLesson() {
                return vm.course.prevLesson(vm.lesson.id) == null;
            }
            function isLastLesson() {
                return vm.course.nextLesson(vm.lesson.id) == null;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbLessonsList', lbLessonsList);

    /** @ngInject */
    function lbLessonsList() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/lessonsList/lessonsList.html',
            controller: LessonsListController,
            controllerAs: 'lessonsList',
            scope: true,
            bindToController: {
                lessons: '<'
            }
        };
        return directive;

        /** @ngInject */
        function LessonsListController() {
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbLessonBar', lbLessonBar);

    /** @ngInject */
    function lbLessonBar() {
        var directive = {
            restrict: 'EA',
            templateUrl: './app/components/lessonBar/lessonBar.html',
            controller: LessonBarController,
            controllerAs: 'lessonBar'
        };
        return directive;

        /** @ngInject */
        function LessonBarController($stateParams, Restangular, viewState, $rootScope, lebuApi, _, $scope, Optimization, $wamp) {
            var vm = this;
            vm.courseId = $stateParams.courseId;
            vm.lessonId = $stateParams.lessonId;
            vm.viewState = viewState;
            vm.currentUser = $rootScope.currentUser;
            vm.selectedSource = 0;
            vm.pageSize = 10;
            vm.userRelationFilter = userRelationFilter;
            vm.selectedUserRelation = 'all';
            vm.users = [];
            vm.loadedUsers = [];
            vm.loadUsers = loadUsers;
            vm.moreUsers = moreUsers;
            vm.loadPosts = loadPosts;
            vm.posts = [];
            vm.updateUsersFilter = updateUsersFilter;
            vm.onPostsUpdate = onPostsUpdate;
            vm.orderUsers = orderUsers;
            vm.onOnlineUsersUpdate = onOnlineUsersUpdate;
            vm.postsLoading = false;
            vm.usersLoading = false;
            vm.onLessonEnter = onLessonEnter;
            vm.selectedTab = 0;
            vm.lessonChannel = null;

            var onOnlineUsersUpdateHandler = $rootScope.$on('social:onlineusers:update', vm.onOnlineUsersUpdate);
            $scope.$on('$destroy', onOnlineUsersUpdateHandler);
            var onLessonEnterHandler = $rootScope.$on('lesson:enter', onLessonEnter);
            $scope.$on('$destroy', onLessonEnterHandler);
            $scope.$on('$destroy', function() {
                $wamp.unsubscribe(vm.lessonChannel.$$state.value);
            });

            vm.lessonChannel = $wamp.subscribe('it.lebu.lesson.' + vm.lessonId, vm.onPostsUpdate);

            function onLessonEnter(ev, params) {
                vm.courseId = params.course.id;
                vm.lessonId = params.lesson.id;
                $wamp.unsubscribe(vm.lessonChannel.$$state.value);
                vm.lessonChannel = $wamp.subscribe('it.lebu.lesson.' + vm.lessonId, vm.onPostsUpdate);
                if (vm.selectedTab == 0) {
                    vm.loadPosts();
                } else if (vm.selectedTab == 1) {
                    vm.loadUsers();
                }
            }
            function onOnlineUsersUpdate() {
                vm.users = _.sortBy(vm.users, vm.orderUsers);
                vm.loadedUsers = _.slice(vm.users, 0, vm.pageSize);
            }
            function orderUsers(user) {
                return vm.viewState.isOnline(user.id) ? -1 : user.id;
            }
            function onPostsUpdate(args) {
                if (vm.selectedTab == 0) {
                    var post = angular.fromJson(args[0]);
                    post = Restangular.restangularizeElement(null, post, 'comments/');
                    angular.extend(post, {added: true});
                    vm.posts.unshift(post);
                    $scope.$apply();
                }
            }
            function loadUsers() {
                vm.usersLoading = true;
                vm.loadedUsers = [];
                var usersList = lebuApi.getLesson(vm.lessonId).getList('users');
                vm.users = usersList.$object;
                usersList.then(function(users) {
                    users = _.sortBy(users, vm.orderUsers);
                    vm.loadedUsers = _.slice(users, 0, vm.pageSize);
                    vm.usersLoading = false;
                });
            }
            function moreUsers() {
                vm.loadedUsers = _.concat(vm.loadedUsers, _.slice(vm.users, vm.loadedUsers.length, vm.loadedUsers.length + vm.pageSize));
            }
            function userRelationFilter(user) {
                if (angular.isDefined(user)) {
                    if (vm.selectedUserRelation == 'following') {
                        return vm.viewState.follows(user.id);
                    } else if (vm.selectedUserRelation == 'followers') {
                        return vm.viewState.followedBy(user.id);
                    }
                }
                return true;
            }
            function loadPosts() {
                if (angular.isDefined(vm.lessonId)) {
                    vm.postsLoading = true;
                    var params = vm.selectedSource == 0
                        ? {limit: Optimization.POSTS_PREVIEW_PAGE_SIZE}
                        : {limit: Optimization.POSTS_PREVIEW_PAGE_SIZE, filter: 'following'};
                    vm.posts = [];
                    lebuApi.getLesson(vm.lessonId).getList('comments', params).then(function(posts) {
                        vm.posts = posts;
                        vm.postsLoading = false;
                    });
                }
            }
            function updateUsersFilter() {
                vm.loadUsers();
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .factory('lebuApi', lebuApi);

    /** @ngInject */
    function lebuApi(Restangular) {
        var service = {
            getUser: getUser,
            getUsers: getUsers,
            getCategories: getCategories,
            getCourse: getCourse,
            getCourses: getCourses,
            getPost: getPost,
            getPosts: getPosts,
            getLesson: getLesson,
            getCurrentUser: getCurrentUser,
            getOg: getOg,
            getNotices: getNotices,
            getHomestrips: getHomestrips,
            getTalk: getTalk,
            getTalks: getTalks,
            getPlaylists: getPlaylists,
            getPlaylist: getPlaylist,
            getRanking: getRanking,
            getLessonComment: getLessonComment,
            getRepositories: getRepositories,
            getSearch: getSearch,
            getEvent: getEvent,
            getGodo: getGodo,
            getGodos: getGodos,
            userApi: {},
            usersApi: undefined,
            categoriesApi: undefined,
            courseApi: {},
            coursesApi: undefined,
            postApi: {},
            postsApi: undefined,
            lessonApi: {},
            currentUserApi: undefined,
            ogApi: undefined,
            homestripsApi: undefined,
            talkApi: {},
            talksApi: undefined,
            godoApi: {},
            godosApi: undefined,
            playlistsApi: undefined,
            playlistApi: {},
            rankingApi: undefined,
            lessonCommentApi: {},
            repositoryApi: undefined,
            searchApi: undefined,
            eventApi: {},
            noticeApi: undefined
        };
        return service;

        function getUser(userId) {
            if (angular.isDefined(service.userApi[userId])) {
                return service.userApi[userId];
            }
            service.userApi[userId] = Restangular.one('users/', userId);
            return service.userApi[userId];
        }
        function getUsers() {
            if (angular.isDefined(service.usersApi)) {
                return service.usersApi;
            }
            service.usersApi = Restangular.all('users/');
            return service.usersApi;
        }
        function getCategories() {
            if (angular.isDefined(service.categoriesApi)) {
                return service.categoriesApi;
            }
            service.categoriesApi = Restangular.one('categories/');
            return service.categoriesApi;
        }
        function getCourse(courseId) {
            if (angular.isDefined(service.courseApi[courseId])) {
                return service.courseApi[courseId];
            }
            service.courseApi[courseId] = Restangular.one('courses/', courseId);
            return service.courseApi[courseId];
        }
        function getCourses() {
            if (angular.isDefined(service.coursesApi)) {
                return service.coursesApi;
            }
            service.coursesApi = Restangular.all('courses/');
            return service.coursesApi;
        }
        function getPost(postId) {
            if (angular.isDefined(service.postApi[postId])) {
                return service.postApi[postId];
            }
            service.postApi[postId] = Restangular.one('posts/', postId);
            return service.postApi[postId];
        }
        function getPosts() {
            if (angular.isDefined(service.postsApi)) {
                return service.postsApi;
            }
//            service.postsApi = Restangular.withConfig(function(RestangularConfigurer) {
//                RestangularConfigurer.setFullResponse(true);
//            }).all('posts/');
            service.postsApi = Restangular.all('posts/');
            return service.postsApi;
        }
        function getLesson(lessonId) {
            if (angular.isDefined(service.lessonApi[lessonId])) {
                return service.lessonApi[lessonId];
            }
            service.lessonApi[lessonId] = Restangular.one('lessons/', lessonId);
            return service.lessonApi[lessonId];
        }
        function getCurrentUser() {
            if (angular.isDefined(service.currentUserApi)) {
                return service.currentUserApi;
            }
            service.currentUserApi = Restangular.one('currentuser');
            return service.currentUserApi;
        }
        function getOg() {
            if (angular.isDefined(service.ogApi)) {
                return service.ogApi;
            }
            service.ogApi = Restangular.one('urlogmeta');
            return service.ogApi;
        }
        function getHomestrips() {
            if (angular.isDefined(service.homestripsApi)) {
                return service.homestripsApi;
            }
            service.homestripsApi = Restangular.one('homestrips');
            return service.homestripsApi;
        }
        function getTalk(talkId) {
            if (angular.isDefined(service.talkApi[talkId])) {
                return service.talkApi[talkId];
            }
            service.talkApi[talkId] = Restangular.one('talks/', talkId);
            return service.talkApi[talkId];
        }
        function getTalks() {
            if (angular.isDefined(service.talksApi)) {
                return service.talksApi;
            }
            service.talksApi = Restangular.all('talks/');
            return service.talksApi;
        }
        function getPlaylists() {
            if (angular.isDefined(service.playlistsApi)) {
                return service.playlistsApi;
            }
            service.playlistsApi = Restangular.all('playlists/');
            return service.playlistsApi;
        }
        function getPlaylist(playlistId) {
            if (angular.isDefined(service.playlistApi[playlistId])) {
                return service.playlistApi[playlistId];
            }
            service.playlistApi[playlistId] = Restangular.one('playlists/', playlistId);
            return service.playlistApi[playlistId];
        }
        function getRanking() {
            if (angular.isDefined(service.rankingApi)) {
                return service.rankingApi;
            }
            service.rankingApi = Restangular.all('ranking');
            return service.rankingApi;
        }
        function getLessonComment(lessonId, commentId) {
            if (angular.isDefined(service.lessonCommentApi[commentId])) {
                return service.lessonCommentApi[commentId];
            }
            service.lessonCommentApi[commentId] = Restangular.one('lessons/', lessonId).one('comments/', commentId);
            return service.lessonCommentApi[commentId];
        }
        function getRepositories() {
            if (angular.isDefined(service.repositoryApi)) {
                return service.repositoryApi;
            }
            service.repositoryApi = Restangular.all('documents/');
            return service.repositoryApi;
        }
        function getSearch() {
            if (angular.isDefined(service.searchApi)) {
                return service.searchApi;
            }
            service.searchApi = Restangular.all('search');
            return service.searchApi;
        }
        function getEvent(eventId) {
            if (angular.isDefined(service.eventApi[eventId])) {
                return service.eventApi[eventId];
            }
            service.eventApi[eventId] = Restangular.one('events/', eventId);
            return service.eventApi[eventId];
        }
        function getNotices() {
            if (angular.isDefined(service.noticeApi)) {
                return service.noticeApi;
            }
            service.noticeApi = Restangular.one('notices');
            return service.noticeApi;
        }
        function getGodo(godoId) {
            if (angular.isDefined(service.godoApi[godoId])) {
                return service.godoApi[godoId];
            }
            service.godoApi[godoId] = Restangular.one('godos/', godoId);
            return service.godoApi[godoId];
        }
        function getGodos() {
            if (angular.isDefined(service.godosApi)) {
                return service.godosApi;
            }
            service.godosApi = Restangular.all('godos/');
            return service.godosApi;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbLastCourse', lbLastCourse);

    /** @ngInject */
    function lbLastCourse() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/lastCourse/lastCourse.html',
            controller: LastCourseController,
            controllerAs: 'lastCourse',
            bindToController: {
                course: '<',
                action: '@'
            }
        };
        return directive;

        /** @ngInject */
        function LastCourseController($rootScope, $scope) {
            var vm = this;

            var onCourseEnterHandler = $rootScope.$on('lesson:enter', onLessonEnter);
            $scope.$on('$destroy', onCourseEnterHandler);

            function onLessonEnter(ev, params) {
                vm.course = params.course;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbHeader', lbHeader);

    /** @ngInject */
    function lbHeader() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/header/header.html',
            controller: HeaderController,
            controllerAs: 'header',
            scope: true,
            bindToController: {
                categories: '<',
                user: '<'
            }
        };
        return directive;

        /** @ngInject */
        function HeaderController($document, $mdPanel, $scope, $log, viewState, $state, $rootScope, lebuApi, TranslationService, $auth, toastr, $wamp) {
            var vm = this;
            vm.viewState = viewState;
            vm.isLeaf = isLeaf;
            vm.currentUser = $rootScope.currentUser;
            vm.searchText = '';
            vm.searchCourse = searchCourse;
            vm.visit = visit;
            vm.getTypeLabel = getTypeLabel;
            vm.getTypeText = getTypeText;
            vm.connect = connect;
            vm.disconnect = disconnect;
            vm.onConnectFail = onConnectFail;
            vm.onConnectSuccess = onConnectSuccess;
            vm.onDisconnectSuccess = onDisconnectSuccess;
            vm.onMessagesUpdate = onMessagesUpdate;
            vm.onNoticesUpdate = onNoticesUpdate;
            vm.unreadedMessages = viewState.unreadedMessages;
            vm.unreadedNotices = viewState.unreadedNotices;
            vm.showNotifications = showNotifications;
            vm.showChatBot = showChatBot;
            vm.notificationsPanel = $mdPanel;

            $wamp.subscribeOnScope($scope, 'it.lebu.user.' + vm.currentUser.id + '.messages', vm.onMessagesUpdate);
            $wamp.subscribeOnScope($scope, 'it.lebu.user.' + vm.currentUser.id + '.notices', vm.onNoticesUpdate);

            function onMessagesUpdate(args) {
                var talks = angular.fromJson(args[0]);
                var unread = 0;
                angular.forEach(talks, function(talk) {
                    unread += talk.unread
                });
                var realtime = angular.fromJson(localStorage.getItem('realtime'));
                realtime.unreadedMessages = unread;
                localStorage.setItem('realtime', angular.toJson(realtime));
                viewState.unreadedMessages = vm.unreadedMessages = unread;
            }
            function onNoticesUpdate(args) {
                var currentNotice = angular.fromJson(args[0]);
                var realtime = angular.fromJson(localStorage.getItem('realtime'));
                realtime.unreadedNotices ++;
                localStorage.setItem('realtime', angular.toJson(realtime));
                viewState.unreadedNotices = vm.unreadedNotices = realtime.unreadedNotices;

                var notice = {
                        id: currentNotice.entity.id,
                        title: TranslationService.trans("notice-" + currentNotice.entityType + "-" + currentNotice.action),
                        type: currentNotice.entityType,
                        state: null
                }

                switch(currentNotice.entityType){
                    case 'post':
                        notice.state = 'postDetail';
                        break;
                    case 'user':
                        if (currentNotice.action == "follow"){
                            notice.id = currentNotice.actor.id;
                        }
                        notice.state = 'user';
                        break;
                    case 'lesson':
                        notice.state = 'course.lesson';
                        notice.id = {lesson: currentNotice.entity.id, course: currentNotice.entity.courseId};
                        break;
                    default:
                        break;
                }
                viewState.notifications.unshift(notice);
            }
            function getTypeText(searchResult) {
                if (searchResult.type == 'post')
                    return moment.unix(searchResult.abstract).fromNow();
                return searchResult.abstract;
            }
            function getTypeLabel(type) {
                if (type == 'course') return TranslationService.trans('program');
                if (type == 'lesson') return TranslationService.trans('lesson');
                if (type == 'user') return TranslationService.trans('user');
                if (type == 'post') return TranslationService.trans('post');
                return '';
            }
            function visit(searchResult) {
                if (searchResult.type == 'course' || searchResult.type == 'lesson') {
                    $state.go('courseDetail', {courseId: searchResult.id});
                } else if (searchResult.type == 'user') {
                    $state.go('user', {userId: searchResult.id});
                } else if (searchResult.type == 'post') {
                    $state.go('postDetail', {postId: searchResult.id});
                }
            }
            function searchCourse() {
                return lebuApi.getSearch().getList({q: vm.searchText}).$object;
            }
            function isLeaf(node) {
                return angular.isUndefined(node.children);
            }
            function connect(provider) {
                $auth.authenticate(provider)
                    .then(vm.onConnectSuccess)
                    .catch(function(error) {
                        vm.onConnectFail(error);
                    });
            }
            function disconnect(provider) {
                $auth.unlink(provider)
                    .then(vm.onDisconnectSuccess)
                    .catch(function(error) {
                        vm.onConnectFail(error);
                    });
            }
            function onConnectFail(error) {
                var message = error && error.data && error.data.message ? TranslationService.trans(error.data.message) : TranslationService.trans('operation-error-retry');
                toastr.error(message);
            }
            function onConnectSuccess() {
                lebuApi.getCurrentUser().get().then(function() {
                    toastr.success(TranslationService.trans('connect-with-linkedin-success'));
                });
            }
            function onDisconnectSuccess() {
                lebuApi.getCurrentUser().get().then(function(currentUser) {
                    vm.currentUser = currentUser;
                    toastr.success(TranslationService.trans('disconnect-from-linkedin-success'));
                });
            }
            function showNotifications(ev) {
                var position = vm.notificationsPanel.newPanelPosition()
                    .relativeTo('.show-notifications')
                    .addPanelPosition($mdPanel.xPosition.ALIGN_END, $mdPanel.yPosition.BELOW);

                $mdPanel.open({
                    attachTo: angular.element($document[0].body),
                    controller: 'NotificationsController',
                    controllerAs: 'notifications',
                    templateUrl: './app/components/notifications/notifications.html',
                    panelClass: 'notifications-menu',
                    position: position,
                    openFrom: ev,
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    focusOnOpen: false,
                    zIndex: 100
                });

                var realtime = angular.fromJson(localStorage.getItem('realtime'));
                realtime.unreadedNotices = 0;
                localStorage.setItem('realtime', angular.toJson(realtime));
                viewState.unreadedNotices = vm.unreadedNotices = 0;
                //drawer
                lebuApi.getNotices().get();
            }

            function showChatBot(ev) {
                var panelRef;
                var position = $mdPanel.newPanelPosition()
                    .relativeTo('.show-botpanel')
                    .addPanelPosition($mdPanel.xPosition.ALIGN_END, $mdPanel.yPosition.BELOW);

                $mdPanel.open({
                    attachTo: angular.element($document[0].body),
                    controller: DialogController,
                    controllerAs: 'ctrl',
                    template: '<iframe id="chatbot allowtransparency="true" style="background: #FFFFFF;" show = "hide" src="https://sji-betta.azurewebsites.net/webchat.html" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" width="340" height="500"> <p>Your browser does not support iframes.</p> </iframe>',
                    position: position,
                    openFrom: ev,
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    focusOnOpen: false,
                    zIndex: 100
                }).then(function(result) {
                    panelRef = result;
                });

                function DialogController() {
                    function closeDialog() {
                        if (panelRef) panelRef.close();
                    }
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('analytics', function() {
            return {
                restrict: 'A',
                scope: {
                    id: '=analytics'
                },
                link: function(scope) {
                    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
                    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
                    })(window,document,'script','//www.google-analytics.com/analytics.js','ga');

                    scope.$watch('id', function(newId) {
                        if (newId) {
                            ga('create', scope.id, { 'cookieDomain': 'none' });
                        }
                  });
                }
            };
        });
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbFooter', lbFooter);

    /** @ngInject */
    function lbFooter() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/footer/footer.html',
            controller: FooterController,
            controllerAs: 'footer',
            bindToController: true
        };
        return directive;

        /** @ngInject */
        function FooterController(viewState) {
            var vm = this;
            vm.viewState = viewState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbFocusMe', lbFocusMe);

    /** @ngInject */
    function lbFocusMe($timeout, $parse) {
        var directive = {
            restrict: 'A',
            link: FocusMeLink
        };
        return directive;

        /** @ngInject */
        function FocusMeLink(scope, element, attrs) {
            var model = $parse(attrs.lbFocusMe);
            scope.$watch(model, function(value) {
                if (value === true) { 
                    $timeout(function() {
                        element[0].focus(); 
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbEventResource', lbEventResource);

    /** @ngInject */
    function lbEventResource() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/eventResource/eventResource.html',
            controller: EventResourceController,
            controllerAs: 'eventResource',
            scope: true,
            bindToController: {
                text: '<',
                lesson: '<'
            }
        };
        return directive;

        /** @ngInject */
        function EventResourceController($scope, $sce) {
            var vm = this;
            vm.text=$sce.trustAsHtml(vm.text);
            $scope.$emit('lesson:complete', {lesson: vm.lesson});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbCourseCard', lbCourseCard);

    /** @ngInject */
    function lbCourseCard() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/courseCard/courseCard.html',
            controller: CourseCardController,
            controllerAs: 'courseCard',
            scope: true,
            bindToController: {
                course: '<'
            }
        };
        return directive;

        /** @ngInject */
        function CourseCardController($state, viewState) {
            var vm = this;
            vm.enter = enter;
            vm.viewState = viewState;
            vm.stars = getStars();

            function enter() {
                if (vm.course.isEnrolled) {
                    $state.go('course', {
                        courseId: vm.course.id
                    });
                } else {
                    $state.go('courseDetail', {
                        courseId: vm.course.id
                    });
                }
            }
            function getStars() {
                return angular.isDefined(vm.course.rating) && vm.course.rating > 0
                    ? new Array(Math.round(vm.course.rating))
                    : [];
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbContactSelect', lbContactSelect);

    /** @ngInject */
    function lbContactSelect() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/contactSelect/contactSelect.html',
            controller: ContactSelectController,
            controllerAs: 'contactSelect',
            scope: true,
            bindToController: {
                contacts: '<',
                model: '='
            }
        };
        return directive;

        /** @ngInject */
        function ContactSelectController($rootScope, $scope, viewState, _) {
            var vm = this;
            vm.querySearch = querySearch;
            vm.filterSelected = true;
            vm.selectContact = selectContact;
            vm.currentUser = $rootScope.currentUser;
            vm.onOnlineUsersUpdate = onOnlineUsersUpdate;
            vm.orderUsers = orderUsers;
            vm.viewState = viewState;
            
            vm.contacts = _.sortBy(vm.contacts, vm.orderUsers);
            angular.forEach(vm.contacts, function(contact) {
                angular.extend(contact, {fullname: contact.name + ' ' + contact.surname});
            });

            var onOnlineUsersUpdateHandler = $rootScope.$on('social:onlineusers:update', vm.onOnlineUsersUpdate);
            $scope.$on('$destroy', onOnlineUsersUpdateHandler);

            function onOnlineUsersUpdate() {
                vm.contacts = _.sortBy(vm.contacts, vm.orderUsers);
            }
            function orderUsers(user) {
                return vm.viewState.isOnline(user.id) ? -1 : user.id;
            }
            function selectContact(contact) {
                var selectedIndex = vm.model.indexOf(contact);
                if (selectedIndex < 0) {
                    vm.model.push(contact);
                } else {
                    vm.model.splice(selectedIndex, 1);
                }
            }
            function querySearch(query) {
                var results = query ?
                    vm.contacts.filter(createFilterFor(query)) : [];
                return results;
            }
            function createFilterFor(query) {
                var lowercaseQuery = angular.lowercase(query);
                return function filterFn(contact) {
                    var name = angular.lowercase(contact.name + ' ' + contact.surname);
                    return (name.indexOf(lowercaseQuery) != -1 && contact.id != vm.currentUser.id);
                };
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbCommentPreview', lbCommentPreview);

    /** @ngInject */
    function lbCommentPreview() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/commentPreview/commentPreview.html',
            controller: CommentPreviewController,
            controllerAs: 'commentPreview',
            scope: true,
            bindToController: {
                post: '<',
                lessonid: '<',
                courseid: '<'
            }
        };
        return directive;

        /** @ngInject */
        function CommentPreviewController($sce, viewState) {
            var vm = this;
            vm.getYTPreview = getYTPreview;
            vm.viewState = viewState;
            
            function getYTPreview(embedUrl) {
                if (embedUrl) {
                    var url = $sce.getTrustedUrl(embedUrl);
                    var found = url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i);
                    if (angular.isDefined(found) && found != null) {
                        return 'http://img.youtube.com/vi/' + found[1] + '/0.jpg';
                    }
                }
                return embedUrl;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .directive('lbBreadcrumb', lbBreadcrumb);

    /** @ngInject */
    function lbBreadcrumb() {
        var directive = {
            restrict: 'E',
            templateUrl: './app/components/breadcrumb/breadcrumb.html',
            controller: BreadcrumbController,
            controllerAs: 'breadcrumb',
            scope: true,
            bindToController: {
                history: '<'
            }
        };
        return directive;

        /** @ngInject */
        function BreadcrumbController(viewState) {
            var vm = this;
            vm.viewState = viewState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .factory('ajv', ajv);

    /** @ngInject */
    function ajv($window) {
        return $window.Ajv({
            allErrors: true
        });
    }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('UserController', UserController)

  /** @ngInject */
  function UserController(user, $scope, $rootScope, $state, viewState, lebuApi, _, userStats, TranslationService) {
      var vm = this;
      vm.user = user;
      vm.userStats = userStats;
      vm.currentUser = $rootScope.currentUser;
      vm.viewState = viewState;
      vm.follow = follow;
      vm.unfollow = unfollow;
      vm.userData = getUserData();
      vm.userLabels = getUserLabels();
      vm.hasStats = hasStats;
      vm.selectedTab = $state.$current.name == 'user' ? 0 : $state.$current.data.selectedTab;
      vm.languages = $rootScope.languages;

      var onStateChangeHandler = $rootScope.$on('$stateChangeSuccess', onStateChange);
      $scope.$on('$destroy', onStateChangeHandler);

      function hasStats() {
          for (var i = 0; i < vm.userData.length; i++) {
              if (vm.userData[i] != 0) {
                  return true;
              }
          }
          return false;
      }
      function getUserData() {
          return _.map(vm.userStats, 'value');
      }
      function getUserLabels() {
          return _.map(vm.userStats, function(o) {
              return TranslationService.trans(o.label);
          });
      }
      function onStateChange(ev, toState) {
          if (toState.name.split('.')[0] == 'user') {
              vm.selectedTab = toState.data.selectedTab;
          }
      }
      function follow() {
          vm.user.post('follow').then(function() {
              lebuApi.getCurrentUser().get().then(function(currentUser) {
                  vm.currentUser = currentUser.user;
              });
          });
      }
      function unfollow() {
          vm.user.customDELETE('follow').then(function() {
              lebuApi.getCurrentUser().get().then(function(currentUser) {
                  vm.currentUser = currentUser.user;
              });
          });
      }
   }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('UploadCoverController', UploadCoverController);

    /** @ngInject */
    function UploadCoverController(user, $log, $mdDialog, $state, lebuApi, toastr, Upload, viewState, TranslationService) {
        var vm = this;
        vm.viewState = viewState;
        vm.user = user;
        vm.picture = null;
        vm.croppedPicture = null;
        vm.upload = upload;
        vm.cancel = cancel;
        vm.progress = null;

        function upload() {
            Upload.upload({
                url: '/users/' + vm.user.id + '/uploadCover',
                data: {
                    file: Upload.dataUrltoBlob(vm.croppedPicture, vm.picture.name)
                }
            }).then(function() {
                toastr.success(TranslationService.trans('cover-updated'));
                lebuApi.getCurrentUser().get().then(function(response) {
                    $state.go('user', {userId: response.user.id}, {reload: true, notify: false}).then(function() {
                        $mdDialog.hide();
                    });
                });
            }, function(response) {
                if (response.status > 0) {
                    $log.error(response.status + ': ' + response.data);
                }
            }, function(ev) {
                vm.progress = parseInt(100.0 * ev.loaded / ev.total);
            });
        }
        function cancel() {
            vm.picture = null;
            $mdDialog.hide();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('UploadAvatarController', UploadAvatarController);

    /** @ngInject */
    function UploadAvatarController(user, $log, $mdDialog, $state, lebuApi, Upload, viewState, toastr, TranslationService) {
        var vm = this;
        vm.viewState = viewState;
        vm.user = user;
        vm.picture = null;
        vm.croppedPicture = null;
        vm.upload = upload;
        vm.cancel = cancel;
        vm.progress = null;

        function upload() {
            Upload.upload({
                url: '/users/' + vm.user.id + '/uploadAvatar',
                data: {
                    file: Upload.dataUrltoBlob(vm.croppedPicture, vm.picture.name)
                }
            }).then(function() {
                toastr.success(TranslationService.trans('image-updated'));
                lebuApi.getCurrentUser().get().then(function(response) {
                    $state.go('user', {userId: response.user.id}, {reload: true, notify: false}).then(function() {
                        $mdDialog.hide();
                    });
                });
            }, function(response) {
                if (response.status > 0) {
                    $log.error(response.status + ': ' + response.data);
                }
            }, function(ev) {
                vm.progress = parseInt(100.0 * ev.loaded / ev.total);
            });
        }
        function cancel() {
          vm.picture = vm.croppedPicture = null;
          $mdDialog.hide();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('SocialPostController', SocialPostController);

    /** @ngInject */
    function SocialPostController($rootScope, $mdDialog, viewState, Upload, lebuApi, $stateParams, toastr, TranslationService, $log) {
        var vm = this;
        vm.viewState = viewState;
        vm.message = '';
        vm.byStaff = false;
        vm.user = $rootScope.currentUser;
        vm.post = post;
        vm.cancel = cancel;
        vm.attachment = null;
        vm.attachmentType = Number($stateParams.type);
        vm.afterPost = afterPost;

        function post(form) {
            if (form.$valid) {
                var post = angular.extend({}, vm.attachment, {
                    message: vm.message,
                    byStaff: vm.byStaff
                });
                if (post.type == 4 || post.type == 5 || post.type == 7) {
                    Upload.upload({
                        url: '/posts/',
                        data: post
                    }).then(function(response) {
                        vm.afterPost(response.data);
                    }, function(response) {
                        if (response.status > 0) {
                            $log.error(response.status + ': ' + response.data);
                        }
                    });
                } else {
                    lebuApi.getPosts().post(post).then(function(response) {
                        vm.afterPost(response);
                    });
                }
            }
        }
        function afterPost(post) {
            $mdDialog.hide();
            if (post.type == 7) {
                var socialRoomLabel = TranslationService.trans('module-community-' + vm.viewState.theme);
                toastr.success( TranslationService.trans('alert-video-uploaded-for', {learningroom: socialRoomLabel}));
            } else {
                toastr.success(TranslationService.trans('message-inserted-successfully'));
                if (!vm.viewState.hasRealtime) {
                    $rootScope.$broadcast('social:post:updated');
                }
            }
        }
        function cancel() {
            $mdDialog.hide();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('SearchController', SearchController);

    /** @ngInject */
    function SearchController(viewState, $state, $mdMenu, $rootScope, lebuApi, $mdDialog, TranslationService) {
        var vm = this;
        vm.viewState = viewState;
        vm.searchText = '';
        vm.searchCourse = searchCourse;
        vm.visit = visit;
        vm.cancel = cancel;
        vm.getTypeLabel = getTypeLabel;
        
        function getTypeLabel(type) {
            if (type == 'course') return TranslationService.trans('program');
            if (type == 'lesson') return TranslationService.trans('lesson');
            if (type == 'user') return TranslationService.trans('user');
            if (type == 'post') return TranslationService.trans('post');
            return '';
        }
        function visit(searchResult) {
            if (searchResult.type == 'course' || searchResult.type == 'lesson') {
                $mdDialog.hide().then(function() {
                    $state.go('courseDetail', {courseId: searchResult.id});
                });
            } else if (searchResult.type == 'user') {
                $mdDialog.hide().then(function() {
                    $state.go('user', {userId: searchResult.id});
                });
            } else if (searchResult.type == 'post') {
                $mdDialog.hide().then(function() {
                    $state.go('postDetail', {postId: searchResult.id});
                });
            }
        }
        function searchCourse() {
            return lebuApi.getSearch().getList({q: vm.searchText}).$object;
        }
        function cancel() {
            $mdDialog.hide();
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('RepositoryController', RepositoryController)

  /** @ngInject */
  function RepositoryController(documents, _) {
      var vm = this;
      vm.documents = documents;
      vm.typeFilter = '';
      vm.typeMatch = typeMatch;
      vm.typeMap = {
          image: ['image/jpeg', 'image/gif', 'image/png', 'image/tiff'],
          presentation: ['application/mspowerpoint', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
          spreadsheet: ['application/excel', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
          text: ['text/plain', 'application/msword', 'application/vnd.ms-word', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
          pdf: ['application/pdf'],
          zip: ['application/zip', 'application/x-compressed', 'application/x-zip-compressed', 'multipart/x-zip']
      };

      function typeMatch(item) {
          if (vm.typeFilter === '') return true;
          var types = vm.typeMap[vm.typeFilter];
          return angular.isDefined(types)
              ? _.indexOf(types, item.filemime) != -1
              : false;
      }
   }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('RateCourseController', RateCourseController);

    /** @ngInject */
    function RateCourseController($scope, $mdDialog, $timeout, viewState) {
        var vm = this;
        vm.viewState = viewState;
        vm.socialPost = false;
        vm.rating = 0;
        vm.submit = submit;
        vm.cancel = cancel;

        function submit() {
            var rating = {
                rate: vm.rating,
                isPost: vm.socialPost
            };
            $scope.$emit('lesson:rate', {rating: rating});
            $mdDialog.hide();
        }
        function cancel() {
            $mdDialog.hide();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('PostDetailController', PostDetailController);

    /** @ngInject */
    function PostDetailController($state, post, $rootScope, toastr, lebuApi, viewState, $mdDialog, TranslationService) {
        var vm = this;
        vm.cancel = cancel;
        vm.viewState = viewState;
        vm.post = post;
        vm.message = '';
        vm.like = like;
        vm.unlike = unlike;
        vm.comment = comment;
        vm.currentUser = $rootScope.currentUser;
        vm.videoPlayerTheme = '/assets/css/videogular.min.css';
        vm.videoPlayerApi = null;
        vm.onVideoPlayerReady = onVideoPlayerReady;
        vm.deletePost = deletePost;
        vm.showCourse = showCourse;

        function showCourse() {
            $mdDialog.hide().then(function() {
                var courseId = Number(_.last(_.split(vm.post.og['og:url'], '/')));
                $state.go('courseDetail', {courseId: courseId});
            });
        }
        function onVideoPlayerReady(videoApi) {
            vm.videoPlayerApi = videoApi;
        }
        function like() {
            lebuApi.getPost(vm.post.id).post('like').then(function(post) {
                toastr.success(TranslationService.trans('like-was-registered'));
                vm.post.liked = post.liked;
                vm.post.likes = post.likes;
            });
        }
        function unlike() {
            lebuApi.getPost(vm.post.id).customDELETE('like').then(function(post) {
                toastr.success(TranslationService.trans('like-was-removed'));
                vm.post.liked = post.liked;
                vm.post.likes = post.likes;
            });
        }
        function comment() {
            lebuApi.getPost(vm.post.id).post('comment', {comment: vm.message}).then(function(post) {
                toastr.success(TranslationService.trans('comment-inserted-successfully'));
                vm.message = '';
                vm.post.comments = post.comments;
                vm.post.formOpened = false;
            });
        }
        function cancel() {
            $mdDialog.hide();
        }
        function deletePost(ev) {
            var confirm = $mdDialog.confirm()
                .title(TranslationService.trans('delete-post-confirm'))
                .ariaLabel(TranslationService.trans('delete-post-confirm'))
                .targetEvent(ev)
                .ok(TranslationService.trans('ok'))
                .cancel(TranslationService.trans('cancel'));
            $mdDialog.show(confirm).then(function() {
                vm.post.remove().then(function() {
                    toastr.success(TranslationService.trans('delete-post-success'));
                    $rootScope.$broadcast('social:post:updated');
                    $mdDialog.hide();
                });
            });
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('PlaylistsController', PlaylistsController)

  /** @ngInject */
  function PlaylistsController($timeout, playlists) {
      var vm = this;
      vm.playlists = playlists;
   }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('PlaylistController', PlaylistController)

  /** @ngInject */
  function PlaylistController($timeout, playlist) {
      var vm = this;
      vm.playlist = playlist;
   }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('NewsController', NewsController);

  /** @ngInject */
  function NewsController($state, lebuApi, $scope, $rootScope, $log, Optimization, _, $timeout) {
      var vm = this;
      vm.loadedPosts = [];
      vm.loadPosts = loadPosts;
      vm.typeFilter = null;
      vm.busy = false;
      vm.after = null;
      vm.reloadPosts = reloadPosts;
      vm.postsLoading = false;
      vm.emptyPosts = false;

      function reloadPosts() {
          vm.loadedPosts = [];
          vm.after = null;
          vm.emptyPosts = false;
          vm.loadPosts();
      }
      function loadPosts() {
          if (vm.busy || vm.emptyPosts) return;
          vm.busy = true;
          vm.postsLoading = true;
          var params = {
              limit: Optimization.POSTS_PAGE_SIZE,
              filter: 'news'
          };
          if (vm.after != null) {
              angular.extend(params, {after: vm.after});
          }
          if (vm.typeFilter != null) {
              angular.extend(params, {type: vm.typeFilter});
          }
          lebuApi.getPosts().getList(params).then(function(posts) {
              _.each(posts, function(post) {
                  vm.loadedPosts.push(post);
              });
              if (posts.length > 0) {
                  vm.after = vm.loadedPosts[vm.loadedPosts.length - 1].id;
              } else {
                  vm.emptyPosts = true;
              }
              vm.busy = false;
              vm.postsLoading = false;
              $timeout(function() {
                  angular.element('#stories').masonry('layout');
              }, 1000);
          }, function() {
              vm.busy = false;
              vm.postsLoading = false;
          });
      }
   }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('MessagesController', MessagesController);

    /** @ngInject */
    function MessagesController(Restangular, $mdSidenav, contacts, viewState, $mdDialog, talks, $state, $mdMedia, $rootScope, _, $stateParams, TranslationService, $wamp, $scope) {
        var vm = this;
        vm.viewState = viewState;
        vm.talks = talks;
        vm.cancel = cancel;
        vm.cancelCreate = cancelCreate;
        vm.currentUser = $rootScope.currentUser;
        vm.selectTalk = selectTalk;
        vm.createTalk = createTalk;
        vm.openCreateTalk = openCreateTalk;
        vm.closeTalk = closeTalk;
        vm.selectedTalk = null;
        vm.contacts = contacts;
        vm.selectedContacts = [];
        vm.onTalksUpdate = onTalksUpdate;
        vm.onMessagesUpdate = onMessagesUpdate;

        $wamp.subscribeOnScope($scope, 'it.lebu.user.' + vm.currentUser.id + '.rooms', vm.onTalksUpdate);
        $wamp.subscribeOnScope($scope, 'it.lebu.user.' + vm.currentUser.id + '.messages', vm.onMessagesUpdate);

        if ($stateParams.recipientId != null) {
            vm.talks.post({
                recipients: [$stateParams.recipientId],
                body: TranslationService.trans('conversation-created-by', {name: vm.currentUser.name})
            }).then(function() {
                vm.talks.getList().then(function(talks) {
                    vm.talks = talks;
                    $state.go('messages.talk', {talkId: vm.talks[0].id});
                });
            }, function() {
                if (vm.talks.length) {
                    $state.go('messages.talk', {talkId: vm.talks[0].id});
                }
            });
        } else if (vm.talks.length) {
            if (angular.isDefined($stateParams.talkId) || $mdMedia('gt-xs')) {
                vm.selectTalk(vm.talks[0]);
            }
        }

        function onMessagesUpdate(args) {
            var unreadTalks = angular.fromJson(args[0]);
            out: for (var i = 0; i < vm.talks.length; i++) {
                for (var k = 0; k < unreadTalks.length; k++) {
                    if (unreadTalks[k].id == vm.talks[i].id) {
                        vm.talks[i].unread = unreadTalks[k].unread;
                        continue out;
                    }
                }
                vm.talks[i].unread = 0;
            }
            $scope.$apply();
        }
        function onTalksUpdate(args) {
            var talk = angular.fromJson(args[0]);
            talk = Restangular.restangularizeElement(null, talk, 'talks/');
            angular.extend(talk, {added: true});
            vm.talks.unshift(talk);
            $scope.$apply();
        }
        function cancel() {
            $mdDialog.cancel();
        }
        function cancelCreate() {
            $mdSidenav('createTalkNav').close();
        }
        function selectTalk(talk) {
            vm.selectedTalk = talk;
            $state.go('messages.talk', {talkId:talk.id});
        }
        function openCreateTalk() {
            $mdSidenav('createTalkNav').open();
        }
        function createTalk() {
            vm.talks.post({
                recipients: _.map(vm.selectedContacts, 'id'),
                body: TranslationService.trans('conversation-created-by', {name: vm.currentUser.name})
            }).then(function() {
                vm.talks.getList().then(function(talks) {
                    vm.selectedContacts = [];
                    vm.talks = talks;
                    $mdSidenav('createTalkNav').close().then(function() {
                        vm.selectTalk(vm.talks[0]);
                    });
                });
            });
        }
        function closeTalk() {
            $state.go('messages');
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('MainController', MainController);

    /** @ngInject */
    function MainController(viewState, categories, $rootScope) {
        var vm = this;
        vm.viewState = viewState;
        vm.categories = categories;
        vm.currentUser = $rootScope.currentUser;
    }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('RecoveryController', RecoveryController);

    /** @ngInject */
    function RecoveryController(Restangular, $mdDialog, toastr, TranslationService, viewState) {
        var vm = this;
        vm.viewState = viewState;
        vm.submit = submit;
        vm.onRecoveryFail = onRecoveryFail;
        vm.onRecoverySuccess = onRecoverySuccess;
        vm.submitting = false;
        vm.form = {email: ''};
        vm.cancel = cancel;

        function submit(form) {
            if (form.$valid) {
                vm.submitting = true;
                Restangular.all('forgotpassword').post({email: vm.form.email})
                    .then(vm.onRecoverySuccess, vm.onRecoveryFail);
            }
        }
        function onRecoveryFail(error) {
            vm.submitting = false;
            var message = error && error.data && error.data.message ? error.data.message : TranslationService.trans('operation-error-retry');
            toastr.error(message);
        }
        function onRecoverySuccess() {
            toastr.success(TranslationService.trans('password-recovery-success'));
            $mdDialog.cancel();
        }
        function cancel() {
            $mdDialog.hide();
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($auth, $mdDialog, $state, lebuApi, $rootScope, toastr, viewState, TranslationService, $document) {
        var vm = this;
        vm.viewState = viewState;
        vm.loginError = false;
        vm.submit = submit;
        vm.authenticate = authenticate;
        vm.onLoginFail = onLoginFail;
        vm.onLoginSuccess = onLoginSuccess;
        vm.submitting = false;
        vm.login = {email: '', password: ''};
        vm.recovery = {email: ''};
        vm.passwordRecovery = passwordRecovery;

        function submit(form) {
            if (form.$valid) {
                var credentials = {
                    _username: vm.login.email,
                    _password: vm.login.password
                }
                vm.submitting = true;
                $auth.login(credentials)
                    .then(function() {
                        return lebuApi.getCurrentUser().get()
                            .then(vm.onLoginSuccess, vm.onLoginFail);
                    })
                    .catch(function() {
                        vm.submitting = false;
                        toastr.error(TranslationService.trans('invalid-email-password'));
                    });
            }
        }
        function authenticate(provider) {
            $auth.authenticate(provider)
                .then(function() {
                    return lebuApi.getCurrentUser().get()
                        .then(vm.onLoginSuccess, vm.onLoginFail);
                })
                .catch(function() {
                    vm.submitting = false;
                    toastr.error(TranslationService.trans('invalid-email-password'));
                });
        }
        function onLoginFail(error) {
            vm.loginError = true;
            vm.submitting = false;
            var message = error && error.data && error.data.message ? error.data.message : TranslationService.trans('operation-error-retry');
            toastr.error(message);
        }
        function onLoginSuccess() {
            viewState.afterLogin();
            if (angular.isDefined($rootScope.stateAfterLogin)) {
                $state.go($rootScope.stateAfterLogin.state.name, $rootScope.stateAfterLogin.params);
                delete $rootScope.stateAfterLogin;
            } else {
                $state.go('home');
            }
        }
        function passwordRecovery(ev) {
            ev.preventDefault();
            $mdDialog.show({
                controller: 'RecoveryController',
                controllerAs: 'recovery',
                templateUrl: './app/login/recovery.html',
                parent: angular.element($document[0].body),
                targetEvent: ev,
                clickOutsideToClose: false
            });
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('LibraryController', LibraryController)

  /** @ngInject */
  function LibraryController($timeout, categories, courses, $stateParams) {
      var vm = this;
      vm.courses = courses;
      vm.history = categories.history($stateParams.categorySlug);
      vm.subcategories = categories.childrenNodes($stateParams.categorySlug);
   }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('LessonController', LessonController);


  /** @ngInject */
  function LessonController(related, $mdBottomSheet, $rootScope, $scope, toastr, lesson, course, viewState, $state, TranslationService, lebuApi) {
      var vm = this;
      vm.viewState = viewState;
      vm.currentUser = $rootScope.currentUser;
      vm.lesson = lesson;
      vm.course = course;
      vm.related = related;
      vm.selectedTab = $state.$current.name == 'course.lesson' ? 0 : $state.$current.data.selectedTab;
      vm.slickConfig = getSlickConfig();

      vm.bookEvent = bookEvent;
      vm.unbookEvent = unbookEvent;

      vm.chartData = chartData;
      vm.chartOptions = chartOptions;
      vm.openVideoConfirm = openVideoConfirm;

      vm.isbookable = checkifbookable();

      var onLessonCompleteHandler = $rootScope.$on('lesson:complete', onLessonComplete);
      $scope.$on('$destroy', onLessonCompleteHandler);
      var onVideoCompleteHandler = $rootScope.$on('video:complete', onVideoComplete);
      $scope.$on('$destroy', onVideoCompleteHandler);
      var onLessonRateHandler = $rootScope.$on('lesson:rate', onLessonRate);
      $scope.$on('$destroy', onLessonRateHandler);
      var onStateChangeHandler = $rootScope.$on('$stateChangeSuccess', onStateChange);
      $scope.$on('$destroy', onStateChangeHandler);


      function onStateChange(ev, toState) {
          if (toState.name.split('.')[0] == 'lesson') {
              vm.selectedTab = toState.data.selectedTab;
          }
      }
      function onLessonComplete() {
          if (!vm.lesson.completed) {
              vm.lesson.post('complete').then(function(lesson) {
                  vm.course.getLesson(lesson.id).completed = true;
                  vm.lesson = lesson;
              });
          }
      }
      function onVideoComplete() {
          if (!vm.lesson.completed) {
              vm.lesson.post('complete').then(function(lesson) {
                  vm.course.getLesson(lesson.id).completed = true;
                  vm.lesson = lesson;
                  vm.openVideoConfirm();
              });
          } else {
              vm.openVideoConfirm();
          }
      }
      function onLessonRate(ev, params) {
          vm.course.post('rate', params.rating).then(function() {
              toastr.success(TranslationService.trans('vote-registered'));
          });
      }
      function onVideoComplete() {
          if (!vm.lesson.completed) {
              vm.lesson.post('complete').then(function(lesson) {
                  vm.course.getLesson(lesson.id).completed = true;
                  vm.lesson = lesson;
                  vm.openVideoConfirm();
              });
          } else {
              vm.openVideoConfirm();
          }
      }

      function checkifbookable() {
        var bookable = false;
        if (vm.lesson.type==4 && vm.lesson.available > 0) {
          bookable = true;
        }

        return bookable;
      }

      function bookEvent() {
        if (!vm.lesson.isBookedByUser) {
          lebuApi.getLesson(vm.lesson.id).post('book').then(function(lesson) {
            vm.course.getLesson(lesson.id).isBookedByUser = true;
            vm.lesson = lesson;
          });

        }
      }
      function unbookEvent() {
        if (vm.lesson.isBookedByUser) {
          lebuApi.getLesson(vm.lesson.id).customDELETE('book').then(function(lesson) {
            vm.course.getLesson(lesson.id).isBookedByUser = true;
            vm.lesson = lesson;
          });

        }
      }
      function chartData() {
          return {
              labels: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio'],
              datasets: [
                {
                  label: 'Partecipazioni',
                  fillColor: 'rgba(244,67,54,0.8)',
                  strokeColor: 'rgba(244,67,54,1)',
                  highlightFill: 'rgba(244,67,54,0.6)',
                  highlightStroke: 'rgba(244,67,54,0.8)',
                  data: [65, 59, 80, 81, 56, 55, 40]
                },
                {
                  label: 'Completati',
                  fillColor: 'rgba(33,150,243,0.8)',
                  strokeColor: 'rgba(33,150,243,1)',
                  highlightFill: 'rgba(33,150,243,0.6)',
                  highlightStroke: 'rgba(33,150,243,0.8)',
                  data: [28, 48, 40, 19, 86, 27, 90]
                }
             ]
          }
      }
      function chartOptions() {
          return {
              responsive: true,
              scaleBeginAtZero : true,
              scaleShowGridLines : true,
              scaleGridLineColor : "rgba(0,0,0,.05)",
              scaleGridLineWidth : 1,
              barShowStroke : true,
              barStrokeWidth : 2,
              barValueSpacing : 5,
              barDatasetSpacing : 1,
              legendTemplate : '<ul class="tc-chart-js-legend"><% for (var i=0; i<datasets.length; i++){%><li><span style="background-color:<%=datasets[i].fillColor%>"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>'
          }
      }
      function openVideoConfirm() {
          $mdBottomSheet.show({
              templateUrl: './app/components/videoConfirm/videoConfirm.html',
              disableParentScroll: false,
              controller: 'VideoConfirmController',
              controllerAs: 'videoConfirm',
              locals: {nextLesson: vm.course.nextLesson(vm.lesson.id)},
              clickOutsideToClose: true,
              parent: angular.element('.video-container')
          });
      }
      function getSlickConfig() {
        return {
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 6,
          slidesToScroll: 6,
          swipe: true,
          draggable: false,
          nextArrow: '<button class="md-fab md-button md-raised md-mini next-button"><md-icon class="material-icons">chevron_right</md-icon></button>',
          prevArrow: '<button class="md-fab md-button md-raised md-mini prev-button"><md-icon class="material-icons">chevron_left</md-icon></button>',
          respondTo: 'slider',
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 5
              }
            },
            {
              breakpoint: 1000,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4
              }
            },
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 599,
              settings: {
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: true,
                arrows: false
              }
            }
          ]
        };
      }
   }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('IntroController', IntroController);

    /** @ngInject */
    function IntroController(viewState, $mdDialog, intro) {
        var vm = this;
        vm.viewState = viewState;
        vm.intro = intro;
        vm.cancel = cancel;
        vm.videoPlayerTheme = '/assets/css/videogular.min.css';

        function cancel() {
            $mdDialog.hide();
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('HomeController', HomeController)

  /** @ngInject */
  function HomeController($sce, viewState, categories, strips, $rootScope) {
      var vm = this;
      vm.viewState = viewState;
      vm.categories = categories;
      vm.newCourses = strips.metaCategories.new;
      vm.popCourses = strips.metaCategories.top_rated;
      vm.catCourses = strips.categories;
      vm.slickConfig = getSlickConfig();
      vm.slideshowSlickConfig = getSlideshowSlickConfig();
      vm.htmlWhenDisabled = $sce.trustAsHtml($rootScope.currentTenant.htmlWhenDisabled);

      function getSlickConfig() {
          return {
              dots: false,
              infinite: true,
              speed: 300,
              slidesToShow: 6,
              slidesToScroll: 6,
              swipe: true,
              draggable: false,
              nextArrow: '<button class="md-fab md-button md-raised md-mini next-button"><md-icon class="material-icons">chevron_right</md-icon></button>',
              prevArrow: '<button class="md-fab md-button md-raised md-mini prev-button"><md-icon class="material-icons">chevron_left</md-icon></button>',
              respondTo: 'slider',
              responsive: [
                  {
                      breakpoint: 1200,
                      settings: {
                          slidesToShow: 5,
                          slidesToScroll: 5
                      }
                  },
                  {
                      breakpoint: 1000,
                      settings: {
                          slidesToShow: 4,
                          slidesToScroll: 4
                      }
                  },
                  {
                      breakpoint: 800,
                      settings: {
                          slidesToShow: 3,
                          slidesToScroll: 3
                      }
                  },
                  {
                      breakpoint: 599,
                      settings: {
                          dots: true,
                          slidesToShow: 1,
                          slidesToScroll: 1,
                          adaptiveHeight: true,
                          arrows: false
                      }
                  }
              ]
          };
      }
      function getSlideshowSlickConfig() {
          return {
              dots: true,
              autoplay: true,
              autoplaySpeed: 10000,
              fade: true,
              cssEase: 'linear',
              adaptiveHeight: true,
              arrows: false
          };
      }
   }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('EventController', EventController);

    /** @ngInject */
    function EventController(lebuApi, $mdDialog, viewState, event, $sce) {
        var vm = this;
        vm.videoPlayerTheme = '/assets/css/videogular.min.css';
        vm.viewState = viewState;
        vm.event = event;
        vm.cancel = cancel;
        vm.options = event.options;
        vm.onComplete = onComplete;
        vm.videoApi = null;
        vm.playerReady = playerReady;
        vm.completeEvent = completeEvent;

        if (vm.event.type == 'video') {
            var resources = [];
            angular.forEach(vm.options.resources, function(resource) {
                resources.push({
                    src: $sce.trustAsResourceUrl(resource.url),
                    type: resource.type
                });
            });
            vm.options.resources = resources;
        }

        function cancel() {
            $mdDialog.hide().then(function() {
                if (vm.event.type == 'simpleHTML') {
                    vm.completeEvent();
                } else {
                    lebuApi.getCurrentUser().get();
                }
            });
        }
        function completeEvent() {
            lebuApi.getEvent(vm.event.id).post('completed').then(function() {
                lebuApi.getCurrentUser().get();
            });
        }
        function playerReady(videoApi) {
            vm.videoApi = videoApi;
        }
        function onComplete() {
            if (vm.videoApi.isFullScreen) {
                vm.videoApi.toggleFullScreen();
            }
            vm.completeEvent();
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('EnrolledController', EnrolledController)

  /** @ngInject */
  function EnrolledController(categories, courses) {
      var vm = this;
      vm.categories = categories.children;
      vm.courses = courses;
   }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('EditProfileController', EditProfileController);

    /** @ngInject */
    function EditProfileController(user, TranslationService, $mdDialog, $rootScope, $state, lebuApi, viewState, toastr) {
        var vm = this;
        vm.viewState = viewState;
        vm.user = user;
        vm.post = post;
        vm.cancel = cancel;
        vm.languages = $rootScope.languages;

        function post(form) {
            if (form.$valid) {
                var user = {
                    name: vm.user.name,
                    surname: vm.user.surname,
                    company: vm.user.company,
                    job: vm.user.job,
                    language: vm.user.language,
                    city: vm.user.city,
                    country: vm.user.country,
                    biography: vm.user.biography
                };
                vm.user.patch(user).then(function() {
                    toastr.success(TranslationService.trans('profile-updated'));
                    lebuApi.getCurrentUser().get().then(function(response) {
                        $state.go('user', {userId: response.user.id}, {reload: true, notify: false}).then(function() {
                            $mdDialog.hide();
                        });
                    });
                });
            }
        }
        function cancel() {
            $mdDialog.hide();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('EditPasswordController', EditPasswordController);

    /** @ngInject */
    function EditPasswordController(user, $mdDialog, toastr, viewState, TranslationService) {
        var vm = this;
        vm.viewState = viewState;
        vm.user = user;
        vm.newPassword = '';
        vm.post = post;
        vm.cancel = cancel;

        function post(form) {
            if (form.$valid) {
                vm.user.post('changepwd', {pwd: vm.newPassword}).then(function() {
                    toastr.success(TranslationService.trans('password-changed'));
                    $mdDialog.hide();
                });
            }
        }
        function cancel() {
            $mdDialog.hide();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('EditGodoController', EditGodoController);

    /** @ngInject */
    function EditGodoController(godo, TranslationService, $mdDialog, $rootScope, $state, lebuApi, viewState, toastr) {
        var vm = this;
        vm.viewState = viewState;
        vm.godo = godo;
        vm.post = post;
        vm.cancel = cancel;
        //vm.relatedContentName = vm.godo.relatedContent.title;
        //vm.relatedContentId = vm.godo.relatedContent.id;
        vm.selectedCourse = null;
        vm.updateSelectedCourse = updateSelectedCourse();

        getDuedate();

        function getDuedate(){
          if (vm.godo.duedate != 0){
            vm.godo.duedate = new Date(vm.godo.duedate);
          }else{
            vm.godo.duedate = new Date();
          }
        }


        function updateSelectedCourse(){
        }




        function post(form) {
            if (form.$valid) {
                var godo = {
                    actionText: vm.godo.actionText,
                    status: vm.godo.status,
                    outcome: vm.godo.outcome,
                    duedate: vm.godo.duedate,
                    relatedContentId: vm.godo.relatedContentId
                };

                if(vm.godo.id == 'new'){
                  lebuApi.getGodos().post(godo).then(function() {
                      toastr.success(TranslationService.trans('profile-updated'));
                      lebuApi.getCurrentUser().get().then(function(response) {
                          $state.go('user', {userId: response.user.id}, {reload: true, notify: false}).then(function() {
                              $mdDialog.hide();
                          });
                      });
                  });
                }else{
                  vm.godo.put(godo).then(function() {
                      toastr.success(TranslationService.trans('profile-updated'));
                      lebuApi.getCurrentUser().get().then(function(response) {
                          $state.go('user', {userId: response.user.id}, {reload: true, notify: false}).then(function() {
                              $mdDialog.hide();
                          });
                      });
                  });
                }



            }
        }
        function cancel() {
            $mdDialog.hide();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('CourseSuggestController', CourseSuggestController);

    /** @ngInject */
    function CourseSuggestController($mdDialog, viewState) {
        var vm = this;
        vm.viewState = viewState;
        vm.querySearch = querySearch;
        vm.createFilterFor = createFilterFor;
        vm.loadContacts = loadContacts;
        vm.cancel = cancel;
        
        vm.allContacts = vm.loadContacts();
        
        function querySearch(query) {
            var filter = vm.createFilterFor(query);
            var results = query ? vm.allContacts.filter(filter) : [];
            return results;
        }
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(contact) {
                return (contact._lowername.indexOf(lowercaseQuery) != -1);
            };
        }
        function loadContacts() {
            var contacts = [
                'Giampaolo Chieddu Microsoft',
                'Marco Brambilla Microsoft',
                'Serena Locappio Lebu',
                'Mario Rossi Lebu',
                'Paolo Marchisio Microsoft',
                'Gennaro Pasquale Lebu',
                'Irene Grandi Lebu',
                'Marino Fronzoli Microsoft',
                'Gabriele Parisi Lebu'
            ];
            return contacts.map(function (c, index) {
                var cParts = c.split(' ');
                var contact = {
                    name: cParts[0] + ' ' + cParts[1],
                    email: cParts[2],
                    image: '/assets/images/user-' + (index%5 + 1) + '.jpg'
                };
                contact._lowername = contact.name.toLowerCase();
                return contact;
            });
        }
        function cancel() {
            $mdDialog.hide();
        }
        vm.contacts = [];
        vm.filterSelected = true;
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('CourseDetailController', CourseDetailController);

    /** @ngInject */
    function CourseDetailController($mdDialog, viewState, $state, course) {
        var vm = this;
        vm.viewState = viewState;
        vm.course = course;
        vm.enter = enter;
        vm.cancel = cancel;
        vm.showSuggest = showSuggest;
        vm.stars = getStars();

        function enter() {
            $mdDialog.hide().then(function() {
                $state.go('course', {courseId: vm.course.id});
            });
        }
        function cancel() {
            $mdDialog.hide();
        }
        function showSuggest(ev) {
            $mdDialog.show({
                templateUrl: './app/courseSuggest/courseSuggest.html',
                controller: 'CourseSuggestController',
                controllerAs: 'courseSuggest',
                clickOutsideToClose: true,
                targetEvent: ev
            });
            ev.stopPropagation();
        }
        function getStars() {
            return angular.isDefined(vm.course.rating) && vm.course.rating > 0
                ? new Array(Math.round(vm.course.rating))
                : [];
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('CourseController', CourseController);


  /** @ngInject */
  function CourseController($timeout, $rootScope, related, viewState, $state, course, TranslationService, toastr) {
      var vm = this;
      vm.course = course;
      vm.related = related;
      vm.unlockCode = '';
      vm.nextLesson = getNextLesson();
      vm.start = start;
      vm.getStartVerb = getStartVerb;
      vm.unlock = unlock;
      vm.viewState = viewState;
      vm.slickConfig = getSlickConfig();

      if (!$state.includes('course.lesson') && !vm.course.locked && vm.course.isStarted() && !vm.course.isCompleted()) {
          vm.start();
      }
      $timeout(function() {
          angular.element(window).resize();
      }, 1000);
      var onStateChangeStartHandler = $rootScope.$on('$stateChangeStart', function(event, toState) {
          if (toState.name == 'course') {
              $timeout(function() {
                  angular.element(window).resize();
              }, 1000);
          }
      });
      $rootScope.$on('$destroy', onStateChangeStartHandler);

      function getNextLesson() {
          var nextLesson = vm.course.nextUncompletedLesson();
          return nextLesson != null ? nextLesson : vm.course.lessons[0];
      }
      function getStartVerb() {
          if (vm.course.isStarted()) {
              if (vm.course.isCompleted()) {
                  return TranslationService.trans('start-again');
              }
              return TranslationService.trans('resume');
          }
          return TranslationService.trans('start');
      }
      function start() {
          if (!vm.course.isEnrolled) {
              vm.course.post('enroll').then(function() {
                  vm.course.isEnrolled = true;
                  $state.go('course.lesson', {
                      courseId: vm.course.id,
                      lessonId: vm.nextLesson.id
                  });
              });
          } else {
              $state.go('course.lesson', {
                  courseId: vm.course.id,
                  lessonId: vm.nextLesson.id
              });
          }
      }
      function unlock(form) {
          if (form.$valid) {
              var data = {unlock_code: vm.unlockCode};
              vm.course.post('unlock', data).then(function() {
                  toastr.success(TranslationService.trans('course-unlocked'));
                  vm.start();
              }, function() {
                  toastr.error(TranslationService.trans('wrong-unlocking-code'));
              });
          }
      }
      function getSlickConfig() {
        return {
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 6,
          slidesToScroll: 6,
          swipe: true,
          draggable: false,
          nextArrow: '<button class="md-fab md-button md-raised md-mini next-button"><md-icon class="material-icons">chevron_right</md-icon></button>',
          prevArrow: '<button class="md-fab md-button md-raised md-mini prev-button"><md-icon class="material-icons">chevron_left</md-icon></button>',
          respondTo: 'slider',
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 5
              }
            },
            {
              breakpoint: 1000,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4
              }
            },
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 599,
              settings: {
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: true,
                arrows: false
              }
            }
          ]
        };
      }
  }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('CompleteProfileController', CompleteProfileController);

    /** @ngInject */
    function CompleteProfileController($mdDialog, $document, $log, TranslationService, $rootScope, $state, lebuApi, toastr, viewState) {
        var vm = this;
        vm.user = $rootScope.currentUser;
        vm.tenant = $rootScope.currentTenant;
        vm.languages = $rootScope.languages;
        vm.viewState = viewState;
        vm.post = post;
        vm.openPrivacy = openPrivacy;
        vm.privacyBody = TranslationService.trans('privacy_modal_body'+ vm.tenant.configuration.privacyKeySuffix);
        vm.privacyConfirm = TranslationService.trans('privacy-confirm'+ vm.tenant.configuration.privacyKeySuffix);
        vm.closePrivacy = closePrivacy;

        vm.openPrivacy();



        function post(form) {
            form.$setSubmitted();
            if (form.$valid) {
                var user = {
                    name: vm.user.name,
                    surname: vm.user.surname,
                    company: vm.user.company,
                    job: vm.user.job,
                    language: vm.user.language,
                    city: vm.user.city,
                    country: vm.user.country,
                    biography: vm.user.biography,
                    privacy: vm.user.privacy
                };
                lebuApi.getUser(vm.user.id).patch(user).then(function() {
                    toastr.success(TranslationService.trans('profile-updated'));
                    lebuApi.getCurrentUser().get().then(function(response) {
                        $state.go('home', {userId: response.user.id}, {reload: true});
                    }, function(response) {
                        $log.log("There was an error: " + response);
                    });
                }, function(response) {
                    $log.log("There was an error: " + response);
                });
            } else {
                var firstInvalid = $document[0].getElementById('profileForm').querySelector('.ng-invalid');
                if (firstInvalid) firstInvalid.focus();
            }
        }
        function openPrivacy(ev) {
            $mdDialog.show({
                contentElement: '#privacyDialog',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }
        function closePrivacy() {
            $mdDialog.cancel();
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('CompareStatsController', CompareStatsController)

  /** @ngInject */
  function CompareStatsController(viewState, compareStats, lebuApi, $stateParams, $mdDialog, _, TranslationService) {
      var vm = this;
      vm.viewState = viewState;
      vm.parseStats = parseStats;
      vm.updateData = updateData;
      vm.compareStats = compareStats;
      vm.cancel = cancel;

      vm.parseStats();

      function parseStats() {
          vm.me = getMe();
          vm.other = getOther();
          vm.meData = getMeData();
          vm.meLabels = getMeLabels();
          vm.otherData = getOtherData();
          vm.otherLabels = getOtherLabels();
      }
      function updateData() {
          lebuApi.getUser($stateParams.userId).one('comparestat').get().then(function(compareStats) {
              vm.compareStats = compareStats;
              vm.parseStats();
          });
      }
      function getMe() {
          return vm.compareStats.me.user;
      }
      function getOther() {
          return vm.compareStats.other.user;
      }
      function getMeData() {
          return _.map(vm.compareStats.me.data, 'value');
      }
      function getMeLabels() {
          return _.map(vm.compareStats.me.data, function(o) {
              return TranslationService.trans(o.label);
          });
      }
      function getOtherData() {
          return _.map(vm.compareStats.other.data, 'value');
      }
      function getOtherLabels() {
          return _.map(vm.compareStats.other.data, function(o) {
              return TranslationService.trans(o.label);
          });
      }
      function cancel() {
          $mdDialog.hide();
      }
   }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .controller('CommunityController', CommunityController);

  /** @ngInject */
  function CommunityController(lebuApi, $scope, $rootScope, Optimization, _, $timeout, viewState) {
      var vm = this;
      vm.loadedPosts = [];
      vm.loadPosts = loadPosts;
      vm.typeFilter = null;
      vm.busy = false;
      vm.after = null;
      vm.reloadPosts = reloadPosts;
      vm.postsLoading = false;
      vm.emptyPosts = false;
      vm.searchText = '';
      vm.searchPosts = searchPosts;
      vm.getFromNow = getFromNow;
      vm.addPost = addPost;
      vm.viewState = viewState;

      var onSocialPostUpdatedHandler = $rootScope.$on('social:post:updated', vm.reloadPosts);
      $scope.$on('$destroy', onSocialPostUpdatedHandler);

      var onSocialPostAddHandler = $rootScope.$on('social:post:add', vm.addPost);
      $scope.$on('$destroy', onSocialPostAddHandler);

      function addPost(ev, args) {
          vm.loadedPosts.unshift(args.post);
          $timeout(function() {
              angular.element('#stories').masonry('layout');
          }, 500);
      }
      function reloadPosts() {
          vm.loadedPosts = [];
          vm.after = null;
          vm.emptyPosts = false;
          vm.loadPosts();
      }
      function loadPosts() {
          if (vm.busy || vm.emptyPosts) return;
          vm.busy = true;
          vm.postsLoading = true;
          var params = {
              limit: Optimization.POSTS_PAGE_SIZE
          };
          if (vm.after != null) {
              angular.extend(params, {after: vm.after});
          }
          if (vm.typeFilter != null) {
              angular.extend(params, {type: vm.typeFilter});
          }
          lebuApi.getPosts().getList(params).then(function(posts) {
              _.each(posts, function(post) {
                  vm.loadedPosts.push(post);
              });
              if (posts.length > 0) {
                  vm.after = vm.loadedPosts[vm.loadedPosts.length - 1].id;
              } else {
                  vm.emptyPosts = true;
              }
              vm.busy = false;
              vm.postsLoading = false;
              $timeout(function() {
                  angular.element('#stories').masonry('layout');
              }, 1000);
          }, function() {
              vm.busy = false;
              vm.postsLoading = false;
          });
      }
      function getFromNow(searchResult) {
          return moment.unix(searchResult.abstract).fromNow();
      }
      function searchPosts() {
          return lebuApi.getSearch().all('post').getList({q: vm.searchText}).$object;
      }
   }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('CommentLessonController', CommentLessonController);

    /** @ngInject */
    function CommentLessonController(viewState, $rootScope, $mdDialog, $stateParams, lebuApi, Upload, $log, toastr,TranslationService) {
        var vm = this;
        vm.viewState = viewState;
        vm.message = '';
        vm.socialPost = false;
        vm.user = $rootScope.currentUser;
        vm.post = post;
        vm.cancel = cancel;
        vm.attachment = null;
        vm.afterComment = afterComment;

        function post(form) {
            if (form.$valid) {
                var comment = angular.extend({}, vm.attachment, {
                    comment: vm.message,
                    isPost: vm.socialPost
                });
                if (comment.type == 4 || comment.type == 5 || comment.type == 7) {
                    Upload.upload({
                        url: '/lessons/' + $stateParams.lessonId + '/comment',
                        data: comment
                    }).then(function(response) {
                        vm.afterComment(response.data);
                    }, function(response) {
                        if (response.status > 0) {
                            $log.error(response.status + ': ' + response.data);
                        }
                    });
                } else {
                    lebuApi.getLesson($stateParams.lessonId).post('comment', comment).then(function(response) {
                        vm.afterComment(response);
                    });
                }
            }
        }
        function afterComment(comment) {
            $mdDialog.hide();
            if (comment.type == 7) {
                toastr.success(TranslationService.trans('alert-video-uploaded'));
            } else {
                toastr.success(TranslationService.trans('comment-inserted-successfully'));
                $rootScope.$broadcast('course:lesson:updated');
            }
        }
        function cancel() {
            $mdDialog.hide();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lebuFend')
        .controller('CommentDetailController', CommentDetailController);

    /** @ngInject */
    function CommentDetailController(comment, $rootScope, toastr, lebuApi, viewState, $mdDialog, $stateParams, TranslationService) {
        var vm = this;
        vm.cancel = cancel;
        vm.viewState = viewState;
        vm.comment = comment;
        vm.message = '';
        vm.answer = answer;
        vm.currentUser = $rootScope.currentUser;
        vm.videoPlayerTheme = '/assets/css/videogular.min.css';
        vm.videoPlayerApi = null;
        vm.onVideoPlayerReady = onVideoPlayerReady;

        function onVideoPlayerReady(videoApi) {
            vm.videoPlayerApi = videoApi;
        }
        function answer() {
            lebuApi.getLesson($stateParams.lessonId).post('comment', {
                comment: vm.message,
                type: 0,
                parentComment: vm.comment.id
            }).then(function(comment) {
                toastr.success(TranslationService.trans('answer-was-registered'));
                vm.message = '';
                vm.comment.children = comment.children;
                vm.comment.formOpened = false;
            });
        }
        function cancel() {
            $mdDialog.hide();
        }
    }
})();

angular.module("lebuFend")
.constant("Symfony", {"LOCALE":"en","WEBSOCKET_URL":"ws://52.208.9.252:8580","WAMP_URL":"ws://52.208.9.252:80"});

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .run(runBlock);

  /** @ngInject */
  function runBlock(cfpLoadingBar, $http, amMoment, TranslationService, $auth, $wamp, $rootScope, $state, Restangular, $sce, $previousState, grant, $mdMedia, viewState, toastr, $log, _) {
      $rootScope.$state = $state;
      $rootScope.$mdMedia = $mdMedia;
      $rootScope.languages = {
          it: 'Italiano',
          en: 'English',
          de: 'Deutsch',
          es: 'Español',
          fr: 'Français',
          hu: 'Magyar',
          pl: 'Polski',
          ro: 'Român',
          sv: 'Svenska',
          tr: 'Türkçe'
      };

      var onStateChangeStartHandler = $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState) {
          if (toState.name == 'denied' || toState.name == 'notfound' || toState.name == 'logout') return;
          if ($auth.isAuthenticated()) {
              if (toState.name === 'login') {
                  event.preventDefault();
                  if (fromState.name !== '') {
                      try { $previousState.go(); } catch(e) {
                          $state.go('home');
                          return;
                      }
                  } else {
                      $state.go('home');
                      return;
                  }
              } else if (fromState.name === '' && viewState.validateLocalStorage()) {
                  viewState.afterLogin();
              }
              if (toState.name == 'completeProfile' && !$rootScope.currentUser.hasRole('ROLE_USER_INCOMPLETE')) {
                  event.preventDefault();
                  return;
              } else if (toState.name != 'completeProfile' && toState.name != 'editPassword' && toState.name != 'intro' && $rootScope.currentUser.hasRole('ROLE_USER_INCOMPLETE')) {
                  event.preventDefault();
                  $state.go('completeProfile');
                  return;
              }
          } else {
              if (toState.name !== 'login') {
                  event.preventDefault();
                  $state.go('logout');
                  return;
              }
          }
          if (fromState.name === '' && angular.isDefined(toState.data) && toState.data.dialog) {
              var targetState = null;
              var targetParams = null;
              if ((/intro.*/.exec(toState.name) || /editPassword.*/.exec(toState.name)) && $rootScope.currentUser.hasRole('ROLE_USER_INCOMPLETE')) {
                  targetState = 'completeProfile';
              } else if (/courseDetail.*/.exec(toState.name) || /search.*/.exec(toState.name) || /messages.*/.exec(toState.name) || /compareStats.*/.exec(toState.name) || (new RegExp('event.*', 'i')).exec(toState.name)) {
                  targetState = 'home';
              } else if (/editProfile.*/.exec(toState.name) || /editPassword.*/.exec(toState.name) || /uploadAvatar.*/.exec(toState.name) || /uploadCover.*/.exec(toState.name)) {
                  targetState = 'user.posts';
                  targetParams = toParams;
              } else if (/socialPost.*/.exec(toState.name) || /postDetail.*/.exec(toState.name)) {
                  targetState = 'community';
              } else if (/commentLesson.*/.exec(toState.name) || /commentDetail.*/.exec(toState.name) || /rateCourse.*/.exec(toState.name)) {
                  targetState = 'course.lesson';
                  targetParams = toParams;
              } else if (/intro.*/.exec(toState.name) || /postDetail.*/.exec(toState.name)) {
                  targetState = 'community';
              }
              if (targetState != null) {
                  event.preventDefault();
                  $state.go(targetState, targetParams, {location: false}).then(function() {
                      $state.go(toState, toParams); }
                  );
              }
          }
      });
      $rootScope.$on('$destroy', onStateChangeStartHandler);

      grant.addTest('me', function() {
          return $rootScope.currentUser.id == this.stateParams.userId;
      });
      grant.addTest('profileComplete', function() {
          return !$rootScope.currentUser.hasRole('ROLE_USER_INCOMPLETE');
      });
      Restangular.setErrorInterceptor(function(response) {
          if (response.status === 403 || response.status === 401) {
              $state.go('logout');
              return false;
          }
          if (response.status !== 400) {
              toastr.error(response.data, {
                  closeButton: true,
                  timeOut: 0
              });
              $log.error('Lebu API error: ' + response.data + ' (status ' + response.status + ')');
              cfpLoadingBar.complete();
              return false;
          }
          return true;
      });
      Restangular.addResponseInterceptor(function(data, operation, what) {
          if (what == 'currentuser') {
              var user = angular.extend(data.user, {_roles: data.roles});
              //unreadedMessages
              var unreadedUserMessages = 0;
              for (var i=0, to=data.unreadedMessages.length; i<to;i++){
                  unreadedUserMessages += data.unreadedMessages[i].unread
              }
              localStorage.setItem('user', angular.toJson(user));
              localStorage.setItem('tenant', angular.toJson(data.tenant));
              localStorage.setItem('config', angular.toJson(data.configuration));
              localStorage.setItem('realtime', angular.toJson({
                  unreadedMessages: Number(unreadedUserMessages), 
                  unreadedNotices: Number(data.unreadedNotices.length)
              }));
              if (angular.isDefined(data.event)) {
                  var notification = {
                      id: data.event.id,
                      title: TranslationService.trans(data.event.title),
                      type: data.event.type,
                      options: data.event.options,
                      body: $sce.trustAsHtml(data.event.htmlContent),
                      state: 'event'
                  };
                  viewState.notifications = [notification];
                  localStorage.setItem('event', angular.toJson(data.event));
                  var realtime = angular.fromJson(localStorage.getItem('realtime'));
                  realtime.unreadedNotices ++;
                  localStorage.setItem('realtime', angular.toJson(realtime));
                  viewState.unreadedNotices = realtime.unreadedNotices;
              } else {
                  viewState.notifications = [];
                  localStorage.removeItem('event');
              }
              if (angular.isDefined(data.unreadedNotices)) {
                  var realtime = angular.fromJson(localStorage.getItem('realtime'));
                  for (var i=0; i<data.unreadedNotices.length; i++){
                      var currentNotice = data.unreadedNotices[i];
                      var notice = {
                              id: currentNotice.entity.id,
                              title: TranslationService.trans("notice-" + currentNotice.entityType + "-" + currentNotice.action),
                              type: currentNotice.entityType,
                              state: null
                      }

                      switch(currentNotice.entityType){
                          case 'post':
                              notice.state = 'postDetail';
                              break;
                          case 'user':
                              if (currentNotice.action == "follow"){
                                  notice.id = currentNotice.actor.id;
                              }
                              notice.state = 'user';
                              break;
                          case 'lesson':
                              notice.state = 'course.lesson';
                              notice.id = {lesson: currentNotice.entity.id, course: currentNotice.entity.courseId};
                              break;
                          default:
                              break;
                      }

                      viewState.notifications.unshift(notice);
                      realtime.unreadedNotices ++;
                    }
                  localStorage.setItem('realtime', angular.toJson(realtime));
                  viewState.unreadedNotices = realtime.unreadedNotices;
              }
              if (angular.isDefined(data.configuration.theme)) {
                  viewState.theme = data.configuration.theme.id;
                  localStorage.setItem('theme', viewState.theme);
              }
              if (angular.isDefined(user.language)) {
                  viewState.locale = user.language;
                  localStorage.setItem('locale', user.language);
              }
              Restangular.restangularizeElement(null, user, 'currentuser/');
              $rootScope.currentUser = user;
              $rootScope.currentTenant = data.tenant;
          }
          return data;
      });
      Restangular.addElementTransformer('posts/', false, function(post) {
          if (post.type == 3) {
              post.resourceLink = $sce.trustAsResourceUrl(post.resourceLink + '?rel=0&amp;showinfo=0');
          }
          if (post.type == 6 && !angular.isArray(post.message)) {
              post.message = new Array(Math.round(post.message));
          }
          if (post.byStaff) {
              post.message = $sce.trustAsHtml(post.message);
          }
          return post;
      });
      Restangular.addElementTransformer('posts', true, function(posts) {
          angular.forEach(posts, function(post) {
              if (post.type == 3) {
                  post.resourceLink = $sce.trustAsResourceUrl(post.resourceLink + '?rel=0&amp;showinfo=0');
              }
              if (post.type == 6) {
                  post.message = new Array(Math.round(post.message));
              }
          });
          return posts;
      });
      Restangular.extendModel('posts/', function(model) {
          model.getFormattedCreationDate = function() {
              return moment.unix(model.created).format('dddd, D MMMM YYYY');
          };
          model.getVideoResources = _.memoize(function() {
              var resources = [];
              if (model.type == 7 && model.og && model.og['og:video:url'] && angular.isArray(model.og['og:video:url'])) {
                  angular.forEach(model.og['og:video:url'], function(resource) {
                      resources.push({
                          src: $sce.trustAsResourceUrl(resource.url),
                          type: resource.type
                      });
                  });
              }
              return resources;
          });
          model.getCourseSref = function() {
              if (model.type == 1 || model.type == 6) {
                  var courseId = Number(_.last(_.split(model.og['og:url'], '/')));
                  return 'courseDetail({courseId:' + courseId + '})';
              }
              return '';
          };
          model.isMine = function() {
              return model.user.id == $rootScope.currentUser.id;
          };
          return model;
      });
      Restangular.extendModel('currentuser/', function(model) {
          model.hasRole = function(roles) {
              var requiredRoles = angular.isArray(roles) ? roles : [roles];
              return _.intersection(requiredRoles, model._roles).length > 0;
          };
          return model;
      });
      Restangular.extendCollection('posts', function(collection) {
          angular.forEach(collection, function(post) {
              Restangular.restangularizeElement(null, post, 'posts/');
          });
          return collection;
      });
      Restangular.extendModel('lessons/', function(model) {
          model.getVideoResources = _.memoize(function() {
              var videos = [];
              if (model.resource && model.resource.video && angular.isArray(model.resource.video)) {
                  angular.forEach(model.resource.video, function(video) {
                      var resources = [];
                      angular.forEach(video.resources, function(resource) {
                          resources.push({
                              src: $sce.trustAsResourceUrl(resource.url),
                              type: resource.mimeType
                          });
                      });
                      videos.push({
                          name: TranslationService.trans('video-quality-' + video.name.toLowerCase()),
                          sources: resources
                      });
                  });
              }
              return videos;
          });
          return model;
      });
      Restangular.extendModel('comments/', function(model) {
          model.getFormattedCreationDate = function() {
              return moment.unix(model.created).format('dddd, D MMMM YYYY');
          };
          return model;
      });
      Restangular.addElementTransformer('lessons/', false, function(lesson) {
          angular.forEach(lesson.comments, function(comment) {
              if (comment.type == 3) {
                  comment.resourceLink = $sce.trustAsResourceUrl(comment.resourceLink + '?rel=0&amp;showinfo=0');
              }
          });
          return lesson;
      });
      Restangular.addElementTransformer('comments', true, function(comments) {
          angular.forEach(comments, function(comment) {
              if (comment.type == 3) {
                  comment.resourceLink = $sce.trustAsResourceUrl(comment.resourceLink + '?rel=0&amp;showinfo=0');
              }
          });
          return comments;
      });
      Restangular.addElementTransformer('ranking', true, function(ranking) {
          angular.forEach(ranking, function(user, index) {
              user.position = index + 1;
          });
          return ranking;
      });
      Restangular.extendModel('categories/', function(model) {
          model.map = function() {
              return $.map(model.children, function(el) { return el });
          };
          model.tree = function() {
              return Arboreal.parse(model, 'children');
          };
          model.find = function(id, findBySlug, returnNode) {
              var category = null;
              model.tree().find(function (node) {
                  var comparator = findBySlug ? node.data.slug : node.data.id;
                  if (comparator == id) {
                      category = returnNode ? node : node.data;
                  }
              });
              return category;
          };
          model.history = function(slug) {
              var node = model.find(slug, true, true);
              var history = [node.data];
              var complete = false;
              node.traverseUp(function(n) {
                  if (!complete && (n.depth < node.depth)) {
                      history.push(this.data);
                  }
                  if (n.depth == '1') complete = true;
              });
              history[0].current = true;
              history.reverse();
              return history;
          };
          model.childrenNodes = function(slug) {
              var node = model.find(slug, true, true);
              var children = [];
              node.traverseDown(function(n) {
                  if (n.parent.data.id == node.data.id) {
                      children.push(n.data);
                  }
              });
              return children;
          };
          return model;
      });
      Restangular.extendModel('courses/', function(model) {
          model.nextUncompletedLesson = function() {
              for (var i = 0; i < model.lessons.length; i++) {
                  var lesson = model.lessons[i];
                  if (!lesson.completed) {
                      return lesson;
                  }
              }
              return null;
          };
          model.nextLesson = function(id) {
              for (var i = 0; i < model.lessons.length; i++) {
                  if (model.lessons[i].id == id && i < model.lessons.length - 1) {
                      return model.lessons[i + 1];
                  }
              }
              return null;
          };
          model.prevLesson = function(id) {
              for (var i = 0; i < model.lessons.length; i++) {
                  if (model.lessons[i].id == id && i > 0) {
                      return model.lessons[i - 1];
                  }
              }
              return null;
          };
          model.getLesson = function(id) {
              for (var i = 0; i < model.lessons.length; i++) {
                  var lesson = model.lessons[i];
                  if (lesson.id == id) {
                      return lesson;
                  }
              }
              return null;
          };
          model.getLessonIndex = function(id) {
              for (var i = 0; i < model.lessons.length; i++) {
                  var lesson = model.lessons[i];
                  if (lesson.id == id) {
                      return i;
                  }
              }
              return null;
          };
          model.isLastLesson = function(id) {
              if (model.lessons.length > 0) {
                  return model.lessons[model.lessons.length - 1].id == id;
              }
              return false;
          };
          model.isCompleted = function() {
              for (var i = 0; i < model.lessons.length; i++) {
                  var lesson = model.lessons[i];
                  if (!lesson.completed) {
                      return false;
                  }
              }
              return true;
          };
          model.isStarted = function() {
              for (var i = 0; i < model.lessons.length; i++) {
                  var lesson = model.lessons[i];
                  if (lesson.completed) {
                      return true;
                  }
              }
              return false;
          };
          model.getSpeakers = function() {
              return _.map(model.speakers, function(speaker) {
                  return [speaker.name, speaker.surname].join(', ');
              });
          };
          return model;
      });
      Restangular.extendModel('talks/', function(model) {
          if (angular.isObject(model)) {
              model.formatPersons = function() {
                  if (model.persons.length > 2) {
                      var rv = [];
                      _.each(model.persons, function(person) {
                          if (person.id != $rootScope.currentUser.id) {
                              rv.push(person.name);
                          }
                      });
                      return rv.join(', ');
                  }
                  if (model.persons.length == 2) {
                      if (model.persons[0].id != $rootScope.currentUser.id) {
                          return model.persons[0].name + ' ' + model.persons[0].surname;
                      }
                      return model.persons[1].name + ' ' + model.persons[1].surname;
                  }
                  return '';
              };
              model.getInterlocutorAvatar = function() {
                  if (model.persons.length > 2) {
                      return '/assets/images/group.jpg';
                  }
                  if (model.persons.length == 2) {
                      if (model.persons[0].id != $rootScope.currentUser.id) {
                          return model.persons[0].picture;
                      }
                      return model.persons[1].picture;
                  }
                  return '';
              };
          }
          return model;
      });
    }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
      $stateProvider
          .state('root', {
              url: '/',
              deepStateRedirect: {default: 'home'}
          })
          .state('login', {
              url: '/login',
              resolve: {
                  config: function($http, viewState, $rootScope) {
                      return $http({method: 'GET', url: '/configuration'})
                          .then(function(config) {
                              if (angular.isObject(config)) {
                                  if (angular.isDefined(config.data.gacode) && config.data.gacode != '' && config.data.gacode != null) {
                                      $rootScope.trackingId = config.data.gacode;
                                  }
                                  if (angular.isDefined(config.data.language) && config.data.language != '' && config.data.language != null) {
                                      viewState.locale = config.data.language;
                                      localStorage.setItem('locale', viewState.locale);
                                  }
                                  if (angular.isDefined(config.data.theme) && config.data.theme != '' && config.data.theme != null) {
                                      viewState.theme = config.data.theme;
                                      localStorage.setItem('theme', viewState.theme);
                                      viewState.updateTheme();
                                  }
                                  if (angular.isDefined(config.data.linkedinEnabled) && typeof(config.data.linkedinEnabled) === "boolean") {
                                      viewState.linkedinEnabled = config.data.linkedinEnabled;
                                      localStorage.setItem('linkedinEnabled', viewState.linkedinEnabled);
                                  }
                              }
                          });
                  },
                  translate: function(viewState, config) {
                      return viewState.updateLocale();
                  }
              },
              views: {
                  main: {
                      controller: 'LoginController',
                      controllerAs: 'login',
                      templateUrl: './app/login/login.html'
                  }
              }
          })
          .state('logout', {
              url: '/logout',
              views: {
                  logout: {
                      controller: function($auth, $rootScope, viewState, $state, $stickyState) {
                          $auth.logout().then(function() {
                              $rootScope.authenticated = false;
                              viewState.resetLocalStorage();
                              viewState.disconnectWs();
                              $stickyState.reset('main');
                              $state.go('login');
                          });
                      },
                      controllerAs: 'logout'
                  }
              }
          })
          .state('completeProfile', {
              url: '/completeProfile',
              sticky: true,
              resolve: {
                  translate: function (viewState) {
                      return viewState.updateLocale();
                  }
              },
              views: {
                  main: {
                      templateUrl: './app/completeProfile/completeProfile.html',
                      controller: 'CompleteProfileController',
                      controllerAs: 'completeProfile'
                  }
              }
          })
          .state('search', {
              url: '/search',
              template: '<div ui-view></div>',
              onEnter: openSearchDialog
          })
          .state('intro', {
              url: '/intro',
              template: '<div ui-view></div>',
              data: {dialog: true},
              onEnter: openIntroDialog
          })
          .state('courseDetail', {
              url: '/courseDetail/:courseId',
              template: '<div ui-view></div>',
              resolve: {
                  course: function(lebuApi, $stateParams) {
                      return lebuApi.getCourse($stateParams.courseId).get();
                  }
              },
              data: {dialog: true},
              onEnter: openCourseDetailDialog
          })
          .state('socialPost', {
              url: '/socialPost/:type',
              template: '<div ui-view></div>',
              data: {dialog: true},
              onEnter: openSocialPostDialog
          })
          .state('commentLesson', {
              url: '/commentLesson/:courseId/:lessonId',
              template: '<div ui-view></div>',
              data: {dialog: true},
              onEnter: openCommentLessonDialog
          })
          .state('rateCourse', {
              url: '/rateCourse/:courseId/:lessonId',
              template: '<div ui-view></div>',
              data: {dialog: true},
              onEnter: openRateCourseDialog
          })
          .state('messages', {
              url: '/messages',
              template: '<div ui-view></div>',
              params: {recipientId: null},
              resolve: {
                  talks: function(lebuApi) {
                      return lebuApi.getTalks().getList();
                  },
                  contacts: function(lebuApi) {
                      return lebuApi.getUsers().getList();
                  }
              },
              data: {dialog: true},
              onEnter: openMessagesDialog
          })
          .state('messages.talk', {
              url: '/talk/:talkId',
              templateUrl: './app/messages/talk/talk.html',
              controller: 'MessagesTalkController',
              controllerAs: 'messagesTalk',
              resolve: {
                  talk: function(lebuApi, $stateParams) {
                      return lebuApi.getTalk($stateParams.talkId).getList();
                  }
              },
              onEnter: function($mdSidenav, $mdMedia, $timeout, $state) {
                  if (!$mdMedia('gt-sm')) {
                      $timeout(function() {
                          $mdSidenav('talkNav').onClose(function() {
                              $state.go('messages');
                          })
                          $mdSidenav('talkNav').open();
                      });
                  }
              },
              onExit: function($mdSidenav, $mdMedia, $timeout) {
                  if (!$mdMedia('gt-sm')) {
                      $timeout(function() {
                          $mdSidenav('talkNav').close();
                      });
                  }
              }
          })
          .state('editProfile', {
              url: '/editProfile/:userId',
              template: '<div ui-view></div>',
              resolve: {
                  user: function(lebuApi, $stateParams) {
                      return lebuApi.getUser($stateParams.userId).get();
                  },
                  me: function(grant, $stateParams) {
                      return grant.only({test: 'me', state: 'denied'}, $stateParams);
                  }
              },
              data: {dialog: true},
              onEnter: openEditProfileDialog
          })
          .state('editGodo', {
              url: '/editGodo/:godoId',
              template: '<div ui-view></div>',
              resolve: {
                  godo: function(lebuApi, $stateParams) {
                      return lebuApi.getGodo($stateParams.godoId).get();
                  }
              },
              data: {dialog: true},
              onEnter: openEditGodoDialog
          })
          .state('createGodo', {
              url: '/createGodo',
              template: '<div ui-view></div>',
              resolve: {
                  godo: function() {
                      return {id:'new', actionText: '',status: 0, outcome: '',duedate: 0}
                  }
              },
              data: {dialog: true},
              onEnter: openEditGodoDialog
          })
          .state('editPassword', {
              url: '/editPassword/:userId',
              template: '<div ui-view></div>',
              resolve: {
                  user: function(lebuApi, $stateParams) {
                      return lebuApi.getUser($stateParams.userId).get();
                  },
                  me: function(grant, $stateParams) {
                      return grant.only({test: 'me', state: 'denied'}, $stateParams);
                  }
              },
              data: {dialog: true},
              onEnter: openEditPasswordDialog
          })
          .state('uploadAvatar', {
              url: '/uploadAvatar/:userId',
              template: '<div ui-view></div>',
              resolve: {
                  user: function(lebuApi, $stateParams) {
                      return lebuApi.getUser($stateParams.userId).get();
                  },
                  me: function(grant, $stateParams) {
                      return grant.only({test: 'me', state: 'denied'}, $stateParams);
                  }
              },
              data: {dialog: true},
              onEnter: openUploadAvatarDialog
          })
          .state('uploadCover', {
              url: '/uploadCover/:userId',
              template: '<div ui-view></div>',
              resolve: {
                  user: function(lebuApi, $stateParams) {
                      return lebuApi.getUser($stateParams.userId).get();
                  },
                  me: function(grant, $stateParams) {
                      return grant.only({test: 'me', state: 'denied'}, $stateParams);
                  }
              },
              data: {dialog: true},
              onEnter: openUploadCoverDialog
          })
          .state('compareStats', {
              url: '/compareStats/:userId',
              template: '<div ui-view></div>',
              resolve: {
                  compareStats: function(lebuApi, $stateParams) {
                      return lebuApi.getUser($stateParams.userId).one('comparestat').get();
                  }
              },
              data: {dialog: true},
              onEnter: openCompareStatsDialog
          })
          .state('postDetail', {
              url: '/postDetail/:postId',
              template: '<div ui-view></div>',
              resolve: {
                  post: function(lebuApi, $stateParams) {
                      return lebuApi.getPost($stateParams.postId).get();
                  }
              },
              data: {dialog: true},
              onEnter: openPostDetailDialog
          })
          .state('commentDetail', {
              url: '/commentDetail/:courseId/:lessonId/:commentId',
              template: '<div ui-view></div>',
              resolve: {
                  comment: function(lebuApi, $stateParams) {
                      return lebuApi.getLessonComment($stateParams.lessonId, $stateParams.commentId).get();
                  }
              },
              data: {dialog: true},
              onEnter: openCommentDetailDialog
          })
          .state('event', {
              url: '/event',
              template: '<div ui-view></div>',
              data: {dialog: true},
              onEnter: openEventDialog
          })
          .state('main', {
              sticky: true,
              deepStateRedirect: {default: 'home'},
              url: '',
              views: {
                  main: {
                      controller: 'MainController',
                      controllerAs: 'main',
                      templateUrl: './app/main/main.html'
                  }
              },
              resolve: {
                  translate: function (viewState) {
                      return viewState.updateLocale();
                  },
                  categories: function(lebuApi) {
                      return lebuApi.getCategories().get({view: 'tree'});
                  }
              }
          })
          .state('denied', {
              parent: 'main',
              url: '/denied',
              template: '<h1>Accesso negato</h1>'
          })
          .state('notfound', {
              url: '/notfound',
              views: {
                  main: {
                      template: '<h1>Pagina non trovata</h1>'
                  }
              }
          })
          .state('home', {
              parent: 'main',
              url: '/home',
              templateUrl: './app/home/home.html',
              controller: 'HomeController',
              controllerAs: 'home',
              resolve: {
                  strips: function(lebuApi) {
                      return lebuApi.getHomestrips().get();
                  }
              },
              onEnter: function($timeout, viewState, $state) {
                  $timeout(function() {
                      angular.element(window).resize();
                      if(viewState.themeHome !==null){
                        $state.go(viewState.themeHome);
                      }
                      if (!localStorage.getItem('homeTutorialDone')) {
                          viewState.startHomeTutorial();
                      } else if (viewState.hasIntro && !localStorage.getItem('introDone')) {
                          $state.go('intro');
                      } else if (viewState.notifications.length > 0) {
                          $state.go('event');
                      }
                  }, 1000);
              }
          })
          .state('library', {
              parent: 'main',
              url: '/library/:categorySlug',
              templateUrl: './app/library/library.html',
              controller: 'LibraryController',
              controllerAs: 'library',
              resolve: {
                  courses: function(lebuApi, $stateParams, categories) {
                      return lebuApi.getCourses().getList({
                          cat: categories.find($stateParams.categorySlug, true).id
                      });
                  }
              }
          })
          .state('enrolled', {
              parent: 'main',
              url: '/enrolled',
              templateUrl: './app/enrolled/enrolled.html',
              controller: 'EnrolledController',
              controllerAs: 'enrolled',
              resolve: {
                  courses: function(lebuApi, $rootScope) {
                      return lebuApi.getUser($rootScope.currentUser.id).getList('courses');
                  }
              }
          })
          .state('playlists', {
              parent: 'main',
              url: '/playlists',
              templateUrl: './app/playlists/playlists.html',
              controller: 'PlaylistsController',
              controllerAs: 'playlists',
              resolve: {
                  playlists: function(lebuApi) {
                      return lebuApi.getPlaylists().getList();
                  }
              }
          })
          .state('playlist', {
              parent: 'main',
              url: '/playlist/:playlistId',
              templateUrl: './app/playlist/playlist.html',
              controller: 'PlaylistController',
              controllerAs: 'playlist',
              resolve: {
                  playlist: function(lebuApi, $stateParams) {
                      return lebuApi.getPlaylist($stateParams.playlistId).get();
                  }
              }
          })
          .state('course', {
              parent: 'main',
              url: '/course/:courseId',
              templateUrl: './app/course/course.html',
              controller: 'CourseController',
              controllerAs: 'course',
              resolve: {
                  course: function(lebuApi, $stateParams) {
                      return lebuApi.getCourse($stateParams.courseId).get();
                  },
                  related: function(lebuApi, course) {
                      return lebuApi.getCourses().getList({
                          cat: course.category.id
                      });
                  }
              }
          })
          .state('course.lesson', {
              url: '/lesson/:lessonId',
              templateUrl: './app/lesson/lesson.html',
              controller: 'LessonController',
              controllerAs: 'lesson',
              resolve: {
                  lesson: function(lebuApi, $stateParams) {
                      return lebuApi.getLesson($stateParams.lessonId).get();
                  }
              },
              onEnter: function($rootScope, lesson, course, $timeout) {
                  $timeout(function() {
                      $rootScope.$broadcast('lesson:enter', {course: course, lesson: lesson});
                  });
              }
          })
          .state('user', {
              parent: 'main',
              url: '/user/:userId',
              templateUrl: './app/user/user.html',
              controller: 'UserController',
              controllerAs: 'user',
              resolve: {
                  user: function(lebuApi, $stateParams) {
                      return lebuApi.getUser($stateParams.userId).get();
                  },
                  userStats: function(user) {
                      return user.one('userstats').get();
                  }
              },
              deepStateRedirect: {
                  params: true,
                  default: {state: 'user.posts'}
              }
          })
          .state('user.posts', {
              url: '/posts',
              views: {
                  posts: {
                      templateUrl: './app/user/posts/posts.html',
                      controller: 'UserPostsController',
                      controllerAs: 'userPosts'
                  }
              },
              data: {selectedTab: 0}
          })
          .state('user.courses', {
              url: '/courses',
              resolve: {
                  userCourses: function(user) {
                      return user.one('courses').get();
                  }
              },
              views: {
                  courses: {
                      templateUrl: './app/user/courses/courses.html',
                      controller: 'UserCoursesController',
                      controllerAs: 'userCourses'
                  }
              },
              data: {selectedTab: 1}
          })
          .state('user.stats', {
              url: '/stats',
              resolve: {
                  timeStats: function(user) {
                      return user.one('timestats').get();
                  },
                  categoryStats: function(user) {
                      return user.one('categorystats').get();
                  },
                  coursesStats: function(user) {
                      return user.one('coursesstats').get();
                  }
              },
              views: {
                  stats: {
                      templateUrl: './app/user/stats/stats.html',
                      controller: 'UserStatsController',
                      controllerAs: 'userStats'
                  }
              },
              data: {selectedTab: 2}
          })
          .state('user.contacts', {
              url: '/contacts',
              views: {
                  contacts: {
                      templateUrl: './app/user/contacts/contacts.html',
                      controller: 'UserContactsController',
                      controllerAs: 'userContacts'
                  }
              },
              data: {selectedTab: 3}
          })
          .state('user.godos', {
              url: '/godos',
              views: {
                  godos: {
                      templateUrl: './app/user/godos/godos.html',
                      controller: 'UserGodosController',
                      controllerAs: 'userGodos'
                  }
              },
              data: {selectedTab: 4}
          })
          .state('news', {
              parent: 'main',
              url: '/news',
              templateUrl: './app/news/news.html',
              controller: 'NewsController',
              controllerAs: 'news'
          })
          .state('community', {
              parent: 'main',
              url: '/community',
              templateUrl: './app/community/community.html',
              controller: 'CommunityController',
              controllerAs: 'community'
          })
          .state('repository', {
              parent: 'main',
              url: '/repository',
              templateUrl: './app/repository/repository.html',
              controller: 'RepositoryController',
              controllerAs: 'repository',
              resolve: {
                  documents: function(lebuApi) {
                      return lebuApi.getRepositories().getList();
                  }
              }
          });

      $urlRouterProvider.otherwise('/notfound');

      function openSearchDialog($mdDialog, $previousState) {
          $previousState.memo('searchInvoker');
          $mdDialog.show({
              fullscreen: true,
              templateUrl: './app/search/search.html',
              controller: 'SearchController',
              controllerAs: 'search',
              clickOutsideToClose: true,
              onRemoving: function() {
                  $previousState.go('searchInvoker');
              }
          });
      }
      function openIntroDialog($mdDialog, $previousState, viewState) {
          if (viewState.hasIntro) {
              $previousState.memo('introInvoker');
              $mdDialog.show({
                  templateUrl: './app/intro/intro.html',
                  controller: 'IntroController',
                  locals: {intro: viewState.intro},
                  controllerAs: 'intro',
                  onRemoving: function() {
                      localStorage.setItem('introDone', true);
                      $previousState.go('introInvoker');
                  }
              });
          } else {
              $previousState.go();
          }
      }
      function openCourseDetailDialog($mdDialog, course, $previousState) {
          $previousState.memo('courseDetailInvoker');
          $mdDialog.show({
              templateUrl: './app/courseDetail/courseDetail.html',
              controller: 'CourseDetailController',
              controllerAs: 'courseDetail',
              locals: {course: course},
              clickOutsideToClose: true,
              onRemoving: function() {
                  $previousState.go('courseDetailInvoker');
              }
          });
      }
      function openSocialPostDialog($mdDialog, $previousState) {
          $previousState.memo('socialPostInvoker');
          $mdDialog.show({
              templateUrl: './app/socialPost/socialPost.html',
              controller: 'SocialPostController',
              controllerAs: 'socialPost',
              onRemoving: function() {
                  $previousState.go('socialPostInvoker');
              }
          });
      }
      function openCommentLessonDialog($mdDialog, $previousState) {
          $previousState.memo('commentLessonInvoker');
          $mdDialog.show({
              templateUrl: './app/commentLesson/commentLesson.html',
              controller: 'CommentLessonController',
              controllerAs: 'commentLesson',
              onRemoving: function() {
                  $previousState.go('commentLessonInvoker');
              }
          });
      }
      function openRateCourseDialog($mdDialog, $previousState) {
          $previousState.memo('rateCourseInvoker');
          $mdDialog.show({
              templateUrl: './app/rateCourse/rateCourse.html',
              controller: 'RateCourseController',
              controllerAs: 'rateCourse',
              onRemoving: function() {
                  $previousState.go('rateCourseInvoker');
              }
          });
      }
      function openMessagesDialog($mdDialog, talks, contacts, $previousState) {
          $previousState.memo('messagesInvoker');
          $mdDialog.show({
              fullscreen: true,
              templateUrl: './app/messages/messages.html',
              controller: 'MessagesController',
              controllerAs: 'messages',
              locals: {talks: talks, contacts: contacts},
              onRemoving: function() {
                  $previousState.go('messagesInvoker');
              }
          });
      }
      function openEditProfileDialog($mdDialog, user, $previousState) {
          $previousState.memo('editProfileInvoker');
          $mdDialog.show({
              templateUrl: './app/editProfile/editProfile.html',
              controller: 'EditProfileController',
              controllerAs: 'editProfile',
              locals: {user: user},
              onRemoving: function() {
                  $previousState.go('editProfileInvoker');
              }
          });
      }
      function openEditGodoDialog($mdDialog, godo, $previousState) {
          $previousState.memo('editGodoInvoker');
          $mdDialog.show({
              templateUrl: './app/editGodo/editGodo.html',
              controller: 'EditGodoController',
              controllerAs: 'editGodo',
              locals: {godo: godo},
              onRemoving: function() {
                  $previousState.go('editGodoInvoker');
              }
          });
      }
      function openEditPasswordDialog($mdDialog, user, $previousState) {
          $previousState.memo('editPasswordInvoker');
          $mdDialog.show({
              templateUrl: './app/editPassword/editPassword.html',
              controller: 'EditPasswordController',
              controllerAs: 'editPassword',
              locals: {user: user},
              onRemoving: function() {
                  $previousState.go('editPasswordInvoker');
              }
          });
      }
      function openUploadAvatarDialog($mdDialog, user, $previousState) {
          $previousState.memo('uploadAvatarInvoker');
          $mdDialog.show({
              templateUrl: './app/uploadAvatar/uploadAvatar.html',
              controller: 'UploadAvatarController',
              controllerAs: 'uploadAvatar',
              locals: {user: user},
              onRemoving: function() {
                  $previousState.go('uploadAvatarInvoker');
              }
          });
      }
      function openUploadCoverDialog($mdDialog, user, $previousState) {
          $previousState.memo('uploadCoverInvoker');
          $mdDialog.show({
              templateUrl: './app/uploadCover/uploadCover.html',
              controller: 'UploadCoverController',
              controllerAs: 'uploadCover',
              locals: {user: user},
              onRemoving: function() {
                  $previousState.go('uploadCoverInvoker');
              }
          });
      }
      function openCompareStatsDialog($mdDialog, compareStats, $previousState) {
          $previousState.memo('compareStatsInvoker');
          $mdDialog.show({
              templateUrl: './app/compareStats/compareStats.html',
              controller: 'CompareStatsController',
              controllerAs: 'compareStats',
              locals: {compareStats: compareStats},
              clickOutsideToClose: true,
              onRemoving: function() {
                  $previousState.go('compareStatsInvoker');
              }
          });
      }
      function openPostDetailDialog($mdDialog, post, $previousState) {
          $previousState.memo('postDetailInvoker');
          $mdDialog.show({
              templateUrl: './app/postDetail/postDetail.html',
              controller: 'PostDetailController',
              controllerAs: 'postDetail',
              locals: {post: post},
              clickOutsideToClose: true,
              fullscreen: post.byStaff,
              onRemoving: function() {
                  $previousState.go('postDetailInvoker');
              }
          });
      }
      function openCommentDetailDialog($mdDialog, comment, $previousState) {
          $previousState.memo('commentDetailInvoker');
          $mdDialog.show({
              templateUrl: './app/commentDetail/commentDetail.html',
              controller: 'CommentDetailController',
              controllerAs: 'commentDetail',
              locals: {comment: comment},
              clickOutsideToClose: true,
              onRemoving: function() {
                  $previousState.go('commentDetailInvoker');
              }
          });
      }
      function openEventDialog($mdDialog, $previousState, viewState) {
          if (viewState.notifications.length > 0) {
              $previousState.memo('eventInvoker');
              $mdDialog.show({
                  fullscreen: true,
                  templateUrl: './app/event/event.html',
                  controller: 'EventController',
                  controllerAs: 'event',
                  locals: {event: viewState.notifications[0]},
                  onRemoving: function() {
                      $previousState.go('eventInvoker');
                  }
              });
          } else {
              $previousState.go();
          }
      }
   }
})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .constant('Environment', {
        SUPPORTED_LOCALES: ['it', 'en'],
        DEFAULT_LOCALE: 'en',
        DEFAULT_THEME: 'lebu',
        DEFAULT_LINKEDIN_ENABLED: true,
        PREVIEW_URL: '/preview/c/'
    })
    .constant('Optimization', {
        POSTS_PAGE_SIZE: 6,
        POSTS_PREVIEW_PAGE_SIZE: 12
    })
    .constant('LocalStorage', {
        SCHEMA: {
          type: 'object',
          not: {type: 'null'},
          required: ['config', 'user', 'tenant', 'locale', 'theme'],
          properties: {
            config: {
              type: 'object',
              required: ['modules'],
              not: {type: 'null'},
              properties: {
                modules: {
                  type: 'array',
                  not: {type: 'null'},
                  uniqueItems: true,
                  items: {
                    type: 'string'
                  }
                },
                theme: {
                  type: 'object',
                  not: {type: 'null'},
                  required: ['id', 'brandUrl', 'brandHeaderUrl', 'brandNavbarUrl', 'brandFooterUrl']
                },
                homeCategories: {
                  type: 'array',
                  not: {type: 'null'},
                  uniqueItems: true,
                  items: {
                    type: 'number'
                  }
                },
                homeMetaCategories: {
                  type: 'array',
                  not: {type: 'null'},
                  uniqueItems: true,
                  items: {
                    type: 'string'
                  }
                }
              }
            },
            user: {
              type: 'object',
              not: {type: 'null'}
            },
            tenant: {
              type: 'object',
              not: {type: 'null'}
            },
            locale: {
              type: 'string',
              not: {type: 'null'}
            },
            theme: {
              type: 'string',
              not: {type: 'null'}
            },
            realtime: {
              type: 'object',
              not: {type: 'null'}
            },
            linkedinEnabled: {
              type: 'boolean',
              not: {type: 'null'}
            },
            event: {
              type: 'object',
              required: ['htmlContent'],
              not: {type: 'null'},
              properties: {
                htmlContent: {
                  type: 'string',
                  not: {type: 'null'}
                },
                title: {
                  type: 'string',
                  not: {type: 'null'}
                }
              }
            }
          }
        }
    });

})();

(function() {
  'use strict';

  angular
    .module('lebuFend')
    .factory('httpErrorInterceptor', function ($q, $location) {
        return {
            'httpError': function(rejection) {
                if (rejection.status === 403) {
                    var homeTutorialDone = localStorage.getItem('homeTutorialDone');
                    var introDone = localStorage.getItem('introDone');
                    var videogularVolume = localStorage.getItem('videogularVolume');
                    localStorage.clear();
                    if (homeTutorialDone != null) {
                        localStorage.setItem('homeTutorialDone', homeTutorialDone);
                    }
                    if (introDone != null) {
                        localStorage.setItem('introDone', introDone);
                    }
                    if (videogularVolume != null) {
                        localStorage.setItem('videogularVolume', videogularVolume);
                    }
                    $location.path('/login');
                }
                return $q.reject(rejection);
            }
        };
    })
    .config(config);

  /** @ngInject */
  function config($provide, $wampProvider, $httpProvider, $locationProvider, $compileProvider, $logProvider, toastrConfig, $mdThemingProvider, $authProvider, cfpLoadingBarProvider, ScrollBarsProvider, ChartJsProvider, Symfony) {
//  $locationProvider.html5Mode(true);
    $httpProvider.interceptors.push('httpErrorInterceptor');

    // dev
    $logProvider.debugEnabled(false);
    $compileProvider.debugInfoEnabled(false);

    // logger
    $provide.decorator('$log', ['$delegate', 'Logger', function($delegate, Logger) {
      var error = $delegate.error;
      function postError() {
        error.apply($delegate, arguments);
        Logger.post.apply($delegate, arguments);
      }
      $delegate.error = postError;
      return $delegate;
    }]);

    // components
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.progressBar = false;

    // theme
    $mdThemingProvider.generateThemesOnDemand(true);
    $provide.value('themeProvider', $mdThemingProvider);
    $mdThemingProvider.definePalette('defaultPalette', {
        '50': 'C3CAED',
        '100': '636679',
        '200': '4f5472',
        '300': '3a426b',
        '400': '2b3467',
        '500': '1b2762',
        '600': '18225c',
        '700': '141c56',
        '800': '101750',
        '900': '090f45',
        'A100': '434d87',
        'A200': '243389',
        'A400': '172889',
        'A700': '11238a',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': ['50', '100', 'A100'],
        'contrastLightColors': undefined
    });
    $mdThemingProvider.definePalette('defaultAccentPalette', {
        '50': 'cebdc5',
        '100': 'c89db4',
        '200': 'c37ba2',
        '300': 'be598f',
        '400': 'b83e7f',
        '500': 'b42472',
        '600': 'a7206c',
        '700': '961d64',
        '800': '85185e',
        '900': '691351',
        'A100': 'cb70a1',
        'A200': 'c73f88',
        'A400': 'bc0e6f',
        'A700': '98186b',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': ['50', '100', '200', 'A100'],
        'contrastLightColors': undefined
    });
    $mdThemingProvider.definePalette('equiPalette', {
        '50': 'ebeaf3',
        '100': 'cecbe2',
        '200': 'ada9cf',
        '300': '8c87bc',
        '400': '746eae',
        '500': '5b54a0',
        '600': '554d96',
        '700': '4c448b',
        '800': '443b80',
        '900': '362c6c',
        'A100': 'a7a0ea',
        'A200': '7c71df',
        'A400': '6c5fdb',
        'A700': '6255d9',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': ['50', '100', '200', 'A100'],
        'contrastLightColors': undefined
    });
    var equiAccentPalette = $mdThemingProvider.extendPalette('light-green', {
        'A100': '95ca49',
        'A200': '83b736',
        'A400': '71a728',
        'A700': '61981c',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': ['100', '200', '300', '400'],
        'contrastLightColors': undefined
    });
    $mdThemingProvider.definePalette('equiAccentPalette', equiAccentPalette);
    var artsanaPalette = $mdThemingProvider.extendPalette('red', {
        '50': 'd5c1c3',
        '100': 'd7a6a9',
        '200': 'cc7e7a',
        '300': 'c55e58',
        '400': 'd14238',
        '500': 'd73620',
        '600': 'c92c20',
        '700': 'b9241c',
        '800': 'af1e16',
        '900': 'a2150d',
        'A100': 'dc7261',
        'A200': 'df4139',
        'A400': 'e30424',
        'A700': 'b10900'
    });
    $mdThemingProvider.definePalette('artsanaPalette', artsanaPalette);
    $mdThemingProvider.definePalette('sofidelPalette', {
        '50': '92a8b4',
        '100': '92a8b4',
        '200': '7398ac',
        '300': '5387a2',
        '400': '3b799c',
        '500': '236e96',
        '600': '1f678e',
        '700': '195c84',
        '800': '13537b',
        '900': '09426a',
        'A100': 'a7a0ea',
        'A200': '7c71df',
        'A400': '6c5fdb',
        'A700': '6255d9',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': ['50', '100', '200', 'A100'],
        'contrastLightColors': undefined
    });
    var sofidelAccentPalette = $mdThemingProvider.extendPalette('orange', {
        'contrastDefaultColor': 'light',
        'contrastDarkColors': ['100', '200', '300', '400'],
        'contrastLightColors': undefined
    });
    $mdThemingProvider.definePalette('sofidelAccentPalette', sofidelAccentPalette);
    $mdThemingProvider.definePalette('prysmianPalette', {
        '50': 'dcdde2',
        '100': 'c1c5d0',
        '200': 'a3aabb',
        '300': '8690a8',
        '400': '707c99',
        '500': '556689',
        '600': '536082',
        '700': '4a5677',
        '800': '414c6d',
        '900': '323b5b',
        'A100': 'a1aed0',
        'A200': '798ec0',
        'A400': '6b81ba',
        'A700': '627ab7',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': ['50', '100', '200', 'A100'],
        'contrastLightColors': undefined
    });
    var prysmianAccentPalette = $mdThemingProvider.extendPalette('green', {
      'A100': '34b233',
      'A200': '34b233',
      'A400': '34b233',
      'A700': '34b233',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': ['100', '200', '300', '400'],
      'contrastLightColors': undefined
    });
    $mdThemingProvider.definePalette('prysmianAccentPalette', prysmianAccentPalette);
    $mdThemingProvider.definePalette('luxotticaPalette', {
      '50': 'bfccd6',
      '100': '819aaf',
      '200': '5e84a7',
      '300': '3c709e',
      '400': '246097',
      '500': '0c5291',
      '600': '0a4a88',
      '700': '05407d',
      '800': '013872',
      '900': '002a5c',
      'A100': '448fd2',
      'A200': '0f79db',
      'A400': '0071dc',
      'A700': '006bd3',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': ['50', '100', '200', 'A100'],
      'contrastLightColors': undefined
    });
    $mdThemingProvider.definePalette('luxotticaAccentPalette', {
      '50': 'ccddcc',
      '100': 'abd4ac',
      '200': 'abd4ac',
      '300': '63c067',
      '400': '48b94c',
      '500': '2db232',
      '600': '27a32b',
      '700': '1e9122',
      '800': '17811d',
      '900': '09630f',
      'A100': '48b94c',
      'A200': '48b94c',
      'A400': '48b94c',
      'A700': '2db232',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': ['50', '100', '200', 'A100'],
      'contrastLightColors': undefined
    });
    $mdThemingProvider.definePalette('snamPalette', {
      '50': 'bfccd6',
      '100': '819aaf',
      '200': '5e84a7',
      '300': '3c709e',
      '400': '246097',
      '500': '0c5291',
      '600': '0a4a88',
      '700': '05407d',
      '800': '013872',
      '900': '002a5c',
      'A100': '448fd2',
      'A200': '0f79db',
      'A400': '0071dc',
      'A700': '006bd3',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': ['50', '100', '200', 'A100'],
      'contrastLightColors': undefined
    });
    $mdThemingProvider.definePalette('snamAccentPalette', {
      '50': 'e2e4c2',
      '100': 'c4c6a4',
      '200': 'babf85',
      '300': 'b0b767',
      '400': 'a8b050',
      '500': 'a2ab39',
      '600': '989d33',
      '700': '898b2b',
      '800': '7a7725',
      '900': '645b19',
      'A100': 'c3ca71',
      'A200': 'bcc641',
      'A400': '9cc20f',
      'A700': '8ab20e',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': ['50', '100', '200', 'A100'],
      'contrastLightColors': undefined
    });
    var leroymerlinPalette = $mdThemingProvider.extendPalette('light-green', {
      '500': '79aa3d',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': ['50', '100', '200', '300', '400', 'A100', 'A200'],
      'contrastLightColors': undefined
    });
    $mdThemingProvider.definePalette('leroymerlinPalette', leroymerlinPalette);
    var leroymerlinAccentPalette = $mdThemingProvider.extendPalette('orange', {
      'contrastDefaultColor': 'light',
      'contrastDarkColors': ['50', '100', '200', '300', '400'],
      'contrastLightColors': undefined
    });
    $mdThemingProvider.definePalette('leroymerlinAccentPalette', leroymerlinAccentPalette);
    $mdThemingProvider.definePalette('clapPalette', {
      '50': 'aeb8bf',
      '100': '92a7b4',
      '200': '7193a9',
      '300': '4e7e9c',
      '400': '347093',
      '500': '1b618a',
      '600': '17567d',
      '700': '144c6c',
      '800': '11425d',
      '900': '0c3141',
      'A100': '76a5b6',
      'A200': '2f89aa',
      'A400': '1f77a7',
      'A700': '1b608a',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': ['50', '100', '200', 'A100'],
      'contrastLightColors': undefined
    });
    var clapAccentPalette = $mdThemingProvider.extendPalette('orange', {
      'contrastDefaultColor': 'light',
      'contrastDarkColors': ['50', '100', '200', '300', '400'],
      'contrastLightColors': undefined
    });
    $mdThemingProvider.definePalette('clapAccentPalette', clapAccentPalette);
    var nokiaPalette = $mdThemingProvider.extendPalette('indigo', {
      '500': '134195'
    });
    $mdThemingProvider.definePalette('nokiaPalette', nokiaPalette);
    var nokiaAccentPalette = $mdThemingProvider.extendPalette('indigo', {
      'A200': '000000',
      'A700': '3F51B5'
    });
    $mdThemingProvider.definePalette('nokiaAccentPalette', nokiaAccentPalette);
    var curePalette = $mdThemingProvider.extendPalette('light-blue', {
      'contrastDefaultColor': 'light'
    });
    $mdThemingProvider.definePalette('curePalette', curePalette);

    var henkelPalette = $mdThemingProvider.extendPalette('red', {
        '50': 'fbdee0',
        '100': 'f6b0b5',
        '200': 'f07f87',
        '300': 'ea4c57',
        '400': 'e52633',
        '500': 'e1000f',
        '600': 'cd000e',
        '700': 'b7000c',
        '800': 'a0000b',
        '900': '750008'
     // 'contrastDefaultColor': 'light',
    });
    $mdThemingProvider.definePalette('henkelPalette', henkelPalette);
    var henkelAccentPalette = $mdThemingProvider.extendPalette('indigo', {
        '50': 'e4e5ef',
        '100': 'bec0da',
        '200': '9599c3',
        '300': '6b71ab',
        '400': '4b5299',
        '500': '2c3487',
        '600': '282f7b',
        '700': '242a6e',
        '800': '1f2560',
        '900': '171b46'
     // 'contrastDefaultColor': 'light',
    });
    $mdThemingProvider.definePalette('henkelAccentPalette', henkelAccentPalette);

    var mosaicoonPalette = $mdThemingProvider.extendPalette('pink', {
        '50':'ffe2ef',
        '100':'febad9',
        '200':'fe8fc1',
        '300':'fe62a9',
        '400':'fd4096',
        '500':'fd1f84',
        '600':'e61c78',
        '700':'cd196b',
        '800':'b4165e',
        '900':'841045'
     // 'contrastDefaultColor': 'light',
    });
    $mdThemingProvider.definePalette('mosaicoonPalette', mosaicoonPalette);
    var mosaicoonAccentPalette = $mdThemingProvider.extendPalette('indigo', {
        '50':'c8b7f0',
        '100':'c8b7f0',
        '200':'a68be6',
        '300':'825cdc',
        '400':'683ad4',
        '500':'4d17cd',
        '600':'4615bb',
        '700':'3f13a6',
        '800':'371092',
        '900':'280c6b'
     // 'contrastDefaultColor': 'light',
    });
    $mdThemingProvider.definePalette('mosaicoonAccentPalette', mosaicoonAccentPalette);


	var alleanzaAccentPalette = $mdThemingProvider.extendPalette('orange', {
        '50': 'fceae2',
        '100': 'f7cab6',
        '200': 'f1a785',
        '300': 'eb8454',
        '400': 'e76930',
        '500': 'e34f0b',
        '600': 'e0480a',
        '700': 'dc3f08',
        '800': 'd83606',
        '900': 'd02603',
        'A100': 'e76930',
        'A200': 'e34f0b',
        'A400': 'e0480a',
        'A700': 'dc3f08'
        // 'contrastDefaultColor': 'light',
    });
	$mdThemingProvider.definePalette('alleanzaAccentPalette', alleanzaAccentPalette);

  $mdThemingProvider.definePalette('btsdiPrimaryPAlette', {
      '50': 'ffe8f4',
      '100': 'ffc6e4',
      '200': 'ffa0d3',
      '300': 'ff7ac1',
      '400': 'ff5eb3',
      '500': 'ff41a6',
      '600': 'ff3b9e',
      '700': 'ff3295',
      '800': 'ff2a8b',
      '900': 'ff1c7b',
      'A100': 'ffffff',
      'A200': 'ffffff',
      'A400': 'ffcde0',
      'A700': 'ffb3d0',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        '400',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': [
        '500',
        '600',
        '700',
        '800',
        '900'
      ]
    });

	var coesiaPalette = $mdThemingProvider.extendPalette('red', {
        '50': 'fbdee0',
        '100': 'f6b0b5',
        '200': 'f07f87',
        '300': 'ea4c57',
        '400': 'e52633',
        '500': 'e1000f',
        '600': 'cd000e',
        '700': 'b7000c',
        '800': 'a0000b',
        '900': '750008'
     // 'contrastDefaultColor': 'light',
    });
    $mdThemingProvider.definePalette('coesiaPalette', coesiaPalette);
    var coesiaAccentPalette = $mdThemingProvider.extendPalette('indigo', {
        '50': 'e4e5ef',
        '100': 'bec0da',
        '200': '9599c3',
        '300': '6b71ab',
        '400': '4b5299',
        '500': '2c3487',
        '600': '282f7b',
        '700': '242a6e',
        '800': '1f2560',
        '900': '171b46'
     // 'contrastDefaultColor': 'light',
    });
    $mdThemingProvider.definePalette('coesiaAccentPalette', coesiaAccentPalette);




    $mdThemingProvider.definePalette('alphabetPalette', {
      '50': 'e2e6ed',
      '100': 'b6c0d2',
      '200': '8696b4',
      '300': '566c96',
      '400': '314d80',
      '500': '0d2d69',
      '600': '0b2861',
      '700': '092256',
      '800': '071c4c',
      '900': '03113b',
      'A100': '7188ff',
      'A200': '3e5dff',
      'A400': '0b33ff',
      'A700': '0027f1',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        'A100'
      ],
      'contrastLightColors': [
        '300',
        '400',
        '500',
        '600',
        '700',
        '800',
        '900',
        'A200',
        'A400',
        'A700'
      ]
    });


    $mdThemingProvider.definePalette('alphabetAccentPalette', {
      '50': 'fdefe0',
      '100': 'fad8b3',
      '200': 'f7be80',
      '300': 'f4a44d',
      '400': 'f19126',
      '500': 'ef7d00',
      '600': 'ed7500',
      '700': 'eb6a00',
      '800': 'e86000',
      '900': 'e44d00',
      'A100': 'ffffff',
      'A200': 'ef7d00',
      'A400': 'E44D00',
      'A700': 'E44D00',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        '400',
        '500',
        '600',
        '700',
        'A100',
        'A200'
      ],
      'contrastLightColors': [
        '800',
        '900',
        'A400',
        'A700'
      ]
    });



    $mdThemingProvider.definePalette('marzoccoPalette',  {
        '50': 'e8e8e8',
        '100': 'c6c6c6',
        '200': 'a0a0a0',
        '300': '7a7a7a',
        '400': '5e5e5e',
        '500': '414141',
        '600': '3b3b3b',
        '700': '323232',
        '800': '2a2a2a',
        '900': '1c1c1c',
        'A100': 'f07777',
        'A200': 'eb4949',
        'A400': 'ff0202',
        'A700': 'e70000',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': [
          '50',
          '100',
          '200',
          'A100'
        ],
        'contrastLightColors': [
          '300',
          '400',
          '500',
          '600',
          '700',
          '800',
          '900',
          'A200',
          'A400',
          'A700'
        ]
      });

    $mdThemingProvider.definePalette('marzoccoAccentPalette', {
      '50': 'fefefc',
      '100': 'fdfbf8',
      '200': 'fbf9f3',
      '300': 'f9f7ee',
      '400': 'f8f5eb',
      '500': 'f7f3e7',
      '600': 'f6f1e4',
      '700': 'f5efe0',
      '800': 'f3eddd',
      '900': 'f1ead7',
      'A100': 'ffffff',
      'A200': 'ffffff',
      'A400': 'ffffff',
      'A700': 'ffffff',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        '400',
        '500',
        '600',
        '700',
        '800',
        '900',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': []
    });

    $mdThemingProvider.theme('default')
        .primaryPalette('defaultPalette')
        .warnPalette('red')
        .accentPalette('defaultAccentPalette');
    $mdThemingProvider.theme('lebu')
        .primaryPalette('defaultPalette')
        .warnPalette('red')
        .accentPalette('defaultAccentPalette');
    $mdThemingProvider.theme('equi')
        .primaryPalette('equiPalette')
        .warnPalette('orange')
        .accentPalette('equiAccentPalette');
    $mdThemingProvider.theme('artsana')
        .primaryPalette('artsanaPalette')
        .warnPalette('orange')
        .accentPalette('red')
    $mdThemingProvider.theme('unicredit')
        .primaryPalette('red')
        .warnPalette('orange')
        .accentPalette('blue')
    $mdThemingProvider.theme('sofidel')
        .primaryPalette('sofidelPalette')
        .warnPalette('red')
        .accentPalette('sofidelAccentPalette')
    $mdThemingProvider.theme('prysmian')
        .primaryPalette('prysmianPalette')
        .warnPalette('orange')
        .accentPalette('prysmianAccentPalette')
    $mdThemingProvider.theme('docflow')
        .primaryPalette('teal')
        .warnPalette('red')
        .accentPalette('pink');
    $mdThemingProvider.theme('luxottica')
        .primaryPalette('luxotticaPalette')
        .warnPalette('red')
        .accentPalette('luxotticaAccentPalette');
    $mdThemingProvider.theme('snam')
        .primaryPalette('snamPalette')
        .warnPalette('red')
        .accentPalette('snamAccentPalette');
    $mdThemingProvider.theme('siram')
        .primaryPalette('defaultPalette')
        .warnPalette('orange')
        .accentPalette('red');
    $mdThemingProvider.theme('sol')
        .primaryPalette('defaultPalette')
        .warnPalette('red')
        .accentPalette('blue');
    $mdThemingProvider.theme('leroymerlin')
        .primaryPalette('leroymerlinPalette')
        .warnPalette('red')
        .accentPalette('leroymerlinAccentPalette');
    $mdThemingProvider.theme('clap')
        .primaryPalette('clapPalette')
        .warnPalette('red')
        .accentPalette('clapAccentPalette');
    $mdThemingProvider.theme('nokia')
        .primaryPalette('nokiaPalette')
        .warnPalette('red')
        .accentPalette('nokiaAccentPalette');
    $mdThemingProvider.theme('cure')
        .primaryPalette('curePalette')
        .warnPalette('orange')
        .accentPalette('blue');
    $mdThemingProvider.theme('henkel')
        .primaryPalette('henkelPalette')
        .warnPalette('orange')
        .accentPalette('henkelAccentPalette');
    $mdThemingProvider.theme('mosaicoon')
        .primaryPalette('mosaicoonAccentPalette')
        .warnPalette('red')
        .accentPalette('mosaicoonPalette');
    $mdThemingProvider.theme('accenture')
        .primaryPalette('clapAccentPalette')
        .warnPalette('red')
        .accentPalette('nokiaPalette');
    $mdThemingProvider.theme('bosch')
        .primaryPalette('henkelPalette')
        .warnPalette('orange')
        .accentPalette('henkelAccentPalette');
	$mdThemingProvider.theme('henkel_gvbg')
        .primaryPalette('henkelPalette')
        .warnPalette('orange')
        .accentPalette('henkelAccentPalette');
	$mdThemingProvider.theme('alleanza')
        .primaryPalette('snamPalette')
        .warnPalette('alleanzaAccentPalette')
        .accentPalette('alleanzaAccentPalette');
    $mdThemingProvider.theme('btsdi')
        .primaryPalette('btsdiPrimaryPAlette')
        .warnPalette('red')
        .accentPalette('defaultAccentPalette');
	$mdThemingProvider.theme('coesia')
        .primaryPalette('coesiaPalette')
        .warnPalette('orange')
        .accentPalette('coesiaAccentPalette');
  $mdThemingProvider.theme('alphabet')
      .primaryPalette('alphabetPalette')
      .warnPalette('red')
      .accentPalette('alphabetAccentPalette');
  $mdThemingProvider.theme('marzocco_gvbg')
        .primaryPalette('marzoccoPalette')
        .warnPalette('orange')
        .accentPalette('marzoccoAccentPalette');




    cfpLoadingBarProvider.includeSpinner = false;

    // authentication
    $authProvider.loginUrl = '/api/login';
    $authProvider.unlinkUrl = '/auth/unlink';
    $authProvider.baseUrl = '/';
    $authProvider.linkedin({
        clientId: '77sytza7nn0q4m'
    });

    // realtime
    $wampProvider.init({
        url: Symfony.WAMP_URL,
        realm: 'realm1'
    });

    // scrollbar
    ScrollBarsProvider.defaults = {
        theme: 'minimal-dark'
    };

    // charts
    ChartJsProvider.setOptions({
        colours: ['#FF5722', '#FF9800', '#FFC107', '#CDDC39', '#8BC34A', '#4CAF50', '#03A9F4']
    });
  }
})();

angular.module("lebuFend").run(["$templateCache", function($templateCache) {$templateCache.put("./app/commentDetail/commentDetail.html","<md-dialog aria-label=\"{{commentDetail.comment.user.name}} {{commentDetail.comment.user.surname}}\" md-theme=\"{{commentDetail.viewState.theme}}\" class=\"postdetail-dialog\" flex=\"\" flex-md=\"50\" flex-gt-md=\"40\"><md-toolbar><div class=\"md-toolbar-tools\"><md-list style=\"margin-top:22px;margin-left:-24px\"><md-list-item class=\"md-2-line md-no-proxy\"><lb-user-button user=\"commentDetail.comment.user\"></lb-user-button><div class=\"md-list-item-text smoothable\"><h3>{{commentDetail.comment.user.name}} {{commentDetail.comment.user.surname}}</h3><p><small am-time-ago=\"commentDetail.comment.created | amParse: \'X\'\" \"=\"\"></small></p></div></md-list-item></md-list><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"commentDetail.cancel()\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color:\'grey\'}\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-card class=\"social-post post-detail\"><md-card-content><a ng-if=\"commentDetail.comment.type==2\" href=\"{{commentDetail.comment.og[\'og:url\']}}\" target=\"_blank\"><img ng-src=\"{{commentDetail.comment.og[\'og:image\']}}\"><h4 class=\"md-title md-primary\" style=\"margin-bottom:0\">{{commentDetail.comment.og[\'og:title\']}}</h4></a><iframe ng-if=\"commentDetail.comment.type==3\" class=\"videoplayer\" width=\"100%\" height=\"100%\" src=\"{{commentDetail.comment.resourceLink}}\" frameborder=\"0\" allowfullscreen=\"\"></iframe><img ng-if=\"commentDetail.comment.type==4\" ng-src=\"{{commentDetail.comment.resourceBigLink}}\" class=\"picture\"> <a class=\"md-primary\" ng-if=\"commentDetail.comment.type==5\" href=\"{{commentDetail.comment.resourceLink}}\">{{commentDetail.comment.resourceLink.split(\'/\').reverse()[0]}}</a><videogular ng-if=\"commentDetail.comment.type==7\" vg-player-ready=\"commentDetail.onVideoPlayerReady($API)\" vg-theme=\"commentDetail.videoPlayerTheme\"><vg-media vg-src=\"commentDetail.comment.getVideoResources()\"></vg-media><vg-controls vg-autohide=\"true\" vg-autohide-time=\"3000\"><vg-play-pause-button></vg-play-pause-button><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-fullscreen-button></vg-fullscreen-button></vg-controls><vg-overlay-play></vg-overlay-play><vg-poster vg-url=\"commentDetail.comment.og[\'og:image\']\"></vg-poster></videogular><p>{{commentDetail.comment.comment}}</p><div class=\"community-comments\" ng-class=\"{empty: commentDetail.comment.children.length==0}\"><md-subheader ng-if=\"commentDetail.comment.children.length>1\" style=\"padding-bottom:4px\">{{commentDetail.comment.children.length}} {{\'comments\' | trans}}</md-subheader><md-content style=\"max-height:inherit\"><md-list><md-list-item class=\"md-3-line md-long-text closed write\" ng-class=\"{opened: commentDetail.comment.formOpened}\"><img ng-src=\"{{commentDetail.currentUser.picture}}\" class=\"md-avatar\" alt=\"{{commentDetail.currentUser.name}} {{commentDetail.currentUser.surname}}\"><div class=\"md-list-item-text\"><form name=\"commentForm\" layout=\"row\"><md-input-container class=\"md-block\"><label>{{\'comment\' | trans}}</label> <input md-maxlength=\"200\" name=\"message\" lb-focus-me=\"commentDetail.comment.formOpened\" ng-model=\"commentDetail.message\"><div ng-messages=\"commentForm.message.$error\"><div ng-message=\"md-maxlength\">{{\'info-message-length\' | trans}}</div></div></md-input-container></form></div></md-list-item><md-list-item ng-repeat=\"comment in commentDetail.comment.children\" class=\"md-3-line md-long-text\"><img ng-src=\"{{comment.user.picture}}\" class=\"md-avatar\" alt=\"{{comment.user.name}} {{comment.user.surname}}\"><div class=\"md-list-item-text\"><h3>{{comment.user.name}} {{comment.user.surname}}</h3><p><small am-time-ago=\"comment.created | amParse: \'X\'\"></small></p><p>{{comment.comment}}</p></div></md-list-item></md-list></md-content></div></md-card-content></md-card></md-dialog-content><md-dialog-actions><span flex=\"\"></span><md-button class=\"md-accent md-raised\" ng-if=\"commentDetail.message.length>0\" ng-click=\"commentDetail.answer()\">{{\'send\' | trans}}</md-button><md-button class=\"md-primary\" ng-click=\"commentDetail.comment.formOpened=!commentDetail.comment.formOpened\">{{commentDetail.comment.formOpened ? \'cancel\' : \'comment-on\' | trans}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("./app/commentLesson/commentLesson.html","<md-dialog aria-label=\"{{\'comment-the-episode\' | trans}}\" md-theme=\"{{commentLesson.viewState.theme}}\" class=\"post-dialog\" flex=\"\" flex-md=\"50\" flex-gt-md=\"40\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2>{{\'comment-the-episode\' | trans}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"commentLesson.cancel()\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"postForm\"><div layout=\"row\" layout-padding=\"\" class=\"post-message\" layout-align=\"center center\"><img ng-src=\"{{commentLesson.user.picture}}\" class=\"avatar-big\" alt=\"{{commentLesson.user.name}} {{commentLesson.user.surname}}\"><md-input-container class=\"md-block\" flex=\"\"><label>{{\'write-a-message\' | trans}}</label> <input md-maxlength=\"2000\" lb-focus-me=\"true\" required=\"\" name=\"message\" ng-model=\"commentLesson.message\"><div ng-messages=\"postForm.message.$error\"><div ng-message=\"required\">{{\'message-mandatory\' | trans}}</div><div ng-message=\"md-maxlength\">{{\'info-message-length\' | trans}}</div></div></md-input-container></div></form><lb-post-attachment default-type=\"0\" model=\"commentLesson.attachment\" exclude=\"[\'course\']\"></lb-post-attachment></md-dialog-content><md-dialog-actions><md-checkbox ng-if=\"commentLesson.viewState.hasModule(\'social_post\')\" ng-model=\"commentLesson.socialPost\">{{\'share-comment-in\' | trans}} {{\'module-community-\' + commentLesson.viewState.theme | trans}}</md-checkbox><span flex=\"\"></span><md-button ng-disabled=\"!postForm.$valid\" class=\"md-raised md-accent\" ng-click=\"commentLesson.post(postForm)\">{{\'publish\' | trans}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("./app/community/community.html","<div layout=\"column\" class=\"content-body\" style=\"margin-top: 30px\"><div class=\"post-button\"><md-button class=\"md-fab\" ng-click=\"$state.go(\'socialPost\')\"><md-icon md-font-set=\"material-icons\">mode_edit</md-icon></md-button><md-tooltip md-direction=\"top\">{{\'publish\' | trans}}</md-tooltip></div><div layout=\"row\" class=\"search\" layout-wrap=\"\" layout-align=\"center center\"><md-autocomplete hide=\"\" show-gt-xs=\"\" ng-cloak=\"\" style=\"width:400px\" md-search-text=\"community.searchText\" md-items=\"item in community.searchPosts()\" md-min-length=\"3\" md-delay=\"600\" md-menu-class=\"md-list\" md-selected-item-change=\"community.searchText=\'\'\" placeholder=\"{{\'search-on-posts\' | trans}}\"><md-item-template><md-list-item class=\"md-3-line\" ui-sref=\"postDetail({postId: item.id})\"><img ng-show=\"item.thumb\" ng-src=\"{{item.thumb}}\" alt=\"{{item.title}}\" class=\"search-thumb\"><div class=\"md-list-item-text\"><p style=\"color:#bbb\">{{\'post\' | trans}}</p><h3>{{item.title}}</h3><h4>{{community.getFromNow(item)}}</h4></div></md-list-item></md-item-template><md-not-found><span style=\"padding:0 15px\">{{\'no-items-found\' | trans}}</span></md-not-found></md-autocomplete></div><div layout=\"row\" class=\"search\" layout-wrap=\"\" layout-align=\"center center\"><md-input-container><md-select ng-model=\"community.typeFilter\" ng-change=\"community.reloadPosts()\" placeholder=\"{{\'filter-by-type-content\' | trans}}\"><md-option value=\"\">{{\'no-filter\' | trans}}</md-option><md-option value=\"1\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#3F51B5\', \'margin-right\': \'4px\'}\">dns</md-icon>{{\'programs\' | trans}}</md-option><md-option value=\"2\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#03A9F4\', \'margin-right\': \'4px\'}\">public</md-icon>{{\'link\' | trans}}</md-option><md-option value=\"3\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#F44336\', \'margin-right\': \'4px\'}\">play_circle_filled</md-icon>{{\'video\' | trans}}</md-option><md-option value=\"4\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#4CAF50\', \'margin-right\': \'4px\'}\">camera_alt</md-icon>{{\'images\' | trans}}</md-option><md-option value=\"5\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#FF9800\', \'margin-right\': \'4px\'}\">insert_drive_file</md-icon>{{\'documents\' | trans}}</md-option></md-select></md-input-container><md-button ng-show=\"!community.viewState.hasRealtime\" class=\"md-raised md-fab md-mini\" ng-click=\"community.reloadPosts()\" style=\"margin-left:15px\"><md-icon md-font-set=\"material-icons\">autorenew</md-icon><md-tooltip>{{\'update\' | trans}}</md-tooltip></md-button></div><div id=\"stories\" class=\"stories community\" infinite-scroll=\"community.loadPosts()\" infinite-scroll-disabled=\"community.busy\" masonry=\"\" preserve-order=\"\" item-selector=\".grid-item\" masonry-options=\"{percentPosition: true}\"><div masonry-brick=\"\" class=\"grid-item\" ng-repeat=\"post in community.loadedPosts\"><lb-post-card ng-if=\"!post.byStaff\" post=\"post\"></lb-post-card><lb-news-card ng-if=\"post.byStaff\" post=\"post\"></lb-news-card></div></div><md-icon ng-if=\"community.busy || community.postsLoading\" md-svg-src=\"/assets/icons/spinner.svg\" style=\"margin: 10px\"></md-icon><p ng-if=\"community.loadedPosts.length==0 && !community.postsLoading\" ng-cloak=\"\">{{\'no-activity-yet\' | trans}}</p></div>");
$templateCache.put("./app/compareStats/compareStats.html","<md-dialog aria-label=\"{{\'compare-with\' | trans}} {{compareStats.other.name}} {{compareStats.other.surname}}\" md-theme=\"{{compareStats.viewState.theme}}\" flex=\"\" flex-md=\"70\" flex-lg=\"60\" flex-gt-md=\"50\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2>{{\'compare-with\' | trans}} {{compareStats.other.name}} {{compareStats.other.surname}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"compareStats.cancel()\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div layout=\"column\" layout-gt-xs=\"row\" layout-padding=\"\" class=\"chart-container\"><div flex=\"\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"center center\"><h3 class=\"md-title\"><strong>{{compareStats.me.name}}</strong>: {{compareStats.me.score}} {{\'points\' | trans}}</h3><div class=\"user-pie\"><lb-user-chart data=\"compareStats.meData\" labels=\"compareStats.meLabels\"></lb-user-chart><img class=\"avatar\" ng-src=\"{{compareStats.me.pictureBig}}\"></div></div><div flex=\"\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"center center\" class=\"user-pie\"><h3 class=\"md-title\"><strong>{{compareStats.other.name}}</strong>: {{compareStats.other.score}} {{\'points\' | trans}}</h3><div class=\"user-pie\"><lb-user-chart data=\"compareStats.otherData\" labels=\"compareStats.otherLabels\"></lb-user-chart><img class=\"avatar\" ng-src=\"{{compareStats.other.pictureBig}}\"></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"compareStats.updateData()\" class=\"md-raised md-accent\">{{\'update\' | trans}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("./app/completeProfile/completeProfile.html","<header md-theme=\"{{completeProfile.viewState.theme}}\" md-theme-watch=\"\"><md-toolbar class=\"md-whiteframe-2dp\" ng-cloak=\"\"><div class=\"md-toolbar-tools\"><img ng-src=\"{{completeProfile.viewState.brand.header}}\"> <span flex=\"\"></span><md-menu-bar style=\"padding:0 5px;margin-top:6px\"><md-menu><a href=\"javascript:void()\" class=\"header-menu\" ng-click=\"$mdOpenMenu($event)\"><img ng-src=\"{{completeProfile.user.picture}}\" class=\"md-avatar\" alt=\"{{completeProfile.user.name}} {{completeProfile.user.surname}}\" style=\"margin:0 0 0 6px\"><div class=\"user-image\"><span ng-if=\"completeProfile.viewState.hasRealtimeUsers && completeProfile.viewState.isOnline(completeProfile.user.id)\" class=\"status mini online\"></span></div></a><md-menu-content width=\"4\"><md-menu-item ng-if=\"completeProfile.viewState.hasIntro\"><md-button ui-sref=\"intro\"><div layout=\"row\"><md-icon md-font-set=\"material-icons\">ondemand_video</md-icon>{{\'video-intro\' | trans}}</div></md-button></md-menu-item><md-menu-divider ng-if=\"completeProfile.viewState.hasIntro\"></md-menu-divider><md-menu-item><md-button ui-sref=\"editPassword({userId: completeProfile.user.id})\"><div layout=\"row\"><md-icon md-font-set=\"material-icons\">lock</md-icon>{{\'change-password\' | trans}}</div></md-button></md-menu-item><md-menu-item><md-button ui-sref=\"logout\"><div layout=\"row\"><md-icon md-font-set=\"material-icons\">exit_to_app</md-icon>{{\'exit\' | trans}}</div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></md-toolbar></header><div layout=\"column\" class=\"content-body\" style=\"max-width:900px;margin-top:80px\"><h1>{{\'complete-profile\'|trans}}</h1><md-card layout-padding=\"\"><p>{{\'complete-profile-intro\'|trans}}</p><form name=\"profileForm\" id=\"profileForm\" novalidate=\"\"><md-input-container class=\"md-block\" flex=\"\"><label>{{\'name\' | trans}}</label> <input md-maxlength=\"200\" required=\"\" name=\"name\" ng-model=\"completeProfile.user.name\" disabled=\"\"><div ng-messages=\"profileForm.name.$error\"><div ng-message=\"required\">{{\'name-is-required\' | trans}}</div><div ng-message=\"md-maxlength\">{{\'field-maxlength\' | trans}}</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>{{\'surname\' | trans}}</label> <input md-maxlength=\"200\" required=\"\" name=\"surname\" ng-model=\"completeProfile.user.surname\" disabled=\"\"><div ng-messages=\"profileForm.surname.$error\"><div ng-message=\"required\">{{\'surname-is-required\' | trans}}</div><div ng-message=\"md-maxlength\">{{\'field-maxlength\' | trans}}</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>{{\'language\' | trans}}</label><md-select name=\"language\" required=\"\" ng-model=\"completeProfile.user.language\" style=\"margin-bottom:26px\" ng-disabled=\"true\"><md-option ng-repeat=\"(key, value) in completeProfile.languages\" value=\"{{key}}\">{{value}}</md-option></md-select><div ng-messages=\"profileForm.language.$error\"><div ng-message=\"required\">{{\'surname-is-required\' | trans}}</div><div ng-message=\"md-maxlength\">{{\'field-maxlength\' | trans}}</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>{{\'company\' | trans}}</label> <input md-maxlength=\"200\" name=\"company\" ng-model=\"completeProfile.user.company\"><div ng-messages=\"profileForm.company.$error\" md-auto-hide=\"false\"><div ng-message=\"md-maxlength\">{{\'field-maxlength\' | trans}}</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>{{\'position\' | trans}}</label> <input md-maxlength=\"200\" name=\"job\" ng-model=\"completeProfile.user.job\"><div ng-messages=\"profileForm.job.$error\" md-auto-hide=\"false\"><div ng-message=\"md-maxlength\">{{\'field-maxlength\' | trans}}</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>{{\'city\' | trans}}</label> <input md-maxlength=\"200\" name=\"city\" ng-model=\"completeProfile.user.city\"><div ng-messages=\"profileForm.city.$error\" md-auto-hide=\"false\"><div ng-message=\"md-maxlength\">{{\'field-maxlength\' | trans}}</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>{{\'state\' | trans}}</label> <input md-maxlength=\"200\" name=\"country\" ng-model=\"completeProfile.user.country\"><div ng-messages=\"profileForm.country.$error\" md-auto-hide=\"false\"><div ng-message=\"md-maxlength\">{{\'field-maxlength\' | trans}}</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>{{\'biography\' | trans}}</label> <textarea name=\"biography\" ng-model=\"completeProfile.user.biography\" md-maxlength=\"500\" rows=\"5\" md-select-on-focus=\"\"></textarea><div ng-messages=\"profileForm.biography.$error\"><div ng-message=\"md-maxlength\">{{\'bio-maxlength\' | trans}}</div></div></md-input-container><div layout=\"column\" layout-padding=\"\"><md-input-container style=\"margin:0\"><md-checkbox name=\"privacy\" required=\"\" ng-model=\"completeProfile.user.privacy\"><small ng-bind=\"completeProfile.privacyConfirm\">*</small><div style=\"margin-top: 3px\" ng-messages=\"profileForm.privacy.$error\"><div ng-message=\"required\">{{\'input-required\' | trans}}</div></div></md-checkbox><md-button style=\"margin-left:24px\" ng-click=\"completeProfile.openPrivacy($event)\">Privacy Agreement</md-button><div style=\"margin-left:30px; text-transform:uppercase; font-size:14px\"><a href=\"/privacy\" target=\"_blank\">{{\'privacy_modal_title\' | trans}}</a></div></md-input-container><div style=\"visibility:hidden\"><div class=\"md-dialog-container\" id=\"privacyDialog\"><md-dialog style=\"max-width:800px; background-color:rgb(239, 239, 239);\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Privacy Agreement</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"completeProfile.closePrivacy()\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding=\"\"><div ng-bind-html=\"completeProfile.privacyBody\"></div></md-dialog-content></md-dialog></div></div></div><div layout=\"column\" layout-align=\"center center\" layout-align-gt-xs=\"end end\"><md-button class=\"md-raised md-accent\" ng-click=\"completeProfile.post(profileForm)\">{{\'save\' | trans}}</md-button></div></form></md-card></div>");
$templateCache.put("./app/course/course.html","<div ng-if=\"$state.is(\'course\')\" style=\"width: 90%;\"><div class=\"content-header anim-zoom-out-full\" layout=\"column\" layout-align=\"center center\"><h1><md-icon ng-if=\"course.course.locked\" md-font-set=\"material-icons\" ng-style=\"{\'margin-top\': \'-8px\'}\" class=\"material-icons\">lock</md-icon>{{course.course.title}}</h1></div><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{course.course.image}}\"><p style=\"max-width: 500px; text-align: center\">{{course.course.description}}</p><form ng-if=\"course.course.locked\" layout=\"row\" name=\"unlockForm\" style=\"margin: 20px 0 40px;\"><md-input-container><label>{{\'unlock-code\' | trans}}</label> <input required=\"\" ng-maxlength=\"128\" name=\"unlockCode\" lb-focus-me=\"\" ng-model=\"course.unlockCode\"><div ng-messages=\"unlockForm.unlockCode.$error\"><div ng-message=\"required\">{{\'input-required\' | trans}}</div><div ng-message=\"md-maxlength\">{{\'field-maxlength\' | trans}}</div></div></md-input-container><div><md-button ng-disabled=\"!unlockForm.$valid\" class=\"md-raised md-accent\" ng-click=\"course.unlock(unlockForm)\">{{\'unlock\' | trans}}</md-button></div></form><p ng-if=\"course.course.locked\" style=\"max-width: 500px; text-align: center\">{{course.course.unlockMessage}}</p><md-button ng-if=\"!course.course.locked\" class=\"md-raised md-accent\" ng-click=\"course.start()\" style=\"margin: 20px 0 40px;\">{{course.getStartVerb()}}</md-button></div></div><div ui-view=\"\"></div><div ng-if=\"$state.is(\'course\') && course.related.length>0\" layout=\"column\" layout-align=\"end center\" style=\"margin-top: 70px; margin-bottom: 50px\"><div class=\"card-list\" layout-wrap=\"\" ng-cloak=\"\"><div class=\"strip\"><h2 class=\"strip-title\" flex=\"\">{{\'related-courses\' | trans}}</h2><div class=\"slick-container\"><slick settings=\"course.slickConfig\"><div ng-repeat=\"relatedCourse in course.related\"><lb-course-card course=\"relatedCourse\"></lb-course-card></div></slick></div></div></div></div>");
$templateCache.put("./app/courseDetail/courseDetail.html","<md-dialog aria-label=\"{{courseDetail.course.title}}\" md-theme=\"{{courseDetail.viewState.theme}}\" flex=\"\" flex-md=\"70\" flex-lg=\"60\" flex-gt-md=\"50\"><md-toolbar style=\"background-color: {{courseDetail.course.category.colour}}\"><div class=\"md-toolbar-tools\"><h2><md-icon ng-if=\"courseDetail.course.locked\" md-font-set=\"material-icons\" ng-style=\"{color: \'white\', \'margin-right\': \'4px\', \'margin-top\': \'-10px\'}\" class=\"material-icons\">lock</md-icon>{{courseDetail.course.title}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"courseDetail.cancel()\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div id=\"courseInfo\" layout-padding=\"\" layout=\"column\" layout-gt-md=\"row\"><div layout=\"column\" flex-lg=\"50\" flex-gt-lg=\"55\"><img ng-src=\"{{courseDetail.course.image}}\" alt=\"image caption\" layout-fill=\"\" style=\"height:inherit;min-height:inherit\"><p>{{courseDetail.course.description}}</p></div><div layout=\"column\" flex-lg=\"50\" flex-gt-lg=\"45\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-swipe-content=\"\"><md-tab label=\"{{\'info\' | trans}}\"><md-list class=\"tab-info\"><md-list-item><md-divider></md-divider><label flex=\"\">{{\'category\' | trans}}</label> <small class=\"md-secondary\"><a ui-sref=\"library({categorySlug: courseDetail.course.category.slug})\" ui-sref-opts=\"{reload: true}\">{{courseDetail.course.category.name}}</a></small></md-list-item><md-list-item ng-if=\"courseDetail.viewState.hasModule(\'social\') && courseDetail.stars.length>0\"><md-divider></md-divider><label flex=\"\">{{\'rating\' | trans}}</label><div layout=\"row\" class=\"rating md-secondary\"><md-icon ng-repeat=\"i in courseDetail.getStars(courseDetail.course.rating) track by $index\" md-font-set=\"material-icons\" ng-style=\"{color: \'#FDD835\', \'font-size\': \'18px\', \'margin\': \'0 -5px 0 0\'}\">star_rate</md-icon></div></md-list-item><md-list-item ng-if=\"courseDetail.course.completingExpectedTime\"><md-divider></md-divider><label flex=\"\">{{\'duration\' | trans}}</label><div layout=\"row\" layout-align=\"center center\" class=\"md-secondary\"><md-icon ng-if=\"courseDetail.course.completingExpectedTime<=6\" md-svg-src=\"/assets/icons/coffee.svg\" style=\"margin-right:3px\"></md-icon><md-icon ng-if=\"courseDetail.course.completingExpectedTime>6 && courseDetail.course.completingExpectedTime<=15\" md-font-set=\"material-icons\" style=\"margin-right:3px\">directions_subway</md-icon><md-icon ng-if=\"courseDetail.course.completingExpectedTime>15\" style=\"margin-right:3px\" md-font-set=\"material-icons\">flight</md-icon>{{courseDetail.course.completingExpectedTime}} {{\'minutes\' | trans}}</div></md-list-item><md-list-item ng-if=\"courseDetail.viewState.hasModule(\'gamification\')\"><md-divider></md-divider><label flex=\"\">{{\'points-earned\' | trans}}</label> <span class=\"md-secondary\">{{courseDetail.course.score}}</span></md-list-item><md-list-item ng-if=\"courseDetail.course.speakers.length>0\"><md-divider></md-divider><label flex=\"\">{{\'speakers\' | trans}}</label> <span class=\"md-secondary\">{{courseDetail.course.getSpeakers()}}</span></md-list-item></md-list></md-tab><md-tab label=\"{{\'users\' | trans}}\"><md-content><lb-user-list users=\"courseDetail.course.enrolledUsers\"></lb-user-list></md-content></md-tab><md-tab label=\"{{\'episodes\' | trans}}\"><lb-lessons-list lessons=\"courseDetail.course.lessons\"></lb-lessons-list></md-tab><md-tab ng-if=\"courseDetail.course.review.length > 0\" label=\"{{\'review\' | trans}}\"><md-content><lb-reviews-list reviews=\"courseDetail.course.review\"></lb-reviews-list></md-content></md-tab></md-tabs></div></div></md-dialog-content><md-dialog-actions><span flex=\"\"></span><md-button ng-if=\"!courseDetail.course.isEnrolled\" class=\"md-raised md-accent\" ng-click=\"courseDetail.enter()\">{{\'join-the-program\' | trans}}</md-button><md-button ng-if=\"courseDetail.course.isEnrolled\" class=\"md-raised md-accent\" ng-click=\"courseDetail.enter()\">{{\'sign-in-program\' | trans}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("./app/courseSuggest/courseSuggest.html","<md-dialog aria-label=\"{{\'suggest-the-program\' | trans}}\" md-theme=\"{{courseSuggest.viewState.theme}}\" flex=\"\" flex-md=\"70\" flex-lg=\"60\" flex-gt-md=\"50\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2>{{\'suggest-the-program\' | trans}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"courseSuggest.cancel()\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-content class=\"contact-chips\" layout=\"column\"><md-contact-chips +=\"\" ng-model=\"courseSuggest.contacts\" md-contacts=\"courseSuggest.querySearch($query)\" md-contact-name=\"name\" md-contact-image=\"image\" md-contact-email=\"email\" md-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"courseSuggest.filterSelected\" placeholder=\"{{\'type-the-name\' | trans}}\"></md-contact-chips><md-list class=\"fixedRows\"><md-list-item class=\"md-2-line contact-item\" ng-repeat=\"(index, contact) in courseSuggest.allContacts\" ng-if=\"courseSuggest.contacts.indexOf(contact) < 0\"><img ng-src=\"{{contact.image}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"md-list-item-text compact\"><h3>{{contact.name}}</h3><p>{{contact.email}}</p></div></md-list-item><md-list-item class=\"md-2-line contact-item selected\" ng-repeat=\"(index, contact) in courseSuggest.contacts\"><img ng-src=\"{{contact.image}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"md-list-item-text compact\"><h3>{{contact.name}}</h3><p>{{contact.email}}</p></div></md-list-item></md-list></md-content></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"courseSuggest.cancel()\">{{\'cancel\' | trans}}</md-button><md-button ng-click=\"courseSuggest.cancel()\">{{\'send\' | trans}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("./app/editGodo/editGodo.html","<md-dialog aria-label=\"{{\'edit-godo\' | trans}}\" md-theme=\"{{editGodo.viewState.theme}}\" flex=\"\" flex-md=\"50\" flex-gt-md=\"40\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2>{{\'edit-godo\' | trans}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"editGodo.cancel()\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><form name=\"profileForm\"><md-input-container class=\"md-block\" flex=\"\"><label>{{\'godoActionText\' | trans}}</label> <input md-maxlength=\"500\" required=\"\" name=\"actionText\" ng-model=\"editGodo.godo.actionText\"><div ng-messages=\"profileForm.actionText.$error\"><div ng-message=\"required\">{{\'action-is-required\' | trans}}</div><div ng-message=\"md-maxlength\">{{\'field-maxlength\' | trans}}</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>{{\'godoCourse\' | trans}}</label><md-select name=\"course\" ng-model=\"editGodo.godo.relatedContentId\" style=\"margin-bottom:26px\"><md-option value=\"0\">-</md-option><md-option ng-repeat=\"enrolled in editGodo.godo.userEnrolledCourses\" ng-value=\"enrolled.id\">{{ enrolled.title }}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>{{\'godoStatus\' | trans}}</label><md-select name=\"status\" ng-model=\"editGodo.godo.status\" style=\"margin-bottom:26px\"><md-option value=\"0\">{{\'godo-status-0\' | trans}}</md-option><md-option value=\"1\">{{\'godo-status-1\' | trans}}</md-option><md-option value=\"2\">{{\'godo-status-2\' | trans}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>{{\'godoDueDate\' | trans}}</label><md-datepicker ng-model=\"editGodo.godo.duedate\"></md-datepicker></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>{{\'godoOutcome\' | trans}}</label> <input md-maxlength=\"200\" name=\"outcome\" ng-model=\"editGodo.godo.outcome\"><div ng-messages=\"profileForm.outcome.$error\" md-auto-hide=\"false\"><div ng-message=\"md-maxlength\">{{\'field-maxlength\' | trans}}</div></div></md-input-container></form></div></md-dialog-content><md-dialog-actions><span flex=\"\"></span><md-button class=\"md-raised\" ng-click=\"editGodo.cancel()\">{{\'cancel\' | trans}}</md-button><md-button ng-disabled=\"!profileForm.$valid\" class=\"md-raised md-accent\" ng-click=\"editGodo.post(profileForm)\">{{\'save\' | trans}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("./app/editPassword/editPassword.html","<md-dialog aria-label=\"{{\'change-password\' | trans}}\" md-theme=\"{{editPassword.viewState.theme}}\" flex=\"\" flex-md=\"50\" flex-gt-md=\"40\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2>{{\'change-password\' | trans}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"editPassword.cancel()\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><form name=\"passwordForm\"><md-input-container class=\"md-block\" flex=\"\"><label>{{\'new-password\' | trans}}</label> <input ng-pattern=\"/^[a-zA-Z0-9\\-_]{4,50}$/\" required=\"\" name=\"newPassword\" ng-model=\"editPassword.newPassword\"><div ng-messages=\"passwordForm.newPassword.$error\"><div ng-message=\"required\">{{\'password is required\' | trans}}</div><div ng-message=\"pattern\">{{\'pattern-password\' | trans}}</div></div></md-input-container></form></div></md-dialog-content><md-dialog-actions><span flex=\"\"></span><md-button class=\"md-raised\" ng-click=\"editPassword.cancel()\">{{\'cancel\' | trans}}</md-button><md-button ng-disabled=\"!passwordForm.$valid\" class=\"md-raised md-accent\" ng-click=\"editPassword.post(passwordForm)\">{{\'save\' | trans}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("./app/editProfile/editProfile.html","<md-dialog aria-label=\"{{\'edit-profile\' | trans}}\" md-theme=\"{{editProfile.viewState.theme}}\" flex=\"\" flex-md=\"50\" flex-gt-md=\"40\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2>{{\'edit-profile\' | trans}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"editProfile.cancel()\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><form name=\"profileForm\"><md-input-container class=\"md-block\" flex=\"\"><label>{{\'name\' | trans}}</label> <input md-maxlength=\"200\" required=\"\" name=\"name\" ng-model=\"editProfile.user.name\"><div ng-messages=\"profileForm.name.$error\"><div ng-message=\"required\">{{\'name-is-required\' | trans}}</div><div ng-message=\"md-maxlength\">{{\'field-maxlength\' | trans}}</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>{{\'surname\' | trans}}</label> <input md-maxlength=\"200\" required=\"\" name=\"surname\" ng-model=\"editProfile.user.surname\"><div ng-messages=\"profileForm.surname.$error\"><div ng-message=\"required\">{{\'surname-is-required\' | trans}}</div><div ng-message=\"md-maxlength\">{{\'field-maxlength\' | trans}}</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Lingua</label><md-select name=\"language\" required=\"\" ng-model=\"editProfile.user.language\" style=\"margin-bottom:26px\"><md-option ng-repeat=\"(key, value) in editProfile.languages\" value=\"{{key}}\">{{value}}</md-option></md-select><div ng-messages=\"profileForm.language.$error\"><div ng-message=\"required\">{{\'surname-is-required\' | trans}}</div><div ng-message=\"md-maxlength\">{{\'field-maxlength\' | trans}}</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>{{\'company\' | trans}}</label> <input md-maxlength=\"200\" required=\"\" name=\"company\" ng-model=\"editProfile.user.company\"><div ng-messages=\"profileForm.company.$error\" md-auto-hide=\"false\"><div ng-message=\"required\">{{\'company-is-required\' | trans}}</div><div ng-message=\"md-maxlength\">{{\'field-maxlength\' | trans}}</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>{{\'position\' | trans}}</label> <input md-maxlength=\"200\" required=\"\" name=\"job\" ng-model=\"editProfile.user.job\"><div ng-messages=\"profileForm.job.$error\" md-auto-hide=\"false\"><div ng-message=\"required\">{{\'position-is-required\' | trans}}</div><div ng-message=\"md-maxlength\">{{\'field-maxlength\' | trans}}</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>{{\'city\' | trans}}</label> <input md-maxlength=\"200\" required=\"\" name=\"city\" ng-model=\"editProfile.user.city\"><div ng-messages=\"profileForm.city.$error\" md-auto-hide=\"false\"><div ng-message=\"required\">{{\'city-is-required\' | trans}}</div><div ng-message=\"md-maxlength\">{{\'field-maxlength\' | trans}}</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>{{\'state\' | trans}}</label> <input md-maxlength=\"200\" required=\"\" name=\"country\" ng-model=\"editProfile.user.country\"><div ng-messages=\"profileForm.country.$error\" md-auto-hide=\"false\"><div ng-message=\"required\">{{\'the-state-is-required\' | trans}}</div><div ng-message=\"md-maxlength\">{{\'field-maxlength\' | trans}}</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>{{\'biography\' | trans}}</label> <textarea name=\"biography\" ng-model=\"editProfile.user.biography\" md-maxlength=\"500\" rows=\"5\" md-select-on-focus=\"\"></textarea><div ng-messages=\"profileForm.biography.$error\"><div ng-message=\"md-maxlength\">{{\'bio-maxlength\' | trans}}</div></div></md-input-container></form></div></md-dialog-content><md-dialog-actions><span flex=\"\"></span><md-button class=\"md-raised\" ng-click=\"editProfile.cancel()\">{{\'cancel\' | trans}}</md-button><md-button ng-disabled=\"!profileForm.$valid\" class=\"md-raised md-accent\" ng-click=\"editProfile.post(profileForm)\">{{\'save\' | trans}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("./app/enrolled/enrolled.html","<div layout=\"column\" class=\"content-body wide-content\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\" class=\"search\"><md-input-container><md-select ng-model=\"enrolled.selectedCategory\" placeholder=\"{{\'select-category\' | trans}}\"><md-option>{{\'all\' | trans}}</md-option><md-option ng-value=\"category\" ng-repeat=\"category in enrolled.categories\"><md-icon ng-if=\"category.icon\" ng-style=\"{color: category.colour, \'margin-right\': \'3px\'}\" md-font-set=\"material-icons\">{{category.icon}}</md-icon>{{category.name}}</md-option></md-select></md-input-container></div><div class=\"card-grid\" layout=\"row\" layout-wrap=\"\" layout-align=\"center start\"><lb-course-card ng-repeat=\"course in enrolled.courses | filter: {category: {id: enrolled.selectedCategory.id}}\" course=\"course\" lazy=\"true\"></lb-course-card></div></div>");
$templateCache.put("./app/event/event.html","<md-dialog aria-label=\"{{event.event.title}}\" md-theme=\"{{event.viewState.theme}}\" flex=\"\" flex-md=\"50\" flex-gt-md=\"40\" ng-class=\"{\'typeform\': event.event.type == \'typeform\'}\" class=\"event-dialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{event.event.title}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"event.cancel()\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"event.event.type==\'simpleHTML\' || event.event.type==\'typeform\'\" ng-bind-html=\"event.event.body\" flex=\"\"></md-dialog-content><md-dialog-content ng-if=\"event.event.type==\'video\'\" flex=\"\"><videogular vg-player-ready=\"event.playerReady($API)\" vg-complete=\"event.onComplete()\" vg-theme=\"event.videoPlayerTheme\"><vg-media vg-src=\"event.options.resources\"></vg-media><vg-controls vg-autohide=\"true\" vg-autohide-time=\"3000\"><vg-play-pause-button></vg-play-pause-button><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-fullscreen-button></vg-fullscreen-button></vg-controls><vg-overlay-play></vg-overlay-play><vg-poster ng-if=\"event.options.posterUrl\" vg-url=\"event.options.posterUrl\"></vg-poster></videogular></md-dialog-content></md-dialog>");
$templateCache.put("./app/home/home.html","<div ng-if=\"currentTenant.enabled\" tour-step=\"\" tour-step-title=\"{{\'welcome-to-lebu\' | trans}}\" tour-step-content=\"{{\'tour-step-content-home\' | trans}}\" tour-step-order=\"0\" tour-step-orphan=\"true\"></div><div ng-if=\"currentTenant.enabled\" tour-step=\"\" tour-step-title=\"{{\'title-surfing\' | trans}}\" tour-step-content=\"{{\'content-surfing\' | trans}}\" tour-step-order=\"14\" tour-step-orphan=\"true\"></div><div ng-if=\"home.viewState.brand.main\" class=\"content-header anim-zoom-out-full\" layout=\"row\" layout-align=\"center center\"><img class=\"brand\" ng-src=\"{{home.viewState.brand.main}}\"></div><div ng-if=\"home.viewState.homeDescription\" layout=\"row\" class=\"content-body home-content wide-content\" layout-align=\"center center\"><div ng-bind-html=\"home.viewState.homeDescription\"></div></div><div ng-if=\"currentTenant.enabled && home.viewState.slideshow\" class=\"slideshow\" ng-cloak=\"\"><div class=\"slick-container\"><slick settings=\"home.slideshowSlickConfig\"><div class=\"slide\" ng-repeat=\"slide in home.viewState.slideshow\" ng-style=\"{\'background-image\': \'url({{slide.src}})\'}\"><a href=\"{{slide.url}}\" ng-attr-target=\"slide.ext ? \'_blank\' : \'_self\'\"><h2 class=\"md-title slideshow-caption\">{{slide.label}}</h2></a></div></slick></div></div><div ng-if=\"currentTenant.enabled\" layout=\"column\" class=\"content-body home-content wide-content\" layout-align=\"end center\"><div class=\"card-list\" layout-wrap=\"\" ng-cloak=\"\"><div ng-if=\"home.newCourses.length>0\" class=\"strip\"><h2 class=\"strip-title\" flex=\"\"><md-icon md-font-set=\"material-icons\" md-colors=\"{\'color\': home.viewState.theme + \'-primary\'}\">star</md-icon>{{\'news\' | trans}}</h2><div class=\"slick-container\"><slick settings=\"home.slickConfig\"><div ng-repeat=\"course in home.newCourses\"><lb-course-card course=\"course\"></lb-course-card></div></slick></div></div><div ng-if=\"home.popCourses.length>0\" class=\"strip\"><h2 class=\"strip-title\" flex=\"\"><md-icon md-font-set=\"material-icons\" md-colors=\"{\'color\': home.viewState.theme + \'-primary\'}\">people</md-icon>{{\'popular\' | trans}}</h2><div class=\"slick-container\"><slick settings=\"home.slickConfig\"><div ng-repeat=\"course in home.popCourses\"><lb-course-card course=\"course\"></lb-course-card></div></slick></div></div><div ng-if=\"catCourses.courses.length>0\" ng-repeat=\"catCourses in home.catCourses\" class=\"strip\"><h2 class=\"strip-title\" flex=\"\"><md-icon ng-if=\"home.categories.find(catCourses.id).icon\" ng-style=\"{color: home.categories.find(catCourses.id).colour}\" md-font-set=\"material-icons\">{{home.categories.find(catCourses.id).icon}}</md-icon>{{home.categories.find(catCourses.id).name}} <a ng-if=\"catCourses.courses.length>1\" ui-sref=\"library({categorySlug: home.categories.find(catCourses.id).slug})\" style=\"white-space:nowrap;\">{{\'show-all\' | trans}}</a></h2><div class=\"slick-container\"><slick settings=\"home.slickConfig\"><div ng-repeat=\"course in catCourses.courses\"><lb-course-card course=\"course\"></lb-course-card></div></slick></div></div></div></div><div ng-if=\"!currentTenant.enabled\" ng-bind-html=\"home.htmlWhenDisabled\"></div>");
$templateCache.put("./app/intro/intro.html","<md-dialog aria-label=\"{{\'video-intro\' | trans}}\" md-theme=\"{{intro.viewState.theme}}\" flex=\"\" flex-md=\"50\" flex-gt-md=\"40\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2>{{\'video-intro\' | trans}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"intro.cancel()\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><videogular vg-theme=\"intro.videoPlayerTheme\"><vg-media vg-src=\"intro.viewState.intro.resources\"></vg-media><vg-controls vg-autohide=\"true\" vg-autohide-time=\"3000\"><vg-play-pause-button></vg-play-pause-button><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-fullscreen-button></vg-fullscreen-button></vg-controls><vg-overlay-play></vg-overlay-play><vg-poster ng-if=\"intro.intro.hasPoster\" vg-url=\"intro.intro.posterUrl\"></vg-poster></videogular></md-dialog-content></md-dialog>");
$templateCache.put("./app/lesson/lesson.html","<div class=\"content-header anim-zoom-out-full\" layout=\"column\" layout-align=\"center center\" style=\"margin-top:2px;padding-bottom:0\"><h1><small><a ui-sref=\"course({courseId:lesson.course.id})\" md-colors=\"{color: lesson.viewState.theme + \'-accent\'}\">{{lesson.course.title}}</a></small> {{lesson.lesson.title}}<md-menu ng-if=\"lesson.lesson.attachments.length>0\"><md-button aria-label=\"Open attachments menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" style=\"margin: 0\"><md-icon md-menu-origin=\"\" md-font-set=\"material-icons\">attach_file</md-icon></md-button><md-menu-content width=\"6\"><md-menu-item ng-repeat=\"attachment in lesson.lesson.attachments\"><a href=\"{{attachment.url}}\" class=\"md-button\" target=\"_blank\">{{attachment.label}}</a></md-menu-item></md-menu-content></md-menu></h1></div><div><div layout=\"column\" class=\"content-body\" layout-align=\"center center\"><p style=\"text-align: center\">{{lesson.lesson.description}}</p></div><div id=\"lessonResource\" class=\"lesson-resource\"><lb-video-resource ng-if=\"lesson.lesson.type==3\" resource=\"lesson.lesson.resource\" course=\"lesson.course\" lesson=\"lesson.lesson\"></lb-video-resource><lb-text-resource ng-if=\"lesson.lesson.type==2\" lesson=\"lesson.lesson\" text=\"lesson.lesson.text\"></lb-text-resource><lb-event-resource ng-if=\"lesson.lesson.type==4\" lesson=\"lesson.lesson\" text=\"lesson.lesson.text\"></lb-event-resource><lb-quiz-player ng-if=\"lesson.lesson.type==7\" course=\"lesson.course\" lesson=\"lesson.lesson\"></lb-quiz-player><div ng-if=\"lesson.lesson.type==4\" layout=\"column\" layout-align=\"center center\">{{\'event-availablility\' | trans}}: {{lesson.lesson.available}}<md-button ng-if=\"!lesson.lesson.isBookedByUser && lesson.lesson.available>0\" class=\"md-raised md-accent\" ng-click=\"lesson.bookEvent()\">{{\'book-the-event\' | trans}}</md-button><md-button ng-if=\"lesson.lesson.isBookedByUser\" class=\"md-raised md-accent\" ng-click=\"lesson.unbookEvent()\">{{\'unbook-the-event\' | trans}}</md-button></div></div><lb-lessons-nav course=\"lesson.course\" lesson=\"lesson.lesson\"></lb-lessons-nav></div><div ng-if=\"lesson.course.isLastLesson(lesson.lesson.id) && lesson.related.length>0\" layout=\"column\" layout-align=\"end center\" style=\"margin-top: 70px; margin-bottom: 50px\"><div class=\"card-list\" layout-wrap=\"\" ng-cloak=\"\"><div class=\"strip\"><h2 class=\"strip-title\" flex=\"\">{{\'related-courses\' | trans}}</h2><div class=\"slick-container\"><slick settings=\"lesson.slickConfig\"><div ng-repeat=\"relatedCourse in lesson.related\"><lb-course-card course=\"relatedCourse\"></lb-course-card></div></slick></div></div></div></div>");
$templateCache.put("./app/library/library.html","<div layout=\"column\" class=\"content-body wide-content\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><lb-breadcrumb history=\"library.history\"></lb-breadcrumb><md-select ng-if=\"library.subcategories.length>0\" ng-model=\"library.subcategory\" placeholder=\"{{\'subcategories\' | trans}}\"><md-option ui-sref=\"library({categorySlug: subcategory.slug})\" ng-repeat=\"subcategory in library.subcategories\" value=\"{{subcategory.slug}}\">{{subcategory.name}}</md-option></md-select></div><div class=\"card-grid\" style=\"margin-top:20px\"><lb-course-card ng-repeat=\"course in library.courses\" course=\"course\" lazy=\"true\"></lb-course-card></div></div>");
$templateCache.put("./app/login/login.html","<div md-theme=\"{{login.viewState.theme}}\" layout=\"row\" layout-align=\"center center\"><form name=\"loginForm\"><md-card class=\"login-form\"><div class=\"logo\"><img ng-src=\"/assets/images/logo-{{login.viewState.theme}}.png\"></div><md-card-title><md-card-title-text><span class=\"md-headline\">{{\'login\' | trans}}</span></md-card-title-text></md-card-title><md-card-content><md-input-container class=\"md-block\"><label>{{\'email\' | trans}}</label> <input lb-focus-me=\"true\" md-select-on-focus=\"\" required=\"\" name=\"email\" ng-model=\"login.login.email\"><div ng-messages=\"loginForm.email.$error\"><div ng-message=\"required\">{{\'email-required\' | trans}}</div></div></md-input-container><md-input-container class=\"md-block\"><label>{{\'password\' | trans}}</label> <input type=\"password\" required=\"\" name=\"password\" ng-model=\"login.login.password\"><div ng-messages=\"loginForm.password.$error\"><div ng-message=\"required\">{{\'password-required\' | trans}}</div></div><div class=\"hint\"><a href=\"#\" ng-click=\"login.passwordRecovery($event)\">{{\'forgot-password\' | trans}}</a></div></md-input-container></md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"login.viewState.linkedinEnabled\" ng-click=\"login.authenticate(\'linkedin\')\" style=\"background-color: #1D87BD; color: #ffffff; font-size: 13px; text-transform: inherit; padding-right: 10px\"><md-icon md-svg-src=\"/assets/icons/linkedin.svg\" ng-style=\"{\'margin-right\':\'8px\',color:\'#ffffff\'}\"></md-icon>{{\'login-with-linkedin\' | trans}}</md-button><md-button type=\"submit\" ng-disabled=\"login.submitting\" class=\"md-raised md-accent\" ng-click=\"login.submit(loginForm)\">{{\'enter\' | trans}}</md-button></md-card-actions></md-card></form></div>");
$templateCache.put("./app/login/recovery.html","<md-dialog aria-label=\"{{\'password-recovery\' | trans}}\" md-theme=\"{{recovery.viewState.theme}}\" flex=\"\" flex-sm=\"60\" flex-md=\"40\" flex-gt-md=\"30\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2>{{\'password-recovery\' | trans}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"recovery.cancel()\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><form name=\"recoveryForm\"><md-input-container class=\"md-block\" flex=\"\"><label>{{\'email\' | trans}}</label> <input lb-focus-me=\"true\" md-select-on-focus=\"\" required=\"\" name=\"email\" ng-model=\"recovery.form.email\"><div ng-messages=\"recoveryForm.email.$error\"><div ng-message=\"required\">{{\'email-required\' | trans}}</div></div></md-input-container></form></div></md-dialog-content><md-dialog-actions><span flex=\"\"></span><md-button class=\"md-raised\" ng-click=\"recovery.cancel()\">{{\'cancel\' | trans}}</md-button><md-button ng-disabled=\"!recoveryForm.$valid || recovery.submitting\" class=\"md-raised md-accent\" ng-click=\"recovery.submit(recoveryForm)\">{{\'send\' | trans}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("./app/main/main.html","<div md-theme=\"{{main.viewState.theme}}\" md-theme-watch=\"\" ui-tour=\"\" ui-tour-backdrop=\"true\" ui-tour-use-hotkeys=\"true\" ui-tour-append-to-body=\"true\" ui-tour-popup-delay=\"300\"><lb-header categories=\"main.categories\" user=\"main.currentUser\"></lb-header><lb-nav-bar ng-if=\"currentTenant.enabled\" ng-scrollbars=\"\" ng-show=\"$mdMedia(\'min-width: 1360px\')\" class=\"sidebar-menu fixed-sidebar\" ng-class=\"{\'lock-left\': main.viewState.lockLeft}\"></lb-nav-bar><section class=\"main\" layout=\"row\" flex=\"\"><md-sidenav ng-if=\"currentTenant.enabled\" class=\"md-sidenav-left md-whiteframe-z2\" ng-class=\"{\'lock-left\': main.viewState.lockLeft}\" md-component-id=\"mainNav\" md-is-locked-open=\"$mdMedia(\'min-width: 1360px\')\"><lb-sliding-nav-bar last-viewed-course=\"main.currentUser.lastViewedCourse\"></lb-sliding-nav-bar></md-sidenav><md-content flex=\"\" style=\"background:transparent\"><div id=\"content\" ui-view=\"\" layout=\"column\" layout-align=\"start center\" class=\"anim-in-out anim-fade\"></div></md-content><md-sidenav ng-if=\"currentTenant.enabled && main.viewState.hasModule(\'social\')\" md-is-locked-open=\"$mdMedia(\'min-width: 1020px\') && !main.viewState.theatreMode\" ng-cloak=\"\" lb-social-bar=\"\" class=\"social-bar md-sidenav-right md-whiteframe-z2\" md-component-id=\"socialNav\"></md-sidenav><md-sidenav ng-if=\"currentTenant.enabled && main.viewState.hasModule(\'social\')\" md-is-locked-open=\"$mdMedia(\'min-width: 1020px\') && main.viewState.theatreMode\" ng-cloak=\"\" lb-lesson-bar=\"\" class=\"lesson-bar md-sidenav-right md-whiteframe-z2\" md-component-id=\"lessonNav\"></md-sidenav></section><lb-footer ng-if=\"currentTenant.enabled\"></lb-footer><lb-last-course ng-if=\"currentTenant.enabled\" ng-show=\"!main.viewState.lockLeft\" course=\"main.currentUser.lastViewedCourse\" class=\"sidebar-menu-bottom locked-open\"></lb-last-course></div>");
$templateCache.put("./app/messages/messages.html","<md-dialog aria-label=\"{{\'messages\' | trans}}\" md-theme=\"{{messages.viewState.theme}}\" class=\"messages-dialog\" flex=\"\" flex-md=\"80\" flex-gt-md=\"70\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2>{{\'messages\' | trans}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"messages.cancel()\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div id=\"messages\" layout=\"row\"><md-content class=\"senders\" flex=\"\"><md-subheader style=\"background-color: #fff\"><div layout=\"row\"><md-input-container style=\"padding: 0; margin-bottom: -20px; margin-left: 5px; font-size: 15px;\"><label>{{\'search-for-a-talk\' | trans}}</label> <input ng-model=\"talkSearch\"></md-input-container><span flex=\"\"></span><md-button ng-click=\"messages.openCreateTalk()\" md-theme=\"{{messages.viewState.theme}}\" class=\"md-fab md-mini\"><md-icon md-font-set=\"material-icons\">edit</md-icon></md-button></div></md-subheader><md-list class=\"active-list\"><md-list-item class=\"md-2-line animated\" md-colors=\"{\'background-color\':\'{{talk.unread>0 ? messages.viewState.theme + \'-accent\' : \'default-primary-50-0\'}}\'}\" ng-repeat=\"talk in messages.talks | filter:talkSearch:strict | orderBy:[\'-unread\',\'-created\']\" ng-class=\"{active: talk.id==messages.selectedTalk.id, slideInLeft: talk.added, unread: talk.unread>0}\" ng-click=\"messages.selectTalk(talk)\"><img ng-src=\"{{talk.getInterlocutorAvatar()}}\" class=\"md-avatar\" alt=\"{{talk.formatPersons()}}\"><div class=\"md-list-item-text\"><h3>{{talk.formatPersons()}}</h3><p hide-gt-sm=\"\">{{talk.lastMessage.body}}</p><p hide=\"\" show-gt-sm=\"\" ng-class=\"{ellipsis: talk.lastMessage.body.length>80}\">{{talk.lastMessage.body | limitTo:80}}</p><small am-time-ago=\"talk.lastMessage.date.date | amUtc | amLocal | amParse:\'YYYY-MM-DD HH:mm:ss\'\"></small></div><md-divider></md-divider></md-list-item></md-list></md-content><md-sidenav flex=\"66\" class=\"md-sidenav-right\" md-component-id=\"talkNav\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-whiteframe=\"4\"><div layout=\"row\" ng-if=\"messages.selectedTalk\"><md-button hide-gt-xs=\"\" class=\"close-talk md-icon-button\" ng-click=\"messages.closeTalk()\"><md-icon md-font-set=\"material-icons\">list</md-icon></md-button><md-list flex=\"\" style=\"padding:0;margin-right:50px\"><md-list-item class=\"md-2-line\"><img ng-src=\"{{messages.selectedTalk.getInterlocutorAvatar()}}\" class=\"md-avatar\" alt=\"{{messages.selectedTalk.formatPersons()}}\"><div class=\"md-list-item-text\"><h3>{{messages.selectedTalk.formatPersons()}}</h3></div></md-list-item></md-list></div><div ui-view=\"\" flex=\"\"></div></md-sidenav><md-sidenav flex=\"66\" class=\"md-sidenav-right\" md-component-id=\"createTalkNav\" md-is-open=\"false\" style=\"overflow:visible\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'select-persons\' | trans}}</h2><span flex=\"\"></span><md-button class=\"md-raised\" ng-click=\"messages.cancelCreate()\">{{\'cancel\' | trans}}</md-button><md-button class=\"md-raised md-accent\" ng-click=\"messages.createTalk()\" ng-disabled=\"messages.selectedContacts.length==0\">{{\'create\' | trans}}</md-button></div></md-toolbar><lb-contact-select contacts=\"messages.contacts\" model=\"messages.selectedContacts\"></lb-contact-select></md-sidenav></div></md-dialog-content></md-dialog>");
$templateCache.put("./app/news/news.html","<div layout=\"column\" class=\"content-body\" style=\"margin-top: 30px\"><div layout=\"row\" class=\"search\" layout-wrap=\"\" layout-align=\"center center\"><md-input-container><md-select ng-model=\"news.typeFilter\" ng-change=\"news.reloadPosts()\" placeholder=\"{{\'filter-by-type-content\' | trans}}\"><md-option value=\"\">{{\'no-filter\' | trans}}</md-option><md-option value=\"1\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#3F51B5\', \'margin-right\': \'4px\'}\">dns</md-icon>{{\'programs\' | trans}}</md-option><md-option value=\"2\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#03A9F4\', \'margin-right\': \'4px\'}\">public</md-icon>{{\'link\' | trans}}</md-option><md-option value=\"3\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#F44336\', \'margin-right\': \'4px\'}\">play_circle_filled</md-icon>{{\'video\' | trans}}</md-option><md-option value=\"4\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#4CAF50\', \'margin-right\': \'4px\'}\">camera_alt</md-icon>{{\'images\' | trans}}</md-option><md-option value=\"5\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#FF9800\', \'margin-right\': \'4px\'}\">insert_drive_file</md-icon>{{\'documents\' | trans}}</md-option></md-select></md-input-container><md-button class=\"md-raised md-fab md-mini\" ng-click=\"news.reloadPosts()\" style=\"margin-left:15px\"><md-icon md-font-set=\"material-icons\">autorenew</md-icon><md-tooltip>{{\'update\' | trans}}</md-tooltip></md-button></div><div id=\"stories\" class=\"stories news\" infinite-scroll=\"news.loadPosts()\" infinite-scroll-disabled=\"news.busy\" masonry=\"\" preserve-order=\"\" item-selector=\".grid-item\" masonry-options=\"{percentPosition: true}\"><div masonry-brick=\"\" class=\"grid-item\" ng-repeat=\"post in news.loadedPosts\"><lb-news-card post=\"post\"></lb-news-card></div></div><md-icon ng-if=\"news.busy || news.postsLoading\" md-svg-src=\"/assets/icons/spinner.svg\" style=\"margin: 10px\"></md-icon><p ng-if=\"news.loadedPosts.length==0 && !news.postsLoading\" ng-cloak=\"\">{{\'no-news-yet\' | trans}}</p></div>");
$templateCache.put("./app/playlist/playlist.html","<div class=\"content-header anim-zoom-out-full\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\"><h1 style=\"margin:0\"><small>{{\'playlist\' | trans}}</small> {{playlist.playlist.name}}</h1></div></div><div layout=\"column\" class=\"content-body wide-content\" layout-align=\"start center\"><div class=\"card-grid\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><lb-course-card ng-repeat=\"course in playlist.playlist.courses\" course=\"course\" lazy=\"true\"></lb-course-card></div></div>");
$templateCache.put("./app/playlists/playlists.html","<div layout=\"column\" class=\"content-body wide-content\" layout-align=\"start center\"><div class=\"card-grid\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><lb-playlist-card ng-repeat=\"playlist in playlists.playlists\" playlist=\"playlist\" lazy=\"true\"></lb-playlist-card></div><p ng-if=\"playlists.playlists.length==0\" ng-cloak=\"\">{{\'no-playlist\' | trans}}</p></div>");
$templateCache.put("./app/postDetail/postDetail.html","<md-dialog aria-label=\"{{postDetail.post.user.name}} {{postDetail.post.user.surname}}\" md-theme=\"{{postDetail.viewState.theme}}\" class=\"postdetail-dialog\" flex=\"\" flex-md=\"50\" flex-gt-md=\"40\"><md-toolbar><div class=\"md-toolbar-tools\"><md-list style=\"margin-top:22px;margin-left:-24px\"><md-list-item class=\"md-2-line md-no-proxy\"><lb-user-button user=\"postDetail.post.user\"></lb-user-button><div class=\"md-list-item-text smoothable\"><h3>{{postDetail.post.user.name}} {{postDetail.post.user.surname}}</h3><p><small am-time-ago=\"postDetail.post.created | amParse: \'X\'\" \"=\"\"></small></p></div></md-list-item></md-list><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"postDetail.cancel()\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color:\'grey\'}\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-card class=\"social-post post-detail\"><md-card-content><a href=\"#\" ng-if=\"postDetail.post.type==1\" ng-click=\"postDetail.showCourse()\"><img ng-src=\"{{postDetail.post.og[\'og:image\']}}\"><h4 md-colors=\"{\'color\': postDetail.viewState.theme + \'-primary\'}\" class=\"md-title\" style=\"margin-bottom:0\">{{postDetail.post.og[\'og:title\']}}</h4></a> <a ng-if=\"postDetail.post.type==2\" href=\"{{postDetail.post.og[\'og:url\']}}\" target=\"_blank\"><img ng-src=\"{{postDetail.post.og[\'og:image\']}}\"><h4 class=\"md-title md-primary\" style=\"margin-bottom:0\">{{postDetail.post.og[\'og:title\']}}</h4></a><iframe ng-if=\"postDetail.post.type==3\" class=\"videoplayer\" width=\"100%\" height=\"100%\" src=\"{{postDetail.post.resourceLink}}\" frameborder=\"0\" allowfullscreen=\"\"></iframe><img ng-if=\"postDetail.post.type==4\" ng-src=\"{{postDetail.post.resourceBigLink}}\" class=\"picture\"> <a class=\"md-primary\" ng-if=\"postDetail.post.type==5\" href=\"{{postDetail.post.resourceLink}}\">{{postDetail.post.resourceLink.split(\'/\').reverse()[0]}}</a><div ng-if=\"postDetail.post.type==6\" layout=\"row\" class=\"rating\"><md-icon ng-repeat=\"i in postDetail.post.message track by $index\" md-font-set=\"material-icons\" ng-style=\"{color: \'#FDD835\', \'font-size\': \'26px\', \'margin\': 0}\">star_rate</md-icon></div><videogular ng-if=\"postDetail.post.type==7\" vg-player-ready=\"postDetail.onVideoPlayerReady($API)\" vg-theme=\"postDetail.videoPlayerTheme\"><vg-media vg-src=\"postDetail.post.getVideoResources()\"></vg-media><vg-controls vg-autohide=\"true\" vg-autohide-time=\"3000\"><vg-play-pause-button></vg-play-pause-button><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-fullscreen-button></vg-fullscreen-button></vg-controls><vg-overlay-play></vg-overlay-play><vg-poster vg-url=\"postDetail.post.og[\'og:image\']\"></vg-poster></videogular><p ng-if=\"postDetail.post.type!=6 && !postDetail.post.byStaff\" style=\"margin:20px 0\">{{postDetail.post.message}}</p><div class=\"staff-content\" ng-bind-html=\"postDetail.post.message\" ng-if=\"postDetail.post.type!=6 && postDetail.post.byStaff\"></div><p ng-if=\"postDetail.post.type==6\" style=\"margin:20px 0\">{{\'has-rated\' | trans:{name: postDetail.post.user.name, rate: postDetail.post.message.length} }} <strong><a href=\"#\" ng-click=\"postDetail.showCourse()\">{{postDetail.post.og[\'og:title\']}}</a></strong>.</p><div class=\"community-comments\" ng-class=\"{empty: postDetail.post.comments.length==0}\"><md-subheader ng-if=\"postDetail.post.comments.length>1\" style=\"padding-bottom:4px\">{{postDetail.post.comments.length}} {{\'comments\' | trans}}</md-subheader><md-content><md-list><md-list-item class=\"md-3-line md-long-text closed write\" ng-class=\"{opened: postDetail.post.formOpened}\"><img ng-src=\"{{postDetail.currentUser.picture}}\" class=\"md-avatar\" alt=\"{{postDetail.currentUser.name}} {{postDetail.currentUser.surname}}\"><div class=\"md-list-item-text\"><form name=\"commentForm\" layout=\"row\"><md-input-container class=\"md-block\"><label>{{\'comment\' | trans}}</label> <input md-maxlength=\"200\" name=\"message\" lb-focus-me=\"postDetail.post.formOpened\" ng-model=\"postDetail.message\"><div ng-messages=\"commentForm.message.$error\"><div ng-message=\"md-maxlength\">{{\'info-message-length\' | trans}}</div></div></md-input-container></form></div></md-list-item><md-list-item ng-repeat=\"comment in postDetail.post.comments\" class=\"md-3-line md-long-text\"><img ng-src=\"{{comment.user.picture}}\" class=\"md-avatar\" alt=\"{{comment.user.name}} {{comment.user.surname}}\"><div class=\"md-list-item-text\"><h3>{{comment.user.name}} {{comment.user.surname}}</h3><p><small am-time-ago=\"comment.created | amParse: \'X\'\"></small></p><p>{{comment.comment}}</p></div></md-list-item></md-list></md-content></div></md-card-content></md-card></md-dialog-content><md-dialog-actions><div ng-if=\"postDetail.post.likes>0\" layout=\"row\" layout-align=\"center center\" style=\"padding:0 6px\"><strong md-colors=\"{\'color\': postDetail.viewState.theme + \'-primary\'}\">{{postDetail.post.likes}}</strong><md-icon md-font-set=\"material-icons\" md-colors=\"{\'color\': postDetail.viewState.theme + \'-primary-100\'}\" ng-style=\"{\'font-size\':\'20px\',\'margin-left\':\'4px\'}\">thumb_up</md-icon></div><span flex=\"\"></span><md-button ng-if=\"!postDetail.post.liked\" ng-click=\"postDetail.like()\" class=\"md-primary\" style=\"margin:0\">{{\'i-like\' | trans}}</md-button><md-button ng-if=\"postDetail.post.liked\" ng-click=\"postDetail.unlike()\" class=\"md-primary\" style=\"margin:0\">{{\'dont-like\' | trans}}</md-button><md-button class=\"md-accent md-raised\" ng-if=\"postDetail.message.length>0\" ng-click=\"postDetail.comment()\">{{\'send\' | trans}}</md-button><md-button class=\"md-primary\" ng-click=\"postDetail.post.formOpened=!postDetail.post.formOpened\">{{postDetail.post.formOpened ? \'cancel\' : \'comment-on\' | trans}}</md-button><md-button class=\"md-primary\" ng-if=\"postDetail.post.isMine()\" ng-click=\"postDetail.deletePost($event)\">{{\'delete\' | trans}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("./app/rateCourse/rateCourse.html","<md-dialog aria-label=\"{{\'rate-the-programm\' | trans}}\" md-theme=\"{{rateCourse.viewState.theme}}\" class=\"post-dialog\" flex=\"\" flex-md=\"50\" flex-gt-md=\"40\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2>{{\'rate-the-programm\' | trans}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"rateCourse.cancel()\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-dialog-content flex-xs=\"\"><div layout=\"column\" layout-padding=\"\" layout-align=\"center center\"><p style=\"text-align: center\">{{\'give-vote-program\' | trans}}</p><jk-rating-stars max-rating=\"5\" rating=\"rateCourse.rating\"></jk-rating-stars></div></md-dialog-content><md-dialog-actions layout-align-xs=\"center center\" layout-xs=\"column\"><md-checkbox ng-if=\"rateCourse.viewState.hasModule(\'social_post\')\" style=\"font-size: 14px; margin: 0\" ng-model=\"rateCourse.socialPost\">{{\'share-comment-in\' | trans}} {{\'module-community-\' + rateCourse.viewState.theme | trans}}</md-checkbox><span flex=\"\"></span><div layout=\"row\" style=\"margin-top: 15px\"><md-button class=\"md-raised\" ng-click=\"rateCourse.cancel()\">{{\'cancel\' | trans}}</md-button><md-button ng-disabled=\"rateCourse.rating==0\" class=\"md-raised md-accent\" ng-click=\"rateCourse.submit()\">{{\'send\' | trans}}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("./app/repository/repository.html","<div layout=\"column\" class=\"content-body\" style=\"max-width:900px\"><div layout=\"row\" class=\"search\" layout-wrap=\"\" layout-align=\"center center\"><md-input-container><md-select ng-model=\"repository.typeFilter\" placeholder=\"{{\'filter-by-type-doc\' | trans}}\"><md-option value=\"\">{{\'no-filter\' | trans}}</md-option><md-option value=\"image\"><md-icon class=\"document-type image\" md-svg-src=\"/assets/icons/file-picture.svg\"></md-icon>{{\'image\' | trans}}</md-option><md-option value=\"text\"><md-icon class=\"document-type word\" md-svg-src=\"/assets/icons/file-word-o.svg\"></md-icon>{{\'word-document\' | trans}}</md-option><md-option value=\"spreadsheet\"><md-icon class=\"document-type excel\" md-svg-src=\"/assets/icons/file-excel-o.svg\"></md-icon>{{\'excel-document\' | trans}}</md-option><md-option value=\"presentation\"><md-icon class=\"document-type powerpoint\" md-svg-src=\"/assets/icons/file-powerpoint-o.svg\"></md-icon>{{\'powerpoint-document\' | trans}}</md-option><md-option value=\"pdf\"><md-icon class=\"document-type pdf\" md-svg-src=\"/assets/icons/file-pdf-o.svg\"></md-icon>{{\'pdf-document\' | trans}}</md-option><md-option value=\"zip\"><md-icon class=\"document-type zip\" md-svg-src=\"/assets/icons/file-archive-o.svg\"></md-icon>{{\'zip-document\' | trans}}</md-option></md-select></md-input-container></div><md-card ng-if=\"repository.documents.length>0\"><md-list ng-cloak=\"\"><md-list-item ng-href=\"{{document.url}}\" target=\"_blank\" ng-repeat=\"document in repository.documents | filter:repository.typeMatch\" class=\"md-2-line\"><md-button ng-if=\"document.filemime.split(\'/\')[0] ==\'image\'\" aria-label=\"{{\'image\' | trans}}\" class=\"md-fab md-mini filetype image\"><md-icon class=\"image\" md-svg-src=\"/assets/icons/file-picture.svg\"></md-icon></md-button><md-button ng-if=\"document.filemime==\'text/plain\' || document.filemime==\'application/vnd.ms-word\' || document.filemime==\'application/msword\' || document.filemime==\'application/vnd.openxmlformats-officedocument.wordprocessingml.document\'\" aria-label=\"{{\'word-document\' | trans}}\" class=\"md-fab md-mini filetype word\"><md-icon class=\"word\" md-svg-src=\"/assets/icons/file-word-o.svg\"></md-icon></md-button><md-button ng-if=\"document.filemime==\'application/excel\' || document.filemime==\'application/vnd.ms-excel\' || document.filemime==\'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'\" aria-label=\"{{\'excel-document\' | trans}}\" class=\"md-fab md-mini filetype excel\"><md-icon class=\"excel\" md-svg-src=\"/assets/icons/file-excel-o.svg\"></md-icon></md-button><md-button ng-if=\"document.filemime==\'application/mspowerpoint\' || document.filemime==\'application/vnd.ms-powerpoint\' || document.filemime==\'application/vnd.openxmlformats-officedocument.presentationml.presentation\'\" aria-label=\"{{\'powerpoint-document\' | trans}}\" class=\"md-fab md-mini filetype powerpoint\"><md-icon class=\"powerpoint\" md-svg-src=\"/assets/icons/file-powerpoint-o.svg\"></md-icon></md-button><md-button ng-if=\"document.filemime==\'application/pdf\'\" aria-label=\"{{\'pdf-document\' | trans}}\" class=\"md-fab md-mini filetype pdf\"><md-icon class=\"pdf\" md-svg-src=\"/assets/icons/file-pdf-o.svg\"></md-icon></md-button><md-button ng-if=\"document.filemime==\'application/zip\'\" aria-label=\"{{\'zip-document\' | trans}}\" class=\"md-fab md-mini filetype zip\"><md-icon class=\"zip\" md-svg-src=\"/assets/icons/file-archive-o.svg\"></md-icon></md-button><div hide=\"\" show-gt-xs=\"\" class=\"md-list-item-text\"><h3 style=\"line-height:24px\" class=\"ng-binding\">{{document.name}}</h3><p style=\"line-height:20px\">{{document.description}}</p></div><p hide-gt-xs=\"\">{{document.name}}</p><md-icon class=\"md-secondary\" md-font-set=\"material-icons\">file_download</md-icon></md-list-item></md-list></md-card><p ng-if=\"repository.documents.length==0\" ng-cloak=\"\">{{\'no-document-found\' | trans}}</p></div>");
$templateCache.put("./app/search/search.html","<md-dialog aria-label=\"{{\'search\' | trans}}\" md-theme=\"{{search.viewState.theme}}\" class=\"post-dialog\" flex=\"\" flex-md=\"50\" flex-gt-md=\"40\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2>{{\'search\' | trans}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"search.cancel()\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content><md-autocomplete md-autofocus=\"\" ng-cloak=\"\" md-search-text=\"search.searchText\" md-items=\"item in search.searchCourse()\" md-min-length=\"3\" md-delay=\"600\" md-menu-class=\"md-list\" md-selected-item-change=\"search.searchText=\'\'\" placeholder=\"{{\'search-on-the-platform\' | trans}}\"><md-item-template><md-list-item class=\"md-3-line\" ng-click=\"search.visit(item)\"><img ng-show=\"item.thumb\" ng-src=\"{{item.thumb}}\" alt=\"{{item.title}}\" ng-class=\"{\'search-thumb\':item.type!=\'user\',\'md-avatar\':item.type==\'user\'}\"><div class=\"md-list-item-text\"><p style=\"color:#bbb\">{{search.getTypeLabel(item.type)}}</p><h3>{{item.title}}</h3><h4>{{item.abstract}}</h4></div></md-list-item></md-item-template><md-not-found><span style=\"padding:0 15px\">{{\'no-items-found\' | trans}}</span></md-not-found></md-autocomplete></md-content></md-dialog-content></md-dialog>");
$templateCache.put("./app/socialPost/socialPost.html","<md-dialog aria-label=\"{{\'publish\' | trans}}\" md-theme=\"{{socialPost.viewState.theme}}\" class=\"post-dialog\" flex=\"\" flex-md=\"60\" flex-gt-md=\"50\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2>{{\'publish\' | trans}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"socialPost.cancel()\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"postForm\"><div layout=\"row\" layout-padding=\"\" class=\"post-message\" layout-align=\"center center\"><img ng-src=\"{{socialPost.user.picture}}\" class=\"avatar-big\" alt=\"{{socialPost.user.name}} {{socialPost.user.surname}}\"><md-input-container class=\"md-block\" flex=\"\"><label>{{\'write-a-message\' | trans}}</label> <input md-maxlength=\"2000\" lb-focus-me=\"true\" required=\"\" name=\"message\" ng-model=\"socialPost.message\"><div ng-messages=\"postForm.message.$error\"><div ng-message=\"required\">{{\'message-mandatory\' | trans}}</div><div ng-message=\"md-maxlength\">{{\'Messagge-md-maxlength\' | trans}}</div></div></md-input-container></div></form><lb-post-attachment default-type=\"socialPost.attachmentType\" model=\"socialPost.attachment\"></lb-post-attachment></md-dialog-content><md-dialog-actions><md-checkbox ng-if=\"currentUser.hasRole(\'ROLE_TUTOR\')\" ng-model=\"socialPost.byStaff\">{{\'bystaff\' | trans}}</md-checkbox><span flex=\"\"></span><md-button ng-disabled=\"!postForm.$valid\" class=\"md-raised md-accent\" ng-click=\"socialPost.post(postForm)\">{{\'publish\' | trans}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("./app/uploadAvatar/uploadAvatar.html","<md-dialog aria-label=\"{{\'edit-profile-picture\' | trans}}\" md-theme=\"{{uploadAvatar.viewState.theme}}\" class=\"avatar-dialog\" flex=\"\" flex-md=\"50\" flex-gt-md=\"40\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2>{{\'edit-profile-picture\' | trans}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"uploadAvatar.cancel()\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><form ng-show=\"uploadAvatar.picture==null\" name=\"avatarForm\"><div class=\"drop-box\" ngf-drop=\"\" name=\"picture\" ngf-select=\"\" accept=\"image/*\" ngf-fix-orientation=\"true\" ng-model=\"uploadAvatar.picture\" ngf-model-invalid=\"uploadAvatar.errorFiles\" ngf-drag-over-class=\"\'dragover\'\" ngf-pattern=\"\'image/*\'\">{{\'drag-and-drop-image\' | trans}}</div></form><img-crop class=\"cropArea\" ng-show=\"uploadAvatar.picture!=null\" image=\"uploadAvatar.picture | ngfDataUrl\" result-image=\"uploadAvatar.croppedPicture\" area-type=\"circle\" result-image-size=\"112\" result-image-format=\"image/jpeg\"></img-crop></div></md-dialog-content><md-dialog-actions><md-progress-linear ng-if=\"uploadAvatar.progress!=null\" md-mode=\"determinate\" value=\"{{uploadAvatar.progress}}\"></md-progress-linear><span flex=\"\"></span><md-button class=\"md-raised\" ng-click=\"uploadAvatar.cancel()\">{{\'cancel\' | trans}}</md-button><md-button class=\"md-raised md-accent\" ng-disabled=\"!avatarForm.$valid\" ng-click=\"uploadAvatar.upload()\">{{\'send\' | trans}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("./app/uploadCover/uploadCover.html","<md-dialog aria-label=\"{{\'edit-cover-photo\' | trans}}\" md-theme=\"{{uploadCover.viewState.theme}}\" class=\"cover-dialog\" flex=\"\" flex-md=\"50\" flex-gt-md=\"40\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2>{{\'edit-cover-photo\' | trans}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"uploadCover.cancel()\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><form ng-show=\"uploadCover.picture==null\" name=\"coverForm\"><div class=\"drop-box\" ngf-drop=\"\" name=\"picture\" ngf-select=\"\" accept=\"image/*\" ng-model=\"uploadCover.picture\" ngf-fix-orientation=\"true\" ngf-model-invalid=\"uploadCover.errorFiles\" ngf-drag-over-class=\"\'dragover\'\" ngf-pattern=\"\'image/*\'\">{{\'drag-and-drop-image\' | trans}}</div></form><img-crop class=\"cropArea\" ng-show=\"uploadCover.picture!=null\" image=\"uploadCover.picture | ngfDataUrl\" result-image=\"uploadCover.croppedPicture\" area-type=\"rectangle\" aspect-ratio=\"4\" result-image-size=\"{w: 1000, h: 250}\" init-max-area=\"true\" result-image-format=\"image/jpeg\"></img-crop></div></md-dialog-content><md-dialog-actions><md-progress-linear ng-if=\"uploadCover.progress!=null\" md-mode=\"determinate\" value=\"{{uploadCover.progress}}\"></md-progress-linear><span flex=\"\"></span><md-button ng-click=\"uploadCover.cancel()\" class=\"md-raised\">{{\'cancel\' | trans}}</md-button><md-button ng-disabled=\"!coverForm.$valid\" ng-click=\"uploadCover.upload()\" class=\"md-raised md-accent\">{{\'send\' | trans}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("./app/user/user.html","<div id=\"episodeContent\" layout=\"column\" class=\"content-body wide-content\" layout-align=\"start center\"><md-card class=\"user-header\" ng-style=\"{\'background-image\': \'url({{user.user.cover}})\', \'background-size\': \'cover\'}\"><md-card-title><md-card-title-text><span class=\"md-subhead\">{{user.user.company}}, {{user.user.job}}</span> <span class=\"md-display-1\">{{user.user.name}} {{user.user.surname}}</span></md-card-title-text><md-card-title-media><div class=\"md-media-md card-media\"><md-button ng-if=\"user.user.id==user.currentUser.id && user.viewState.hasModule(\'core_edit-profile\')\" ng-click=\"$state.go(\'uploadAvatar\', {userId: user.user.id})\" class=\"md-fab md-raised md-mini avatar-update-button\" aria-label=\"Cambia foto\"><md-icon md-font-set=\"material-icons\">edit</md-icon><md-tooltip>{{\'edit-profile-picture\' | trans}}</md-tooltip></md-button><div class=\"user-avatar\" layou=\"column\" layout-align=\"center center\" layout-fill=\"\"><img ng-src=\"{{user.user.pictureBig}}\" width=\"112\" height=\"112\"> <span ng-if=\"user.viewState.hasModule(\'gamification\')\" class=\"score md-whiteframe-1dp\">{{user.user.score}}</span></div></div></md-card-title-media></md-card-title><md-card-actions layout=\"row\" style=\"margin-top:20px\"><md-button ng-if=\"user.user.id!=user.currentUser.id\" ng-click=\"$state.go(\'messages\', {recipientId: user.user.id})\" class=\"md-raised\" ng-class=\"{\'md-fab md-mini\': $mdMedia(\'xs\')}\"><span hide=\"\" show-gt-xs=\"\">{{\'send-a-message\' | trans}}</span><md-icon hide-gt-xs=\"\" md-font-set=\"material-icons\">message</md-icon></md-button><md-button ng-if=\"user.user.id!=user.currentUser.id && !user.viewState.follows(user.user.id)\" ng-click=\"user.follow()\" class=\"md-raised\" ng-class=\"{\'md-fab md-mini\': $mdMedia(\'xs\')}\"><span hide=\"\" show-gt-xs=\"\">{{\'follow\' | trans}}</span><md-icon hide-gt-xs=\"\" md-font-set=\"material-icons\">add_circle</md-icon></md-button><md-button ng-if=\"user.user.id!=user.currentUser.id && user.viewState.follows(user.user.id)\" ng-click=\"user.unfollow()\" class=\"md-raised\" ng-class=\"{\'md-fab md-mini\': $mdMedia(\'xs\')}\"><span hide=\"\" show-gt-xs=\"\">{{\'unfollow\' | trans}}</span><md-icon hide-gt-xs=\"\" md-font-set=\"material-icons\">remove_circle</md-icon></md-button><md-button ng-if=\"user.user.id!=user.currentUser.id\" ng-click=\"$state.go(\'compareStats\', {userId: user.user.id})\" class=\"md-raised\" ng-class=\"{\'md-fab md-mini\': $mdMedia(\'xs\')}\"><span hide=\"\" show-gt-xs=\"\">{{\'compare\' | trans}}</span><md-icon hide-gt-xs=\"\" md-font-set=\"material-icons\">people</md-icon></md-button><md-button ng-if=\"user.user.id==user.currentUser.id && user.viewState.hasModule(\'core_edit-profile\')\" ng-click=\"$state.go(\'editProfile\', {userId: user.user.id})\" class=\"md-raised\" ng-class=\"{\'md-fab md-mini\': $mdMedia(\'xs\')}\"><span hide=\"\" show-gt-xs=\"\">{{\'edit-info\' | trans}}</span><md-icon hide-gt-xs=\"\" md-font-set=\"material-icons\">info</md-icon></md-button><md-button ng-if=\"user.user.id==user.currentUser.id\" ng-click=\"$state.go(\'editPassword\', {userId: user.user.id})\" class=\"md-raised\" ng-class=\"{\'md-fab md-mini\': $mdMedia(\'xs\')}\"><span hide=\"\" show-gt-xs=\"\">{{\'change-password\' | trans}}</span><md-icon hide-gt-xs=\"\" md-font-set=\"material-icons\">lock</md-icon></md-button><md-button ng-if=\"user.user.id==user.currentUser.id && user.viewState.hasModule(\'core_edit-profile\')\" ng-click=\"$state.go(\'uploadCover\', {userId: user.user.id})\" class=\"md-raised\" ng-class=\"{\'md-fab md-mini\': $mdMedia(\'xs\')}\"><span hide=\"\" show-gt-xs=\"\">{{\'change-cover\' | trans}}</span><md-icon hide-gt-xs=\"\" md-font-set=\"material-icons\">insert_photo</md-icon></md-button></md-card-actions></md-card><div layout=\"row\" layout-fill=\"\" flex=\"\"><div hide=\"\" show-gt-sm=\"\" flex=\"33\" flex-gt-md=\"25\"><div class=\"summary-box\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span>{{\'info\' | trans}}</span></h2><span flex=\"\"></span><md-button ng-if=\"user.user.id==user.currentUser.id && user.viewState.hasModule(\'core_edit-profile\')\" class=\"md-icon-button\" ui-sref=\"editProfile({userId: user.user.id})\"><md-icon md-font-set=\"material-icons\">edit</md-icon><md-tooltip ng-if=\"user.user.id==user.currentUser.id\" md-direction=\"right\">{{\'edit-info\' | trans}}</md-tooltip></md-button></div></md-toolbar><p class=\"summary-info\" ng-if=\"user.user.biography!=\'\'\">{{user.user.biography}}</p><p class=\"summary-info\"><strong>{{\'name\' | trans}}</strong> {{user.user.name}} {{user.user.surname}}</p><p class=\"summary-info\"><strong>{{\'company\' | trans}}</strong> {{user.user.company}}</p><p class=\"summary-info\"><strong>{{\'position\' | trans}}</strong> {{user.user.job || \'-\'}}</p><p class=\"summary-info\"><strong>{{\'location\' | trans}}</strong> {{user.user.city}} ({{user.user.country}})</p><p class=\"summary-info\"><strong>{{\'language\' | trans}}</strong> {{user.languages[user.user.language]}}</p></div><div class=\"summary-box\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span>{{\'results\' | trans}}</span></h2><span flex=\"\"></span><div ng-if=\"user.user.id!=user.currentUser.id\"><md-button style=\"margin:0\" class=\"md-icon-button\" ui-sref=\"compareStats({userId: user.user.id})\"><md-icon md-font-set=\"material-icons\">people</md-icon><md-tooltip md-direction=\"right\">{{\'compare\' | trans}}</md-tooltip></md-button></div><div style=\"margin-right: -8px;\"><md-button style=\"margin:0\" class=\"md-icon-button\" ui-sref=\"user.stats({userId: user.user.id})\"><md-icon md-font-set=\"material-icons\">equalizer</md-icon></md-button><md-tooltip md-direction=\"right\">{{\'statistics\' | trans}}</md-tooltip></div></div></md-toolbar><div layout=\"column\" ng-if=\"user.hasStats()\"><lb-user-chart data=\"user.userData\" labels=\"user.userLabels\"></lb-user-chart></div><p ng-if=\"!user.hasStats()\"><small>{{\'still-no-results\' | trans}}</small></p></div><div class=\"summary-box\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span>{{\'last-program\' | trans}}</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ui-sref=\"user.courses({userId: user.user.id})\"><md-icon md-font-set=\"material-icons\">dns</md-icon><md-tooltip md-direction=\"right\">{{\'all-programs\' | trans}}</md-tooltip></md-button></div></md-toolbar><div layout=\"column\" ng-if=\"user.user.lastViewedCourse!=null\"><lb-last-course course=\"user.user.lastViewedCourse\" action=\"Visita\"></lb-last-course></div><p ng-if=\"user.user.lastViewedCourse==null\"><small>{{\'no-program-visited\' | trans}}</small></p></div><div class=\"summary-box\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span>{{\'following\' | trans}}</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ui-sref=\"user.contacts({userId: user.user.id})\"><md-icon md-font-set=\"material-icons\">people</md-icon><md-tooltip md-direction=\"right\">{{\'all-contacts\' | trans}}</md-tooltip></md-button></div></md-toolbar><md-list ng-if=\"user.user.following.length>0\"><md-list-item ng-repeat=\"user in user.user.following\" class=\"md-2-line md-no-proxy\"><lb-user-button user=\"user\"></lb-user-button><div class=\"md-list-item-text smoothable\"><h3>{{user.name}} {{user.surname}}</h3><p>{{user.company}}</p></div></md-list-item></md-list><p ng-if=\"user.user.following.length==0\"><small>{{\'no-users-found\' | trans}}</small></p></div></div><md-tabs flex=\"\" flex-gt-sm=\"66\" flex-gt-md=\"75\" md-selected=\"user.selectedTab\" md-border-bottom=\"\" md-dynamic-height=\"\" md-center-tabs=\"\" md-swipe-content=\"\" style=\"margin-top: 30px\"><md-tab label=\"{{\'activity\' | trans}}\" ui-sref=\"user.posts({userId: user.user.id})\"><div ui-view=\"posts\"></div></md-tab><md-tab label=\"{{\'programs\' | trans}}\" ui-sref=\"user.courses({userId: user.user.id})\"><div ui-view=\"courses\"></div></md-tab><md-tab label=\"{{\'statistics\' | trans}}\" ui-sref=\"user.stats({userId: user.user.id})\"><div ui-view=\"stats\"></div></md-tab><md-tab label=\"{{\'contacts\' | trans}}\" ui-sref=\"user.contacts({userId: user.user.id})\"><div ui-view=\"contacts\"></div></md-tab><md-tab label=\"{{\'godos\' | trans}}\" ui-sref=\"user.godos({userId: user.user.id})\"><div ui-view=\"godos\"></div></md-tab></md-tabs></div></div>");
$templateCache.put("./app/components/breadcrumb/breadcrumb.html","<ul class=\"breadcrumb\"><li ng-repeat=\"node in breadcrumb.history\"><a href=\"#\" md-colors=\"{\'color\': breadcrumb.viewState.theme + \'-primary\'}\" ng-if=\"!node.current\" ui-sref=\"library({categorySlug: node.slug})\"><h3 class=\"md-subhead\"><md-icon ng-if=\"node.icon\" ng-style=\"{color: node.colour, \'margin-right\': \'3px\'}\" md-font-set=\"material-icons\">{{node.icon}}</md-icon>{{node.name}}</h3></a><md-icon ng-if=\"node.current && node.icon\" ng-style=\"{color: node.colour, \'margin-right\': \'3px\'}\" md-font-set=\"material-icons\">{{node.icon}}</md-icon><h3 ng-if=\"node.current\" class=\"md-subhead\">{{node.name}}</h3></li></ul>");
$templateCache.put("./app/components/commentPreview/commentPreview.html","<md-list-item ng-class=\"{slideInRight: commentPreview.post.added}\" md-=\"\" ui-sref=\"commentDetail({courseId:commentPreview.courseid,lessonId:commentPreview.lessonid,commentId:commentPreview.post.id})\" class=\"social-post post-preview md-3-line md-long-text animated\" ng-cloak=\"\"><lb-user-button user=\"commentPreview.post.user\" style=\"margin-top:-3px\"></lb-user-button><div class=\"md-list-item-text smoothable\"><h3>{{commentPreview.post.user.name}} {{commentPreview.post.user.surname}}</h3><p><small am-time-ago=\"commentPreview.post.created | amParse: \'X\'\"></small></p><div class=\"post-content\"><div ng-if=\"commentPreview.post.type==2\"><img ng-if=\"commentPreview.post.og[\'og:image\']\" ng-src=\"{{commentPreview.post.og[\'og:image\']}}\" class=\"picture\"> <span md-colors=\"{\'color\': commentPreview.viewState.theme + \'-primary\'}\">{{commentPreview.post.og[\'og:title\']}}</span></div><img ng-if=\"commentPreview.post.type==3\" ng-src=\"{{commentPreview.getYTPreview(post.resourceLink)}}\" class=\"picture\"> <img ng-if=\"commentPreview.post.type==4\" ng-src=\"{{commentPreview.post.resourceThumbLink}}\" class=\"picture\"><div ng-if=\"commentPreview.post.type==5\" md-colors=\"{\'color\': commentPreview.viewState.theme + \'-primary\'}\">{{commentPreview.post.resourceLink.split(\'/\').reverse()[0]}}</div><img ng-if=\"commentPreview.post.type==7\" ng-src=\"{{commentPreview.post.og[\'og:image\']}}\" class=\"picture\"><p>{{commentPreview.post.comment}}</p></div></div></md-list-item>");
$templateCache.put("./app/components/contactSelect/contactSelect.html","<md-content class=\"contact-select\" style=\"height:100%\"><section><md-subheader style=\"background:white\"><md-contact-chips ng-model=\"contactSelect.model\" md-contacts=\"contactSelect.querySearch($query)\" md-contact-name=\"fullname\" md-contact-image=\"picture\" md-contact-email=\"company\" md-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"contactSelect.filterSelected\" placeholder=\"Cerca...\" style=\"margin-left: 10px\"></md-contact-chips></md-subheader><md-list><md-list-item ng-repeat=\"(index, contact) in contactSelect.contacts\" ng-class=\"{selected: contactSelect.model.indexOf(contact) >= 0}\" ng-click=\"contactSelect.selectContact(contact)\" class=\"md-2-line contact-item\" ng-if=\"contact.id != contactSelect.currentUser.id\"><div class=\"user-image\"><img ng-src=\"{{contact.picture}}\" class=\"md-avatar md-whiteframe-3dp\" alt=\"{{contact.name}} {{contact.surname}}\"> <span ng-if=\"contactSelect.viewState.hasModule(\'gamification\')\" class=\"score md-whiteframe-1dp\">{{contact.score}}</span> <span ng-if=\"contactSelect.viewState.hasRealtimeUsers && contactSelect.viewState.isOnline(contact.id)\" class=\"status online\"></span></div><div class=\"md-list-item-text compact\"><h3>{{contact.name}} {{contact.surname}}</h3><p>{{contact.company}}</p></div></md-list-item></md-list></section></md-content>");
$templateCache.put("./app/components/courseCard/courseCard.html","<div class=\"hide-gt-xs\" layout=\"column\" style=\"padding:4px\"><md-card layout-fill=\"\" ng-click=\"courseCard.enter()\" ng-style=\"{\'background-color\': courseCard.course.category.colour}\" ng-class=\"{enrolled: courseCard.course.isEnrolled}\"><md-icon ng-if=\"courseCard.course.locked\" md-font-set=\"material-icons\" style=\"position: absolute;top:3px;right:3px;color:white;text-shadow:2px 2px 4px rgba(0, 0, 0, 0.33);font-size:40px;\" class=\"material-icons\">lock</md-icon><img ng-if=\"lazy\" data-lazy=\"{{courseCard.course.image}}\" class=\"md-card-image\" alt=\"image caption\"> <img ng-if=\"!lazy\" ng-src=\"{{courseCard.course.image}}\" class=\"md-card-image\" alt=\"image caption\"><div class=\"course-info\" layout=\"row\"><div flex=\"\"><div ng-if=\"courseCard.course.completingExpectedTime\"><md-icon ng-if=\"courseCard.course.completingExpectedTime<=6\" md-svg-src=\"/assets/icons/coffee.svg\" ng-style=\"{color: \'white\'}\"></md-icon><md-icon ng-if=\"courseCard.course.completingExpectedTime>6 && courseCard.course.completingExpectedTime<=15\" ng-style=\"{color: \'white\'}\" md-font-set=\"material-icons\">directions_subway</md-icon><md-icon ng-if=\"courseCard.course.completingExpectedTime>15\" ng-style=\"{color: \'white\'}\" md-font-set=\"material-icons\">flight</md-icon><small>{{courseCard.course.completingExpectedTime}}\'</small></div></div><div ng-if=\"courseCard.viewState.hasModule(\'gamification\')\"><md-icon style=\"color: white !important\" ng-style=\"{\'font-size\': \'18px\', margin: \'0 -4px 0 10px\', \'line-height\': \'24px\'}\" md-font-set=\"material-icons\">security</md-icon><small>{{courseCard.course.score}} {{ \'points\' | trans }}</small></div></div><div class=\"course-progress\" ng-if=\"courseCard.course.isEnrolled\"><small>{{\'episodes-progress\' | trans:{maked: courseCard.course.lessonsCurrentUser.lessonsMaked, total: courseCard.course.totalLessons} }}</small><md-progress-linear md-mode=\"determinate\" value=\"{{courseCard.course.lessonsCurrentUser.progress}}\"></md-progress-linear></div><div class=\"rating details-link\" style=\"text-align: right;margin: 5px 8px 0;\" ng-if=\"courseCard.course.isEnrolled\"><a ui-sref=\"courseDetail({courseId: courseCard.course.id})\" ng-click=\"$event.stopPropagation()\"><md-icon md-font-set=\"material-icons\" style=\"color: #ffffff !important; font-size: 18px; padding-top: 3px;\">info_outline</md-icon>{{\'details\' | trans}}</a></div><md-card-content style=\"margin-top: -30px; margin-bottom: 30px;\"><div layout=\"row\" class=\"rating\" ng-if=\"courseCard.viewState.hasModule(\'social\') && courseCard.stars.length>0\"><md-icon ng-repeat=\"i in courseCard.stars track by $index\" md-font-set=\"material-icons\" ng-style=\"{color: \'#FDD835\', \'font-size\': \'18px\', \'margin\': \'0 -5px 0 0\'}\">star_rate</md-icon></div><h2 class=\"md-title\"><small>{{courseCard.course.category.name}}</small> {{courseCard.course.title}}</h2></md-card-content></md-card></div><flippy layout-fill=\"\" hide-xs=\"\" flip=\"[\'mouseenter\']\" flip-back=\"[\'mouseleave\']\" duration=\"800\" timing-function=\"ease-in-out\"><flippy-front><md-card ng-style=\"{\'background-color\': courseCard.course.category.colour}\" ng-class=\"{enrolled: courseCard.course.isEnrolled}\"><img ng-if=\"lazy\" data-lazy=\"{{courseCard.course.thumbImage}}\" class=\"md-card-image\" alt=\"image caption\"> <img ng-if=\"!lazy\" ng-src=\"{{courseCard.course.thumbImage}}\" class=\"md-card-image\" alt=\"image caption\"><div ng-if=\"courseCard.course.locked\" class=\"locked-course\"><md-icon md-font-set=\"material-icons\" style=\"padding-bottom:16px\">lock</md-icon></div><div class=\"course-progress\" ng-if=\"courseCard.course.isEnrolled\"><small>{{\'episodes-progress\' | trans:{maked: courseCard.course.lessonsCurrentUser.lessonsMaked, total: courseCard.course.totalLessons} }}</small><md-progress-linear md-mode=\"determinate\" value=\"{{courseCard.course.lessonsCurrentUser.progress}}\"></md-progress-linear></div><md-card-content><div layout=\"row\" class=\"rating\" ng-if=\"courseCard.viewState.hasModule(\'social\') && courseCard.stars.length>0\"><md-icon ng-repeat=\"i in courseCard.stars track by $index\" md-font-set=\"material-icons\" ng-style=\"{color: \'#FDD835\', \'font-size\': \'18px\', \'margin\': \'0 -5px 0 0\'}\">star_rate</md-icon></div><h2 class=\"md-title\"><small>{{courseCard.course.category.name}}</small> {{courseCard.course.title}}</h2></md-card-content></md-card></flippy-front><flippy-back><md-card ng-click=\"courseCard.enter()\" ng-class=\"{enrolled: courseCard.course.isEnrolled}\"><img ng-if=\"lazy\" data-lazy=\"{{courseCard.course.thumbImage}}\" class=\"md-card-image\" alt=\"image caption\"> <img ng-if=\"!lazy\" ng-src=\"{{courseCard.course.thumbImage}}\" class=\"md-card-image\" alt=\"image caption\"><div ng-if=\"!courseCard.course.locked && courseCard.course.isEnrolled\" class=\"play-course\"><md-icon md-font-set=\"material-icons\" style=\"padding-bottom:37px\">play_circle_outline</md-icon></div><div ng-if=\"!courseCard.course.locked && !courseCard.course.isEnrolled\" class=\"play-course\"><md-icon md-font-set=\"material-icons\" style=\"padding-bottom:37px\">info_outline</md-icon></div><div ng-if=\"courseCard.course.locked\" class=\"play-course\"><md-icon md-font-set=\"material-icons\" style=\"padding-bottom:16px\">lock</md-icon></div><div class=\"course-info\" layout=\"row\"><div flex=\"\"><div ng-if=\"courseCard.course.completingExpectedTime\"><md-icon ng-if=\"courseCard.course.completingExpectedTime<=6\" md-svg-src=\"/assets/icons/coffee.svg\" ng-style=\"{color: \'white\'}\"></md-icon><md-icon ng-if=\"courseCard.course.completingExpectedTime>6 && courseCard.course.completingExpectedTime<=15\" ng-style=\"{color: \'white\'}\" md-font-set=\"material-icons\">directions_subway</md-icon><md-icon ng-if=\"courseCard.course.completingExpectedTime>15\" ng-style=\"{color: \'white\'}\" md-font-set=\"material-icons\">flight</md-icon><small>{{courseCard.course.completingExpectedTime}}\'</small></div></div><div ng-if=\"courseCard.viewState.hasModule(\'gamification\')\"><md-icon style=\"color: white !important\" ng-style=\"{\'font-size\': \'18px\', margin: \'0 -4px 0 10px\', \'line-height\': \'24px\'}\" md-font-set=\"material-icons\">security</md-icon><small>{{courseCard.course.score}} {{\'points\' | trans}}</small></div></div><md-card-content><p flex=\"\">{{courseCard.course.description}}</p><div class=\"details-link\" ng-if=\"courseCard.course.isEnrolled\"><a ui-sref=\"courseDetail({courseId: courseCard.course.id})\" ng-click=\"$event.stopPropagation()\"><md-icon md-font-set=\"material-icons\" style=\"margin-left: -3px; margin-right: 3px; margin-top: -2px;\">info_outline</md-icon>{{\'details\' | trans}}</a></div></md-card-content></md-card></flippy-back></flippy>");
$templateCache.put("./app/components/eventResource/eventResource.html","<div layout=\"column\" class=\"content-body\"><div ng-bind-html=\"eventResource.text\" class=\"text-container resource-container md-whiteframe-3dp\" style=\"background-color: white;padding:20px\"></div></div>");
$templateCache.put("./app/components/footer/footer.html","<footer class=\"anim-slide-below-fade\"><md-toolbar><div class=\"md-toolbar-tools\"><div layout=\"row\" class=\"footer-menu\" hide-xs=\"\"><a ui-sref=\"home\" ng-class=\"{active: $state.includes(\'home\')}\">{{\'home\' | trans}}</a> <a ui-sref=\"enrolled\" ng-if=\"footer.viewState.hasModule(\'core_enrolled-view\')\" ng-class=\"{active: $state.includes(\'enrolled\')}\">{{\'module-enrolled-\' + footer.viewState.theme | trans}}</a> <a ui-sref=\"community\" ng-if=\"footer.viewState.hasModule(\'social_post\')\" ng-class=\"{active: $state.includes(\'community\')}\">{{\'module-community-\' + footer.viewState.theme | trans}}</a> <a ui-sref=\"playlists\" ng-if=\"footer.viewState.hasModule(\'playlist\')\" ng-class=\"{active: $state.includes(\'playlists\') || $state.includes(\'playlist\')}\">{{\'module-playlist-\' + footer.viewState.theme | trans}}</a> <a ui-sref=\"news\" ng-if=\"footer.viewState.hasModule(\'news\')\" ng-class=\"{active: $state.includes(\'news\')}\">{{\'module-blog-\' + footer.viewState.theme | trans}}</a> <a ui-sref=\"messages\" ng-if=\"footer.viewState.hasModule(\'messages-menu\')\" ng-class=\"{active: $state.includes(\'messages\')}\">{{\'module-messages-menu-\' + footer.viewState.theme | trans}}</a> <a ui-sref=\"repository\" ng-if=\"footer.viewState.hasModule(\'repository\')\" ng-class=\"{active: $state.includes(\'repository\')}\">{{\'module-repository-\' + footer.viewState.theme | trans}}</a></div><a ng-if=\"footer.viewState.brand.footer\" ui-sref=\"home\" class=\"footer-brand\" hide-gt-xs=\"\"><img ng-src=\"{{footer.viewState.brand.footer}}\"></a> <span flex=\"\"></span><md-button id=\"openRight\" ng-click=\"footer.viewState.toggleRight()\" class=\"md-icon-button\" md-no-ink=\"\"><md-icon md-font-set=\"material-icons\">public</md-icon></md-button></div></md-toolbar></footer>");
$templateCache.put("./app/components/header/header.html","<header><md-toolbar class=\"md-whiteframe-2dp\" ng-cloak=\"\"><div class=\"md-toolbar-tools\"><md-button ng-if=\"currentTenant.enabled\" class=\"main-menu-toggle md-icon-button\" ng-click=\"header.viewState.toggleMain()\"><md-icon md-font-set=\"material-icons\">dehaze</md-icon></md-button><a ui-sref=\"home\" ng-if=\"header.viewState.brand.header\" hide-sm=\"\" hide-xs=\"\" class=\"logo\"><img ng-src=\"{{header.viewState.brand.header}}\"></a><md-autocomplete ng-if=\"currentTenant.enabled\" hide=\"\" show-gt-xs=\"\" ng-cloak=\"\" md-search-text=\"header.searchText\" md-items=\"item in header.searchCourse()\" md-min-length=\"3\" md-delay=\"600\" md-menu-class=\"md-list\" md-selected-item-change=\"header.searchText=\'\'\" placeholder=\"{{\'search-on-the-platform\' | trans}}\"><md-item-template><md-list-item class=\"md-3-line\" ng-click=\"header.visit(item)\"><img ng-show=\"item.thumb\" ng-src=\"{{item.thumb}}\" alt=\"{{item.title}}\" ng-class=\"{\'search-thumb\':item.type!=\'user\',\'md-avatar\':item.type==\'user\'}\"><div class=\"md-list-item-text\"><p style=\"color:#bbb\">{{header.getTypeLabel(item.type)}}</p><h3>{{item.title}}</h3><h4>{{header.getTypeText(item)}}</h4></div></md-list-item></md-item-template><md-not-found><span style=\"padding:0 15px\">{{\'no-items-found\' | trans}}</span></md-not-found></md-autocomplete><a ng-if=\"currentTenant.enabled\" hide-gt-xs=\"\" class=\"header-menu search-trigger\" href=\"#\" ui-sref=\"search\"><md-icon md-font-set=\"material-icons\">search</md-icon></a><md-menu-bar ng-if=\"currentTenant.enabled && !header.viewState.hasHiddenButton(\'browse_category\')\" sf-treepeat=\"node in children of header.categories\" tour-step=\"\" tour-step-title=\"{{\'browse\' | trans}}\" tour-step-content=\"{{\'navigate-favorite-categories\' | trans}}\" tour-step-placement=\"bottom\" tour-step-order=\"12\"><md-menu ng-if=\"node.id == null\"><a class=\"header-menu\" href=\"#\" ng-click=\"$mdOpenMenu();$event.preventDefault()\"><md-icon md-font-set=\"material-icons\">folder</md-icon><span hide=\"\" show-gt-xs=\"\">{{\'browse\' | trans}}</span></a><md-menu-content width=\"4\"><md-menu-item sf-treecurse=\"\"></md-menu-item></md-menu-content></md-menu><md-menu md-position-mode=\"cascade\" ng-if=\"node.id != null && !header.isLeaf(node)\"><md-button ui-sref=\"library({categorySlug: node.slug})\" ng-click=\"\"><div layout=\"row\"><md-icon ng-if=\"node.icon\" ng-style=\"{color: node.colour}\" md-font-set=\"material-icons\">{{node.icon}}</md-icon>{{node.name}}</div></md-button><md-menu-content width=\"4\"><md-menu-item sf-treecurse=\"\"></md-menu-item></md-menu-content></md-menu><md-button ng-if=\"node.id != null && header.isLeaf(node)\" ui-sref=\"library({categorySlug: node.slug})\"><div layout=\"row\"><md-icon ng-if=\"node.icon\" ng-style=\"{color: node.colour}\" md-font-set=\"material-icons\">{{node.icon}}</md-icon>{{node.name}}</div></md-button></md-menu-bar><md-menu-bar ng-if=\"currentTenant.enabled && header.viewState.hasModule(\'social_post\')\" tour-step=\"\" tour-step-title=\"{{\'post\' | trans}}\" tour-step-content=\"{{\'uploading-content-files\' | trans}}\" tour-step-placement=\"bottom\" tour-step-order=\"13\"><md-menu><a class=\"header-menu\" href=\"#\" ng-click=\"$mdOpenMenu();$event.preventDefault()\"><md-icon md-font-set=\"material-icons\">file_upload</md-icon><span hide=\"\" show-gt-xs=\"\">{{\'post\' | trans}}</span></a><md-menu-content width=\"4\"><md-menu-item><md-button ui-sref=\"socialPost({type:0})\"><div layout=\"row\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#3F51B5\'}\">dns</md-icon>{{\'a-comment\' | trans}}</div></md-button></md-menu-item><md-menu-item><md-button ui-sref=\"socialPost({type:1})\"><div layout=\"row\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#03A9F4\'}\">public</md-icon>{{\'a-link\' | trans}}</div></md-button></md-menu-item><md-menu-item><md-button ui-sref=\"socialPost({type:2})\"><div layout=\"row\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#F44336\'}\">play_circle_filled</md-icon>{{\'a-video\' | trans}}</div></md-button></md-menu-item><md-menu-item><md-button ui-sref=\"socialPost({type:3})\"><div layout=\"row\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#4CAF50\'}\">camera_alt</md-icon>{{\'an-image\' | trans}}</div></md-button></md-menu-item><md-menu-item><md-button ui-sref=\"socialPost({type:4})\"><div layout=\"row\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#FF9800\'}\">insert_drive_file</md-icon>{{\'a-document\' | trans}}</div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><span flex=\"\"></span><md-button ng-if=\"currentTenant.enabled && header.viewState.hasModule(\'chatbot\')\" class=\"md-icon-button show-botpanel\" ng-click=\"header.showChatBot($event)\" style=\"margin: 0; min-width: 34px;\"><md-tooltip>{{\'open-messages\' | trans}}</md-tooltip><md-icon md-font-set=\"material-icons\">adb</md-icon></md-button><md-button ng-if=\"currentTenant.enabled && header.viewState.hasModule(\'social_messages\')\" class=\"md-icon-button\" ng-click=\"$state.go(\'messages\')\" style=\"margin: 0; min-width: 34px;\" tour-step=\"\" tour-step-popup-class=\"messages-tour-step\" tour-step-title=\"{{\'messages\' | trans}}\" tour-step-content=\"{{\'can-open-conversation\' | trans}}\" tour-step-placement=\"bottom\" tour-step-order=\"5\"><md-tooltip>{{\'open-messages\' | trans}}</md-tooltip><md-icon md-font-set=\"material-icons\">message</md-icon></md-button><div class=\"badge\" style=\"right:109px\" ng-show=\"currentTenant.enabled && header.viewState.hasRealtime && header.unreadedMessages>0\">{{header.unreadedMessages}}</div><md-button class=\"md-icon-button show-notifications\" ng-click=\"header.showNotifications($event)\" style=\"margin: 0; min-width: 34px;\" tour-step=\"\" tour-step-popup-class=\"notifications-tour-step\" tour-step-title=\"{{\'notifications\' | trans}}\" tour-step-content=\"{{\'can-open-notifications\' | trans}}\" tour-step-placement=\"bottom\" tour-step-order=\"6\"><md-tooltip>{{\'open-notifications\' | trans}}</md-tooltip><md-icon md-font-set=\"material-icons\">notifications</md-icon></md-button><div class=\"badge\" ng-show=\"header.viewState.unreadedNotices>0\">{{header.viewState.unreadedNotices}}</div><md-menu-bar style=\"padding:0 5px;margin-top:6px\"><md-menu><a href=\"javascript:void()\" class=\"header-menu\" ng-click=\"$mdOpenMenu($event)\"><img ng-src=\"{{header.user.picture}}\" class=\"md-avatar\" alt=\"{{header.user.name}} {{header.user.surname}}\" style=\"margin:0 0 0 6px\"><div class=\"user-image\"><span ng-if=\"header.viewState.hasRealtimeUsers && header.viewState.isOnline(header.user.id)\" class=\"status mini online\"></span></div></a><md-menu-content width=\"4\"><md-menu-item ng-if=\"header.viewState.hasIntro\"><md-button ui-sref=\"intro\"><div layout=\"row\"><md-icon md-font-set=\"material-icons\">ondemand_video</md-icon>{{\'video-intro\' | trans}}</div></md-button></md-menu-item><md-menu-item ng-if=\"currentTenant.enabled && header.viewState.hasTour\" ng-show=\"$mdMedia(\'min-width: 1360px\')\"><a class=\"md-button\" ng-click=\"header.viewState.startHomeTutorial()\"><div layout=\"row\"><md-icon md-font-set=\"material-icons\">help_outline</md-icon>{{\'tutorial\' | trans}}</div></a></md-menu-item><md-menu-divider ng-if=\"header.viewState.hasIntro || header.viewState.hasTour\"></md-menu-divider><md-menu-item ng-if=\"currentTenant.enabled\"><md-button ui-sref=\"user({userId: header.currentUser.id})\"><div layout=\"row\"><md-icon md-font-set=\"material-icons\">person</md-icon>{{\'my-profile\' | trans}}</div></md-button></md-menu-item><md-menu-item ng-if=\"currentTenant.enabled\"><md-button ui-sref=\"user.stats({userId: header.currentUser.id})\"><div layout=\"row\"><md-icon md-font-set=\"material-icons\">equalizer</md-icon>{{\'my-statistics\' | trans}}</div></md-button></md-menu-item><md-menu-item ng-if=\"currentTenant.enabled\"><md-button ui-sref=\"user.godos({userId: header.currentUser.id})\"><div layout=\"row\"><md-icon md-font-set=\"material-icons\">flash_on</md-icon>{{\'my-godos\' | trans}}</div></md-button></md-menu-item><md-menu-divider ng-if=\"currentTenant.enabled\"></md-menu-divider><md-menu-item><md-button ui-sref=\"editPassword({userId: header.currentUser.id})\"><div layout=\"row\"><md-icon md-font-set=\"material-icons\">lock</md-icon>{{\'change-password\' | trans}}</div></md-button></md-menu-item><md-menu-item ng-if=\"currentTenant.enabled && header.viewState.linkedinEnabled && (currentUser.linkedinId==null || currentUser.linkedinId==\'\')\"><a class=\"md-button linkedin-connect\" ng-click=\"header.connect(\'linkedin\')\"><div layout=\"row\"><md-icon md-svg-src=\"/assets/icons/linkedin.svg\"></md-icon>{{\'connect-with-linkedin\' | trans}}</div></a></md-menu-item><md-menu-item ng-if=\"currentTenant.enabled && currentUser.linkedinId!=null && currentUser.linkedinId!=\'\'\"><a class=\"md-button linkedin-connect\" ng-click=\"header.disconnect(\'linkedin\')\"><div layout=\"row\"><md-icon md-svg-src=\"/assets/icons/linkedin.svg\"></md-icon>{{\'disconnect-from-linkedin\' | trans}}</div></a></md-menu-item><md-menu-item ng-if=\"currentUser.hasRole(\'ROLE_ADMIN\') || currentUser.hasRole(\'ROLE_TENANT_ADMIN\')\"><a class=\"md-button\" href=\"/admin/home\"><div layout=\"row\"><md-icon md-font-set=\"material-icons\">build</md-icon>{{\'admin-app\' | trans}}</div></a></md-menu-item><md-menu-item><md-button ui-sref=\"logout\"><div layout=\"row\"><md-icon md-font-set=\"material-icons\">exit_to_app</md-icon>{{\'exit\' | trans}}</div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></md-toolbar></header>");
$templateCache.put("./app/components/lastCourse/lastCourse.html","<div class=\"last-course card-single\" ng-if=\"lastCourse.course\" ng-class=\"{\'lock-left\': navBar.viewState.lockLeft}\"><small style=\"margin-bottom:5px\" class=\"last-course-caption\">{{\'last-visited-program\' | trans}}</small> <a ui-sref=\"course({courseId: lastCourse.course.id})\"><md-card ng-style=\"{\'background-color\': lastCourse.course.category.colour}\" ng-class=\"{enrolled: lastCourse.course.isEnrolled}\"><img ng-src=\"{{lastCourse.course.thumbImage}}\" class=\"md-card-image\" alt=\"image caption\"><div class=\"play-course\"><div class=\"course-progress\"><md-progress-linear md-mode=\"determinate\" value=\"{{lastCourse.course.lessonsCurrentUser.progress}}\"></md-progress-linear></div><md-icon md-font-set=\"material-icons\" class=\"material-icons\">play_circle_outline</md-icon><p>{{lastCourse.action || \'resume\' | trans}}</p></div><md-card-content><h2 class=\"md-title\"><small>{{lastCourse.course.category.name}}</small> {{lastCourse.course.title}}</h2></md-card-content></md-card></a></div>");
$templateCache.put("./app/components/lessonBar/lessonBar.html","<md-toolbar class=\"md-accent\" hide-gt-xs=\"\"><div class=\"md-toolbar-tools\"><span flex=\"\"></span><md-button ng-click=\"lessonBar.viewState.toggleRight()\" class=\"md-icon-button\" hide-gt-md=\"\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-stretch-tabs=\"always\" md-center-tabs=\"true\" md-no-pagination=\"\" md-swipe-content=\"\" md-selected=\"lessonBar.selectedTab\"><md-tab label=\"{{\'comments\' | trans}}\" md-on-select=\"lessonBar.loadPosts()\"><md-content class=\"activities\"><section><md-subheader class=\"post-filter\"><div layout=\"row\" flex=\"\" layout-align=\"start-center\"><h3 class=\"md-title\" style=\"margin-bottom:0;margin-top:10px\" md-colors=\"{\'color\': lessonBar.viewState.theme + \'-primary\'}\">{{\'lesson-comments\' | trans}}</h3><span flex=\"\"></span><div layout=\"row\"><md-button ng-show=\"!lessonBar.viewState.hasRealtime\" class=\"md-raised md-fab md-mini\" ng-click=\"lessonBar.loadPosts()\" style=\"margin-right:0\"><md-icon md-font-set=\"material-icons\">autorenew</md-icon><md-tooltip>{{\'update\' | trans}}</md-tooltip></md-button><md-button class=\"md-raised md-fab md-mini\" style=\"margin-right:0\" ng-click=\"$state.go(\'rateCourse\', {courseId: lessonBar.courseId, lessonId: lessonBar.lessonId})\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#FDD835\'}\">star</md-icon><md-tooltip>{{\'vote\' | trans}}</md-tooltip></md-button><md-button id=\"createPostLink\" class=\"md-fab md-mini\" ng-click=\"$state.go(\'commentLesson\', {courseId:lessonBar.courseId,lessonId:lessonBar.lessonId})\"><md-icon md-font-set=\"material-icons\">mode_edit</md-icon><md-tooltip>{{\'comment-on\' | trans}}</md-tooltip></md-button></div></div></md-subheader><md-icon ng-if=\"lessonBar.postsLoading\" md-svg-src=\"/assets/icons/spinner.svg\" style=\"margin: 10px\"></md-icon><md-list ng-if=\"!lessonBar.postsLoading && lessonBar.posts.length>0\"><lb-comment-preview ng-repeat=\"post in lessonBar.posts\" post=\"post\" courseid=\"lessonBar.courseId\" lessonid=\"lessonBar.lessonId\"></lb-comment-preview></md-list><p ng-if=\"!lessonBar.postsLoading && lessonBar.posts.length==0\" style=\"padding:14px\"><small>{{\'no-activity-yet\' | trans}}</small></p></section></md-content></md-tab><md-tab label=\"{{\'participants\' | trans}}\" md-on-select=\"lessonBar.loadUsers()\"><md-content class=\"users\"><section><md-subheader class=\"user-filter\"><div layout=\"column\"><md-input-container><label>{{\'search-for-a-participant\' | trans}}</label> <input ng-model=\"userSearch.$\" ng-change=\"lessonBar.updateUsersFilter()\"></md-input-container><md-radio-group ng-model=\"lessonBar.selectedUserRelation\" ng-change=\"lessonBar.updateUsersFilter()\" layout=\"row\"><md-radio-button ng-value=\"\'all\'\">{{\'everyone\' | trans}}</md-radio-button><md-radio-button ng-value=\"\'following\'\">{{\'following\' | trans}}</md-radio-button><md-radio-button ng-value=\"\'followers\'\">{{\'followers\' | trans}}</md-radio-button><span style=\"clear: both;\"></span></md-radio-group></div></md-subheader><md-icon ng-if=\"lessonBar.usersLoading\" md-svg-src=\"/assets/icons/spinner.svg\" style=\"margin: 10px\"></md-icon><md-list ng-if=\"lessonBar.loadedUsers.length>0\" infinite-scroll=\"lessonBar.moreUsers()\" style=\"12px 12px 10px 2px\"><md-list-item ng-repeat=\"user in lessonBar.loadedUsers | filter:userSearch | filter:lessonBar.userRelationFilter | orderBy:lessonBar.orderUsers track by $index\" ng-if=\"user.id != lessonBar.currentUser.id\" class=\"md-2-line md-no-proxy\"><lb-user-button user=\"user\"></lb-user-button><div class=\"md-list-item-text smoothable\"><h3>{{user.name}} {{user.surname}}</h3><p>{{user.company}}</p></div></md-list-item></md-list><p ng-if=\"!lessonBar.usersLoading && lessonBar.loadedUsers.length<=1\" style=\"padding:0 14px\"><small>{{\'no-users-found\' | trans}}</small></p></section></md-content></md-tab></md-tabs>");
$templateCache.put("./app/components/lessonsList/lessonsList.html","<md-list><md-list-item ng-repeat=\"lesson in lessonsList.lessons\" class=\"md-2-line\" role=\"listitem\"><md-icon ng-if=\"lesson.type == 3\" md-font-set=\"material-icons\">ondemand_video</md-icon><div ng-if=\"lesson.type == 3\" class=\"md-list-item-text\"><h3>{{lesson.title}}</h3><p ng-if=\"completingExpectedTime != null\">{{\'duration\' | trans}}: {{completingExpectedTime}} {{\'minutes\' | trans}}</p></div><md-icon ng-if=\"lesson.type == 2\" md-font-set=\"material-icons\">subject</md-icon><div ng-if=\"lesson.type == 2\" class=\"md-list-item-text\"><h3>{{lesson.title}}</h3><p ng-if=\"completingExpectedTime != null\">{{\'duration\' | trans}}: {{completingExpectedTime}} {{\'minutes\' | trans}}</p></div><md-icon ng-if=\"lesson.type == 7\" md-font-set=\"material-icons\">help_outline</md-icon><div ng-if=\"lesson.type == 7\" class=\"md-list-item-text\"><h3>{{lesson.title}}</h3></div><md-divider></md-divider></md-list-item></md-list>");
$templateCache.put("./app/components/lessonsNav/lessonsNav.html","<div hide=\"\" show-gt-md=\"\" layout=\"row\" layout-align=\"center center\" style=\"margin-top:10px\"><md-button ng-click=\"lessonsNav.prevLesson()\" ng-disabled=\"lessonsNav.isFirstLesson()\" class=\"md-fab md-mini md-raised\"><md-icon md-font-set=\"material-icons\">keyboard_arrow_left</md-icon><md-tooltip md-direction=\"bottom\">{{\'previous-episode\' | trans}}</md-tooltip></md-button><md-button ng-click=\"lessonsNav.showLessonsThumbs($event)\" style=\"margin-left:0;margin-right:0;margin-top:9px;padding-left:0;\"><div layout=\"row\"><md-icon ng-if=\"lessonsNav.lessonsThumbsShown\" md-font-set=\"material-icons\" style=\"margin-right:3px\">keyboard_arrow_down</md-icon><md-icon ng-if=\"!lessonsNav.lessonsThumbsShown\" md-font-set=\"material-icons\" style=\"margin-right:3px\">keyboard_arrow_up</md-icon><div class=\"lessons-path\" layout=\"row\"><div ng-repeat=\"lesson in lessonsNav.course.lessons track by $index\" layout=\"row\" ng-class=\"{uncompleted: !lesson.completed, current: lessonsNav.lesson.id==lesson.id}\"><div class=\"path-track\"></div><div class=\"path-node\" md-colors=\"{\'background-color\': lessonsNav.viewState.theme + \'-primary\'}\"><span>{{$index + 1}}</span></div></div></div><md-tooltip>{{\'index-episodes\' | trans}}</md-tooltip></div></md-button><md-button ng-click=\"lessonsNav.nextLesson()\" ng-disabled=\"lessonsNav.isLastLesson()\" class=\"md-fab md-mini md-raised\"><md-icon md-font-set=\"material-icons\">keyboard_arrow_right</md-icon><md-tooltip md-direction=\"bottom\">{{\'next-episode\' | trans}}</md-tooltip></md-button></div><div hide-gt-md=\"\" layout=\"column\" layout-align=\"center center\" style=\"margin-top:5px\"><md-button class=\"md-media-sm\" ng-click=\"lessonsNav.showLessonsThumbs($event)\"><md-icon ng-if=\"lessonsNav.lessonsThumbsShown\" md-font-set=\"material-icons\">keyboard_arrow_down</md-icon><md-icon ng-if=\"!lessonsNav.lessonsThumbsShown\" md-font-set=\"material-icons\">keyboard_arrow_up</md-icon>{{\'list-episodes\' | trans}}</md-button><div><md-button ng-click=\"lessonsNav.prevLesson()\" ng-disabled=\"lessonsNav.isFirstLesson()\" class=\"md-fab md-mini md-raised\" style=\"margin:2px\"><md-icon md-font-set=\"material-icons\">keyboard_arrow_left</md-icon><md-tooltip md-direction=\"bottom\">{{\'previous-episode\' | trans}}</md-tooltip></md-button><md-button ng-click=\"lessonsNav.nextLesson()\" ng-disabled=\"lessonsNav.isLastLesson()\" class=\"md-fab md-mini md-raised\" style=\"margin:2px\"><md-icon md-font-set=\"material-icons\">keyboard_arrow_right</md-icon><md-tooltip md-direction=\"bottom\">{{\'next-episode\' | trans}}</md-tooltip></md-button></div></div>");
$templateCache.put("./app/components/lessonsThumbs/lessonsThumbs.html","<md-bottom-sheet style=\"padding-left: 6px; padding-right: 6px; padding-top: 6px;\"><div class=\"slick-container lessons-thumbs\"><slick settings=\"lessonsThumbs.slickConfig\" style=\"margin-bottom: 0\"><a class=\"lesson-thumb\" ui-sref=\"course.lesson({courseId: lessonsThumbs.courseId, lessonId: lesson.id})\" ng-repeat=\"lesson in lessonsThumbs.lessons track by $index\" ng-class=\"{completed: lesson.completed}\"><div class=\"lesson-index\">{{$index + 1}}</div><img ng-src=\"{{lesson.resource.previewThumbnailUrl}}\"><div class=\"image-caption\">{{lesson.title}}</div></a></slick></div></md-bottom-sheet>");
$templateCache.put("./app/components/navBar/navBar.html","<md-list><md-list-item ng-if=\"!$state.includes(\'home\') && !navBar.viewState.hasHiddenButton(\'nav_home\')\" ui-sref=\"home\"><md-icon md-font-set=\"material-icons\">home</md-icon><p>{{\'home\' | trans}}</p></md-list-item><md-list-item ng-if=\"$state.includes(\'home\') && !navBar.viewState.hasHiddenButton(\'nav_home\')\" ui-sref=\"home\" class=\"active\"><md-icon md-colors=\"{\'color\': navBar.viewState.theme + \'-primary\'}\" md-font-set=\"material-icons\">home</md-icon><p md-colors=\"{\'color\': navBar.viewState.theme + \'-primary\'}\">{{\'home\' | trans}}</p></md-list-item><md-list-item ng-class=\"{active:navBar.tourStep==6}\" ng-if=\"!$state.includes(\'enrolled\') && navBar.viewState.hasModule(\'core_enrolled-view\')\" ui-sref=\"enrolled\" tour-step=\"\" tour-step-enabled=\"!$state.includes(\'enrolled\')\" tour-step-title=\"{{\'module-enrolled-\' + navBar.viewState.theme | trans}}\" tour-step-content=\"{{\'view-courses-enrolled\' | trans}}\" tour-step-scroll-into-view=\"false\" tour-step-placement=\"right\" tour-step-on-show=\"navBar.tourStep=6\" tour-step-on-prev=\"navBar.tourStep=-1\" tour-step-order=\"7\"><md-icon md-font-set=\"material-icons\">dns</md-icon><p>{{\'module-enrolled-\' + navBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-class=\"{active:navBar.tourStep==6}\" ng-if=\"$state.includes(\'enrolled\') && navBar.viewState.hasModule(\'core_enrolled-view\')\" ui-sref=\"enrolled\" class=\"active\" tour-step=\"\" tour-step-enabled=\"$state.includes(\'enrolled\')\" tour-step-title=\"{{\'module-enrolled-\' + navBar.viewState.theme | trans}}\" tour-step-content=\"{{\'view-courses-enrolled\' | trans}}\" tour-step-scroll-into-view=\"false\" tour-step-placement=\"right\" tour-step-on-show=\"navBar.tourStep=6\" tour-step-order=\"7\"><md-icon md-colors=\"{\'color\': navBar.viewState.theme + \'-primary\'}\" md-font-set=\"material-icons\">dns</md-icon><p md-colors=\"{\'color\': navBar.viewState.theme + \'-primary\'}\">{{\'module-enrolled-\' + navBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-class=\"{active:navBar.tourStep==7}\" ng-if=\"navBar.viewState.hasModule(\'social_post\') && !$state.includes(\'community\')\" ui-sref=\"community\" tour-step=\"\" tour-step-enabled=\"!$state.includes(\'community\')\" tour-step-title=\"{{\'module-community-\' + navBar.viewState.theme | trans}}\" tour-step-content=\"{{\'view-posts-drafting-comment-and-publish\' | trans}}\" tour-step-placement=\"right\" tour-step-on-show=\"navBar.tourStep=7\" tour-step-scroll-into-view=\"false\" tour-step-order=\"8\"><md-icon md-font-set=\"material-icons\">whatshot</md-icon><p ng-if=\"!$state.includes(\'community\')\">{{\'module-community-\' + navBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-class=\"{active:navBar.tourStep==7}\" ng-if=\"navBar.viewState.hasModule(\'social_post\') && $state.includes(\'community\')\" ui-sref=\"community\" class=\"active\" tour-step=\"\" tour-step-enabled=\"$state.includes(\'community\')\" tour-step-title=\"{{\'module-community-\' + navBar.viewState.theme | trans}}\" tour-step-content=\"{{\'view-posts-drafting-comment-and-publish\' | trans}}\" tour-step-placement=\"right\" tour-step-on-show=\"navBar.tourStep=7\" tour-step-scroll-into-view=\"false\" tour-step-order=\"8\"><md-icon md-colors=\"{\'color\': navBar.viewState.theme + \'-primary\'}\" md-font-set=\"material-icons\">whatshot</md-icon><p md-colors=\"{\'color\': navBar.viewState.theme + \'-primary\'}\">{{\'module-community-\' + navBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-class=\"{active:navBar.tourStep==8}\" ng-if=\"navBar.viewState.hasModule(\'playlist\') && !$state.includes(\'playlists\') && !$state.includes(\'playlist\')\" ui-sref=\"playlists\" tour-step=\"\" tour-step-enabled=\"navBar.viewState.hasModule(\'playlist\') && !$state.includes(\'playlists\') && !$state.includes(\'playlist\')\" tour-step-title=\"{{\'module-playlist-\' + navBar.viewState.theme | trans}}\" tour-step-content=\"{{\'courses-dedicated-to-you\' | trans}}\" tour-step-placement=\"right\" tour-step-on-show=\"navBar.tourStep=8\" tour-step-scroll-into-view=\"false\" tour-step-order=\"9\"><md-icon md-font-set=\"material-icons\">view_list</md-icon><p ng-if=\"!$state.includes(\'playlists\') && !$state.includes(\'playlist\')\">{{\'module-playlist-\' + navBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-class=\"{active:navBar.tourStep==8}\" ng-if=\"navBar.viewState.hasModule(\'playlist\') && ($state.includes(\'playlists\') || $state.includes(\'playlist\'))\" ui-sref=\"playlists\" class=\"active\" tour-step=\"\" tour-step-enabled=\"navBar.viewState.hasModule(\'playlist\') && ($state.includes(\'playlists\') || $state.includes(\'playlist\'))\" tour-step-title=\"{{\'module-playlist-\' + navBar.viewState.theme | trans}}\" tour-step-content=\"{{\'courses-dedicated-to-you\' | trans}}\" tour-step-placement=\"right\" tour-step-on-show=\"navBar.tourStep=8\" tour-step-scroll-into-view=\"false\" tour-step-order=\"9\"><md-icon md-colors=\"{\'color\': navBar.viewState.theme + \'-primary\'}\" md-font-set=\"material-icons\">view_list</md-icon><p md-colors=\"{\'color\': navBar.viewState.theme + \'-primary\'}\">{{\'module-playlist-\' + navBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-class=\"{active:navBar.tourStep==9}\" ng-if=\"navBar.viewState.hasModule(\'news\') && !$state.includes(\'news\')\" ui-sref=\"news\" tour-step=\"\" tour-step-enabled=\"!$state.includes(\'news\')\" tour-step-title=\"{{\'module-blog-\' + navBar.viewState.theme | trans}}\" tour-step-content=\"{{\'tour-step-posts-published-editors\' | trans}}\" tour-step-placement=\"right\" tour-step-on-show=\"navBar.tourStep=9\" tour-step-scroll-into-view=\"false\" tour-step-order=\"10\"><md-icon md-font-set=\"material-icons\">cast</md-icon><p>{{\'module-blog-\' + navBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-class=\"{active:navBar.tourStep==9}\" ng-if=\"navBar.viewState.hasModule(\'news\') && $state.includes(\'news\')\" ui-sref=\"news\" class=\"active\" tour-step=\"\" tour-step-enabled=\"$state.includes(\'news\')\" tour-step-title=\"{{\'module-blog-\' + navBar.viewState.theme | trans}}\" tour-step-content=\"{{\'tour-step-posts-published-editors\' | trans}}\" tour-step-placement=\"right\" tour-step-on-show=\"navBar.tourStep=9\" tour-step-scroll-into-view=\"false\" tour-step-order=\"10\"><md-icon md-colors=\"{\'color\': navBar.viewState.theme + \'-primary\'}\" md-font-set=\"material-icons\">cast</md-icon><p md-colors=\"{\'color\': navBar.viewState.theme + \'-primary\'}\">{{\'module-blog-\' + navBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-class=\"{active:navBar.tourStep==10}\" ng-if=\"navBar.viewState.hasModule(\'messages-menu\') && !$state.includes(\'messages\')\" ui-sref=\"messages\" tour-step=\"\" tour-step-enabled=\"false\" tour-step-title=\"{{\'module-repository-\' + navBar.viewState.theme | trans}}\" tour-step-content=\"{{\'tour-step-download-documents\' | trans}}\" tour-step-placement=\"right\" tour-step-on-show=\"navBar.tourStep=10\" tour-step-on-next=\"navBar.tourStep=-1\" tour-step-scroll-into-view=\"false\" tour-step-order=\"11\"><md-icon md-font-set=\"material-icons\">message</md-icon><p>{{\'module-messages-menu-\' + navBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-class=\"{active:navBar.tourStep==10}\" ng-if=\"navBar.viewState.hasModule(\'messages-menu\') && $state.includes(\'messages\')\" ui-sref=\"messages\" class=\"active\" tour-step=\"\" tour-step-enabled=\"false\" tour-step-title=\"{{\'module-repository-\' + navBar.viewState.theme | trans}}\" tour-step-content=\"{{\'tour-step-download-documents\' | trans}}\" tour-step-placement=\"right\" tour-step-on-show=\"navBar.tourStep=10\" tour-step-on-next=\"navBar.tourStep=-1\" tour-step-scroll-into-view=\"false\" tour-step-order=\"11\"><md-icon md-colors=\"{\'color\': navBar.viewState.theme + \'-primary\'}\" md-font-set=\"material-icons\">message</md-icon><p md-colors=\"{\'color\': navBar.viewState.theme + \'-primary\'}\">{{\'module-messages-menu-\' + navBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-class=\"{active:navBar.tourStep==11}\" ng-if=\"navBar.viewState.hasModule(\'repository\') && !$state.includes(\'repository\')\" ui-sref=\"repository\" tour-step=\"\" tour-step-enabled=\"$state.includes(\'repository\')\" tour-step-title=\"{{\'module-repository-\' + navBar.viewState.theme | trans}}\" tour-step-content=\"{{\'tour-step-download-documents\' | trans}}\" tour-step-placement=\"right\" tour-step-on-show=\"navBar.tourStep=11\" tour-step-on-next=\"navBar.tourStep=-1\" tour-step-scroll-into-view=\"false\" tour-step-order=\"11\"><md-icon md-font-set=\"material-icons\">folder</md-icon><p>{{\'module-repository-\' + navBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-class=\"{active:navBar.tourStep==11}\" ng-if=\"navBar.viewState.hasModule(\'repository\') && $state.includes(\'repository\')\" ui-sref=\"repository\" class=\"active\" tour-step=\"\" tour-step-enabled=\"$state.includes(\'repository\')\" tour-step-title=\"{{\'module-repository-\' + navBar.viewState.theme | trans}}\" tour-step-content=\"{{\'tour-step-download-documents\' | trans}}\" tour-step-placement=\"right\" tour-step-on-show=\"navBar.tourStep=11\" tour-step-on-next=\"navBar.tourStep=-1\" tour-step-scroll-into-view=\"false\" tour-step-order=\"11\"><md-icon md-colors=\"{\'color\': navBar.viewState.theme + \'-primary\'}\" md-font-set=\"material-icons\">folder</md-icon><p md-colors=\"{\'color\': navBar.viewState.theme + \'-primary\'}\">{{\'module-repository-\' + navBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-class=\"{active:navBar.tourStep==12}\" ng-if=\"navBar.viewState.hasModule(\'godos-menu\') && !$state.includes(\'godos\')\" ui-sref=\"user.godos({userId: navBar.currentUser.id})\" tour-step=\"\" tour-step-enabled=\"$state.includes(\'godos\')\" tour-step-title=\"{{\'module-godos-\' + navBar.viewState.theme | trans}}\" tour-step-content=\"{{\'tour-step-godos\' | trans}}\" tour-step-placement=\"right\" tour-step-on-show=\"navBar.tourStep=12\" tour-step-on-next=\"navBar.tourStep=-1\" tour-step-scroll-into-view=\"false\" tour-step-order=\"11\"><md-icon md-font-set=\"material-icons\">flash_on</md-icon><p>{{\'module-godos-\' + navBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-class=\"{active:navBar.tourStep==12}\" ng-if=\"navBar.viewState.hasModule(\'godos-menu\') && $state.includes(\'godos\')\" ui-sref=\"user.godos({userId: navBar.currentUser.id})\" class=\"active\" tour-step=\"\" tour-step-enabled=\"$state.includes(\'godos\')\" tour-step-title=\"{{\'module-godos-\' + navBar.viewState.theme | trans}}\" tour-step-content=\"{{\'tour-step-godos\' | trans}}\" tour-step-placement=\"right\" tour-step-on-show=\"navBar.tourStep=12\" tour-step-on-next=\"navBar.tourStep=-1\" tour-step-scroll-into-view=\"false\" tour-step-order=\"11\"><md-icon md-colors=\"{\'color\': navBar.viewState.theme + \'-primary\'}\" md-font-set=\"material-icons\">flash_on</md-icon><p md-colors=\"{\'color\': navBar.viewState.theme + \'-primary\'}\">{{\'module-godos-\' + navBar.viewState.theme | trans}}</p></md-list-item></md-list>");
$templateCache.put("./app/components/newsCard/newsCard.html","<md-card class=\"news-post social-post\" md-colors=\"{\'background-color\': newsCard.viewState.theme + \'-primary\', \'border-color\': newsCard.viewState.theme + \'-primary-800\'}\"><md-list><md-list-item class=\"md-2-line md-no-proxy\"><lb-user-button user=\"newsCard.post.user\"></lb-user-button><div class=\"md-list-item-text smoothable\"><h3>{{newsCard.post.user.name}} {{newsCard.post.user.surname}}</h3><p><small am-time-ago=\"newsCard.post.created | amParse: \'X\'\" \"=\"\"></small></p></div></md-list-item></md-list><md-card-content><a ng-if=\"newsCard.post.type==1\" ui-sref=\"{{newsCard.post.getCourseSref()}}\"><img ng-src=\"{{newsCard.post.og[\'og:image\']}}\"><h4 class=\"md-title\" style=\"margin-bottom:0\">{{newsCard.post.og[\'og:title\']}}</h4></a> <a ng-if=\"newsCard.post.type==2\" href=\"{{newsCard.post.og[\'og:url\']}}\" target=\"_blank\"><img ng-src=\"{{newsCard.post.og[\'og:image\']}}\"><h4 class=\"md-title\" style=\"margin-bottom:0\">{{newsCard.post.og[\'og:title\']}}</h4></a><iframe ng-if=\"newsCard.post.type==3\" class=\"videoplayer\" width=\"100%\" height=\"100%\" src=\"{{newsCard.post.resourceLink}}\" frameborder=\"0\" allowfullscreen=\"\"></iframe><a ng-if=\"newsCard.post.type==4\" ui-sref=\"postDetail({postId:newsCard.post.id})\"><img ng-src=\"{{newsCard.post.resourceLink}}\" class=\"picture\"></a> <a ng-if=\"newsCard.post.type==5\" href=\"{{newsCard.post.resourceLink}}\">{{newsCard.post.resourceLink.split(\'/\').reverse()[0]}}</a><div ng-if=\"newsCard.post.type==6\" layout=\"row\" class=\"rating\"><md-icon ng-repeat=\"i in newsCard.post.abstract track by $index\" md-font-set=\"material-icons\" ng-style=\"{color: \'#FDD835\', \'font-size\': \'14px\', \'margin\': 0}\">star_rate</md-icon></div><div ng-if=\"newsCard.post.type==7\" class=\"videoplayer\"><videogular vg-player-ready=\"newsCard.onVideoPlayerReady($API)\" vg-theme=\"newsCard.videoPlayerTheme\"><vg-media vg-src=\"newsCard.post.getVideoResources()\"></vg-media><vg-controls vg-autohide=\"true\" vg-autohide-time=\"3000\"><vg-play-pause-button></vg-play-pause-button><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-fullscreen-button></vg-fullscreen-button></vg-controls><vg-overlay-play></vg-overlay-play><vg-poster vg-url=\"newsCard.post.og[\'og:image\']\"></vg-poster></videogular></div><p ng-if=\"newsCard.post.abstract.length == newsCard.post.messageLength\">{{newsCard.post.abstract}}</p><a ui-sref=\"postDetail({postId:newsCard.post.id})\" ng-if=\"newsCard.post.abstract.length < newsCard.post.messageLength\"><p>{{newsCard.post.abstract}}</p></a></md-card-content><div class=\"community-comments\" ng-class=\"{empty: newsCard.post.comments.length==0}\"><md-subheader ng-if=\"newsCard.post.comments.length>1\" md-colors=\"{\'background-color\': newsCard.viewState.theme + \'-primary-100\'}\"><div layout=\"row\"><a ng-click=\"newsCard.post.commentsOpened=!newsCard.post.commentsOpened\" style=\"color:inherit;cursor:pointer\">{{newsCard.post.comments.length}} {{\'comments\' | trans}}<md-icon md-font-set=\"material-icons\">{{newsCard.post.commentsOpened ? \'keyboard_arrow_up\' : \'keyboard_arrow_down\'}}</md-icon></a></div></md-subheader><md-content md-colors=\"{\'background-color\': newsCard.viewState.theme + \'-primary-100\'}\"><md-list><md-list-item ng-init=\"newsCard.post.commentsOpened=false\" ng-repeat=\"comment in newsCard.post.comments\" class=\"md-3-line md-long-text\" ng-class=\"{opened: newsCard.post.commentsOpened, closed: $index!=0}\"><img ng-src=\"{{comment.user.picture}}\" class=\"md-avatar\" alt=\"{{comment.user.name}} {{comment.user.surname}}\"><div class=\"md-list-item-text\"><h3>{{comment.user.name}} {{comment.user.surname}}</h3><p><small am-time-ago=\"comment.created | amParse: \'X\'\"></small></p><p>{{comment.comment}}</p></div></md-list-item></md-list></md-content></div><md-divider></md-divider><div class=\"md-actions\" layout=\"row\"><div ng-if=\"newsCard.post.likes>0\" layout=\"row\" layout-align=\"center center\" style=\"padding:0 6px\"><strong md-colors=\"{\'color\': newsCard.viewState.theme + \'-primary\'}\">{{newsCard.post.likes}}</strong><md-icon md-font-set=\"material-icons\" ng-style=\"{\'font-size\':\'20px\',\'margin-left\':\'4px\',color:\'rgba(255,255,255,.5)\'}\">thumb_up</md-icon></div><span flex=\"\"></span><md-button ng-if=\"!newsCard.post.liked\" ng-click=\"newsCard.like()\" style=\"margin:0\">{{\'i-like\' | trans}}</md-button><md-button ng-if=\"newsCard.post.liked\" ng-click=\"newsCard.unlike()\" style=\"margin:0\">{{\'dont-like\' | trans}}</md-button><md-button ui-sref=\"postDetail({postId:newsCard.post.id})\" style=\"color: white !important\">{{\'read-the-article\' | trans}}</md-button></div></md-card>");
$templateCache.put("./app/components/notifications/notifications.html","<div class=\"notifications-menu\" aria-label=\"{{\'notifications\' | trans}}\" role=\"listbox\"><div class=\"notifications-menu-item\" tabindex=\"-1\" role=\"option\" ng-repeat=\"notification in notifications.viewState.notifications\" ng-click=\"notifications.go(notification)\">{{ notification.title }}</div></div>");
$templateCache.put("./app/components/playlistCard/playlistCard.html","<md-card layout-fill=\"\" ng-click=\"$state.go(\'playlist\', {playlistId: playlistCard.playlist.id})\" class=\"playlist-card hide-gt-xs\"><div style=\"position:relative\"><img ng-if=\"lazy\" data-lazy=\"{{playlistCard.playlist.cover}}\" class=\"md-card-image\" alt=\"image caption\"> <img ng-if=\"!lazy\" ng-src=\"{{playlistCard.playlist.cover}}\" class=\"md-card-image\" alt=\"image caption\"></div><md-card-content><h2 class=\"md-title\">{{playlistCard.playlist.name}}</h2></md-card-content></md-card><flippy layout-fill=\"\" hide-xs=\"\" flip=\"[\'mouseenter\']\" flip-back=\"[\'mouseleave\']\" duration=\"800\" timing-function=\"ease-in-out\"><flippy-front><md-card class=\"playlist-card\"><img ng-if=\"lazy\" data-lazy=\"{{playlistCard.playlist.coverThumb}}\" class=\"md-card-image\" alt=\"image caption\"> <img ng-if=\"!lazy\" ng-src=\"{{playlistCard.playlist.coverThumb}}\" class=\"md-card-image\" alt=\"image caption\"><md-card-content><h2 class=\"md-title\">{{playlistCard.playlist.name}}</h2></md-card-content></md-card></flippy-front><flippy-back><md-card class=\"playlist-card\" ng-click=\"$state.go(\'playlist\', {playlistId: playlistCard.playlist.id})\"><div style=\"position: relative\"><img ng-if=\"lazy\" data-lazy=\"{{playlistCard.playlist.coverThumb}}\" class=\"md-card-image\" alt=\"image caption\"> <img ng-if=\"!lazy\" ng-src=\"{{playlistCard.playlist.coverThumb}}\" class=\"md-card-image\" alt=\"image caption\"></div><md-card-content><p flex=\"\">{{playlistCard.playlist.description}}</p></md-card-content></md-card></flippy-back></flippy>");
$templateCache.put("./app/components/postAttachment/postAttachment.html","<md-tabs class=\"attachments\" md-no-pagination=\"\" md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"postAttachment.defaultType\"><md-tab ng-if=\"!postAttachment.exclude || postAttachment.exclude.indexOf(\'course\')<0\" md-on-select=\"postAttachment.selectForm(courseForm, 1)\"><md-tab-label><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#3F51B5\'}\">dns</md-icon><span hide-xs=\"\">{{\'program\' | trans}}</span></md-tab-label><md-tab-body><form name=\"courseForm\"><div layout=\"row\" layout-padding=\"\" layout-align=\"center center\"><md-autocomplete md-input-name=\"attachedCourse\" ng-cloak=\"\" style=\"width:400px;padding:0;margin:30px 0\" md-search-text=\"postAttachment.searchText\" md-item-text=\"item.title\" md-items=\"item in postAttachment.searchCourse()\" md-min-length=\"3\" md-delay=\"600\" md-menu-class=\"md-list\" md-selected-item=\"postAttachment.form.attachedCourse\" md-selected-item-change=\"postAttachment.attachmentChange()\" placeholder=\"{{\'search-program\' | trans}}\"><md-item-template><md-list-item class=\"md-3-line\" ng-click=\"header.visit(item)\"><img ng-show=\"item.thumb\" ng-src=\"{{item.thumb}}\" alt=\"{{item.title}}\" ng-class=\"{\'search-thumb\':item.type!=\'user\',\'md-avatar\':item.type==\'user\'}\"><div class=\"md-list-item-text\"><h3>{{item.title}}</h3></div></md-list-item></md-item-template><md-not-found><span style=\"padding:0 15px\">{{\'no-items-found\' | trans}}</span></md-not-found></md-autocomplete></div></form></md-tab-body></md-tab><md-tab ng-if=\"!postAttachment.exclude || postAttachment.exclude.indexOf(\'link\')<0\" md-on-select=\"postAttachment.selectForm(linkForm, 2)\"><md-tab-label><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#03A9F4\'}\">public</md-icon><span hide-xs=\"\">{{\'link\' | trans}}</span></md-tab-label><md-tab-body><form name=\"linkForm\"><div layout=\"row\" layout-fill=\"\" layout-padding=\"\" layout-align=\"center center\"><md-input-container flex=\"\"><label>{{\'attach-a-link\' | trans}}</label> <input ng-change=\"postAttachment.attachmentChange()\" type=\"url\" ng-pattern=\"/^(https?|ftp)://[^\\s/$.?#].[^\\s]*$/\" name=\"attachedLink\" ng-model=\"postAttachment.form.attachedLink\"><div ng-messages=\"linkForm.attachedLink.$error\"><div ng-message=\"pattern\">{{\'correct-url\' | trans}}</div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-if=\"!postAttachment.exclude || postAttachment.exclude.indexOf(\'video\')<0\" md-on-select=\"postAttachment.selectForm(videoForm, 3)\"><md-tab-label><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#F44336\'}\">play_circle_filled</md-icon><span hide-xs=\"\">{{\'video\' | trans}}</span></md-tab-label><md-tab-body><form name=\"videoForm\"><div layout=\"column\" layout-padding=\"\"><md-radio-group layout=\"row\" layout-align=\"end start\" ng-model=\"postAttachment.videoType\"><md-radio-button value=\"youtube\"><small>{{\'video-on-youtube\' | trans}}</small></md-radio-button><md-radio-button value=\"file\"><small>{{\'upload-file\' | trans}}</small></md-radio-button></md-radio-group><md-input-container flex=\"\" ng-if=\"postAttachment.videoType==\'youtube\'\"><label>{{\'attach-youtube-video\' | trans}}</label> <input ng-change=\"postAttachment.attachmentChange()\" type=\"url\" ng-pattern=\"/^(https?\\:\\/\\/)?(www\\.)?(youtube\\.com|youtu\\.?be)\\/.+$/\" name=\"attachedYTVideo\" ng-model=\"postAttachment.form.attachedYTVideo\"><div ng-messages=\"videoForm.attachedYTVideo.$error\"><div ng-message=\"pattern\">{{\'correct-url\' | trans}}</div></div></md-input-container><div ng-if=\"postAttachment.videoType==\'file\'\" layout=\"row\" layout-padding=\"\"><div layout=\"column\" layout-padding=\"\" flex=\"70\"><div class=\"drop-box\" ngf-drop=\"\" ngf-change=\"postAttachment.attachmentChange()\" ng-show=\"postAttachment.form.attachedVideo==null\" name=\"attachedVideo\" ngf-select=\"\" accept=\"video/mp4,video/webm,video/ogg\" ng-model=\"postAttachment.form.attachedVideo\" ngf-model-invalid=\"postAttachment.errorFiles\" ngf-max-size=\"50MB\" ngf-drag-over-class=\"\'dragover\'\" ngf-pattern=\"\'video/mp4,video/webm,video/ogg\'\">{{\'drag-and-drop-video\' | trans}}</div><video width=\"100%\" ng-show=\"postAttachment.form.attachedVideo!=null\" controls=\"\" ngf-src=\"postAttachment.form.attachedVideo\"></video></div><div flex=\"30\" layout-padding=\"\" layout=\"column\"><md-button ng-disabled=\"postAttachment.form.attachedVideo==null || !videoForm.$valid\" ng-click=\"postAttachment.form.attachedVideo=null\">{{\'cancel\' | trans}}</md-button><div ng-messages=\"videoForm.attachedVideo.$error\"><div ng-message=\"maxSize\">{{\'max-video-file\' | trans}}</div></div></div></div></div></form></md-tab-body></md-tab><md-tab ng-if=\"!postAttachment.exclude || postAttachment.exclude.indexOf(\'image\')<0\" md-on-select=\"postAttachment.selectForm(imageForm, 4)\"><md-tab-label><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#4CAF50\'}\">camera_alt</md-icon><span hide-xs=\"\">{{\'image\' | trans}}</span></md-tab-label><md-tab-body><form name=\"imageForm\" layout=\"row\" layout-padding=\"\"><div layout=\"column\" layout-padding=\"\" flex=\"\"><div class=\"drop-box\" ngf-drop=\"\" ngf-change=\"postAttachment.attachmentChange()\" ng-show=\"postAttachment.form.attachedImage==null\" name=\"attachedImage\" ngf-select=\"\" ngf-fix-orientation=\"true\" accept=\"image/*\" ng-model=\"postAttachment.form.attachedImage\" ngf-model-invalid=\"postAttachment.errorFiles\" ngf-max-size=\"10MB\" ngf-drag-over-class=\"\'dragover\'\" ngf-pattern=\"\'image/*\'\">{{\'drag-and-drop-image\' | trans}}</div><div ng-show=\"postAttachment.form.attachedImage!=null\" ngf-background=\"postAttachment.form.attachedImage\" class=\"preview cropArea\"></div></div><div laypout-align=\"end end\"><md-button ng-disabled=\"postAttachment.form.attachedImage==null || !imageForm.$valid\" ng-click=\"postAttachment.form.attachedImage=null\">{{\'cancel\' | trans}}</md-button><div ng-messages=\"imageForm.attachedImage.$error\"><div ng-message=\"maxSize\">{{\'max image file\' | trans}}</div></div></div></form></md-tab-body></md-tab><md-tab ng-if=\"!postAttachment.exclude || postAttachment.exclude.indexOf(\'document\')<0\" md-on-select=\"postAttachment.selectForm(documentForm, 5)\"><md-tab-label><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#FF9800\'}\">insert_drive_file</md-icon><span hide-xs=\"\">{{\'document\' | trans}}</span></md-tab-label><md-tab-body><form name=\"documentForm\" layout=\"row\" layout-padding=\"\"><div layout=\"column\" layout-padding=\"\" flex=\"\"><div class=\"drop-box\" ngf-drop=\"\" ngf-change=\"postAttachment.attachmentChange()\" ng-show=\"postAttachment.form.attachedDocument==null\" name=\"attachedDocument\" ngf-select=\"\" accept=\"application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,application/mspowerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/zip\" ng-model=\"postAttachment.form.attachedDocument\" ngf-model-invalid=\"postAttachment.errorFiles\" ngf-max-size=\"10MB\" ngf-drag-over-class=\"\'dragover\'\" ngf-pattern=\"\'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,application/mspowerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/zip\'\">{{\'drag-and-drop-doc\' | trans}}</div><div ng-show=\"postAttachment.form.attachedDocument!=null\">{{postAttachment.form.attachedDocument.name}}</div></div><div laypout-align=\"end end\"><md-button ng-disabled=\"postAttachment.form.attachedDocument==null || !documentForm.$valid\" ng-click=\"postAttachment.form.attachedDocument=null\">{{\'cancel\' | trans}}</md-button><div ng-messages=\"documentForm.attachedDocument.$error\"><div ng-message=\"maxSize\">{{\'max-doc-file\' | trans}}</div></div></div></form></md-tab-body></md-tab></md-tabs><md-card class=\"preview-card\" ng-if=\"postAttachment.previewUrl!=null\"><md-card-title><md-card-title-text><span class=\"md-headline\">{{postAttachment.previewTitle}}</span> <span class=\"md-subhead\">{{postAttachment.previewDescription}}</span></md-card-title-text><md-card-title-media><img class=\"card-media\" ng-src=\"{{postAttachment.previewImage}}\"></md-card-title-media></md-card-title></md-card>");
$templateCache.put("./app/components/postCard/postCard.html","<md-card class=\"social-post animated\" ng-class=\"{tada: postCard.post.added}\"><md-list><md-list-item class=\"md-2-line md-no-proxy\"><lb-user-button user=\"postCard.post.user\"></lb-user-button><div class=\"md-list-item-text smoothable\"><h3>{{postCard.post.user.name}} {{postCard.post.user.surname}}</h3><p><small am-time-ago=\"postCard.post.created | amParse: \'X\'\"></small></p></div></md-list-item></md-list><md-menu ng-if=\"postCard.post.isMine()\" style=\"position: absolute; right: 0; top: 0;\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-set=\"material-icons\">expand_more</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"postCard.deletePost($event)\">{{\'delete-post\' | trans}}</md-button></md-menu-item></md-menu-content></md-menu><md-card-content><a ng-if=\"postCard.post.type==1\" ui-sref=\"{{postCard.post.getCourseSref()}}\"><img ng-src=\"{{postCard.post.og[\'og:image\']}}\"><h4 class=\"md-title\" style=\"margin-bottom:0\">{{postCard.post.og[\'og:title\']}}</h4></a> <a ng-if=\"postCard.post.type==2\" href=\"{{postCard.post.og[\'og:url\']}}\" target=\"_blank\"><img ng-src=\"{{postCard.post.og[\'og:image\']}}\"><h4 class=\"md-title\" md-colors=\"{\'color\': postCard.viewState.theme + \'-primary\'}\" style=\"margin-bottom:0\">{{postCard.post.og[\'og:title\']}}</h4></a><iframe ng-if=\"postCard.post.type==3\" class=\"videoplayer\" width=\"100%\" height=\"100%\" src=\"{{postCard.post.resourceLink}}\" frameborder=\"0\" allowfullscreen=\"\"></iframe><a ng-if=\"postCard.post.type==4\" ui-sref=\"postDetail({postId:postCard.post.id})\"><img ng-src=\"{{postCard.post.resourceLink}}\" class=\"picture\"></a> <a class=\"md-primary\" ng-if=\"postCard.post.type==5\" href=\"{{postCard.post.resourceLink}}\">{{postCard.post.resourceLink.split(\'/\').reverse()[0]}}</a><div ng-if=\"postCard.post.type==6\" layout=\"row\" class=\"rating\"><md-icon ng-repeat=\"i in postCard.post.abstract track by $index\" md-font-set=\"material-icons\" ng-style=\"{color: \'#FDD835\', \'font-size\': \'18px\', \'margin\': \'0 -5px 0 0\'}\">star_rate</md-icon></div><div ng-if=\"postCard.post.type==7\" class=\"videoplayer\"><videogular vg-player-ready=\"postCard.onVideoPlayerReady($API)\" vg-theme=\"postCard.videoPlayerTheme\"><vg-media vg-src=\"postCard.post.getVideoResources()\"></vg-media><vg-controls vg-autohide=\"true\" vg-autohide-time=\"3000\"><vg-play-pause-button></vg-play-pause-button><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-fullscreen-button></vg-fullscreen-button></vg-controls><vg-overlay-play></vg-overlay-play><vg-poster vg-url=\"postCard.post.og[\'og:image\']\"></vg-poster></videogular></div><p ng-if=\"postCard.post.type!=6 && postCard.post.abstract.length == postCard.post.messageLength\">{{postCard.post.abstract}}</p><a ng-if=\"postCard.post.type!=6 && postCard.post.abstract.length < postCard.post.messageLength\" ui-sref=\"postDetail({postId:postCard.post.id})\"><p>{{postCard.post.abstract}}</p></a><p ng-if=\"postCard.post.type==6\">{{\'has-rated\' | trans:{name: postCard.post.user.name, rate: postCard.post.abstract.length} }} <strong><a ui-sref=\"{{postCard.post.getCourseSref()}}\">{{postCard.post.og[\'og:title\']}}</a></strong>.</p></md-card-content><div class=\"community-comments\" ng-class=\"{empty: postCard.post.comments.length==0}\"><md-subheader ng-if=\"postCard.post.comments.length>1\"><div layout=\"row\"><a ng-click=\"postCard.post.commentsOpened=!postCard.post.commentsOpened\" style=\"color:inherit;cursor:pointer\">{{postCard.post.comments.length}} {{\'comments\' | trans}}<md-icon md-font-set=\"material-icons\">{{postCard.post.commentsOpened ? \'keyboard_arrow_up\' : \'keyboard_arrow_down\'}}</md-icon></a></div></md-subheader><md-content><md-list><md-list-item ng-init=\"postCard.post.formOpened=false\" class=\"md-3-line md-long-text closed write\" ng-class=\"{opened: postCard.post.formOpened}\"><img ng-src=\"{{postCard.currentUser.picture}}\" class=\"md-avatar\" alt=\"{{postCard.currentUser.name}} {{postCard.currentUser.surname}}\"><div class=\"md-list-item-text\"><form name=\"commentForm\" layout=\"row\"><md-input-container class=\"md-block\"><label>{{\'comment\' | trans}}</label> <input md-maxlength=\"200\" name=\"message\" lb-focus-me=\"postCard.post.formOpened\" ng-model=\"postCard.message\"><div ng-messages=\"commentForm.message.$error\"><div ng-message=\"md-maxlength\">{{\'info-message-length\' | trans}}</div></div></md-input-container></form></div></md-list-item><md-list-item ng-init=\"postCard.post.commentsOpened=false\" ng-repeat=\"comment in postCard.post.comments\" class=\"md-3-line md-long-text\" ng-class=\"{opened: postCard.post.commentsOpened, closed: $index!=postCard.post.comments.length-1}\"><img ng-src=\"{{comment.user.picture}}\" class=\"md-avatar\" alt=\"{{comment.user.name}} {{comment.user.surname}}\"><div class=\"md-list-item-text\"><h3>{{comment.user.name}} {{comment.user.surname}}</h3><p><small am-time-ago=\"comment.created | amParse: \'X\'\"></small></p><p>{{comment.comment}}</p></div></md-list-item></md-list></md-content></div><md-divider></md-divider><div class=\"md-actions\" layout=\"row\"><div ng-if=\"postCard.post.likes>0\" layout=\"row\" layout-align=\"center center\" style=\"padding:0 6px\"><strong md-colors=\"{\'color\': postCard.viewState.theme + \'-primary\'}\">{{postCard.post.likes}}</strong><md-icon md-font-set=\"material-icons\" md-colors=\"{\'color\': postCard.viewState.theme + \'-primary-100\'}\" ng-style=\"{\'font-size\':\'20px\',\'margin-left\':\'4px\'}\">thumb_up</md-icon></div><span flex=\"\"></span><md-button ng-if=\"!postCard.post.liked\" ng-click=\"postCard.like()\" class=\"md-primary\" style=\"margin:0\">{{\'i-like\' | trans}}</md-button><md-button ng-if=\"postCard.post.liked\" ng-click=\"postCard.unlike()\" class=\"md-primary\" style=\"margin:0\">{{\'dont-like\' | trans}}</md-button><md-button class=\"md-accent md-raised\" ng-if=\"postCard.message.length>0\" ng-click=\"postCard.comment()\">Invia</md-button><md-button class=\"md-primary\" ng-click=\"postCard.post.formOpened=!postCard.post.formOpened\">{{postCard.post.formOpened ? \'cancel\' : \'comment-on\' | trans}}</md-button></div></md-card>");
$templateCache.put("./app/components/postPreview/postPreview.html","<md-list-item ng-class=\"{slideInRight: postPreview.post.added}\" ui-sref=\"postDetail({postId:postPreview.post.id})\" class=\"social-post post-preview md-3-line md-long-text animated\" ng-cloak=\"\"><lb-user-button user=\"postPreview.post.user\" style=\"margin-top:-3px\"></lb-user-button><div class=\"md-list-item-text smoothable\"><h3>{{postPreview.post.user.name}} {{postPreview.post.user.surname}}</h3><p><small am-time-ago=\"postPreview.post.created | amParse: \'X\'\"></small></p><div class=\"post-content\"><div ng-if=\"(postPreview.post.type==1 || postPreview.post.type==2)\"><img ng-if=\"postPreview.post.og[\'og:image\']\" ng-src=\"{{postPreview.post.og[\'og:image\']}}\" class=\"picture\"> <span md-colors=\"{\'color\': postPreview.viewState.theme + \'-primary\'}\">{{postPreview.post.og[\'og:title\']}}</span></div><img ng-if=\"postPreview.post.type==3\" ng-src=\"{{postPreview.getYTPreview(post.resourceLink)}}\" class=\"picture\"> <img ng-if=\"postPreview.post.type==4\" ng-src=\"{{postPreview.post.resourceThumbLink}}\" class=\"picture\"><div ng-if=\"postPreview.post.type==5\" md-colors=\"{\'color\': postPreview.viewState.theme + \'-primary\'}\">{{postPreview.post.resourceLink.split(\'/\').reverse()[0]}}</div><div ng-if=\"postPreview.post.type==6\" layout=\"row\" class=\"rating\"><md-icon ng-repeat=\"i in postPreview.post.abstract track by $index\" md-font-set=\"material-icons\" ng-style=\"{color: \'#FDD835\', \'font-size\': \'18px\', \'margin\': \'0 -5px 0 0\'}\">star_rate</md-icon></div><img ng-if=\"postPreview.post.type==7\" ng-src=\"{{postPreview.post.og[\'og:image\']}}\" class=\"picture\"><p ng-if=\"postPreview.post.type!=6\">{{postPreview.post.abstract}}</p><p ng-if=\"postPreview.post.type==6\">{{\'has-rated\' | trans:{name: postPreview.post.user.name, rate: postPreview.post.abstract.length} }} <strong>{{postPreview.post.og[\'og:title\']}}</strong>.</p></div></div></md-list-item>");
$templateCache.put("./app/components/quizPlayer/quizPlayer.html","<md-card ng-if=\"quizPlayer.quiz\" class=\"quiz-player-container resource-container\"><div class=\"quiz-player\"><div layout=\"column\" layout-align=\"center end\"><md-progress-linear md-mode=\"determinate\" value=\"{{quizPlayer.getProgress()}}\"></md-progress-linear><small style=\"color: rgba(0,0,0,.5);\">{{\'quiz\' | trans}} {{quizPlayer.quiz.index + 1}} {{\'of\' | trans}} {{quizPlayer.lesson.quizCounter}}</small></div><lb-truefalse-quiz ng-if=\"quizPlayer.quiz.type==\'truefalse\'\" question=\"{{quizPlayer.quiz.question}}\"></lb-truefalse-quiz><lb-shortanswer-quiz ng-if=\"quizPlayer.quiz.type==\'shortanswer\'\" question=\"{{quizPlayer.quiz.question}}\"></lb-shortanswer-quiz><lb-multichoice-quiz ng-if=\"quizPlayer.quiz.type==\'multichoice\'\" question=\"{{quizPlayer.quiz.question}}\" options=\"quizPlayer.quiz.execution\"></lb-multichoice-quiz><lb-matching-quiz ng-if=\"quizPlayer.quiz.type==\'matching\'\" question=\"{{quizPlayer.quiz.question}}\" options=\"quizPlayer.quiz.execution.question\" answers=\"quizPlayer.quiz.execution.answer\"></lb-matching-quiz></div></md-card><div class=\"quiz-result quiz-player-container resource-container\" ng-if=\"!quizPlayer.quiz\"><div layout=\"column\" layout-align=\"center center\"><h2 ng-if=\"quizPlayer.result.solved\" class=\"md-headline\">{{\'exercise-successfully-completed\' | trans}} <span ng-if=\"quizPlayer.viewState.hasModule(\'gamification\')\">{{\'points-earned-notification\' | trans:{pointsearned: quizPlayer.result.score} }}</span></h2><h2 ng-if=\"!quizPlayer.result.solved\" class=\"md-headline\">{{\'not-passed-exercise\' | trans}}</h2></div><div ng-repeat=\"quiz in quizPlayer.result.quiz\"><lb-truefalse-quiz-result ng-if=\"quiz.type==\'truefalse\'\" question=\"{{quiz.question}}\" user-execution=\"quiz.userExecution\" answer=\"quiz.answer\" solved=\"quiz.solved\"></lb-truefalse-quiz-result><lb-shortanswer-quiz-result ng-if=\"quiz.type==\'shortanswer\'\" question=\"{{quiz.question}}\" user-execution=\"quiz.userExecution\" answer=\"quiz.answer\" solved=\"quiz.solved\"></lb-shortanswer-quiz-result><lb-multichoice-quiz-result ng-if=\"quiz.type==\'multichoice\'\" question=\"{{quiz.question}}\" options=\"quiz.execution\" user-execution=\"quiz.userExecution\" answer=\"quiz.answer\" solved=\"quiz.solved\"></lb-multichoice-quiz-result><lb-matching-quiz-result ng-if=\"quiz.type==\'matching\'\" question=\"{{quiz.question}}\" options=\"quiz.execution.question\" answers=\"quiz.execution.answer\" user-execution=\"quiz.userExecution\" answer=\"quiz.answer\" solved=\"quiz.solved\"></lb-matching-quiz-result></div><div class=\"quiz-controls\" layout-align=\"center center\" layout-padding=\"\" layout=\"row\"><md-button ng-click=\"quizPlayer.replay()\" class=\"md-raised\">{{\'try-again\' | trans}}</md-button><md-button ng-click=\"quizPlayer.showSolutions()\" class=\"md-raised\">{{\'show-solutions\' | trans}}</md-button><md-button ng-if=\"quizPlayer.course.nextLesson(quizPlayer.lesson.id)!=null\" ng-click=\"$state.go(\'course.lesson\', {courseId: quizPlayer.course.id, lessonId: quizPlayer.course.nextLesson(quizPlayer.lesson.id).id})\" class=\"md-accent md-raised\">{{\'continue\' | trans}}</md-button></div></div>");
$templateCache.put("./app/components/reviewsList/reviewsList.html","<md-list><md-list-item ng-repeat=\"review in reviewsList.reviews\" class=\"md-3-line\"><lb-user-button user=\"review.user\"></lb-user-button><div class=\"md-list-item-text smoothable\"><p>{{review.review}}</p></div></md-list-item></md-list>");
$templateCache.put("./app/components/slidingNavBar/slidingNavBar.html","<div class=\"sliding-sidebar sidebar-menu\"><md-button ng-click=\"slidingNavBar.viewState.toggleMain()\" class=\"md-icon-button close-left\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button><md-list ng-click=\"slidingNavBar.viewState.toggleMain()\"><div layout=\"row\" layout-align=\"start center\" style=\"min-height:34px\"><img ng-if=\"slidingNavBar.viewState.brand.navbar\" ng-src=\"{{slidingNavBar.viewState.brand.navbar}}\" style=\"margin-left: 20px\"></div><md-divider></md-divider><md-list-item ng-if=\"!$state.includes(\'home\') && !slidingNavBar.viewState.hasHiddenButton(\'nav_home\')\" ui-sref=\"home\"><md-icon md-font-set=\"material-icons\">home</md-icon><p>{{\'home\' | trans}}</p></md-list-item><md-list-item ng-if=\"$state.includes(\'home\') && !slidingNavBar.viewState.hasHiddenButton(\'nav_home\')\" ui-sref=\"home\" class=\"active\"><md-icon md-colors=\"{\'color\': slidingNavBar.viewState.theme + \'-primary\'}\" md-font-set=\"material-icons\">home</md-icon><p md-colors=\"{\'color\': slidingNavBar.viewState.theme + \'-primary\'}\">{{\'home\' | trans}}</p></md-list-item><md-list-item ng-if=\"!$state.includes(\'enrolled\') && slidingNavBar.viewState.hasModule(\'core_enrolled-view\')\" ui-sref=\"enrolled\"><md-icon md-font-set=\"material-icons\">dns</md-icon><p>{{\'module-enrolled-\' + slidingNavBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-if=\"$state.includes(\'enrolled\') && slidingNavBar.viewState.hasModule(\'core_enrolled-view\')\" ui-sref=\"enrolled\" class=\"active\"><md-icon md-colors=\"{\'color\': slidingNavBar.viewState.theme + \'-primary\'}\" md-font-set=\"material-icons\">dns</md-icon><p md-colors=\"{\'color\': slidingNavBar.viewState.theme + \'-primary\'}\">{{\'module-enrolled-\' + slidingNavBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-if=\"slidingNavBar.viewState.hasModule(\'social_post\') && !$state.includes(\'community\')\" ui-sref=\"community\"><md-icon md-font-set=\"material-icons\">whatshot</md-icon><p ng-if=\"slidingNavBar.viewState.hasModule(\'social_post\') && !$state.includes(\'community\')\">{{\'module-community-\' + slidingNavBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-if=\"$state.includes(\'community\')\" ui-sref=\"community\" class=\"active\"><md-icon md-colors=\"{\'color\': slidingNavBar.viewState.theme + \'-primary\'}\" md-font-set=\"material-icons\">whatshot</md-icon><p md-colors=\"{\'color\': slidingNavBar.viewState.theme + \'-primary\'}\">{{\'module-community-\' + slidingNavBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-if=\"slidingNavBar.viewState.hasModule(\'playlist\') && !$state.includes(\'playlists\') && !$state.includes(\'playlist\')\" ui-sref=\"playlists\"><md-icon md-font-set=\"material-icons\">view_list</md-icon><p ng-if=\"!$state.includes(\'playlists\') && !$state.includes(\'playlist\')\">{{\'module-playlist-\' + slidingNavBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-if=\"slidingNavBar.viewState.hasModule(\'playlist\') && ($state.includes(\'playlists\') || $state.includes(\'playlist\'))\" ui-sref=\"playlists\" class=\"active\"><md-icon md-colors=\"{\'color\': slidingNavBar.viewState.theme + \'-primary\'}\" md-font-set=\"material-icons\">view_list</md-icon><p md-colors=\"{\'color\': slidingNavBar.viewState.theme + \'-primary\'}\">{{\'module-playlist-\' + slidingNavBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-if=\"slidingNavBar.viewState.hasModule(\'news\') && !$state.includes(\'news\')\" ui-sref=\"news\"><md-icon md-font-set=\"material-icons\">cast</md-icon><p>{{\'module-blog-\' + slidingNavBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-if=\"slidingNavBar.viewState.hasModule(\'news\') && $state.includes(\'news\')\" ui-sref=\"news\" class=\"active\"><md-icon md-colors=\"{\'color\': slidingNavBar.viewState.theme + \'-primary\'}\" md-font-set=\"material-icons\">cast</md-icon><p md-colors=\"{\'color\': slidingNavBar.viewState.theme + \'-primary\'}\">{{\'module-blog-\' + slidingNavBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-if=\"slidingNavBar.viewState.hasModule(\'messages-menu\') && !$state.includes(\'messages\')\" ui-sref=\"messages\"><md-icon md-font-set=\"material-icons\">message</md-icon><p>{{\'module-messages-menu-\' + slidingNavBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-if=\"slidingNavBar.viewState.hasModule(\'messages-menu\') && $state.includes(\'messages\')\" ui-sref=\"messages\" class=\"active\"><md-icon md-colors=\"{\'color\': slidingNavBar.viewState.theme + \'-primary\'}\" md-font-set=\"material-icons\">message</md-icon><p md-colors=\"{\'color\': slidingNavBar.viewState.theme + \'-primary\'}\">{{\'module-messages-menu-\' + slidingNavBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-if=\"slidingNavBar.viewState.hasModule(\'repository\') && !$state.includes(\'repository\')\" ui-sref=\"repository\"><md-icon md-font-set=\"material-icons\">folder</md-icon><p>{{\'module-repository-\' + slidingNavBar.viewState.theme | trans}}</p></md-list-item><md-list-item ng-if=\"slidingNavBar.viewState.hasModule(\'repository\') && $state.includes(\'repository\')\" ui-sref=\"repository\" class=\"active\"><md-icon md-colors=\"{\'color\': slidingNavBar.viewState.theme + \'-primary\'}\" md-font-set=\"material-icons\">folder</md-icon><p md-colors=\"{\'color\': slidingNavBar.viewState.theme + \'-primary\'}\">{{\'module-repository-\' + slidingNavBar.viewState.theme | trans}}</p></md-list-item></md-list><lb-last-course ng-click=\"slidingNavBar.viewState.toggleMain()\" course=\"slidingNavBar.lastViewedCourse\" class=\"sidebar-menu-bottom\"></lb-last-course></div>");
$templateCache.put("./app/components/socialBar/socialBar.html","<div ng-class=\"{\'sidebar-tour-hotspot\': socialBar.viewState.tourRunning}\" tour-step=\"\" tour-step-popup-class=\"sidebar-tour-step\" tour-step-title=\"{{\'activity\' | trans}}\" tour-step-content=\"{{\'tour-step-content-activity\' | trans}}\" tour-step-order=\"1\" tour-step-placement=\"left\" tour-step-on-show=\"socialBar.viewState.socialSelectedTab=0\"></div><div ng-class=\"{\'sidebar-tour-hotspot\': socialBar.viewState.tourRunning}\" tour-step=\"\" tour-step-popup-class=\"sidebar-tour-step\" tour-step-title=\"{{\'users\' | trans}}\" tour-step-content=\"{{\'tour-step-content-users\' | trans}}\" tour-step-order=\"2\" tour-step-placement=\"left\" tour-step-on-show=\"socialBar.viewState.socialSelectedTab=1\"></div><div ng-if=\"socialBar.viewState.hasModule(\'gamification\')\" ng-class=\"{\'sidebar-tour-hotspot\': socialBar.viewState.tourRunning}\" tour-step=\"\" tour-step-popup-class=\"sidebar-tour-step\" tour-step-title=\"{{\'ranking\' | trans}}\" tour-step-content=\"{{\'tour-step-content-ranking\' | trans}}\" tour-step-order=\"3\" tour-step-placement=\"left\" tour-step-on-show=\"socialBar.viewState.socialSelectedTab=2\" tour-step-on-next=\"socialBar.viewState.socialSelectedTab=0\"></div><md-toolbar class=\"md-accent\" hide-gt-xs=\"\"><div class=\"md-toolbar-tools\"><span flex=\"\"></span><md-button ng-click=\"socialBar.viewState.toggleRight()\" class=\"md-icon-button\" hide-gt-md=\"\"><md-icon md-font-set=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-stretch-tabs=\"always\" md-center-tabs=\"true\" md-no-pagination=\"\" md-swipe-content=\"\" md-selected=\"socialBar.viewState.socialSelectedTab\"><md-tab ng-if=\"socialBar.viewState.hasModule(\'social_post\')\" label=\"{{\'activity\' | trans}}\" md-on-select=\"socialBar.loadPosts()\"><md-content class=\"activities\"><section><md-subheader class=\"post-filter\"><div layout=\"row\" layout-align=\"start-center\" flex=\"\"><a ui-sref=\"community\"><h3 class=\"md-title\" md-colors=\"{\'color\': socialBar.viewState.theme + \'-primary\'}\" style=\"margin-bottom:0\">{{\'module-community-\' + socialBar.viewState.theme | trans}}</h3></a> <span flex=\"\"></span><div layout=\"row\"><md-button ng-show=\"!socialBar.viewState.hasRealtime\" class=\"md-raised md-fab md-mini\" ng-click=\"socialBar.loadPosts()\" style=\"margin-right:0\"><md-icon md-font-set=\"material-icons\">autorenew</md-icon><md-tooltip>{{\'update\' | trans}}</md-tooltip></md-button><md-button id=\"createPostLink\" class=\"md-fab md-mini\" ng-click=\"$state.go(\'socialPost\')\"><md-icon md-font-set=\"material-icons\">mode_edit</md-icon><md-tooltip>{{\'publish\' | trans}}</md-tooltip></md-button></div></div></md-subheader><md-icon ng-if=\"socialBar.postsLoading\" md-svg-src=\"/assets/icons/spinner.svg\" style=\"margin: 10px\"></md-icon><md-list ng-if=\"!socialBar.postsLoading && socialBar.posts.length>0\"><lb-post-preview ng-repeat=\"post in socialBar.posts\" post=\"post\"></lb-post-preview><md-button class=\"md-primary\" ui-sref=\"community\" style=\"float:right;margin:14px\">{{\'go-to\' | trans}} {{\'module-community-\' + socialBar.viewState.theme | trans}}</md-button></md-list><p ng-if=\"!socialBar.postsLoading && socialBar.posts.length==0\" style=\"padding:14px\"><small>{{\'no-activity-yet\' | trans}}</small></p></section></md-content></md-tab><md-tab label=\"{{\'users\' | trans}}\" md-on-select=\"socialBar.loadUsers()\"><md-content class=\"users\"><section><md-subheader class=\"user-filter\"><div layout=\"column\"><md-input-container><label>{{\'search-for-a-member\' | trans}}</label> <input ng-model=\"userSearch.$\" ng-change=\"socialBar.updateUsersFilter()\"></md-input-container><md-radio-group ng-model=\"socialBar.selectedUserRelation\" ng-change=\"socialBar.updateUsersFilter()\" layout=\"row\"><md-radio-button ng-value=\"\'all\'\">{{\'everyone\' | trans}}</md-radio-button><md-radio-button ng-value=\"\'following\'\">{{\'following\' | trans}}</md-radio-button><md-radio-button ng-value=\"\'followers\'\">{{\'followers\' | trans}}</md-radio-button><span style=\"clear: both;\"></span></md-radio-group></div></md-subheader><md-icon ng-if=\"socialBar.usersLoading\" md-svg-src=\"/assets/icons/spinner.svg\" style=\"margin: 10px\"></md-icon><md-list ng-if=\"socialBar.loadedUsers.length>0\" infinite-scroll=\"socialBar.moreUsers()\" style=\"12px 12px 10px 2px\"><md-list-item ng-repeat=\"user in socialBar.loadedUsers | filter:userSearch | filter:socialBar.userRelationFilter | orderBy:socialBar.orderUsers track by $index\" ng-if=\"user.id != socialBar.currentUser.id\" class=\"md-2-line md-no-proxy\"><lb-user-button user=\"user\"></lb-user-button><div class=\"md-list-item-text smoothable\"><h3>{{user.name}} {{user.surname}}</h3><p>{{user.company}}</p></div></md-list-item></md-list><p ng-if=\"!socialBar.usersLoading && socialBar.loadedUsers.length<=1\" style=\"padding:0 14px\"><small>{{\'no-users-found\' | trans}}</small></p></section></md-content></md-tab><md-tab ng-if=\"socialBar.viewState.hasModule(\'gamification\')\" label=\"{{\'ranking\' | trans}}\" md-on-select=\"socialBar.loadRanking()\"><md-content class=\"ranking\"><section><md-subheader class=\"user-filter\"><div layout=\"column\"><md-input-container><label>{{\'search-for-a-member\' | trans}}</label> <input ng-model=\"userSearch.$\" ng-change=\"socialBar.updateRankingFilter()\"></md-input-container><md-radio-group ng-model=\"socialBar.selectedRankingRelation\" ng-change=\"socialBar.updateRankingFilter()\" layout=\"row\"><md-radio-button ng-value=\"\'all\'\">{{\'everyone\' | trans}}</md-radio-button><md-radio-button ng-value=\"\'following\'\">{{\'following\' | trans}}</md-radio-button><md-radio-button ng-value=\"\'followers\'\">{{\'followers\' | trans}}</md-radio-button><span style=\"clear: both;\"></span></md-radio-group></div></md-subheader><md-icon ng-if=\"socialBar.rankingLoading\" md-svg-src=\"/assets/icons/spinner.svg\" style=\"margin: 10px\"></md-icon><md-list ng-if=\"socialBar.loadedRanking.length>0\" infinite-scroll=\"socialBar.moreRanking()\" style=\"12px 12px 10px 2px\"><md-list-item ng-repeat=\"user in socialBar.loadedRanking | filter:userSearch | filter:socialBar.rankingRelationFilter track by $index\" class=\"md-2-line md-no-proxy\"><lb-user-button user=\"user\"></lb-user-button><div class=\"md-list-item-text smoothable\"><h3>{{user.name}} {{user.surname}}</h3><p>{{user.company}}</p></div><h3 class=\"md-headline rank smoothable md-secondary\" md-colors=\"{\'color\': socialBar.viewState.theme + \'-accent\'}\">{{user.position}}°</h3></md-list-item></md-list><div ng-if=\"!socialBar.rankingLoading && socialBar.loadedRanking.length==0\" style=\"padding:14px\"><small>{{\'empty-ranking\' | trans}}</small></div></section></md-content></md-tab></md-tabs>");
$templateCache.put("./app/components/textResource/textResource.html","<div layout=\"column\" class=\"content-body\"><div ng-bind-html=\"textResource.text\" class=\"text-container resource-container md-whiteframe-3dp\" style=\"background-color: white;padding:20px\"></div></div>");
$templateCache.put("./app/components/userButton/userButton.html","<div class=\"user-button\" ng-class=\"{\'user-button-small\': userButton.size==\'sm\'}\" ng-cloak=\"\"><a ng-if=\"userButton.size==\'sm\'\" ui-sref=\"user({userId: userButton.user.id})\"><div class=\"user-image\"><img ng-src=\"{{userButton.user.picture}}\" class=\"md-avatar md-whiteframe-3dp\" alt=\"{{userButton.user.name}} {{userButton.user.surname}}\"> <span ng-if=\"userButton.viewState.hasModule(\'gamification\')\" class=\"score md-whiteframe-1dp\">{{userButton.user.score}}</span> <span ng-if=\"userButton.viewState.hasRealtimeUsers && userButton.viewState.isOnline(userButton.user.id)\" class=\"status online\"></span></div><md-tooltip>{{\'profile\' | trans}}</md-tooltip></a><md-fab-speed-dial ng-if=\"userButton.size!=\'sm\'\" md-direction=\"right\" class=\"md-scale\" md-open=\"userButton.isOpen\" ng-mouseenter=\"userButton.open($event)\" ng-mouseleave=\"userButton.close($event)\"><md-fab-trigger><div class=\"user-image\"><img ng-src=\"{{userButton.user.picture}}\" class=\"md-avatar md-whiteframe-3dp\" alt=\"{{userButton.user.name}} {{userButton.user.surname}}\"> <span ng-if=\"userButton.viewState.hasModule(\'gamification\')\" class=\"score md-whiteframe-1dp\">{{userButton.user.score}}</span> <span ng-if=\"userButton.viewState.hasRealtimeUsers && userButton.viewState.isOnline(userButton.user.id)\" class=\"status online\"></span></div></md-fab-trigger><md-fab-actions><md-button ui-sref=\"user({userId: userButton.user.id})\" class=\"md-fab md-raised md-mini md-primary\"><md-tooltip>{{\'profile\' | trans}}</md-tooltip><md-icon md-font-set=\"material-icons\">person</md-icon></md-button><md-button ng-if=\"userButton.viewState.hasModule(\'social_messages\') && userButton.currentUser.id!=userButton.user.id\" ui-sref=\"messages({recipientId: userButton.user.id})\" class=\"md-fab md-raised md-mini md-primary\"><md-tooltip>{{\'send-a-message\' | trans}}</md-tooltip><md-icon md-font-set=\"material-icons\">message</md-icon></md-button><md-button ng-if=\"userButton.viewState.hasModule(\'gamification\')\" ui-sref=\"compareStats({userId: userButton.user.id})\" class=\"md-fab md-raised md-mini md-primary\"><md-tooltip>{{\'compare\' | trans}}</md-tooltip><md-icon md-font-set=\"material-icons\">people</md-icon></md-button><md-button ng-if=\"userButton.viewState.hasModule(\'social\') && userButton.currentUser.id!=userButton.user.id && !userButton.viewState.follows(userButton.user.id)\" ng-click=\"userButton.follow()\" class=\"md-raised md-mini md-fab md-primary\"><md-tooltip>{{\'follow\' | trans}}</md-tooltip><md-icon md-font-set=\"material-icons\">add_circle</md-icon></md-button><md-button ng-if=\"userButton.viewState.hasModule(\'social\') && userButton.currentUser.id!=userButton.user.id && userButton.viewState.follows(userButton.user.id)\" ng-click=\"userButton.unfollow()\" class=\"md-raised md-mini md-fab md-primary\"><md-tooltip>{{\'unfollow\' | trans}}</md-tooltip><md-icon md-font-set=\"material-icons\">remove_circle</md-icon></md-button></md-fab-actions></md-fab-speed-dial></div>");
$templateCache.put("./app/components/userCategoryChart/userCategoryChart.html","<canvas ng-if=\"userCategoryChart.data.length>0\" class=\"chart chart-pie user-category-chart\" chart-data=\"userCategoryChart.data\" chart-labels=\"userCategoryChart.labels\" chart-legend=\"true\" chart-colours=\"userCategoryChart.colours\" chart-options=\"userCategoryChart.options\"></canvas><p ng-if=\"!userCategoryChart.data.length>0\">{{\'still-no-results\' | trans}}</p>");
$templateCache.put("./app/components/userChart/userChart.html","<canvas ng-if=\"userChart.data.length>0\" class=\"chart chart-doughnut user-chart\" chart-data=\"userChart.data\" chart-labels=\"userChart.labels\" chart-legend=\"true\" chart-options=\"userChart.options\"></canvas><p ng-if=\"!userChart.data.length>0\">{{\'still-no-results\' | trans}}</p>");
$templateCache.put("./app/components/userCoursesTable/userCoursesTable.html","<md-table-container ng-if=\"userCoursesTable.data.length>0\" class=\"user-courses-table\"><table md-table=\"\"><thead md-head=\"\" md-order=\"sortOrder\"><tr md-row=\"\"><th hide=\"\" show-gt-sm=\"\" md-column=\"\" md-order-by=\"category.name\" md-desc=\"\"><span>{{\'topic\' | trans}}</span></th><th md-column=\"\" md-order-by=\"title\"><span>{{\'title\' | trans}}</span></th><th md-column=\"\" md-order-by=\"time\">{{\'time\' | trans}}</th><th hide=\"\" show-gt-sm=\"\" md-column=\"\" md-order-by=\"progress\">{{\'progress\' | trans}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"course in userCoursesTable.data | orderBy: sortOrder\"><td hide=\"\" show-gt-xs=\"\" md-cell=\"\">{{course.category.name}}</td><td md-cell=\"\">{{course.title}}</td><td md-cell=\"\"><md-progress-linear md-mode=\"determinate\" value=\"{{userCoursesTable.getTimePercent(course.time)}}\"></md-progress-linear><small class=\"progress-caption\">{{userCoursesTable.formatTime(course.time)}}</small></td><td hide=\"\" show-gt-xs=\"\" md-cell=\"\"><md-progress-linear md-mode=\"determinate\" value=\"{{course.progress}}\"></md-progress-linear><small class=\"progress-caption\">{{course.progress}}%</small></td></tr></tbody></table></md-table-container><p ng-if=\"!userCoursesTable.data.length>0\">{{\'still-no-results\' | trans}}</p>");
$templateCache.put("./app/components/userList/userList.html","<md-list><md-list-item ng-repeat=\"user in userList.users\" class=\"md-2-line md-no-proxy\"><lb-user-button user=\"user\"></lb-user-button><div class=\"md-list-item-text smoothable\"><small ng-if=\"user.company\">{{user.company}}</small><h3><a ui-sref=\"user({userId: user.id})\" href=\"#\">{{user.name}} {{user.surname}}</a></h3><p ng-if=\"user.job\">{{user.job}}</p></div></md-list-item></md-list>");
$templateCache.put("./app/components/userTimeChart/userTimeChart.html","<canvas ng-if=\"userTimeChart.data.length>0\" class=\"chart chart-line user-time-chart\" chart-data=\"userTimeChart.data\" chart-labels=\"userTimeChart.labels\" chart-legend=\"false\" chart-series=\"userTimeChart.series\" chart-options=\"userTimeChart.options\"></canvas><p ng-if=\"!userTimeChart.data.length>0\">{{\'still-no-results\' | trans}}</p>");
$templateCache.put("./app/components/videoConfirm/videoConfirm.html","<md-bottom-sheet layout=\"row\" class=\"md-grid\"><md-grid class=\"comleted-actions\" layout-padding=\"\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-grid-item><md-button class=\"md-grid-item-content layout-fill\" ng-click=\"videoConfirm.replayLesson()\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#F44336\'}\">replay</md-icon><div class=\"md-grid-text\">{{\'repeat\' | trans}}</div></md-button></md-grid-item><md-grid-item ng-if=\"videoConfirm.nextLesson != null\"><md-button md-autofocus=\"\" class=\"md-grid-item-content layout-fill\" ng-click=\"$state.go(\'course.lesson\', {courseId: videoConfirm.courseId, lessonId: videoConfirm.nextLesson.id})\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#4CAF50\'}\">skip_next</md-icon><div class=\"md-grid-text\">{{\'continue\' | trans}}</div></md-button></md-grid-item></md-grid></md-bottom-sheet>");
$templateCache.put("./app/components/videoResource/videoResource.html","<div class=\"video-container resource-container\"><videogular vg-player-ready=\"videoResource.playerReady($API)\" vg-complete=\"videoResource.onComplete()\" vg-theme=\"videoResource.theme\"><vg-media vg-src=\"videoResource.currentQualitySource.sources\"></vg-media><vg-controls vg-autohide=\"true\" vg-autohide-time=\"1000\"><vg-play-pause-button></vg-play-pause-button><a class=\"md-icon-button md-button video-control\" ng-disabled=\"!videoResource.completed || videoResource.course.nextLesson(videoResource.lesson.id)==null\" ng-click=\"videoResource.nextLesson($event)\"><md-icon md-font-set=\"material-icons\">skip_next</md-icon><md-tooltip>{{\'continue\' | trans}}</md-tooltip></a><vg-time-display>{{currentTime | date:\'mm:ss\'}}</vg-time-display><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-quality quality-sources=\"videoResource.videoResources\" default-quality=\"videoResource.currentQualitySource\"></vg-quality><vg-fullscreen-button></vg-fullscreen-button></vg-controls><vg-overlay-play></vg-overlay-play><vg-poster vg-url=\"videoResource.resource.previewUrl\"></vg-poster></videogular></div>");
$templateCache.put("./app/messages/talk/talk.html","<md-button ng-show=\"!messagesTalk.viewState.hasRealtime\" ng-click=\"messagesTalk.reload()\" class=\"talk-reload md-fab md-mini md-raised\"><md-icon md-font-set=\"material-icons\">autorenew</md-icon></md-button><md-divider></md-divider><md-content scroll-glue=\"\" class=\"messages\"><section ng-repeat=\"(date, msgs) in messagesTalk.messages\"><md-subheader md-theme=\"equi\" class=\"md-primary\"><small am-time-ago=\"msgs[0].date.date | amUtc | amLocal | amParse:\'YYYY-MM-DD HH:mm:ss\'\"></small></md-subheader><p ng-repeat=\"message in msgs\" class=\"message animated\" ng-class=\"{mine: message.sender.id == messages.currentUser.id, fadeIn: message.added}\"><span ng-if=\"message.sender.id != messages.currentUser.id\" class=\"sender-label\">{{message.sender.name}}</span> <small am-time-ago=\"message.date.date | amUtc | amLocal | amParse:\'YYYY-MM-DD HH:mm:ss\'\"></small> {{message.body}}</p></section></md-content><md-divider></md-divider><form layout=\"row\" layout-padding=\"\" class=\"message-form\"><md-input-container flex=\"\"><label>{{\'write-a-message\' | trans}}</label> <input ng-model=\"messagesTalk.message\" md-maxlength=\"500\"></md-input-container><div layout-padding=\"\" layout-align=\"end end\"><md-button type=\"submit\" ng-click=\"messagesTalk.post()\" class=\"md-raised md-accent\" ng-disabled=\"messagesTalk.message.length==0\">{{\'send\' | trans}}</md-button></div></form>");
$templateCache.put("./app/user/contacts/contacts.html","<div layout=\"row\" layout-align=\"center start\" layout-padding=\"\"><md-radio-group ng-model=\"userContacts.selectedRelation\" ng-change=\"userContacts.updateUsersFilter()\" layout=\"row\"><md-radio-button ng-value=\"\'all\'\">{{\'everyone\' | trans}}</md-radio-button><md-radio-button ng-value=\"\'following\'\">{{\'following\' | trans}}</md-radio-button><md-radio-button ng-value=\"\'followers\'\">{{\'followers\' | trans}}</md-radio-button><span style=\"clear: both;\"></span></md-radio-group></div><md-icon ng-if=\"userContacts.usersLoading\" md-svg-src=\"/assets/icons/spinner.svg\" style=\"margin: 10px\"></md-icon><md-list ng-if=\"userContacts.loadedUsers.length>0\" infinite-scroll=\"userContacts.moreUsers()\" masonry=\"\" preserve-order=\"\" item-selector=\"md-list-item\" id=\"participants\"><md-list-item masonry-brick=\"\" ng-repeat=\"user in userContacts.loadedUsers | filter:userContacts.relationFilter track by $index\" ng-if=\"user.id != userContacts.user.id\" class=\"md-2-line\"><lb-user-button user=\"user\"></lb-user-button><div class=\"md-list-item-text smoothable\"><h3>{{user.name}} {{user.surname}}</h3><p>{{user.company}}</p></div></md-list-item></md-list><p ng-if=\"!userContacts.usersLoading && userContacts.loadedUsers.length<=1\" ng-cloak=\"\">{{\'no-contact-yet\' | trans}}</p>");
$templateCache.put("./app/user/courses/courses.html","<div layout=\"row\" layout-align=\"end start\"><md-input-container><md-select ng-model=\"userCourses.selectedCategory\" placeholder=\"{{\'select-category\' | trans}}\"><md-option>{{\'all\' | trans}}</md-option><md-option ng-value=\"category\" ng-repeat=\"category in userCourses.categories\"><md-icon ng-if=\"category.icon\" ng-style=\"{color: category.color, \'margin-right\': \'3px\'}\" md-font-set=\"material-icons\">{{category.icon}}</md-icon>{{ category.name }}</md-option></md-select></md-input-container></div><div class=\"card-grid\" layout=\"row\" layout-wrap=\"\" layout-align=\"center start\"><lb-course-card ng-repeat=\"course in userCourses.courses | filter: {category: {id: userCourses.selectedCategory.id}}\" course=\"course\" lazy=\"true\"></lb-course-card></div><p ng-if=\"userCourses.courses.length==0\" ng-cloak=\"\">{{\'no-program-yet\' | trans}}</p>");
$templateCache.put("./app/user/godos/godos.html","<md-icon ng-if=\"userGodos.godosLoading\" md-svg-src=\"/assets/icons/spinner.svg\" style=\"margin: 10px\"></md-icon><md-button class=\"md-raised\" ui-sref=\"createGodo()\" layout-align=\"center center\"><span hide=\"\" show-gt-xs=\"\">{{\'godo-create\' | trans}}</span><md-icon hide-gt-xs=\"\" md-font-set=\"material-icons\">edit</md-icon></md-button><div ng-if=\"userGodos.godos.length>0\" ng-cloak=\"\" class=\"card-grid\" layout=\"row\" layout-wrap=\"\" layout-align=\"center start\"><md-list-item class=\"md-3-line md-long-text\" ng-repeat=\"godo in userGodos.godos\" style=\"width:100%\"><md-divider></md-divider><div class=\"md-list-item-text\"><p class=\"summary-info\"><strong>{{\'godoActionText\' | trans}}</strong> {{godo.actionText}}</p><p class=\"summary-info\"><strong>{{\'godoOutcome\' | trans}}</strong> {{godo.outcome}}</p><p class=\"summary-info\"><strong>{{\'godoStatus\' | trans}}</strong> {{godo.status | trans}}</p><p class=\"summary-info\"><strong>{{\'godoDueDate\' | trans}}</strong><md-datepicker ng-model=\"godo.duedate\" disabled=\"\"></md-datepicker></p></div><md-button class=\"md-fab md-mini\" ui-sref=\"editGodo({godoId: godo.id})\"><md-icon md-font-set=\"material-icons\">edit</md-icon><md-tooltip md-direction=\"right\">{{\'edit-info\' | trans}}</md-tooltip></md-button></md-list-item></div><p ng-if=\"!userGodos.godosLoading && userGodos.godos.length<=0\" ng-cloak=\"\"></p>");
$templateCache.put("./app/user/posts/posts.html","<div layout=\"column\" flex=\"\"><div layout=\"row\" class=\"search\" layout-align=\"end center\"><md-input-container><md-select ng-model=\"userPosts.typeFilter\" ng-change=\"userPosts.reloadPosts()\" placeholder=\"{{\'filter-by-type-content\' | trans}}\"><md-option value=\"\">{{\'no-filter\' | trans}}</md-option><md-option value=\"1\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#3F51B5\', \'margin-right\': \'4px\'}\">dns</md-icon>{{\'programs\' | trans}}</md-option><md-option value=\"2\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#03A9F4\', \'margin-right\': \'4px\'}\">public</md-icon>{{\'link\' | trans}}</md-option><md-option value=\"3\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#F44336\', \'margin-right\': \'4px\'}\">play_circle_filled</md-icon>{{\'video\' | trans}}</md-option><md-option value=\"4\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#4CAF50\', \'margin-right\': \'4px\'}\">camera_alt</md-icon>{{\'images\' | trans}}</md-option><md-option value=\"5\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#FF9800\', \'margin-right\': \'4px\'}\">insert_drive_file</md-icon>{{\'documents\' | trans}}</md-option></md-select></md-input-container></div><div id=\"stories\" class=\"stories user-posts\" infinite-scroll=\"userPosts.loadPosts()\" infinite-scroll-disabled=\"userPosts.busy\" masonry=\"\" preserve-order=\"\" item-selector=\".grid-item\" masonry-options=\"{percentPosition: true}\"><div masonry-brick=\"\" class=\"grid-item\" ng-repeat=\"post in userPosts.loadedPosts\"><lb-post-card ng-if=\"!post.byStaff\" post=\"post\"></lb-post-card><lb-news-card ng-if=\"post.byStaff\" post=\"post\"></lb-news-card></div></div><md-icon ng-if=\"userPosts.busy || userPosts.postsLoading\" md-svg-src=\"/assets/icons/spinner.svg\" style=\"margin: 10px\"></md-icon><p ng-if=\"userPosts.loadedPosts.length==0 && !userPosts.postsLoading\" ng-cloak=\"\">{{\'no-activity-yet\' | trans}}<md-button class=\"md-raised\" ng-click=\"userPosts.reloadPosts()\">{{\'update\' | trans}}</md-button></p></div>");
$templateCache.put("./app/user/stats/stats.html","<md-whiteframe class=\"md-whiteframe-2dp chart-card\"><div layout=\"column\" layout-gt-md=\"row\" layout-align=\"center center\"><h3 class=\"md-headline\" flex=\"\">{{userStats.userTimeTotal}} {{\'on-the-platform\' | trans}}</h3><div layout=\"row\" layout-padding=\"\" layout-align=\"end end\"><div layout=\"row\" layout-align=\"center center\"><small>{{\'from\' | trans}}</small><md-datepicker ng-model=\"userStats.userTimeFrom\" ng-change=\"userStats.updateTimeStats()\"></md-datepicker></div><div layout=\"row\" layout-align=\"center center\"><small>{{\'to\' | trans}}</small><md-datepicker ng-model=\"userStats.userTimeTo\" ng-change=\"userStats.updateTimeStats()\"></md-datepicker></div></div></div><lb-user-time-chart data=\"userStats.userTimeData\" labels=\"userStats.userTimeLabels\" series=\"userStats.userTimeSeries\" flex=\"\"></lb-user-time-chart></md-whiteframe><md-whiteframe class=\"md-whiteframe-2dp chart-card\"><div layout=\"column\" layout-gt-sm=\"row\" layout-wrap=\"\"><div layout=\"column\" flex=\"50\"><h3 class=\"md-headline\">{{\'topics\' | trans}}</h3><lb-user-category-chart data=\"userStats.userCategoryData\" labels=\"userStats.userCategoryLabels\" colours=\"userStats.userCategoryColours\"></lb-user-category-chart></div><div layout=\"column\" flex=\"50\"><h3 class=\"md-headline\">{{\'results\' | trans}}</h3><lb-user-chart data=\"userStats.userData\" labels=\"userStats.userLabels\"></lb-user-chart></div></div></md-whiteframe><md-whiteframe class=\"md-whiteframe-2dp chart-card\"><h3 class=\"md-headline\">{{\'programs\' | trans}}</h3><lb-user-courses-table data=\"userStats.coursesStats\"></lb-user-courses-table></md-whiteframe>");
$templateCache.put("./app/components/quizPlayer/matchingQuiz/matchingQuiz.html","<div class=\"matching-quiz\"><md-subheader><h3 class=\"md-subhead\">{{matchingQuiz.question}}</h3><p>{{\'quiz-question-dragging\' | trans}}</p></md-subheader><md-content><div layout=\"row\"><div flex=\"50\"><md-list><md-list-item md-whiteframe=\"{{matchingQuiz.isSelected(option) ? -1 : 1}}\" ng-repeat=\"option in matchingQuiz.options\" ng-drag=\"!matchingQuiz.isSelected(option)\" ng-drag-data=\"{{option}}\" style=\"background-color: {{matchingQuiz.getOptionColor(option)}}\" ng-class=\"{disabled: matchingQuiz.isSelected(option)}\" class=\"draggable\"><p>{{option.value}}</p></md-list-item></md-list></div><div flex=\"50\"><md-list><md-list-item ng-repeat=\"answer in matchingQuiz.answers\" ng-drop=\"!matchingQuiz.isAnswerSelected(answer)\" ng-drop-success=\"matchingQuiz.match($data, answer)\" style=\"background-color: {{matchingQuiz.getAnswerColor(answer)}}\" ng-class=\"{disabled: matchingQuiz.isAnswerSelected(answer)}\" class=\"droppable\"><p>{{answer.value}}</p></md-list-item></md-list></div></div></md-content></div><div ng-if=\"matchingQuiz.matches.length==matchingQuiz.answers.length || matchingQuiz.matches.length>0\" class=\"quiz-controls\" layout-align=\"center-center\" layout=\"row\"><md-button class=\"md-raised\" ng-if=\"matchingQuiz.matches.length>0\" ng-click=\"matchingQuiz.reset()\">{{\'reset\' | trans}}</md-button><md-button class=\"md-raised md-accent\" ng-if=\"matchingQuiz.matches.length==matchingQuiz.answers.length\" ng-click=\"matchingQuiz.matchesSelected()\">{{\'send\' | trans}}</md-button></div>");
$templateCache.put("./app/components/quizPlayer/multichoiceQuiz/multichoiceQuiz.html","<md-list class=\"multichoice-quiz\"><md-subheader><h3 class=\"md-subhead\">{{multichoiceQuiz.question}}</h3><p>{{\'choose-correct-statements\' | trans}}</p></md-subheader><md-list-item ng-repeat=\"option in multichoiceQuiz.options\"><p>{{option.value}}</p><md-checkbox class=\"md-secondary\" checklist-model=\"multichoiceQuiz.selectedOptions\" checklist-value=\"option\"></md-checkbox><md-divider></md-divider></md-list-item></md-list><div ng-if=\"multichoiceQuiz.selectedOptions.length\" class=\"quiz-controls\" layout-align=\"center-center\" layout=\"row\"><md-button class=\"md-raised md-accent\" ng-click=\"multichoiceQuiz.optionsSelected()\">{{\'send\' | trans}}</md-button></div>");
$templateCache.put("./app/components/quizPlayer/quizConfirm/quizConfirm.html","<md-bottom-sheet layout=\"row\" class=\"md-grid\"><md-grid class=\"comleted-actions\" flex=\"\" layout=\"row\" layout-padding=\"\" layout-align=\"center center\"><md-grid-item><md-button class=\"md-grid-item-content\" ng-click=\"quizConfirm.cancel()\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#F44336\'}\">close</md-icon><div class=\"md-grid-text\">{{\'cancel\' | trans}}</div></md-button></md-grid-item><md-grid-item><md-button md-autofocus=\"\" class=\"md-grid-item-content\" ng-click=\"quizConfirm.confirm()\"><md-icon md-font-set=\"material-icons\" ng-style=\"{color: \'#4CAF50\'}\">done</md-icon><div class=\"md-grid-text\">{{\'confirm\' | trans}}</div></md-button></md-grid-item></md-grid></md-bottom-sheet>");
$templateCache.put("./app/components/quizPlayer/shortanswerQuiz/shortanswerQuiz.html","<md-list class=\"shortanswer-quiz\"><md-subheader><h3 class=\"md-subhead\">{{shortanswerQuiz.question}}</h3><p>{{\'write-correct-sentence\' | trans}}</p></md-subheader><md-list-item><md-input-container style=\"width: 100%\"><label>{{\'answer\' | trans}}</label> <input ng-model=\"shortanswerQuiz.answer\"></md-input-container></md-list-item></md-list><div ng-if=\"shortanswerQuiz.answer.length>=shortanswerQuiz.minAnswerLength\" class=\"quiz-controls\" layout-align=\"center-center\" layout=\"row\"><md-button class=\"md-raised md-accent\" ng-click=\"shortanswerQuiz.answered()\">{{\'send\' | trans}}</md-button></div>");
$templateCache.put("./app/components/quizPlayer/truefalseQuiz/truefalseQuiz.html","<md-list class=\"truefalse-quiz\"><md-subheader><h3 class=\"md-subhead\">{{truefalseQuiz.question}}</h3><p>{{\'quiz-question-truefalse\' | trans}}</p></md-subheader><md-content><md-list-item><md-radio-group ng-model=\"truefalseQuiz.selectedOption\"><md-radio-button value=\"true\">{{\'true\' | trans}}</md-radio-button><md-radio-button value=\"false\">{{\'false\' | trans}}</md-radio-button></md-radio-group></md-list-item></md-content></md-list><div ng-if=\"truefalseQuiz.selectedOption!=null\" class=\"quiz-controls\" layout-align=\"center-center\" layout=\"row\"><md-button class=\"md-raised md-accent\" ng-click=\"truefalseQuiz.optionSelected()\">{{\'send\' | trans}}</md-button></div>");
$templateCache.put("./app/components/quizPlayer/matchingQuiz/matchingQuizResult/matchingQuizResult.html","<md-card class=\"quiz-result-card\"><h3 class=\"md-subhead\" style=\"margin-top: 0\"><md-icon ng-if=\"matchingQuizResult.solved\" md-font-set=\"material-icons\" ng-style=\"{color: \'#4CAF50\'}\" class=\"material-icons\">done</md-icon><md-icon ng-if=\"!matchingQuizResult.solved\" md-font-set=\"material-icons\" ng-style=\"{color: \'#F44336\'}\" class=\"material-icons\">close</md-icon>{{matchingQuizResult.question}}</h3><md-list ng-if=\"matchingQuizResult.showSolution\"><md-list-item ng-repeat=\"solution in matchingQuizResult.answer\"><p>{{matchingQuizResult.getAnswer(solution)}}</p><md-divider></md-divider></md-list-item></md-list></md-card>");
$templateCache.put("./app/components/quizPlayer/multichoiceQuiz/multichoiceQuizResult/multichoiceQuizResult.html","<md-card class=\"quiz-result-card\"><h3 class=\"md-subhead\" style=\"margin-top: 0\"><md-icon ng-if=\"multichoiceQuizResult.solved\" md-font-set=\"material-icons\" ng-style=\"{color: \'#4CAF50\'}\" class=\"material-icons\">done</md-icon><md-icon ng-if=\"!multichoiceQuizResult.solved\" md-font-set=\"material-icons\" ng-style=\"{color: \'#F44336\'}\" class=\"material-icons\">close</md-icon>{{multichoiceQuizResult.question}}</h3><p ng-if=\"multichoiceQuizResult.showSolution\">{{\'correct-answer\' | trans}}: {{multichoiceQuizResult.getAnswer()}}</p></md-card>");
$templateCache.put("./app/components/quizPlayer/shortanswerQuiz/shortanswerQuizResult/shortanswerQuizResult.html","<md-card class=\"quiz-result-card\"><h3 class=\"md-subhead\" style=\"margin-top: 0\"><md-icon ng-if=\"shortanswerQuizResult.solved\" md-font-set=\"material-icons\" ng-style=\"{color: \'#4CAF50\'}\" class=\"material-icons\">done</md-icon><md-icon ng-if=\"!shortanswerQuizResult.solved\" md-font-set=\"material-icons\" ng-style=\"{color: \'#F44336\'}\" class=\"material-icons\">close</md-icon>{{shortanswerQuizResult.question}}</h3><p ng-if=\"shortanswerQuizResult.showSolution\">Risposta corretta: \"{{shortanswerQuizResult.answer[0]}}\"</p></md-card>");
$templateCache.put("./app/components/quizPlayer/truefalseQuiz/truefalseQuizResult/truefalseQuizResult.html","<md-card class=\"quiz-result-card\"><h3 class=\"md-subhead\" style=\"margin-top: 0\"><md-icon ng-if=\"truefalseQuizResult.solved\" md-font-set=\"material-icons\" ng-style=\"{color: \'#4CAF50\'}\" class=\"material-icons\">done</md-icon><md-icon ng-if=\"!truefalseQuizResult.solved\" md-font-set=\"material-icons\" ng-style=\"{color: \'#F44336\'}\" class=\"material-icons\">close</md-icon>{{truefalseQuizResult.question}}</h3><p ng-if=\"truefalseQuizResult.showSolution\">Risposta corretta: {{truefalseQuizResult.answer[0]}}</p></md-card>");}]);